(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.cP.a7 === region.d7.a7)
	{
		return 'on line ' + region.cP.a7;
	}
	return 'on lines ' + region.cP.a7 + ' through ' + region.d7.a7;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hA,
		impl.iW,
		impl.iu,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		e3: func(record.e3),
		cR: record.cR,
		cL: record.cL
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.e3;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.cR;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.cL) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hA,
		impl.iW,
		impl.iu,
		function(sendToApp, initialModel) {
			var view = impl.i5;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hA,
		impl.iW,
		impl.iu,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.cN && impl.cN(sendToApp)
			var view = impl.i5;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.df);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.aP) && (_VirtualDom_doc.title = title = doc.aP);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.h_;
	var onUrlRequest = impl.h$;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		cN: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.fH === next.fH
							&& curr.et === next.et
							&& curr.fx.a === next.fx.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		hA: function(flags)
		{
			return A3(impl.hA, flags, _Browser_getUrl(), key);
		},
		i5: impl.i5,
		iW: impl.iW,
		iu: impl.iu
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { hv: 'hidden', g5: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { hv: 'mozHidden', g5: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { hv: 'msHidden', g5: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { hv: 'webkitHidden', g5: 'webkitvisibilitychange' }
		: { hv: 'hidden', g5: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		fT: _Browser_getScene(),
		gG: {
			gK: _Browser_window.pageXOffset,
			gL: _Browser_window.pageYOffset,
			gI: _Browser_doc.documentElement.clientWidth,
			eq: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		gI: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		eq: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			fT: {
				gI: node.scrollWidth,
				eq: node.scrollHeight
			},
			gG: {
				gK: node.scrollLeft,
				gL: node.scrollTop,
				gI: node.clientWidth,
				eq: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			fT: _Browser_getScene(),
			gG: {
				gK: x,
				gL: y,
				gI: _Browser_doc.documentElement.clientWidth,
				eq: _Browser_doc.documentElement.clientHeight
			},
			ho: {
				gK: x + rect.left,
				gL: y + rect.top,
				gI: rect.width,
				eq: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.hW) { flags += 'm'; }
	if (options.g4) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.cr.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.cr.b, xhr)); });
		$elm$core$Maybe$isJust(request.gs) && _Http_track(router, xhr, request.gs.a);

		try {
			xhr.open(request.e4, request.gC, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.gC));
		}

		_Http_configureRequest(xhr, request);

		request.df.a && xhr.setRequestHeader('Content-Type', request.df.a);
		xhr.send(request.df.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.ep; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.gp.a || 0;
	xhr.responseType = request.cr.d;
	xhr.withCredentials = request.gT;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		gC: xhr.responseURL,
		iq: xhr.status,
		ir: xhr.statusText,
		ep: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			im: event.loaded,
			f8: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			h8: event.loaded,
			f8: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}



// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}





// VIRTUAL-DOM WIDGETS


var _Markdown_toHtml = F3(function(options, factList, rawMarkdown)
{
	return _VirtualDom_custom(
		factList,
		{
			a: options,
			b: rawMarkdown
		},
		_Markdown_render,
		_Markdown_diff
	);
});



// WIDGET IMPLEMENTATION


function _Markdown_render(model)
{
	return A2(_Markdown_replace, model, _VirtualDom_doc.createElement('div'));
}


function _Markdown_diff(x, y)
{
	return x.b === y.b && x.a === y.a
		? false
		: _Markdown_replace(y);
}


var _Markdown_replace = F2(function(model, div)
{
	div.innerHTML = _Markdown_marked(model.b, _Markdown_formatOptions(model.a));
	return div;
});



// ACTUAL MARKDOWN PARSER


var _Markdown_marked = function() {
	// catch the `marked` object regardless of the outer environment.
	// (ex. a CommonJS module compatible environment.)
	// note that this depends on marked's implementation of environment detection.
	var module = {};
	var exports = module.exports = {};

	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 * commit cd2f6f5b7091154c5526e79b5f3bfb4d15995a51
	 */
	(function(){var block={newline:/^\n+/,code:/^( {4}[^\n]+\n*)+/,fences:noop,hr:/^( *[-*_]){3,} *(?:\n+|$)/,heading:/^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,nptable:noop,lheading:/^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,blockquote:/^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,list:/^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,html:/^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,table:noop,paragraph:/^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,text:/^[^\n]+/};block.bullet=/(?:[*+-]|\d+\.)/;block.item=/^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;block.item=replace(block.item,"gm")(/bull/g,block.bullet)();block.list=replace(block.list)(/bull/g,block.bullet)("hr","\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def","\\n+(?="+block.def.source+")")();block.blockquote=replace(block.blockquote)("def",block.def)();block._tag="(?!(?:"+"a|em|strong|small|s|cite|q|dfn|abbr|data|time|code"+"|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo"+"|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b";block.html=replace(block.html)("comment",/<!--[\s\S]*?-->/)("closed",/<(tag)[\s\S]+?<\/\1>/)("closing",/<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g,block._tag)();block.paragraph=replace(block.paragraph)("hr",block.hr)("heading",block.heading)("lheading",block.lheading)("blockquote",block.blockquote)("tag","<"+block._tag)("def",block.def)();block.normal=merge({},block);block.gfm=merge({},block.normal,{fences:/^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,paragraph:/^/,heading:/^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/});block.gfm.paragraph=replace(block.paragraph)("(?!","(?!"+block.gfm.fences.source.replace("\\1","\\2")+"|"+block.list.source.replace("\\1","\\3")+"|")();block.tables=merge({},block.gfm,{nptable:/^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,table:/^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/});function Lexer(options){this.tokens=[];this.tokens.links={};this.options=options||marked.defaults;this.rules=block.normal;if(this.options.gfm){if(this.options.tables){this.rules=block.tables}else{this.rules=block.gfm}}}Lexer.rules=block;Lexer.lex=function(src,options){var lexer=new Lexer(options);return lexer.lex(src)};Lexer.prototype.lex=function(src){src=src.replace(/\r\n|\r/g,"\n").replace(/\t/g,"    ").replace(/\u00a0/g," ").replace(/\u2424/g,"\n");return this.token(src,true)};Lexer.prototype.token=function(src,top,bq){var src=src.replace(/^ +$/gm,""),next,loose,cap,bull,b,item,space,i,l;while(src){if(cap=this.rules.newline.exec(src)){src=src.substring(cap[0].length);if(cap[0].length>1){this.tokens.push({type:"space"})}}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);cap=cap[0].replace(/^ {4}/gm,"");this.tokens.push({type:"code",text:!this.options.pedantic?cap.replace(/\n+$/,""):cap});continue}if(cap=this.rules.fences.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"code",lang:cap[2],text:cap[3]||""});continue}if(cap=this.rules.heading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[1].length,text:cap[2]});continue}if(top&&(cap=this.rules.nptable.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].split(/ *\| */)}this.tokens.push(item);continue}if(cap=this.rules.lheading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[2]==="="?1:2,text:cap[1]});continue}if(cap=this.rules.hr.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"hr"});continue}if(cap=this.rules.blockquote.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"blockquote_start"});cap=cap[0].replace(/^ *> ?/gm,"");this.token(cap,top,true);this.tokens.push({type:"blockquote_end"});continue}if(cap=this.rules.list.exec(src)){src=src.substring(cap[0].length);bull=cap[2];this.tokens.push({type:"list_start",ordered:bull.length>1});cap=cap[0].match(this.rules.item);next=false;l=cap.length;i=0;for(;i<l;i++){item=cap[i];space=item.length;item=item.replace(/^ *([*+-]|\d+\.) +/,"");if(~item.indexOf("\n ")){space-=item.length;item=!this.options.pedantic?item.replace(new RegExp("^ {1,"+space+"}","gm"),""):item.replace(/^ {1,4}/gm,"")}if(this.options.smartLists&&i!==l-1){b=block.bullet.exec(cap[i+1])[0];if(bull!==b&&!(bull.length>1&&b.length>1)){src=cap.slice(i+1).join("\n")+src;i=l-1}}loose=next||/\n\n(?!\s*$)/.test(item);if(i!==l-1){next=item.charAt(item.length-1)==="\n";if(!loose)loose=next}this.tokens.push({type:loose?"loose_item_start":"list_item_start"});this.token(item,false,bq);this.tokens.push({type:"list_item_end"})}this.tokens.push({type:"list_end"});continue}if(cap=this.rules.html.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:this.options.sanitize?"paragraph":"html",pre:!this.options.sanitizer&&(cap[1]==="pre"||cap[1]==="script"||cap[1]==="style"),text:cap[0]});continue}if(!bq&&top&&(cap=this.rules.def.exec(src))){src=src.substring(cap[0].length);this.tokens.links[cap[1].toLowerCase()]={href:cap[2],title:cap[3]};continue}if(top&&(cap=this.rules.table.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/(?: *\| *)?\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].replace(/^ *\| *| *\| *$/g,"").split(/ *\| */)}this.tokens.push(item);continue}if(top&&(cap=this.rules.paragraph.exec(src))){src=src.substring(cap[0].length);this.tokens.push({type:"paragraph",text:cap[1].charAt(cap[1].length-1)==="\n"?cap[1].slice(0,-1):cap[1]});continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"text",text:cap[0]});continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return this.tokens};var inline={escape:/^\\([\\`*{}\[\]()#+\-.!_>])/,autolink:/^<([^ >]+(@|:\/)[^ >]+)>/,url:noop,tag:/^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,link:/^!?\[(inside)\]\(href\)/,reflink:/^!?\[(inside)\]\s*\[([^\]]*)\]/,nolink:/^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,strong:/^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,em:/^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,code:/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,br:/^ {2,}\n(?!\s*$)/,del:noop,text:/^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/};inline._inside=/(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;inline._href=/\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;inline.link=replace(inline.link)("inside",inline._inside)("href",inline._href)();inline.reflink=replace(inline.reflink)("inside",inline._inside)();inline.normal=merge({},inline);inline.pedantic=merge({},inline.normal,{strong:/^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,em:/^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/});inline.gfm=merge({},inline.normal,{escape:replace(inline.escape)("])","~|])")(),url:/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,del:/^~~(?=\S)([\s\S]*?\S)~~/,text:replace(inline.text)("]|","~]|")("|","|https?://|")()});inline.breaks=merge({},inline.gfm,{br:replace(inline.br)("{2,}","*")(),text:replace(inline.gfm.text)("{2,}","*")()});function InlineLexer(links,options){this.options=options||marked.defaults;this.links=links;this.rules=inline.normal;this.renderer=this.options.renderer||new Renderer;this.renderer.options=this.options;if(!this.links){throw new Error("Tokens array requires a `links` property.")}if(this.options.gfm){if(this.options.breaks){this.rules=inline.breaks}else{this.rules=inline.gfm}}else if(this.options.pedantic){this.rules=inline.pedantic}}InlineLexer.rules=inline;InlineLexer.output=function(src,links,options){var inline=new InlineLexer(links,options);return inline.output(src)};InlineLexer.prototype.output=function(src){var out="",link,text,href,cap;while(src){if(cap=this.rules.escape.exec(src)){src=src.substring(cap[0].length);out+=cap[1];continue}if(cap=this.rules.autolink.exec(src)){src=src.substring(cap[0].length);if(cap[2]==="@"){text=cap[1].charAt(6)===":"?this.mangle(cap[1].substring(7)):this.mangle(cap[1]);href=this.mangle("mailto:")+text}else{text=escape(cap[1]);href=text}out+=this.renderer.link(href,null,text);continue}if(!this.inLink&&(cap=this.rules.url.exec(src))){src=src.substring(cap[0].length);text=escape(cap[1]);href=text;out+=this.renderer.link(href,null,text);continue}if(cap=this.rules.tag.exec(src)){if(!this.inLink&&/^<a /i.test(cap[0])){this.inLink=true}else if(this.inLink&&/^<\/a>/i.test(cap[0])){this.inLink=false}src=src.substring(cap[0].length);out+=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(cap[0]):escape(cap[0]):cap[0];continue}if(cap=this.rules.link.exec(src)){src=src.substring(cap[0].length);this.inLink=true;out+=this.outputLink(cap,{href:cap[2],title:cap[3]});this.inLink=false;continue}if((cap=this.rules.reflink.exec(src))||(cap=this.rules.nolink.exec(src))){src=src.substring(cap[0].length);link=(cap[2]||cap[1]).replace(/\s+/g," ");link=this.links[link.toLowerCase()];if(!link||!link.href){out+=cap[0].charAt(0);src=cap[0].substring(1)+src;continue}this.inLink=true;out+=this.outputLink(cap,link);this.inLink=false;continue}if(cap=this.rules.strong.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.strong(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.em.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.em(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.codespan(escape(cap[2],true));continue}if(cap=this.rules.br.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.br();continue}if(cap=this.rules.del.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.del(this.output(cap[1]));continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.text(escape(this.smartypants(cap[0])));continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return out};InlineLexer.prototype.outputLink=function(cap,link){var href=escape(link.href),title=link.title?escape(link.title):null;return cap[0].charAt(0)!=="!"?this.renderer.link(href,title,this.output(cap[1])):this.renderer.image(href,title,escape(cap[1]))};InlineLexer.prototype.smartypants=function(text){if(!this.options.smartypants)return text;return text.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\u2014\/(\[{"\s])'/g,"$1‘").replace(/'/g,"’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g,"$1“").replace(/"/g,"”").replace(/\.{3}/g,"…")};InlineLexer.prototype.mangle=function(text){if(!this.options.mangle)return text;var out="",l=text.length,i=0,ch;for(;i<l;i++){ch=text.charCodeAt(i);if(Math.random()>.5){ch="x"+ch.toString(16)}out+="&#"+ch+";"}return out};function Renderer(options){this.options=options||{}}Renderer.prototype.code=function(code,lang,escaped){if(this.options.highlight){var out=this.options.highlight(code,lang);if(out!=null&&out!==code){escaped=true;code=out}}if(!lang){return"<pre><code>"+(escaped?code:escape(code,true))+"\n</code></pre>"}return'<pre><code class="'+this.options.langPrefix+escape(lang,true)+'">'+(escaped?code:escape(code,true))+"\n</code></pre>\n"};Renderer.prototype.blockquote=function(quote){return"<blockquote>\n"+quote+"</blockquote>\n"};Renderer.prototype.html=function(html){return html};Renderer.prototype.heading=function(text,level,raw){return"<h"+level+' id="'+this.options.headerPrefix+raw.toLowerCase().replace(/[^\w]+/g,"-")+'">'+text+"</h"+level+">\n"};Renderer.prototype.hr=function(){return this.options.xhtml?"<hr/>\n":"<hr>\n"};Renderer.prototype.list=function(body,ordered){var type=ordered?"ol":"ul";return"<"+type+">\n"+body+"</"+type+">\n"};Renderer.prototype.listitem=function(text){return"<li>"+text+"</li>\n"};Renderer.prototype.paragraph=function(text){return"<p>"+text+"</p>\n"};Renderer.prototype.table=function(header,body){return"<table>\n"+"<thead>\n"+header+"</thead>\n"+"<tbody>\n"+body+"</tbody>\n"+"</table>\n"};Renderer.prototype.tablerow=function(content){return"<tr>\n"+content+"</tr>\n"};Renderer.prototype.tablecell=function(content,flags){var type=flags.header?"th":"td";var tag=flags.align?"<"+type+' style="text-align:'+flags.align+'">':"<"+type+">";return tag+content+"</"+type+">\n"};Renderer.prototype.strong=function(text){return"<strong>"+text+"</strong>"};Renderer.prototype.em=function(text){return"<em>"+text+"</em>"};Renderer.prototype.codespan=function(text){return"<code>"+text+"</code>"};Renderer.prototype.br=function(){return this.options.xhtml?"<br/>":"<br>"};Renderer.prototype.del=function(text){return"<del>"+text+"</del>"};Renderer.prototype.link=function(href,title,text){if(this.options.sanitize){try{var prot=decodeURIComponent(unescape(href)).replace(/[^\w:]/g,"").toLowerCase()}catch(e){return""}if(prot.indexOf("javascript:")===0||prot.indexOf("vbscript:")===0||prot.indexOf("data:")===0){return""}}var out='<a href="'+href+'"';if(title){out+=' title="'+title+'"'}out+=">"+text+"</a>";return out};Renderer.prototype.image=function(href,title,text){var out='<img src="'+href+'" alt="'+text+'"';if(title){out+=' title="'+title+'"'}out+=this.options.xhtml?"/>":">";return out};Renderer.prototype.text=function(text){return text};function Parser(options){this.tokens=[];this.token=null;this.options=options||marked.defaults;this.options.renderer=this.options.renderer||new Renderer;this.renderer=this.options.renderer;this.renderer.options=this.options}Parser.parse=function(src,options,renderer){var parser=new Parser(options,renderer);return parser.parse(src)};Parser.prototype.parse=function(src){this.inline=new InlineLexer(src.links,this.options,this.renderer);this.tokens=src.reverse();var out="";while(this.next()){out+=this.tok()}return out};Parser.prototype.next=function(){return this.token=this.tokens.pop()};Parser.prototype.peek=function(){return this.tokens[this.tokens.length-1]||0};Parser.prototype.parseText=function(){var body=this.token.text;while(this.peek().type==="text"){body+="\n"+this.next().text}return this.inline.output(body)};Parser.prototype.tok=function(){switch(this.token.type){case"space":{return""}case"hr":{return this.renderer.hr()}case"heading":{return this.renderer.heading(this.inline.output(this.token.text),this.token.depth,this.token.text)}case"code":{return this.renderer.code(this.token.text,this.token.lang,this.token.escaped)}case"table":{var header="",body="",i,row,cell,flags,j;cell="";for(i=0;i<this.token.header.length;i++){flags={header:true,align:this.token.align[i]};cell+=this.renderer.tablecell(this.inline.output(this.token.header[i]),{header:true,align:this.token.align[i]})}header+=this.renderer.tablerow(cell);for(i=0;i<this.token.cells.length;i++){row=this.token.cells[i];cell="";for(j=0;j<row.length;j++){cell+=this.renderer.tablecell(this.inline.output(row[j]),{header:false,align:this.token.align[j]})}body+=this.renderer.tablerow(cell)}return this.renderer.table(header,body)}case"blockquote_start":{var body="";while(this.next().type!=="blockquote_end"){body+=this.tok()}return this.renderer.blockquote(body)}case"list_start":{var body="",ordered=this.token.ordered;while(this.next().type!=="list_end"){body+=this.tok()}return this.renderer.list(body,ordered)}case"list_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.token.type==="text"?this.parseText():this.tok()}return this.renderer.listitem(body)}case"loose_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.tok()}return this.renderer.listitem(body)}case"html":{var html=!this.token.pre&&!this.options.pedantic?this.inline.output(this.token.text):this.token.text;return this.renderer.html(html)}case"paragraph":{return this.renderer.paragraph(this.inline.output(this.token.text))}case"text":{return this.renderer.paragraph(this.parseText())}}};function escape(html,encode){return html.replace(!encode?/&(?!#?\w+;)/g:/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function unescape(html){return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g,function(_,n){n=n.toLowerCase();if(n==="colon")return":";if(n.charAt(0)==="#"){return n.charAt(1)==="x"?String.fromCharCode(parseInt(n.substring(2),16)):String.fromCharCode(+n.substring(1))}return""})}function replace(regex,opt){regex=regex.source;opt=opt||"";return function self(name,val){if(!name)return new RegExp(regex,opt);val=val.source||val;val=val.replace(/(^|[^\[])\^/g,"$1");regex=regex.replace(name,val);return self}}function noop(){}noop.exec=noop;function merge(obj){var i=1,target,key;for(;i<arguments.length;i++){target=arguments[i];for(key in target){if(Object.prototype.hasOwnProperty.call(target,key)){obj[key]=target[key]}}}return obj}function marked(src,opt,callback){if(callback||typeof opt==="function"){if(!callback){callback=opt;opt=null}opt=merge({},marked.defaults,opt||{});var highlight=opt.highlight,tokens,pending,i=0;try{tokens=Lexer.lex(src,opt)}catch(e){return callback(e)}pending=tokens.length;var done=function(err){if(err){opt.highlight=highlight;return callback(err)}var out;try{out=Parser.parse(tokens,opt)}catch(e){err=e}opt.highlight=highlight;return err?callback(err):callback(null,out)};if(!highlight||highlight.length<3){return done()}delete opt.highlight;if(!pending)return done();for(;i<tokens.length;i++){(function(token){if(token.type!=="code"){return--pending||done()}return highlight(token.text,token.lang,function(err,code){if(err)return done(err);if(code==null||code===token.text){return--pending||done()}token.text=code;token.escaped=true;--pending||done()})})(tokens[i])}return}try{if(opt)opt=merge({},marked.defaults,opt);return Parser.parse(Lexer.lex(src,opt),opt)}catch(e){e.message+="\nPlease report this to https://github.com/chjj/marked.";if((opt||marked.defaults).silent){return"<p>An error occured:</p><pre>"+escape(e.message+"",true)+"</pre>"}throw e}}marked.options=marked.setOptions=function(opt){merge(marked.defaults,opt);return marked};marked.defaults={gfm:true,tables:true,breaks:false,pedantic:false,sanitize:false,sanitizer:null,mangle:true,smartLists:false,silent:false,highlight:null,langPrefix:"lang-",smartypants:false,headerPrefix:"",renderer:new Renderer,xhtml:false};marked.Parser=Parser;marked.parser=Parser.parse;marked.Renderer=Renderer;marked.Lexer=Lexer;marked.lexer=Lexer.lex;marked.InlineLexer=InlineLexer;marked.inlineLexer=InlineLexer.output;marked.parse=marked;if(typeof module!=="undefined"&&typeof exports==="object"){module.exports=marked}else if(typeof define==="function"&&define.amd){define(function(){return marked})}else{this.marked=marked}}).call(function(){return this||(typeof window!=="undefined"?window:global)}());

	return module.exports;
}();


// FORMAT OPTIONS FOR MARKED IMPLEMENTATION

function _Markdown_formatOptions(options)
{
	function toHighlight(code, lang)
	{
		if (!lang && $elm$core$Maybe$isJust(options.hh))
		{
			lang = options.hh.a;
		}

		if (typeof hljs !== 'undefined' && lang && hljs.listLanguages().indexOf(lang) >= 0)
		{
			return hljs.highlight(lang, code, true).value;
		}

		return code;
	}

	var gfm = options.ht.a;

	return {
		highlight: toHighlight,
		gfm: gfm,
		tables: gfm && gfm.iD,
		breaks: gfm && gfm.g3,
		sanitize: options.$8,
		smartypants: options.$9
	};
}
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $author$project$Type$OnUrlChange = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$OnUrlRequest = function (a) {
	return {$: 1, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.m) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.o),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.o);
		} else {
			var treeLen = builder.m * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.p) : builder.p;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.m);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.o) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.o);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{p: nodeList, m: (len / $elm$core$Array$branchFactor) | 0, o: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {em: fragment, et: host, h3: path, fx: port_, fH: protocol, b6: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Data$Route$AdminsRoute = {$: 4};
var $author$project$Data$Route$AuditLogRoute = {$: 17};
var $author$project$Data$Route$BotLogRoute = {$: 15};
var $author$project$Data$Route$BotReportRoute = {$: 16};
var $author$project$Data$Route$BotsRoute = {$: 13};
var $author$project$Data$Route$CreateAdminRoute = {$: 5};
var $author$project$Data$Route$CreateSuperAdminRoute = {$: 8};
var $author$project$Data$Route$CreateTenantRoute = {$: 11};
var $author$project$Data$Route$EditAdminRoute = function (a) {
	return {$: 6, a: a};
};
var $author$project$Data$Route$EditBotRoute = function (a) {
	return {$: 14, a: a};
};
var $author$project$Data$Route$EditSuperAdminRoute = function (a) {
	return {$: 9, a: a};
};
var $author$project$Data$Route$EditTenantRoute = function (a) {
	return {$: 12, a: a};
};
var $author$project$Data$Route$HomeRoute = {$: 0};
var $author$project$Data$Route$LoginRoute = {$: 1};
var $author$project$Data$Route$NotFound = {$: 18};
var $author$project$Data$Route$ProfileRoute = {$: 3};
var $author$project$Data$Route$SuperAdminsRoute = {$: 7};
var $author$project$Data$Route$SuperLoginRoute = {$: 2};
var $author$project$Data$Route$TenantsRoute = {$: 10};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Basics$not = _Basics_not;
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Data$Route$removeExtension = function (string) {
	return A2(
		$elm$core$Maybe$withDefault,
		string,
		$elm$core$List$head(
			A2($elm$core$String$split, '.', string)));
};
var $author$project$Data$Route$getUrls = function (url) {
	return A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
		A2(
			$elm$core$String$split,
			'/',
			$author$project$Data$Route$removeExtension(url.h3)));
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Data$Route$getRoute = function (url) {
	var _v0 = $author$project$Data$Route$getUrls(url);
	_v0$19:
	while (true) {
		if (!_v0.b) {
			return $author$project$Data$Route$HomeRoute;
		} else {
			switch (_v0.a) {
				case 'index':
					if (!_v0.b.b) {
						return $author$project$Data$Route$HomeRoute;
					} else {
						break _v0$19;
					}
				case 'login':
					return $author$project$Data$Route$LoginRoute;
				case 'super':
					if (_v0.b.b && (_v0.b.a === 'login')) {
						var _v1 = _v0.b;
						return $author$project$Data$Route$SuperLoginRoute;
					} else {
						break _v0$19;
					}
				case 'profile':
					return $author$project$Data$Route$ProfileRoute;
				case 'admins':
					return $author$project$Data$Route$AdminsRoute;
				case 'create-admin':
					return $author$project$Data$Route$CreateAdminRoute;
				case 'edit-admin':
					if (_v0.b.b) {
						var _v2 = _v0.b;
						var adminID = _v2.a;
						return A2(
							$elm$core$Maybe$withDefault,
							$author$project$Data$Route$CreateAdminRoute,
							A2(
								$elm$core$Maybe$map,
								function (id) {
									return $author$project$Data$Route$EditAdminRoute(id);
								},
								$elm$core$String$toInt(adminID)));
					} else {
						break _v0$19;
					}
				case 'super-admins':
					return $author$project$Data$Route$SuperAdminsRoute;
				case 'create-super-admin':
					return $author$project$Data$Route$CreateSuperAdminRoute;
				case 'edit-super-admin':
					if (_v0.b.b) {
						var _v3 = _v0.b;
						var superAdminID = _v3.a;
						return A2(
							$elm$core$Maybe$withDefault,
							$author$project$Data$Route$CreateSuperAdminRoute,
							A2(
								$elm$core$Maybe$map,
								function (id) {
									return $author$project$Data$Route$EditSuperAdminRoute(id);
								},
								$elm$core$String$toInt(superAdminID)));
					} else {
						break _v0$19;
					}
				case 'tenants':
					return $author$project$Data$Route$TenantsRoute;
				case 'create-tenant':
					return $author$project$Data$Route$CreateTenantRoute;
				case 'edit-tenant':
					if (_v0.b.b) {
						var _v4 = _v0.b;
						var tenantID = _v4.a;
						return A2(
							$elm$core$Maybe$withDefault,
							$author$project$Data$Route$CreateTenantRoute,
							A2(
								$elm$core$Maybe$map,
								function (id) {
									return $author$project$Data$Route$EditTenantRoute(id);
								},
								$elm$core$String$toInt(tenantID)));
					} else {
						break _v0$19;
					}
				case 'bots':
					return $author$project$Data$Route$BotsRoute;
				case 'edit-bot':
					if (_v0.b.b) {
						var _v5 = _v0.b;
						var botID = _v5.a;
						return A2(
							$elm$core$Maybe$withDefault,
							$author$project$Data$Route$NotFound,
							A2(
								$elm$core$Maybe$map,
								function (id) {
									return $author$project$Data$Route$EditBotRoute(id);
								},
								$elm$core$String$toInt(botID)));
					} else {
						break _v0$19;
					}
				case 'bot-log':
					return $author$project$Data$Route$BotLogRoute;
				case 'bot-report':
					return $author$project$Data$Route$BotReportRoute;
				case 'audit-log':
					return $author$project$Data$Route$AuditLogRoute;
				default:
					break _v0$19;
			}
		}
	}
	return $author$project$Data$Route$NotFound;
};
var $author$project$Data$Alert$Alerts = $elm$core$Basics$identity;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $author$project$Data$Alert$initial = $elm$core$Dict$empty;
var $author$project$Data$Form$Init = 0;
var $author$project$Data$Form$InvalidEmail = 1;
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {hz: index, hQ: match, hX: number, it: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{g4: false, hW: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $author$project$Data$Form$validateEmail = function (email) {
	return A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('\\S+@\\S+\\.\\S+')),
		email) ? $elm$core$Result$Ok(email) : $elm$core$Result$Err(1);
};
var $author$project$Data$Form$InvalidPassword = 2;
var $author$project$Data$Form$validateMinChars = F2(
	function (minimumLength, value) {
		return (_Utils_cmp(
			$elm$core$String$length(value),
			minimumLength) < 0) ? $elm$core$Result$Err(2) : $elm$core$Result$Ok(value);
	});
var $author$project$Data$Form$validatePassword = function (password) {
	return A2($author$project$Data$Form$validateMinChars, 6, password);
};
var $author$project$Model$Login$initialModel = {
	d4: {
		bH: $elm$core$Maybe$Nothing,
		gD: _List_fromArray(
			[$author$project$Data$Form$validateEmail]),
		i3: ''
	},
	J: 0,
	fu: {
		bH: $elm$core$Maybe$Nothing,
		gD: _List_fromArray(
			[$author$project$Data$Form$validatePassword]),
		i3: ''
	}
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Type$OnGetAdminProfileResult = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Type$OnGetSuperAdminProfileResult = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$Data$Admin$Admin = F4(
	function (id, name, email, tenantID) {
		return {d4: email, eu: id, fg: name, gm: tenantID};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$map4 = _Json_map4;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Api$Decoder$admin = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Data$Admin$Admin,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'tenantID', $elm$json$Json$Decode$int));
var $author$project$Env$Staging = 1;
var $author$project$Env$env = {c5: 'https://faq-api.nexwavetelecoms.net/', dj: 'https://faq-demo.nexwavetelecoms.net/faq-bot.min.js', eR: 1};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$stringBody = _Http_pair;
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{gT: false, df: r.df, cr: r.ia, ep: r.ep, e4: r.e4, gp: r.gp, gs: $elm$core$Maybe$Nothing, gC: r.gC});
};
var $author$project$Api$Base$authCall = function (_v0) {
	var path = _v0.h3;
	var params = _v0.h2;
	var resolver = _v0.ia;
	var token = _v0.iQ;
	return $elm$http$Http$task(
		{
			df: A2(
				$elm$http$Http$stringBody,
				'application/json',
				A2($elm$json$Json$Encode$encode, 0, params)),
			ep: _List_fromArray(
				[
					A2($elm$http$Http$header, 'Authorization', 'Bearer ' + token)
				]),
			e4: 'POST',
			ia: resolver,
			gp: $elm$core$Maybe$Nothing,
			gC: _Utils_ap($author$project$Env$env.c5, path)
		});
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Api$Base$DecodeError = {$: 2};
var $author$project$Api$Base$NetworkError = {$: 0};
var $author$project$Api$Base$UnknownError = function (a) {
	return {$: 3, a: a};
};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $author$project$Api$Base$ApiError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Base$CommonError = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Base$InternalServerError = {$: 1};
var $author$project$Api$Base$InvalidRole = 1;
var $author$project$Api$Base$InvalidSession = 0;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Api$Base$ErrorResponse = F3(
	function (status, code, message) {
		return {dG: code, e3: message, cQ: status};
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$map3 = _Json_map3;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Api$Base$errorResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Api$Base$ErrorResponse,
	A2(
		$elm$json$Json$Decode$andThen,
		function (string) {
			return (string === 'Err') ? $elm$json$Json$Decode$succeed('Err') : $elm$json$Json$Decode$fail('Invalid status');
		},
		A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$value),
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $author$project$Api$Base$ServerErrorResponse = F3(
	function (status, logID, message) {
		return {hK: logID, e3: message, cQ: status};
	});
var $author$project$Api$Base$serverErrorResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Api$Base$ServerErrorResponse,
	A2(
		$elm$json$Json$Decode$andThen,
		function (string) {
			return (string === 'ServerErr') ? $elm$json$Json$Decode$succeed('ServerErr') : $elm$json$Json$Decode$fail('Invalid status');
		},
		A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'logID', $elm$json$Json$Decode$value),
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Api$Base$errDecoder = function (toErrorCode) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				function (_v0) {
					var code = _v0.dG;
					var _v1 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, code);
					_v1$2:
					while (true) {
						if (!_v1.$) {
							switch (_v1.a) {
								case 'InvalidSession':
									return $author$project$Api$Base$CommonError(0);
								case 'InvalidRole':
									return $author$project$Api$Base$CommonError(1);
								default:
									break _v1$2;
							}
						} else {
							break _v1$2;
						}
					}
					return $author$project$Api$Base$ApiError(
						toErrorCode(code));
				},
				$author$project$Api$Base$errorResponseDecoder),
				A2(
				$elm$json$Json$Decode$map,
				function (_v2) {
					return $author$project$Api$Base$InternalServerError;
				},
				$author$project$Api$Base$serverErrorResponseDecoder)
			]));
};
var $author$project$Api$Base$OkResponse = F2(
	function (status, data) {
		return {dP: data, cQ: status};
	});
var $author$project$Api$Base$okResponseDecoder = function (dataDecoder) {
	return A3(
		$elm$json$Json$Decode$map2,
		$author$project$Api$Base$OkResponse,
		A2(
			$elm$json$Json$Decode$andThen,
			function (string) {
				return (string === 'Ok') ? $elm$json$Json$Decode$succeed('Ok') : $elm$json$Json$Decode$fail('Invalid status');
			},
			A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string)),
		A2($elm$json$Json$Decode$field, 'data', dataDecoder));
};
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $author$project$Api$Base$standardResolver = F2(
	function (errorCodeDecoder, dataDecoder) {
		return $elm$http$Http$stringResolver(
			function (response) {
				switch (response.$) {
					case 0:
						var str = response.a;
						return $elm$core$Result$Err(
							$author$project$Api$Base$UnknownError(str));
					case 1:
						return $elm$core$Result$Err($author$project$Api$Base$NetworkError);
					case 2:
						return $elm$core$Result$Err($author$project$Api$Base$NetworkError);
					case 3:
						var body = response.b;
						var _v1 = A2(
							$elm$json$Json$Decode$decodeString,
							$author$project$Api$Base$errDecoder(errorCodeDecoder),
							body);
						if (!_v1.$) {
							var error = _v1.a;
							return $elm$core$Result$Err(error);
						} else {
							return $elm$core$Result$Err($author$project$Api$Base$DecodeError);
						}
					default:
						var body = response.b;
						var _v2 = A2(
							$elm$json$Json$Decode$decodeString,
							$author$project$Api$Base$okResponseDecoder(dataDecoder),
							body);
						if (!_v2.$) {
							var r = _v2.a;
							return $elm$core$Result$Ok(r.dP);
						} else {
							return $elm$core$Result$Err($author$project$Api$Base$DecodeError);
						}
				}
			});
	});
var $author$project$Api$AdminProfile$InvalidParams = 0;
var $author$project$Api$AdminProfile$MissingError = 1;
var $author$project$Api$AdminProfile$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	if ((!_v0.$) && (_v0.a === 'InvalidParams')) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Api$AdminProfile$exec = function (token) {
	var resolver = A2(
		$author$project$Api$Base$standardResolver,
		$author$project$Api$AdminProfile$toErrorCode,
		A2($elm$json$Json$Decode$field, 'admin', $author$project$Api$Decoder$admin));
	return $author$project$Api$Base$authCall(
		{h2: $elm$json$Json$Encode$null, h3: 'admin/profile', ia: resolver, iQ: token});
};
var $author$project$Data$SuperAdmin$SuperAdmin = F3(
	function (id, name, email) {
		return {d4: email, eu: id, fg: name};
	});
var $author$project$Api$Decoder$superAdmin = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$SuperAdmin$SuperAdmin,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string));
var $author$project$Api$SuperAdminProfile$InvalidParams = 0;
var $author$project$Api$SuperAdminProfile$MissingError = 1;
var $author$project$Api$SuperAdminProfile$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	if ((!_v0.$) && (_v0.a === 'InvalidParams')) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Api$SuperAdminProfile$exec = function (token) {
	var resolver = A2(
		$author$project$Api$Base$standardResolver,
		$author$project$Api$SuperAdminProfile$toErrorCode,
		A2($elm$json$Json$Decode$field, 'superAdmin', $author$project$Api$Decoder$superAdmin));
	return $author$project$Api$Base$authCall(
		{h2: $elm$json$Json$Encode$null, h3: 'super-admin/profile', ia: resolver, iQ: token});
};
var $author$project$Data$Role$Admin = 0;
var $author$project$Data$Role$SuperAdmin = 1;
var $author$project$Data$Role$toRole = function (string) {
	if (string === 'SuperAdmin') {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$Model$onGetProfile = F2(
	function (_v0, model) {
		var token = _v0.iQ;
		var role = _v0.ic;
		var cmd_ = function () {
			var _v1 = $author$project$Data$Role$toRole(role);
			if (_v1 === 1) {
				return A2(
					$elm$core$Task$attempt,
					$author$project$Type$OnGetSuperAdminProfileResult(token),
					$author$project$Api$SuperAdminProfile$exec(token));
			} else {
				return A2(
					$elm$core$Task$attempt,
					$author$project$Type$OnGetAdminProfileResult(token),
					$author$project$Api$AdminProfile$exec(token));
			}
		}();
		return _Utils_Tuple2(model, cmd_);
	});
var $author$project$Model$initialModel = F3(
	function (_v0, url, navKey) {
		var authInfo = _v0.gY;
		var publicModel = {
			ar: $author$project$Data$Alert$initial,
			aW: $elm$core$Maybe$Nothing,
			bO: A2(
				$elm$core$Maybe$withDefault,
				true,
				A2(
					$elm$core$Maybe$map,
					function (_v2) {
						return false;
					},
					authInfo)),
			eY: $author$project$Model$Login$initialModel,
			ab: navKey,
			cM: $author$project$Data$Route$getRoute(url),
			gC: url
		};
		if (authInfo.$ === 1) {
			return _Utils_Tuple2(publicModel, $elm$core$Platform$Cmd$none);
		} else {
			var authInfo_ = authInfo.a;
			return A2($author$project$Model$onGetProfile, authInfo_, publicModel);
		}
	});
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $author$project$Type$OnAuth = function (a) {
	return {$: 9, a: a};
};
var $author$project$Type$OnBotDetail = function (a) {
	return {$: 9, a: a};
};
var $author$project$Type$BotDetail$OnMarkdownEditor = function (a) {
	return {$: 38, a: a};
};
var $author$project$Port$Editor$markDownReceiver = _Platform_incomingPort('markDownReceiver', $elm$json$Json$Decode$string);
var $author$project$Subscription$subscriptions = function (_v0) {
	return $author$project$Port$Editor$markDownReceiver(
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotDetail),
			$author$project$Type$BotDetail$OnMarkdownEditor));
};
var $author$project$Data$Alert$clear = $author$project$Data$Alert$initial;
var $author$project$Data$Role$getRole = function (profile) {
	if (profile.$ === 1) {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$Data$DataStatus$Downloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Data$DataStatus$Init = {$: 0};
var $author$project$Type$OnAdminDetail = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$AdminDetail$OnGetAdminResult = function (a) {
	return {$: 12, a: a};
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Api$AdminDetail$CannotGetAdmin = 1;
var $author$project$Api$AdminDetail$InvalidParams = 0;
var $author$project$Api$AdminDetail$MissingError = 2;
var $author$project$Api$AdminDetail$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'CannotGetAdmin':
					return 1;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 2;
};
var $author$project$Api$AdminDetail$exec = F2(
	function (_v0, token) {
		var id = _v0.eu;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$AdminDetail$toErrorCode,
			A2($elm$json$Json$Decode$field, 'admin', $author$project$Api$Decoder$admin));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(id))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'admin/detail', ia: resolver, iQ: token});
	});
var $author$project$Model$AdminDetail$getAdminCmd = F2(
	function (id, token) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAdminDetail),
				$author$project$Type$AdminDetail$OnGetAdminResult),
			A2(
				$author$project$Api$AdminDetail$exec,
				{eu: id},
				token));
	});
var $author$project$Data$Role$getTenantID = function (profile) {
	if (profile.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var tenantID = profile.a.gm;
		return $elm$core$Maybe$Just(tenantID);
	}
};
var $author$project$Type$AdminDetail$OnGetTenantsResult = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Options$Tenant = {$: 2};
var $author$project$Api$Options$Item = F2(
	function (label, value) {
		return {hH: label, i3: value};
	});
var $author$project$Api$Options$Response = function (items) {
	return {eN: items};
};
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Api$Options$decoder = A2(
	$elm$json$Json$Decode$map,
	function (_v0) {
		var items = _v0.eN;
		return items;
	},
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Api$Options$Response,
		A2(
			$elm$json$Json$Decode$field,
			'items',
			$elm$json$Json$Decode$list(
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Api$Options$Item,
					A2($elm$json$Json$Decode$field, 'label', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$int))))));
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Api$Options$encoder = function (params) {
	switch (params.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('SuperAdmin'))
					]));
		case 1:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('Admin'))
					]));
		case 2:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('Tenant'))
					]));
		default:
			var tenantID = params.a;
			var languageCode = params.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('Bot')),
						_Utils_Tuple2(
						'tenantID',
						A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Encode$null,
							A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, tenantID))),
						_Utils_Tuple2(
						'languageCode',
						A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Encode$null,
							A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, languageCode)))
					]));
	}
};
var $author$project$Api$Options$CannotGetData = 1;
var $author$project$Api$Options$InvalidParams = 0;
var $author$project$Api$Options$MissingError = 2;
var $author$project$Api$Options$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'CannotGetData':
					return 1;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 2;
};
var $author$project$Api$Options$exec = F2(
	function (params, token) {
		var resolver = A2($author$project$Api$Base$standardResolver, $author$project$Api$Options$toErrorCode, $author$project$Api$Options$decoder);
		return $author$project$Api$Base$authCall(
			{
				h2: $author$project$Api$Options$encoder(params),
				h3: 'options',
				ia: resolver,
				iQ: token
			});
	});
var $author$project$Model$AdminDetail$getTenantsCmd = function (token) {
	return A2(
		$elm$core$Task$attempt,
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAdminDetail),
			$author$project$Type$AdminDetail$OnGetTenantsResult),
		A2($author$project$Api$Options$exec, $author$project$Api$Options$Tenant, token));
};
var $author$project$Data$Form$EmptyField = 0;
var $author$project$Data$Form$isNotEmpty = function (string) {
	return ($elm$core$String$length(string) > 0) ? $elm$core$Result$Ok(string) : $elm$core$Result$Err(0);
};
var $author$project$Model$AdminDetail$initialModel = F3(
	function (appModel, token, profile) {
		var tenantID = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$fromInt,
				$author$project$Data$Role$getTenantID(profile)));
		var _v0 = function () {
			if (!profile.$) {
				return _Utils_Tuple2(
					$elm$core$Platform$Cmd$none,
					$author$project$Data$DataStatus$Downloaded(_List_Nil));
			} else {
				return _Utils_Tuple2(
					$author$project$Model$AdminDetail$getTenantsCmd(token),
					$author$project$Data$DataStatus$Init);
			}
		}();
		var tenantCmd = _v0.a;
		var tenants_ = _v0.b;
		var cmd = function () {
			var _v2 = appModel.cM;
			switch (_v2.$) {
				case 6:
					var adminID = _v2.a;
					return $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Model$AdminDetail$getAdminCmd, adminID, token),
								tenantCmd
							]));
				case 5:
					return tenantCmd;
				default:
					return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple2(
			{
				gO: $author$project$Data$DataStatus$Init,
				G: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$validatePassword]),
					i3: ''
				},
				d4: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$validateEmail]),
					i3: ''
				},
				J: 0,
				fg: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$isNotEmpty]),
					i3: ''
				},
				fu: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$validatePassword]),
					i3: ''
				},
				gm: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$isNotEmpty]),
					i3: tenantID
				},
				iM: tenants_
			},
			cmd);
	});
var $jinjor$elm_debounce$Debounce$Debounce = $elm$core$Basics$identity;
var $jinjor$elm_debounce$Debounce$init = {hC: _List_Nil, a8: false};
var $author$project$Ext$Debounce$debounceInit = $jinjor$elm_debounce$Debounce$init;
var $author$project$Type$OnAdminList = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$AdminList$OnGetAdminsResult = function (a) {
	return {$: 13, a: a};
};
var $author$project$Data$Admin$ListResponse = F2(
	function (admins, total) {
		return {gR: admins, iR: total};
	});
var $author$project$Api$Decoder$adminList = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Admin$ListResponse,
	A2(
		$elm$json$Json$Decode$field,
		'admins',
		$elm$json$Json$Decode$list($author$project$Api$Decoder$admin)),
	A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
var $author$project$Api$AdminList$CannotGetAdmin = 3;
var $author$project$Api$AdminList$InvalidLimit = 1;
var $author$project$Api$AdminList$InvalidOffset = 2;
var $author$project$Api$AdminList$InvalidParams = 0;
var $author$project$Api$AdminList$MissingError = 4;
var $author$project$Api$AdminList$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$4:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidLimit':
					return 1;
				case 'InvalidOffset':
					return 2;
				case 'CannotGetAdmin':
					return 3;
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return 4;
};
var $author$project$Api$AdminList$exec = F2(
	function (_v0, token) {
		var search = _v0.fU;
		var limit = _v0.eV;
		var offset = _v0.fo;
		var tenantID = _v0.gm;
		var resolver = A2($author$project$Api$Base$standardResolver, $author$project$Api$AdminList$toErrorCode, $author$project$Api$Decoder$adminList);
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'search',
					$elm$json$Json$Encode$string(search)),
					_Utils_Tuple2(
					'limit',
					$elm$json$Json$Encode$int(limit)),
					_Utils_Tuple2(
					'offset',
					$elm$json$Json$Encode$int(offset)),
					_Utils_Tuple2(
					'tenantID',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, tenantID)))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'admin/list', ia: resolver, iQ: token});
	});
var $author$project$Model$AdminList$getAdminsCmd = F2(
	function (_v0, token) {
		var offset = _v0.fo;
		var search = _v0.fU;
		var limit = _v0.eV;
		var tenantID = _v0.gm;
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAdminList),
				$author$project$Type$AdminList$OnGetAdminsResult),
			A2(
				$author$project$Api$AdminList$exec,
				{
					eV: limit,
					fo: offset * limit,
					fU: search,
					gm: $elm$core$String$toInt(tenantID)
				},
				token));
	});
var $author$project$Type$AdminList$OnGetTenantResult = function (a) {
	return {$: 15, a: a};
};
var $author$project$Data$Tenant$Tenant = F4(
	function (id, name, maxBots, maxNodes) {
		return {eu: id, e0: maxBots, e1: maxNodes, fg: name};
	});
var $author$project$Api$Decoder$tenant = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Data$Tenant$Tenant,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'maxBots', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'maxNodes', $elm$json$Json$Decode$int));
var $author$project$Api$TenantDetail$CannotGetTenant = 1;
var $author$project$Api$TenantDetail$InvalidParams = 0;
var $author$project$Api$TenantDetail$MissingError = 2;
var $author$project$Api$TenantDetail$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'CannotGetTenant':
					return 1;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 2;
};
var $author$project$Api$TenantDetail$exec = F2(
	function (_v0, token) {
		var id = _v0.eu;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$TenantDetail$toErrorCode,
			A2($elm$json$Json$Decode$field, 'tenant', $author$project$Api$Decoder$tenant));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(id))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'tenant/detail', ia: resolver, iQ: token});
	});
var $author$project$Model$AdminList$getTenantCmd = F2(
	function (id, token) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAdminList),
				$author$project$Type$AdminList$OnGetTenantResult),
			A2(
				$author$project$Api$TenantDetail$exec,
				{eu: id},
				token));
	});
var $author$project$Type$AdminList$OnGetTenantsResult = function (a) {
	return {$: 14, a: a};
};
var $author$project$Model$AdminList$getTenantsCmd = function (token) {
	return A2(
		$elm$core$Task$attempt,
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAdminList),
			$author$project$Type$AdminList$OnGetTenantsResult),
		A2($author$project$Api$Options$exec, $author$project$Api$Options$Tenant, token));
};
var $author$project$Model$AdminList$initialModel = F3(
	function (appModel, token, profile) {
		var tenantCmd = function () {
			if (!profile.$) {
				var tenantID = profile.a.gm;
				return A2($author$project$Model$AdminList$getTenantCmd, tenantID, token);
			} else {
				return $author$project$Model$AdminList$getTenantsCmd(token);
			}
		}();
		var cmd = _Utils_eq(appModel.cM, $author$project$Data$Route$AdminsRoute) ? $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$author$project$Model$AdminList$getAdminsCmd,
					{eV: 20, fo: 0, fU: '', gm: ''},
					token),
					tenantCmd
				])) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(
			{
				F: _List_Nil,
				bQ: false,
				eV: 20,
				fo: 0,
				fU: '',
				be: $author$project$Ext$Debounce$debounceInit,
				bf: 0,
				cQ: $author$project$Data$DataStatus$Init,
				gm: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
				iM: _List_Nil,
				iR: 0
			},
			cmd);
	});
var $author$project$Data$DataStatus$Downloading = {$: 1};
var $author$project$Data$AuditLog$ID = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Message$messages = {g8: 'Create admin successfully', g9: 'Create bot successfully', ha: 'Create super admin successfully', hb: 'Create tenant successfully', dQ: 'Something went wrong, please try later', hi: 'Delete admin successfully', hj: 'Delete bot successfully', hk: 'Delete super admin successfully', hl: 'Delete tenant successfully', hr: 'Export bot responses successfully', hy: 'Import bot responses successfully', hF: 'Invalid import file data', eG: 'You do not have permission to do this!', eH: 'Your session has been ended, please login again', hL: 'Session has expired. Please login again', hM: 'Login successfully', hO: 'Logout successfully', hR: 'Reached maximum number of responses', hV: 'Missing user', fj: 'Network has error, please retry', h9: 'Requires a child', f0: 'Server has error at this moment, please try later', iX: 'Update admin successfully', iY: 'Update bot successfully', i_: 'Update password successfully', i$: 'Update profile successfully', i0: 'Update super admin successfully', i1: 'Update tenant successfully'};
var $author$project$Data$Message$apiErrorCodeString = F2(
	function (apiCodeToString, code) {
		switch (code.$) {
			case 0:
				return $author$project$Data$Message$messages.fj;
			case 1:
				return $author$project$Data$Message$messages.f0;
			case 2:
				return $author$project$Data$Message$messages.dQ;
			case 3:
				var string = code.a;
				return 'Unknown error: ' + string;
			case 4:
				if (!code.a) {
					var _v1 = code.a;
					return $author$project$Data$Message$messages.eH;
				} else {
					var _v2 = code.a;
					return $author$project$Data$Message$messages.eG;
				}
			default:
				var code_ = code.a;
				return apiCodeToString(code_);
		}
	});
var $author$project$Api$AuditLogApiCalledSearch$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Cannot find any matched session ID';
		default:
			return 'Missing error code';
	}
};
var $author$project$Api$AuditLogApiCalledSearch$Response = function (apiCalledList) {
	return {c4: apiCalledList};
};
var $author$project$Api$AuditLogApiCalledSearch$decoder = A2(
	$elm$json$Json$Decode$map,
	function (_v0) {
		var apiCalledList = _v0.c4;
		return apiCalledList;
	},
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Api$AuditLogApiCalledSearch$Response,
		A2(
			$elm$json$Json$Decode$field,
			'apiCalledList',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
var $author$project$Api$AuditLogApiCalledSearch$CannotMatch = 1;
var $author$project$Api$AuditLogApiCalledSearch$InvalidParams = 0;
var $author$project$Api$AuditLogApiCalledSearch$MissingError = 2;
var $author$project$Api$AuditLogApiCalledSearch$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'CannotMatch':
					return 1;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 2;
};
var $author$project$Api$AuditLogApiCalledSearch$exec = F2(
	function (apiCalledLike, token) {
		var resolver = A2($author$project$Api$Base$standardResolver, $author$project$Api$AuditLogApiCalledSearch$toErrorCode, $author$project$Api$AuditLogApiCalledSearch$decoder);
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'apiCalledLike',
					$elm$json$Json$Encode$string(apiCalledLike))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'audit/api-called-search', ia: resolver, iQ: token});
	});
var $elm$core$Task$mapError = F2(
	function (convert, task) {
		return A2(
			$elm$core$Task$onError,
			A2($elm$core$Basics$composeL, $elm$core$Task$fail, convert),
			task);
	});
var $author$project$Model$AuditLog$apiCalledFetcher = F2(
	function (token, lastChoices) {
		return A2(
			$elm$core$Task$map,
			function (sessionIDs) {
				return _Utils_update(
					lastChoices,
					{bC: sessionIDs});
			},
			A2(
				$elm$core$Task$mapError,
				$author$project$Data$Message$apiErrorCodeString($author$project$Api$AuditLogApiCalledSearch$errorCodeString),
				A2($author$project$Api$AuditLogApiCalledSearch$exec, lastChoices.b6, token)));
	});
var $author$project$Api$Options$Admin = {$: 1};
var $author$project$Type$OnAuditLog = function (a) {
	return {$: 13, a: a};
};
var $author$project$Type$AuditLog$OnGetAdminsResult = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$AuditLog$getAdminsCmd = function (token) {
	return A2(
		$elm$core$Task$attempt,
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAuditLog),
			$author$project$Type$AuditLog$OnGetAdminsResult),
		A2($author$project$Api$Options$exec, $author$project$Api$Options$Admin, token));
};
var $author$project$Type$AuditLog$OnGetAuditLogList = function (a) {
	return {$: 14, a: a};
};
var $author$project$Data$AuditLog$ListResponse = F2(
	function (auditLogs, total) {
		return {gX: auditLogs, iR: total};
	});
var $author$project$Data$AuditLog$AuditLog = F5(
	function (id, role, apiUrl, apiPayload, createdAt) {
		return {gV: apiPayload, c6: apiUrl, hc: createdAt, eu: id, ic: role};
	});
var $author$project$Data$AuditLog$Authorized = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$AuditLog$NotAuthorized = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$AuditLog$AuthorizedInfo = F3(
	function (kind, id, name) {
		return {eu: id, eR: kind, fg: name};
	});
var $author$project$Api$Decoder$exactMatch = F3(
	function (valueDecoder, match, decoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (value) {
				return _Utils_eq(value, match) ? decoder : $elm$json$Json$Decode$fail('Exact match error');
			},
			valueDecoder);
	});
var $author$project$Api$Decoder$auditLogAuthorizedRecordDecoder = function (kindString) {
	return A3(
		$author$project$Api$Decoder$exactMatch,
		A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string),
		kindString,
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$Data$AuditLog$AuthorizedInfo,
			A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)));
};
var $author$project$Data$AuditLog$NotAuthorizedInfo = function (kind) {
	return {eR: kind};
};
var $author$project$Api$Decoder$auditLogNotAuthorizedRecordDecoder = A3(
	$author$project$Api$Decoder$exactMatch,
	A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string),
	'Anonymous',
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Data$AuditLog$NotAuthorizedInfo,
		A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string)));
var $author$project$Api$Decoder$auditLogRoleInfoDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Data$AuditLog$Authorized,
			$author$project$Api$Decoder$auditLogAuthorizedRecordDecoder('SuperAdmin')),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Data$AuditLog$Authorized,
			$author$project$Api$Decoder$auditLogAuthorizedRecordDecoder('Admin')),
			A2($elm$json$Json$Decode$map, $author$project$Data$AuditLog$NotAuthorized, $author$project$Api$Decoder$auditLogNotAuthorizedRecordDecoder)
		]));
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $author$project$Data$Decode$decodeTime = A2(
	$elm$json$Json$Decode$andThen,
	function (ms) {
		return $elm$json$Json$Decode$succeed(
			$elm$time$Time$millisToPosix(ms));
	},
	$elm$json$Json$Decode$int);
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Api$Decoder$auditLog = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Data$AuditLog$AuditLog,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'role', $author$project$Api$Decoder$auditLogRoleInfoDecoder),
	A2($elm$json$Json$Decode$field, 'apiUrl', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'apiPayload', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'createdAt', $author$project$Data$Decode$decodeTime));
var $author$project$Api$Decoder$auditLogList = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$AuditLog$ListResponse,
	A2(
		$elm$json$Json$Decode$field,
		'auditLogs',
		$elm$json$Json$Decode$list($author$project$Api$Decoder$auditLog)),
	A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Api$Encoder$auditLogOrderBy = function (role) {
	switch (role.$) {
		case 0:
			var asc = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('ID')),
						_Utils_Tuple2(
						'asc',
						$elm$json$Json$Encode$bool(asc))
					]));
		case 1:
			var asc = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('Role')),
						_Utils_Tuple2(
						'asc',
						$elm$json$Json$Encode$bool(asc))
					]));
		case 2:
			var asc = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('UserID')),
						_Utils_Tuple2(
						'asc',
						$elm$json$Json$Encode$bool(asc))
					]));
		case 3:
			var asc = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('UserName')),
						_Utils_Tuple2(
						'asc',
						$elm$json$Json$Encode$bool(asc))
					]));
		case 4:
			var asc = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('ApiUrl')),
						_Utils_Tuple2(
						'asc',
						$elm$json$Json$Encode$bool(asc))
					]));
		default:
			var asc = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('CreatedAt')),
						_Utils_Tuple2(
						'asc',
						$elm$json$Json$Encode$bool(asc))
					]));
	}
};
var $author$project$Api$Encoder$auditRole = function (role) {
	switch (role.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('All'))
					]));
		case 1:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('AnonymousOnly'))
					]));
		case 2:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('AdminOnly'))
					]));
		case 3:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('SuperAdminOnly'))
					]));
		case 4:
			var id = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('SpecificAdmin')),
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$int(id))
					]));
		default:
			var id = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('SpecificSuperAdmin')),
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$int(id))
					]));
	}
};
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $author$project$Api$AuditLogList$InvalidLimit = 2;
var $author$project$Api$AuditLogList$InvalidOffset = 3;
var $author$project$Api$AuditLogList$InvalidParams = 0;
var $author$project$Api$AuditLogList$MissingError = 1;
var $author$project$Api$AuditLogList$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$3:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidLimit':
					return 2;
				case 'InvalidOffset':
					return 3;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 1;
};
var $author$project$Api$AuditLogList$exec = F2(
	function (_v0, token) {
		var roleCase = _v0.fO;
		var search = _v0.fU;
		var apiUrl = _v0.c6;
		var startTime = _v0.gc;
		var endTime = _v0.d8;
		var limit = _v0.eV;
		var offset = _v0.fo;
		var orderBy = _v0.fr;
		var resolver = A2($author$project$Api$Base$standardResolver, $author$project$Api$AuditLogList$toErrorCode, $author$project$Api$Decoder$auditLogList);
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'roleCase',
					$author$project$Api$Encoder$auditRole(roleCase)),
					_Utils_Tuple2(
					'search',
					$elm$json$Json$Encode$string(search)),
					_Utils_Tuple2(
					'apiUrl',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, apiUrl))),
					_Utils_Tuple2(
					'startTime',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Encode$int),
							startTime))),
					_Utils_Tuple2(
					'endTime',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Encode$int),
							endTime))),
					_Utils_Tuple2(
					'limit',
					$elm$json$Json$Encode$int(limit)),
					_Utils_Tuple2(
					'offset',
					$elm$json$Json$Encode$int(offset)),
					_Utils_Tuple2(
					'orderBy',
					$author$project$Api$Encoder$auditLogOrderBy(orderBy))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'audit/list', ia: resolver, iQ: token});
	});
var $author$project$Data$AuditLog$AdminOnly = {$: 2};
var $author$project$Data$AuditLog$All = {$: 0};
var $author$project$Data$AuditLog$AnonymousOnly = {$: 1};
var $author$project$Data$AuditLog$SpecificAdmin = function (a) {
	return {$: 4, a: a};
};
var $author$project$Data$AuditLog$SpecificSuperAdmin = function (a) {
	return {$: 5, a: a};
};
var $author$project$Data$AuditLog$SuperAdminOnly = {$: 3};
var $author$project$Data$AuditLog$Admin = 1;
var $author$project$Data$AuditLog$Anonymous = 0;
var $author$project$Data$AuditLog$SuperAdmin = 2;
var $author$project$Data$AuditLog$toRole = function (role) {
	switch (role) {
		case 'Anonymous':
			return $elm$core$Maybe$Just(0);
		case 'SuperAdmin':
			return $elm$core$Maybe$Just(2);
		case 'Admin':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$AuditLog$generateRoleCase = F3(
	function (roleString, superAdminID, adminID) {
		var role = $author$project$Data$AuditLog$toRole(roleString);
		var _v0 = _Utils_Tuple3(role, superAdminID, adminID);
		_v0$5:
		while (true) {
			if (!_v0.a.$) {
				switch (_v0.a.a) {
					case 2:
						if (_v0.b.$ === 1) {
							if (_v0.c.$ === 1) {
								var _v1 = _v0.a.a;
								var _v2 = _v0.b;
								var _v3 = _v0.c;
								return $author$project$Data$AuditLog$SuperAdminOnly;
							} else {
								break _v0$5;
							}
						} else {
							var _v4 = _v0.a.a;
							var id = _v0.b.a;
							return $author$project$Data$AuditLog$SpecificSuperAdmin(id);
						}
					case 1:
						if (_v0.c.$ === 1) {
							if (_v0.b.$ === 1) {
								var _v5 = _v0.a.a;
								var _v6 = _v0.b;
								var _v7 = _v0.c;
								return $author$project$Data$AuditLog$AdminOnly;
							} else {
								break _v0$5;
							}
						} else {
							var _v8 = _v0.a.a;
							var id = _v0.c.a;
							return $author$project$Data$AuditLog$SpecificAdmin(id);
						}
					default:
						var _v9 = _v0.a.a;
						return $author$project$Data$AuditLog$AnonymousOnly;
				}
			} else {
				break _v0$5;
			}
		}
		return $author$project$Data$AuditLog$All;
	});
var $futureworkz$elm_autocomplete$Autocomplete$query = function (_v0) {
	var s = _v0;
	return s.b6;
};
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {dH: col, g7: contextStack, fA: problem, fQ: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.fQ, s.dH, x, s.f));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.b),
			s.fo) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.b);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.fo, offset) < 0,
					0,
					{dH: col, f: s0.f, g: s0.g, fo: offset, fQ: row, b: s0.b});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.fo, s.fQ, s.dH, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.fo, s1.fo, s0.b),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$Basics$round = _Basics_round;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.fo, s.b);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{dH: 1, f: s.f, g: s.g, fo: s.fo + 1, fQ: s.fQ + 1, b: s.b}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{dH: s.dH + 1, f: s.f, g: s.g, fo: newOffset, fQ: s.fQ, b: s.b}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.fo, s.fQ, s.dH, s.b);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{dH: newCol, f: s.f, g: s.g, fo: newOffset, fQ: newRow, b: s.b});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$Basics$neq = _Utils_notEqual;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {dH: col, fA: problem, fQ: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.fQ, p.dH, p.fA);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{dH: 1, f: _List_Nil, g: 1, fo: 0, fQ: 1, b: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $author$project$Model$AuditLog$getAuditLogCmd = F2(
	function (model, token) {
		var _v0 = model;
		var role = _v0.ic;
		var autocompleteState = _v0.P;
		var search = _v0.fU;
		var offset = _v0.fo;
		var limit = _v0.eV;
		var adminID = _v0.N;
		var superAdminID = _v0.V;
		var startTime = _v0.gc;
		var endTime = _v0.d8;
		var orderBy = _v0.fr;
		var apiUrl = $futureworkz$elm_autocomplete$Autocomplete$query(autocompleteState);
		var roleCase = A3(
			$author$project$Data$AuditLog$generateRoleCase,
			role.i3,
			$elm$core$String$toInt(superAdminID.i3),
			$elm$core$String$toInt(adminID.i3));
		var params = {
			c6: (apiUrl === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(apiUrl),
			d8: A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$time$Time$posixToMillis,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Basics$add((((24 * 60) * 60) * 1000) - 1),
						$elm$time$Time$millisToPosix)),
				$elm$core$Result$toMaybe(
					$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(endTime.i3))),
			eV: limit,
			fo: offset * limit,
			fr: orderBy,
			fO: roleCase,
			fU: search,
			gc: $elm$core$Result$toMaybe(
				$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(startTime.i3))
		};
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAuditLog),
				$author$project$Type$AuditLog$OnGetAuditLogList),
			A2($author$project$Api$AuditLogList$exec, params, token));
	});
var $author$project$Type$AuditLog$OnGetSuperAdminsResult = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Options$SuperAdmin = {$: 0};
var $author$project$Model$AuditLog$getSuperAdminsCmd = function (token) {
	return A2(
		$elm$core$Task$attempt,
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAuditLog),
			$author$project$Type$AuditLog$OnGetSuperAdminsResult),
		A2($author$project$Api$Options$exec, $author$project$Api$Options$SuperAdmin, token));
};
var $futureworkz$elm_autocomplete$Autocomplete$Autocomplete = $elm$core$Basics$identity;
var $futureworkz$elm_autocomplete$Internal$DebounceMsg = function (a) {
	return {$: 6, a: a};
};
var $futureworkz$elm_autocomplete$Autocomplete$NotFetched = {$: 0};
var $jinjor$elm_debounce$Debounce$Later = function (a) {
	return {$: 2, a: a};
};
var $jinjor$elm_debounce$Debounce$later = $jinjor$elm_debounce$Debounce$Later;
var $futureworkz$elm_autocomplete$Autocomplete$init = F2(
	function (initChoices, fetcher) {
		return {
			bC: initChoices.bC,
			bE: {
				is: $jinjor$elm_debounce$Debounce$later(200),
				iV: $futureworkz$elm_autocomplete$Internal$DebounceMsg
			},
			aw: $jinjor$elm_debounce$Debounce$init,
			bI: fetcher,
			cw: initChoices.cw,
			a9: $elm$core$Maybe$Nothing,
			b6: initChoices.b6,
			ij: $elm$core$Maybe$Nothing,
			aT: $futureworkz$elm_autocomplete$Autocomplete$NotFetched
		};
	});
var $author$project$Model$AuditLog$initialModel = F3(
	function (appModel, token, profile) {
		var model = {
			N: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			gR: _List_Nil,
			P: A2(
				$futureworkz$elm_autocomplete$Autocomplete$init,
				{bC: _List_Nil, cw: _List_Nil, b6: ''},
				$author$project$Model$AuditLog$apiCalledFetcher(token)),
			d8: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			a1: $author$project$Data$DataStatus$Init,
			eV: 20,
			fo: 0,
			fr: $author$project$Data$AuditLog$ID(true),
			ic: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			fU: '',
			be: $author$project$Ext$Debounce$debounceInit,
			f_: $elm$core$Maybe$Nothing,
			gc: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			cQ: $author$project$Data$DataStatus$Downloading,
			V: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			iz: _List_Nil,
			iR: 0
		};
		var _v0 = function () {
			if (!profile.$) {
				return _Utils_Tuple2(
					$elm$core$Platform$Cmd$none,
					$author$project$Model$AuditLog$getAdminsCmd(token));
			} else {
				return _Utils_Tuple2(
					$author$project$Model$AuditLog$getSuperAdminsCmd(token),
					$author$project$Model$AuditLog$getAdminsCmd(token));
			}
		}();
		var superAdminCmd = _v0.a;
		var adminCmd = _v0.b;
		var cmd = _Utils_eq(appModel.cM, $author$project$Data$Route$AuditLogRoute) ? $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					superAdminCmd,
					adminCmd,
					A2($author$project$Model$AuditLog$getAuditLogCmd, model, token)
				])) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(model, cmd);
	});
var $author$project$Type$BotDetail$OnGetBotResult = function (a) {
	return {$: 9, a: a};
};
var $author$project$Data$Bot$Bot = F7(
	function (id, tenantID, languageCode, name, host, nodeJson, isPublished) {
		return {et: host, eu: id, eJ: isPublished, eT: languageCode, fg: name, fl: nodeJson, gm: tenantID};
	});
var $author$project$Data$Bot$ApiNode = F3(
	function (kind, data, children) {
		return {bB: children, dP: data, eR: kind};
	});
var $author$project$Data$Bot$Children = $elm$core$Basics$identity;
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $author$project$Data$Bot$Text = 0;
var $author$project$Data$Bot$nodeKindDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		if (s === 'Text') {
			return $elm$json$Json$Decode$succeed(0);
		} else {
			return $elm$json$Json$Decode$fail('Invalid node kind: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
function $author$project$Data$Bot$cyclic$apiNodeDecoder() {
	return A4(
		$elm$json$Json$Decode$map3,
		$author$project$Data$Bot$ApiNode,
		A2($elm$json$Json$Decode$field, 'kind', $author$project$Data$Bot$nodeKindDecoder),
		A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value),
		A2(
			$elm$json$Json$Decode$field,
			'children',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Basics$identity,
				$elm$json$Json$Decode$list(
					$elm$json$Json$Decode$lazy(
						function (_v0) {
							return $author$project$Data$Bot$cyclic$apiNodeDecoder();
						})))));
}
var $author$project$Data$Bot$apiNodeDecoder = $author$project$Data$Bot$cyclic$apiNodeDecoder();
$author$project$Data$Bot$cyclic$apiNodeDecoder = function () {
	return $author$project$Data$Bot$apiNodeDecoder;
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$Api$Decoder$bot = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Data$Bot$Bot,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'tenantID', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'languageCode', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'host', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'nodeJson', $author$project$Data$Bot$apiNodeDecoder),
	A2($elm$json$Json$Decode$field, 'isPublished', $elm$json$Json$Decode$bool));
var $author$project$Api$BotDetail$BotNotFound = 2;
var $author$project$Api$BotDetail$InvalidParams = 0;
var $author$project$Api$BotDetail$InvalidTenant = 1;
var $author$project$Api$BotDetail$MissingError = 3;
var $author$project$Api$BotDetail$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$3:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidTenant':
					return 1;
				case 'BotNotFound':
					return 2;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 3;
};
var $author$project$Api$BotDetail$exec = F2(
	function (id, token) {
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$BotDetail$toErrorCode,
			A2($elm$json$Json$Decode$field, 'bot', $author$project$Api$Decoder$bot));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(id))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'bot/detail', ia: resolver, iQ: token});
	});
var $author$project$Model$BotDetail$getBotCmd = F2(
	function (id, token) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotDetail),
				$author$project$Type$BotDetail$OnGetBotResult),
			A2($author$project$Api$BotDetail$exec, id, token));
	});
var $author$project$Type$BotDetail$OnGetTenantResult = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$BotDetail$getTenantCmd = F2(
	function (id, token) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotDetail),
				$author$project$Type$BotDetail$OnGetTenantResult),
			A2(
				$author$project$Api$TenantDetail$exec,
				{eu: id},
				token));
	});
var $author$project$Type$BotDetail$OnGetTenantsResult = function (a) {
	return {$: 7, a: a};
};
var $author$project$Data$Tenant$ListResponse = F2(
	function (tenants, total) {
		return {iM: tenants, iR: total};
	});
var $author$project$Api$Decoder$tenantList = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Tenant$ListResponse,
	A2(
		$elm$json$Json$Decode$field,
		'tenants',
		$elm$json$Json$Decode$list($author$project$Api$Decoder$tenant)),
	A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
var $author$project$Api$TenantList$InvalidLimit = 1;
var $author$project$Api$TenantList$InvalidOffset = 2;
var $author$project$Api$TenantList$InvalidParams = 0;
var $author$project$Api$TenantList$MissingError = 3;
var $author$project$Api$TenantList$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$3:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidLimit':
					return 1;
				case 'InvalidOffset':
					return 2;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 3;
};
var $author$project$Api$TenantList$exec = F2(
	function (_v0, token) {
		var search = _v0.fU;
		var limit = _v0.eV;
		var offset = _v0.fo;
		var resolver = A2($author$project$Api$Base$standardResolver, $author$project$Api$TenantList$toErrorCode, $author$project$Api$Decoder$tenantList);
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'search',
					$elm$json$Json$Encode$string(search)),
					_Utils_Tuple2(
					'limit',
					$elm$json$Json$Encode$int(limit)),
					_Utils_Tuple2(
					'offset',
					$elm$json$Json$Encode$int(offset))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'tenant/list', ia: resolver, iQ: token});
	});
var $author$project$Model$BotDetail$getTenantsCmd = function (token) {
	return A2(
		$elm$core$Task$attempt,
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotDetail),
			$author$project$Type$BotDetail$OnGetTenantsResult),
		A2(
			$author$project$Api$TenantList$exec,
			{eV: 100000, fo: 0, fU: ''},
			token));
};
var $author$project$Model$BotDetail$initialModel = F3(
	function (appModel, token, profile) {
		var tenantID_ = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$fromInt,
				$author$project$Data$Role$getTenantID(profile)));
		var _v0 = function () {
			var _v1 = appModel.cM;
			if (_v1.$ === 14) {
				var botID = _v1.a;
				if (!profile.$) {
					var tenantID = profile.a.gm;
					return _Utils_Tuple2(
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Model$BotDetail$getBotCmd, botID, token),
									A2($author$project$Model$BotDetail$getTenantCmd, tenantID, token)
								])),
						$author$project$Data$DataStatus$Downloaded(_List_Nil));
				} else {
					return _Utils_Tuple2(
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Model$BotDetail$getBotCmd, botID, token),
									$author$project$Model$BotDetail$getTenantsCmd(token)
								])),
						$author$project$Data$DataStatus$Init);
				}
			} else {
				return _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$Data$DataStatus$Init);
			}
		}();
		var cmd = _v0.a;
		var tenants_ = _v0.b;
		return _Utils_Tuple2(
			{
				j: $author$project$Data$DataStatus$Init,
				k: {
					a_: $elm$core$Maybe$Nothing,
					a$: _List_Nil,
					eR: {
						bH: $elm$core$Maybe$Nothing,
						gD: _List_fromArray(
							[$author$project$Data$Form$isNotEmpty]),
						i3: ''
					},
					hH: {
						bH: $elm$core$Maybe$Nothing,
						gD: _List_fromArray(
							[$author$project$Data$Form$isNotEmpty]),
						i3: ''
					},
					al: false,
					b_: false,
					h3: _List_Nil
				},
				J: 0,
				et: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$isNotEmpty]),
					i3: ''
				},
				eJ: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$isNotEmpty]),
					i3: ''
				},
				eT: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$isNotEmpty]),
					i3: ''
				},
				fg: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$isNotEmpty]),
					i3: ''
				},
				cE: false,
				ae: {
					hH: {
						bH: $elm$core$Maybe$Nothing,
						gD: _List_fromArray(
							[$author$project$Data$Form$isNotEmpty]),
						i3: ''
					},
					al: false
				},
				fU: '',
				gm: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$isNotEmpty]),
					i3: tenantID_
				},
				iM: tenants_
			},
			cmd);
	});
var $author$project$Type$OnBotList = function (a) {
	return {$: 8, a: a};
};
var $author$project$Type$BotList$OnGetBotsResult = function (a) {
	return {$: 14, a: a};
};
var $author$project$Data$Bot$ListResponse = F2(
	function (bots, total) {
		return {g2: bots, iR: total};
	});
var $author$project$Api$Decoder$botList = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Bot$ListResponse,
	A2(
		$elm$json$Json$Decode$field,
		'bots',
		$elm$json$Json$Decode$list($author$project$Api$Decoder$bot)),
	A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
var $author$project$Api$BotList$CannotGetBot = 3;
var $author$project$Api$BotList$InvalidLimit = 1;
var $author$project$Api$BotList$InvalidOffset = 2;
var $author$project$Api$BotList$InvalidParams = 0;
var $author$project$Api$BotList$MissingError = 4;
var $author$project$Api$BotList$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$4:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidLimit':
					return 1;
				case 'InvalidOffset':
					return 2;
				case 'CannotGetBot':
					return 3;
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return 4;
};
var $author$project$Api$BotList$exec = F2(
	function (_v0, token) {
		var search = _v0.fU;
		var tenantID = _v0.gm;
		var languageCode = _v0.eT;
		var limit = _v0.eV;
		var offset = _v0.fo;
		var resolver = A2($author$project$Api$Base$standardResolver, $author$project$Api$BotList$toErrorCode, $author$project$Api$Decoder$botList);
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'search',
					$elm$json$Json$Encode$string(search)),
					_Utils_Tuple2(
					'tenantID',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, tenantID))),
					_Utils_Tuple2(
					'languageCode',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, languageCode))),
					_Utils_Tuple2(
					'limit',
					$elm$json$Json$Encode$int(limit)),
					_Utils_Tuple2(
					'offset',
					$elm$json$Json$Encode$int(offset))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'bot/list', ia: resolver, iQ: token});
	});
var $author$project$Model$BotList$getBotsCmd = F2(
	function (_v0, token) {
		var offset = _v0.fo;
		var limit = _v0.eV;
		var search = _v0.fU;
		var tenantID = _v0.gm;
		var languageCode = _v0.eT;
		var languageMaybe = (languageCode.i3 === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(languageCode.i3);
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotList),
				$author$project$Type$BotList$OnGetBotsResult),
			A2(
				$author$project$Api$BotList$exec,
				{
					eT: languageMaybe,
					eV: limit,
					fo: offset * limit,
					fU: search,
					gm: $elm$core$String$toInt(tenantID.i3)
				},
				token));
	});
var $author$project$Type$BotList$OnGetTenantResult = function (a) {
	return {$: 16, a: a};
};
var $author$project$Model$BotList$getTenantCmd = F2(
	function (id, token) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotList),
				$author$project$Type$BotList$OnGetTenantResult),
			A2(
				$author$project$Api$TenantDetail$exec,
				{eu: id},
				token));
	});
var $author$project$Type$BotList$OnGetTenantsResult = function (a) {
	return {$: 15, a: a};
};
var $author$project$Model$BotList$getTenantsCmd = function (token) {
	return A2(
		$elm$core$Task$attempt,
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotList),
			$author$project$Type$BotList$OnGetTenantsResult),
		A2($author$project$Api$Options$exec, $author$project$Api$Options$Tenant, token));
};
var $author$project$Model$BotList$initialModel = F3(
	function (appModel, token, profile) {
		var tenantCmd = function () {
			if (!profile.$) {
				var tenantID = profile.a.gm;
				return A2($author$project$Model$BotList$getTenantCmd, tenantID, token);
			} else {
				return $author$project$Model$BotList$getTenantsCmd(token);
			}
		}();
		var model = {
			F: _List_Nil,
			t: {
				cq: $elm$core$Maybe$Nothing,
				et: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$isNotEmpty]),
					i3: ''
				},
				eT: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$isNotEmpty]),
					i3: ''
				},
				fg: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$isNotEmpty]),
					i3: ''
				},
				cQ: 0,
				gm: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$isNotEmpty]),
					i3: ''
				}
			},
			cy: false,
			bQ: false,
			eT: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			eV: 20,
			fo: 0,
			fU: '',
			be: $author$project$Ext$Debounce$debounceInit,
			bg: 0,
			fZ: $elm$core$Maybe$Nothing,
			cQ: $author$project$Data$DataStatus$Init,
			gm: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			iM: _List_Nil,
			iR: 0
		};
		var cmd = _Utils_eq(appModel.cM, $author$project$Data$Route$BotsRoute) ? $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Model$BotList$getBotsCmd, model, token),
					tenantCmd
				])) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(model, cmd);
	});
var $author$project$Data$BotLog$ID = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$BotLogEmailSearch$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Cannot find any matched session ID';
		default:
			return 'Missing error code';
	}
};
var $author$project$Api$BotLogEmailSearch$Response = function (emailList) {
	return {d5: emailList};
};
var $author$project$Api$BotLogEmailSearch$decoder = A2(
	$elm$json$Json$Decode$map,
	function (_v0) {
		var emailList = _v0.d5;
		return emailList;
	},
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Api$BotLogEmailSearch$Response,
		A2(
			$elm$json$Json$Decode$field,
			'emailList',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
var $author$project$Api$BotLogEmailSearch$CannotMatch = 1;
var $author$project$Api$BotLogEmailSearch$InvalidParams = 0;
var $author$project$Api$BotLogEmailSearch$MissingError = 2;
var $author$project$Api$BotLogEmailSearch$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'CannotMatch':
					return 1;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 2;
};
var $author$project$Api$BotLogEmailSearch$exec = F2(
	function (emailLike, token) {
		var resolver = A2($author$project$Api$Base$standardResolver, $author$project$Api$BotLogEmailSearch$toErrorCode, $author$project$Api$BotLogEmailSearch$decoder);
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'emailLike',
					$elm$json$Json$Encode$string(emailLike))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'bot/logs-email-search', ia: resolver, iQ: token});
	});
var $author$project$Model$BotLog$emailFetcher = F2(
	function (token, lastChoices) {
		return A2(
			$elm$core$Task$map,
			function (sessionIDs) {
				return _Utils_update(
					lastChoices,
					{bC: sessionIDs});
			},
			A2(
				$elm$core$Task$mapError,
				$author$project$Data$Message$apiErrorCodeString($author$project$Api$BotLogEmailSearch$errorCodeString),
				A2($author$project$Api$BotLogEmailSearch$exec, lastChoices.b6, token)));
	});
var $author$project$Api$Options$Bot = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Type$OnBotLog = function (a) {
	return {$: 10, a: a};
};
var $author$project$Type$BotLog$OnGetBotsResult = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$BotLog$getBotsCmd = F2(
	function (_v0, token) {
		var tenantID = _v0.gm;
		var languageCode = _v0.eT;
		var languageCode_ = (languageCode.i3 === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(languageCode.i3);
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotLog),
				$author$project$Type$BotLog$OnGetBotsResult),
			A2(
				$author$project$Api$Options$exec,
				A2(
					$author$project$Api$Options$Bot,
					$elm$core$String$toInt(tenantID.i3),
					languageCode_),
				token));
	});
var $author$project$Type$BotLog$OnGetLogsResult = function (a) {
	return {$: 10, a: a};
};
var $author$project$Data$BotLog$ListResponse = F2(
	function (botLogs, total) {
		return {dl: botLogs, iR: total};
	});
var $author$project$Data$BotLog$BotLog = F5(
	function (id, botID, sessionID, kind, createdAt) {
		return {di: botID, hc: createdAt, eu: id, eR: kind, f1: sessionID};
	});
var $author$project$Data$BotLog$Branch = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$BotLog$Form = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$BotLog$Text = {$: 0};
var $author$project$Data$BotLog$FormData = F2(
	function (id, fields) {
		return {eg: fields, eu: id};
	});
var $author$project$Data$BotLog$formDataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$BotLog$FormData,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'fields', $elm$json$Json$Decode$value));
var $author$project$Data$BotLog$RawBotLogKind = F2(
	function (t, c) {
		return {dr: c, cb: t};
	});
var $author$project$Data$BotLog$rawBotLogKindDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$BotLog$RawBotLogKind,
	A2($elm$json$Json$Decode$field, 't', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'c', $elm$json$Json$Decode$value));
var $author$project$Data$BotLog$RawTextKind = function (t) {
	return {cb: t};
};
var $author$project$Data$BotLog$rawTextKind = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$BotLog$RawTextKind,
	A2($elm$json$Json$Decode$field, 't', $elm$json$Json$Decode$string));
var $author$project$Data$BotLog$logKindDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (_v0) {
				var t = _v0.cb;
				if (t === 'Text') {
					return $elm$json$Json$Decode$succeed($author$project$Data$BotLog$Text);
				} else {
					return $elm$json$Json$Decode$fail('Invalid bot log kind: ' + t);
				}
			},
			$author$project$Data$BotLog$rawTextKind),
			A2(
			$elm$json$Json$Decode$andThen,
			function (_v2) {
				var t = _v2.cb;
				var c = _v2.dr;
				switch (t) {
					case 'Branch':
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Invalid bot log kind: ' + t),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Data$BotLog$Branch),
								$elm$core$Result$toMaybe(
									A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, c))));
					case 'Form':
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Invalid bot log kind: ' + t),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Data$BotLog$Form),
								$elm$core$Result$toMaybe(
									A2($elm$json$Json$Decode$decodeValue, $author$project$Data$BotLog$formDataDecoder, c))));
					default:
						return $elm$json$Json$Decode$fail('Invalid bot log kind: ' + t);
				}
			},
			$author$project$Data$BotLog$rawBotLogKindDecoder)
		]));
var $author$project$Api$Decoder$botLog = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Data$BotLog$BotLog,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'botID', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'sessionID', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'kind', $author$project$Data$BotLog$logKindDecoder),
	A2($elm$json$Json$Decode$field, 'createdAt', $author$project$Data$Decode$decodeTime));
var $author$project$Api$Decoder$botLogList = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$BotLog$ListResponse,
	A2(
		$elm$json$Json$Decode$field,
		'botLogs',
		$elm$json$Json$Decode$list($author$project$Api$Decoder$botLog)),
	A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
var $author$project$Api$Encoder$botLogOrderBy = function (role) {
	switch (role.$) {
		case 0:
			var asc = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('ID')),
						_Utils_Tuple2(
						'asc',
						$elm$json$Json$Encode$bool(asc))
					]));
		case 1:
			var asc = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('BotID')),
						_Utils_Tuple2(
						'asc',
						$elm$json$Json$Encode$bool(asc))
					]));
		case 2:
			var asc = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('SessionID')),
						_Utils_Tuple2(
						'asc',
						$elm$json$Json$Encode$bool(asc))
					]));
		case 3:
			var asc = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('Kind')),
						_Utils_Tuple2(
						'asc',
						$elm$json$Json$Encode$bool(asc))
					]));
		default:
			var asc = role.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'kind',
						$elm$json$Json$Encode$string('CreatedAt')),
						_Utils_Tuple2(
						'asc',
						$elm$json$Json$Encode$bool(asc))
					]));
	}
};
var $author$project$Api$BotLog$CannotGetCount = 4;
var $author$project$Api$BotLog$InvalidLimit = 2;
var $author$project$Api$BotLog$InvalidOffset = 3;
var $author$project$Api$BotLog$InvalidParams = 0;
var $author$project$Api$BotLog$MissingError = 1;
var $author$project$Api$BotLog$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$4:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidLimit':
					return 2;
				case 'InvalidOffset':
					return 3;
				case 'CannotGetCount':
					return 4;
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return 1;
};
var $author$project$Api$BotLog$exec = F2(
	function (_v0, token) {
		var tenantID = _v0.gm;
		var languageCode = _v0.eT;
		var sessionID = _v0.f1;
		var botID = _v0.di;
		var email = _v0.d4;
		var startTime = _v0.gc;
		var endTime = _v0.d8;
		var limit = _v0.eV;
		var offset = _v0.fo;
		var orderBy = _v0.fr;
		var resolver = A2($author$project$Api$Base$standardResolver, $author$project$Api$BotLog$toErrorCode, $author$project$Api$Decoder$botLogList);
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tenantID',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, tenantID))),
					_Utils_Tuple2(
					'languageCode',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, languageCode))),
					_Utils_Tuple2(
					'botID',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, botID))),
					_Utils_Tuple2(
					'email',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, email))),
					_Utils_Tuple2(
					'sessionID',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, sessionID))),
					_Utils_Tuple2(
					'startTime',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Encode$int),
							startTime))),
					_Utils_Tuple2(
					'endTime',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Encode$int),
							endTime))),
					_Utils_Tuple2(
					'limit',
					$elm$json$Json$Encode$int(limit)),
					_Utils_Tuple2(
					'offset',
					$elm$json$Json$Encode$int(offset)),
					_Utils_Tuple2(
					'orderBy',
					$author$project$Api$Encoder$botLogOrderBy(orderBy))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'bot/logs', ia: resolver, iQ: token});
	});
var $author$project$Model$BotLog$getLogsCmd = F2(
	function (model, token) {
		var _v0 = model;
		var offset = _v0.fo;
		var orderBy = _v0.fr;
		var sessionIDAutocomplete = _v0.U;
		var emailAutocomplete = _v0.R;
		var limit = _v0.eV;
		var tenantID = _v0.gm;
		var languageCode = _v0.eT;
		var botID = _v0.di;
		var startTime = _v0.gc;
		var endTime = _v0.d8;
		var email = $futureworkz$elm_autocomplete$Autocomplete$query(emailAutocomplete);
		var sessionID = $futureworkz$elm_autocomplete$Autocomplete$query(sessionIDAutocomplete);
		var params = {
			di: $elm$core$String$toInt(botID.i3),
			d4: (email === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(email),
			d8: A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$time$Time$posixToMillis,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Basics$add((((24 * 60) * 60) * 1000) - 1),
						$elm$time$Time$millisToPosix)),
				$elm$core$Result$toMaybe(
					$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(endTime.i3))),
			eT: (languageCode.i3 === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(languageCode.i3),
			eV: limit,
			fo: offset * limit,
			fr: orderBy,
			f1: (sessionID === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(sessionID),
			gc: $elm$core$Result$toMaybe(
				$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(startTime.i3)),
			gm: $elm$core$String$toInt(tenantID.i3)
		};
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotLog),
				$author$project$Type$BotLog$OnGetLogsResult),
			A2($author$project$Api$BotLog$exec, params, token));
	});
var $author$project$Type$BotLog$OnGetTenantResult = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$BotLog$getTenantCmd = F2(
	function (id, token) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotLog),
				$author$project$Type$BotLog$OnGetTenantResult),
			A2(
				$author$project$Api$TenantDetail$exec,
				{eu: id},
				token));
	});
var $author$project$Type$BotLog$OnGetTenantsResult = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$BotLog$getTenantsCmd = function (token) {
	return A2(
		$elm$core$Task$attempt,
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotLog),
			$author$project$Type$BotLog$OnGetTenantsResult),
		A2($author$project$Api$Options$exec, $author$project$Api$Options$Tenant, token));
};
var $author$project$Api$BotLogSessionIDSearch$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Cannot find any matched session ID';
		default:
			return 'Missing error code';
	}
};
var $author$project$Api$BotLogSessionIDSearch$Response = function (sessionIDList) {
	return {f2: sessionIDList};
};
var $author$project$Api$BotLogSessionIDSearch$decoder = A2(
	$elm$json$Json$Decode$map,
	function (_v0) {
		var sessionIDList = _v0.f2;
		return sessionIDList;
	},
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Api$BotLogSessionIDSearch$Response,
		A2(
			$elm$json$Json$Decode$field,
			'sessionIDList',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
var $author$project$Api$BotLogSessionIDSearch$CannotMatch = 1;
var $author$project$Api$BotLogSessionIDSearch$InvalidParams = 0;
var $author$project$Api$BotLogSessionIDSearch$MissingError = 2;
var $author$project$Api$BotLogSessionIDSearch$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'CannotMatch':
					return 1;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 2;
};
var $author$project$Api$BotLogSessionIDSearch$exec = F2(
	function (sessionIDLike, token) {
		var resolver = A2($author$project$Api$Base$standardResolver, $author$project$Api$BotLogSessionIDSearch$toErrorCode, $author$project$Api$BotLogSessionIDSearch$decoder);
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sessionIDLike',
					$elm$json$Json$Encode$string(sessionIDLike))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'bot/logs-session-search', ia: resolver, iQ: token});
	});
var $author$project$Model$BotLog$sessionIDFetcher = F2(
	function (token, lastChoices) {
		return A2(
			$elm$core$Task$map,
			function (sessionIDs) {
				return _Utils_update(
					lastChoices,
					{bC: sessionIDs});
			},
			A2(
				$elm$core$Task$mapError,
				$author$project$Data$Message$apiErrorCodeString($author$project$Api$BotLogSessionIDSearch$errorCodeString),
				A2($author$project$Api$BotLogSessionIDSearch$exec, lastChoices.b6, token)));
	});
var $author$project$Model$BotLog$initialModel = F3(
	function (appModel, token, profile) {
		var tenantCmd = function () {
			if (!profile.$) {
				var tenantID = profile.a.gm;
				return A2($author$project$Model$BotLog$getTenantCmd, tenantID, token);
			} else {
				return $author$project$Model$BotLog$getTenantsCmd(token);
			}
		}();
		var model = {
			di: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			cg: $elm$core$Dict$empty,
			aZ: $author$project$Data$DataStatus$Init,
			g2: _List_Nil,
			dN: $elm$core$Maybe$Nothing,
			R: A2(
				$futureworkz$elm_autocomplete$Autocomplete$init,
				{bC: _List_Nil, cw: _List_Nil, b6: ''},
				$author$project$Model$BotLog$emailFetcher(token)),
			d8: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			a1: $author$project$Data$DataStatus$Init,
			eT: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			eV: 20,
			fo: 0,
			fr: $author$project$Data$BotLog$ID(true),
			U: A2(
				$futureworkz$elm_autocomplete$Autocomplete$init,
				{bC: _List_Nil, cw: _List_Nil, b6: ''},
				$author$project$Model$BotLog$sessionIDFetcher(token)),
			cO: false,
			gc: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			cQ: $author$project$Data$DataStatus$Init,
			gm: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			iM: _List_Nil,
			iR: 0
		};
		var cmd = _Utils_eq(appModel.cM, $author$project$Data$Route$BotLogRoute) ? $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Model$BotLog$getLogsCmd, model, token),
					tenantCmd,
					A2($author$project$Model$BotLog$getBotsCmd, model, token)
				])) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(model, cmd);
	});
var $author$project$Type$OnBotReport = function (a) {
	return {$: 11, a: a};
};
var $author$project$Type$BotReport$OnGetBotsResult = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$BotReport$getBotsCmd = F3(
	function (tenantID, languageCode, token) {
		var languageCode_ = (languageCode === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(languageCode);
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotReport),
				$author$project$Type$BotReport$OnGetBotsResult),
			A2(
				$author$project$Api$Options$exec,
				A2(
					$author$project$Api$Options$Bot,
					$elm$core$String$toInt(tenantID),
					languageCode_),
				token));
	});
var $author$project$Type$BotReport$OnGetReportsResult = function (a) {
	return {$: 9, a: a};
};
var $author$project$Data$BotReportDay$ListResponse = F2(
	function (rows, total) {
		return {ie: rows, iR: total};
	});
var $author$project$Data$BotReportDay$BotReportDay = F4(
	function (day, totalUsers, totalBranches, totalText) {
		return {he: day, iS: totalBranches, iT: totalText, iU: totalUsers};
	});
var $author$project$Api$Decoder$botReportDay = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Data$BotReportDay$BotReportDay,
	A2($elm$json$Json$Decode$field, 'day', $author$project$Data$Decode$decodeTime),
	A2($elm$json$Json$Decode$field, 'totalUsers', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'totalBranches', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'totalText', $elm$json$Json$Decode$int));
var $author$project$Api$Decoder$botReportDayList = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$BotReportDay$ListResponse,
	A2(
		$elm$json$Json$Decode$field,
		'rows',
		$elm$json$Json$Decode$list($author$project$Api$Decoder$botReportDay)),
	A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
var $author$project$Api$BotReportDay$CannotGetAdmin = 2;
var $author$project$Api$BotReportDay$InvalidLimit = 1;
var $author$project$Api$BotReportDay$InvalidParams = 0;
var $author$project$Api$BotReportDay$MissingError = 3;
var $author$project$Api$BotReportDay$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$3:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidLimit':
					return 1;
				case 'CannotGetAdmin':
					return 2;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 3;
};
var $author$project$Api$BotReportDay$exec = F2(
	function (_v0, token) {
		var botID = _v0.di;
		var startTime = _v0.gc;
		var endTime = _v0.d8;
		var limit = _v0.eV;
		var offset = _v0.fo;
		var resolver = A2($author$project$Api$Base$standardResolver, $author$project$Api$BotReportDay$toErrorCode, $author$project$Api$Decoder$botReportDayList);
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'botID',
					$elm$json$Json$Encode$int(botID)),
					_Utils_Tuple2(
					'startTime',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Encode$int),
							startTime))),
					_Utils_Tuple2(
					'endTime',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Encode$int),
							endTime))),
					_Utils_Tuple2(
					'limit',
					$elm$json$Json$Encode$int(limit)),
					_Utils_Tuple2(
					'offset',
					$elm$json$Json$Encode$int(offset))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'report/day', ia: resolver, iQ: token});
	});
var $author$project$Model$BotReport$getReportsCmd = F2(
	function (model, token) {
		var _v0 = $elm$core$String$toInt(model.di.i3);
		if (!_v0.$) {
			var botID_ = _v0.a;
			var _v1 = model;
			var offset = _v1.fo;
			var limit = _v1.eV;
			var startTime = _v1.gc;
			var endTime = _v1.d8;
			var params = {
				di: botID_,
				d8: A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$time$Time$posixToMillis,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Basics$add((((24 * 60) * 60) * 1000) - 1),
							$elm$time$Time$millisToPosix)),
					$elm$core$Result$toMaybe(
						$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(endTime.i3))),
				eV: limit,
				fo: offset * limit,
				gc: $elm$core$Result$toMaybe(
					$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(startTime.i3))
			};
			return A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotReport),
					$author$project$Type$BotReport$OnGetReportsResult),
				A2($author$project$Api$BotReportDay$exec, params, token));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Type$BotReport$OnGetTenantResult = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$BotReport$getTenantCmd = F2(
	function (id, token) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotReport),
				$author$project$Type$BotReport$OnGetTenantResult),
			A2(
				$author$project$Api$TenantDetail$exec,
				{eu: id},
				token));
	});
var $author$project$Type$BotReport$OnGetTenantsResult = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$BotReport$getTenantsCmd = function (token) {
	return A2(
		$elm$core$Task$attempt,
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotReport),
			$author$project$Type$BotReport$OnGetTenantsResult),
		A2($author$project$Api$Options$exec, $author$project$Api$Options$Tenant, token));
};
var $author$project$Model$BotReport$initialModel = F3(
	function (appModel, token, profile) {
		var model = {
			di: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			g2: $author$project$Data$DataStatus$Init,
			d8: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			a1: $author$project$Data$DataStatus$Init,
			eT: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			eV: 20,
			fo: 0,
			aI: $author$project$Data$DataStatus$Init,
			gc: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			gm: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: ''},
			iM: $author$project$Data$DataStatus$Init,
			iR: 0
		};
		var _v0 = function () {
			if (!profile.$) {
				var tenantID = profile.a.gm;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iM: $author$project$Data$DataStatus$Downloaded(_List_Nil)
						}),
					A2($author$project$Model$BotReport$getTenantCmd, tenantID, token));
			} else {
				return _Utils_Tuple2(
					model,
					$author$project$Model$BotReport$getTenantsCmd(token));
			}
		}();
		var updatedModel = _v0.a;
		var tenantCmd = _v0.b;
		var cmd = _Utils_eq(appModel.cM, $author$project$Data$Route$BotReportRoute) ? $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Model$BotReport$getReportsCmd, updatedModel, token),
					tenantCmd,
					A3($author$project$Model$BotReport$getBotsCmd, '', '', token)
				])) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(updatedModel, cmd);
	});
var $author$project$Type$OnDashboard = function (a) {
	return {$: 12, a: a};
};
var $author$project$Type$Dashboard$OnGetDashboardResult = $elm$core$Basics$identity;
var $author$project$Data$Dashboard$Dashboard = F6(
	function (superAdmins, admins, tenants, bots, botLogs, users) {
		return {gR: admins, dl: botLogs, g2: bots, iz: superAdmins, iM: tenants, i2: users};
	});
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Api$Decoder$dashboard = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Data$Dashboard$Dashboard,
	A2($elm$json$Json$Decode$field, 'superAdmins', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'admins', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'tenants', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'bots', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'botLogs', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'users', $elm$json$Json$Decode$int));
var $author$project$Api$Dashboard$CannotGetCountAdmins = 2;
var $author$project$Api$Dashboard$CannotGetCountBotLogs = 5;
var $author$project$Api$Dashboard$CannotGetCountBots = 4;
var $author$project$Api$Dashboard$CannotGetCountSuperAdmins = 1;
var $author$project$Api$Dashboard$CannotGetCountTenants = 3;
var $author$project$Api$Dashboard$CannotGetCountUsers = 6;
var $author$project$Api$Dashboard$InvalidParams = 0;
var $author$project$Api$Dashboard$MissingError = 7;
var $author$project$Api$Dashboard$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$7:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'CannotGetCountSuperAdmins':
					return 1;
				case 'CannotGetCountAdmins':
					return 2;
				case 'CannotGetCountTenants':
					return 3;
				case 'CannotGetCountBots':
					return 4;
				case 'CannotGetCountBotLogs':
					return 5;
				case 'CannotGetCountUsers':
					return 6;
				default:
					break _v0$7;
			}
		} else {
			break _v0$7;
		}
	}
	return 7;
};
var $author$project$Api$Dashboard$exec = function (token) {
	var resolver = A2($author$project$Api$Base$standardResolver, $author$project$Api$Dashboard$toErrorCode, $author$project$Api$Decoder$dashboard);
	return $author$project$Api$Base$authCall(
		{
			h2: $elm$json$Json$Encode$object(_List_Nil),
			h3: 'dashboard',
			ia: resolver,
			iQ: token
		});
};
var $author$project$Model$Dashboard$getDashboardCmd = function (token) {
	return A2(
		$elm$core$Task$attempt,
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnDashboard),
			$elm$core$Basics$identity),
		$author$project$Api$Dashboard$exec(token));
};
var $author$project$Model$Dashboard$initialModel = function (token) {
	return _Utils_Tuple2(
		{dP: $author$project$Data$DataStatus$Init},
		$author$project$Model$Dashboard$getDashboardCmd(token));
};
var $author$project$Model$Menu$initialModel = _Utils_Tuple2(
	{eL: false, f3: false},
	$elm$core$Platform$Cmd$none);
var $author$project$Model$Profile$initialModel = F2(
	function (_v0, profile) {
		var _v1 = function () {
			if (profile.$ === 1) {
				var name = profile.a.fg;
				var email = profile.a.d4;
				return _Utils_Tuple2(name, email);
			} else {
				var name = profile.a.fg;
				var email = profile.a.d4;
				return _Utils_Tuple2(name, email);
			}
		}();
		var name_ = _v1.a;
		var email_ = _v1.b;
		return _Utils_Tuple2(
			{
				G: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$validatePassword]),
					i3: ''
				},
				d4: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$validateEmail]),
					i3: email_
				},
				J: 0,
				fg: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$isNotEmpty]),
					i3: name_
				},
				fu: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$validatePassword]),
					i3: ''
				},
				fD: profile
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Type$SuperAdminDetail$OnGetSuperAdminResult = function (a) {
	return {$: 10, a: a};
};
var $author$project$Type$OnSuperAdminDetail = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$SuperAdminDetail$CannotGetSuperAdmin = 1;
var $author$project$Api$SuperAdminDetail$InvalidParams = 0;
var $author$project$Api$SuperAdminDetail$MissingError = 2;
var $author$project$Api$SuperAdminDetail$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'CannotGetSuperAdmin':
					return 1;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 2;
};
var $author$project$Api$SuperAdminDetail$exec = F2(
	function (_v0, token) {
		var id = _v0.eu;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$SuperAdminDetail$toErrorCode,
			A2($elm$json$Json$Decode$field, 'superAdmin', $author$project$Api$Decoder$superAdmin));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(id))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'super-admin/detail', ia: resolver, iQ: token});
	});
var $author$project$Model$SuperAdminDetail$getSuperAdminCmd = F2(
	function (id, token) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnSuperAdminDetail),
				$author$project$Type$SuperAdminDetail$OnGetSuperAdminResult),
			A2(
				$author$project$Api$SuperAdminDetail$exec,
				{eu: id},
				token));
	});
var $author$project$Model$SuperAdminDetail$initialModel = F2(
	function (appModel, token) {
		var _v0 = appModel;
		var route = _v0.cM;
		var cmd = function () {
			if (route.$ === 9) {
				var superAdminID = route.a;
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($author$project$Model$SuperAdminDetail$getSuperAdminCmd, superAdminID, token)
						]));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple2(
			{
				G: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$validatePassword]),
					i3: ''
				},
				d4: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$validateEmail]),
					i3: ''
				},
				J: 0,
				fg: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$isNotEmpty]),
					i3: ''
				},
				fu: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$validatePassword]),
					i3: ''
				},
				iw: $author$project$Data$DataStatus$Init
			},
			cmd);
	});
var $author$project$Type$SuperAdminList$OnGetSuperAdminsResult = function (a) {
	return {$: 12, a: a};
};
var $author$project$Type$OnSuperAdminList = function (a) {
	return {$: 4, a: a};
};
var $author$project$Data$SuperAdmin$ListResponse = F2(
	function (superAdmins, total) {
		return {iz: superAdmins, iR: total};
	});
var $author$project$Api$Decoder$superAdminList = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$SuperAdmin$ListResponse,
	A2(
		$elm$json$Json$Decode$field,
		'superAdmins',
		$elm$json$Json$Decode$list($author$project$Api$Decoder$superAdmin)),
	A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int));
var $author$project$Api$SuperAdminList$InvalidLimit = 1;
var $author$project$Api$SuperAdminList$InvalidOffset = 2;
var $author$project$Api$SuperAdminList$InvalidParams = 0;
var $author$project$Api$SuperAdminList$MissingError = 3;
var $author$project$Api$SuperAdminList$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$3:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidLimit':
					return 1;
				case 'InvalidOffset':
					return 2;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 3;
};
var $author$project$Api$SuperAdminList$exec = F2(
	function (_v0, token) {
		var search = _v0.fU;
		var offset = _v0.fo;
		var limit = _v0.eV;
		var resolver = A2($author$project$Api$Base$standardResolver, $author$project$Api$SuperAdminList$toErrorCode, $author$project$Api$Decoder$superAdminList);
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'search',
					$elm$json$Json$Encode$string(search)),
					_Utils_Tuple2(
					'offset',
					$elm$json$Json$Encode$int(offset)),
					_Utils_Tuple2(
					'limit',
					$elm$json$Json$Encode$int(limit))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'super-admin/list', ia: resolver, iQ: token});
	});
var $author$project$Model$SuperAdminList$getSuperAdminsCmd = F2(
	function (_v0, token) {
		var search = _v0.fU;
		var offset = _v0.fo;
		var limit = _v0.eV;
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnSuperAdminList),
				$author$project$Type$SuperAdminList$OnGetSuperAdminsResult),
			A2(
				$author$project$Api$SuperAdminList$exec,
				{eV: limit, fo: offset * limit, fU: search},
				token));
	});
var $author$project$Model$SuperAdminList$initialModel = F2(
	function (appModel, token) {
		var cmd = _Utils_eq(appModel.cM, $author$project$Data$Route$SuperAdminsRoute) ? A2(
			$author$project$Model$SuperAdminList$getSuperAdminsCmd,
			{eV: 20, fo: 0, fU: ''},
			token) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(
			{F: _List_Nil, bQ: false, eV: 20, fo: 0, fU: '', be: $author$project$Ext$Debounce$debounceInit, bh: 0, cQ: $author$project$Data$DataStatus$Init, iR: 0},
			cmd);
	});
var $author$project$Type$TenantDetail$OnGetTenantResult = function (a) {
	return {$: 7, a: a};
};
var $author$project$Type$OnTenantDetail = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$TenantDetail$getTenantCmd = F2(
	function (id, token) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnTenantDetail),
				$author$project$Type$TenantDetail$OnGetTenantResult),
			A2(
				$author$project$Api$TenantDetail$exec,
				{eu: id},
				token));
	});
var $author$project$Data$Form$InvalidPositiveNumber = 7;
var $author$project$Data$Form$validateIsPositiveNumeric = function (value) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Result$Err(7),
		A2(
			$elm$core$Maybe$map,
			function (numb) {
				return (numb > 0) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(7);
			},
			$elm$core$String$toInt(value)));
};
var $author$project$Model$TenantDetail$initialModel = F2(
	function (appModel, token) {
		var _v0 = appModel;
		var route = _v0.cM;
		var cmd = function () {
			if (route.$ === 12) {
				var tenantID = route.a;
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($author$project$Model$TenantDetail$getTenantCmd, tenantID, token)
						]));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple2(
			{
				J: 0,
				e0: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$validateIsPositiveNumeric]),
					i3: ''
				},
				e1: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$validateIsPositiveNumeric]),
					i3: ''
				},
				fg: {
					bH: $elm$core$Maybe$Nothing,
					gD: _List_fromArray(
						[$author$project$Data$Form$isNotEmpty]),
					i3: ''
				},
				bm: $author$project$Data$DataStatus$Init
			},
			cmd);
	});
var $author$project$Type$TenantList$OnGetTenantsResult = function (a) {
	return {$: 12, a: a};
};
var $author$project$Type$OnTenantList = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$TenantList$getTenantsCmd = F2(
	function (_v0, token) {
		var offset = _v0.fo;
		var search = _v0.fU;
		var limit = _v0.eV;
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnTenantList),
				$author$project$Type$TenantList$OnGetTenantsResult),
			A2(
				$author$project$Api$TenantList$exec,
				{eV: limit, fo: offset * limit, fU: search},
				token));
	});
var $author$project$Model$TenantList$initialModel = F2(
	function (appModel, token) {
		var cmd = _Utils_eq(appModel.cM, $author$project$Data$Route$TenantsRoute) ? A2(
			$author$project$Model$TenantList$getTenantsCmd,
			{eV: 20, fo: 0, fU: ''},
			token) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(
			{F: _List_Nil, bQ: false, eV: 20, fo: 0, fU: '', be: $author$project$Ext$Debounce$debounceInit, bi: 0, cQ: $author$project$Data$DataStatus$Init, iR: 0},
			cmd);
	});
var $author$project$Data$Role$roleToString = function (role) {
	if (role === 1) {
		return 'SuperAdmin';
	} else {
		return 'Admin';
	}
};
var $author$project$Port$LocalStorage$setLocalStorage = _Platform_outgoingPort('setLocalStorage', $elm$json$Json$Encode$string);
var $author$project$Port$LocalStorage$saveLocalStorage = function (data) {
	return $author$project$Port$LocalStorage$setLocalStorage(
		A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'token',
						$elm$json$Json$Encode$string(data.iQ)),
						_Utils_Tuple2(
						'role',
						$elm$json$Json$Encode$string(data.ic))
					]))));
};
var $author$project$Model$initialAuthState = F3(
	function (token, profile, model) {
		var _v0 = A2($author$project$Model$TenantList$initialModel, model, token);
		var tenantListModel = _v0.a;
		var tenantListCmd = _v0.b;
		var _v1 = A2($author$project$Model$TenantDetail$initialModel, model, token);
		var tenantDetailModel = _v1.a;
		var tenantDetailCmd = _v1.b;
		var _v2 = A2($author$project$Model$SuperAdminList$initialModel, model, token);
		var superAdminListModel = _v2.a;
		var superAdminListCmd = _v2.b;
		var _v3 = A2($author$project$Model$SuperAdminDetail$initialModel, model, token);
		var superAdminDetailModel = _v3.a;
		var superAdminDetailCmd = _v3.b;
		var _v4 = A2($author$project$Model$Profile$initialModel, model, profile);
		var profileModel = _v4.a;
		var profileCmd = _v4.b;
		var _v5 = $author$project$Model$Menu$initialModel;
		var menuModel = _v5.a;
		var menuCmd = _v5.b;
		var _v6 = $author$project$Model$Dashboard$initialModel(token);
		var dashboardModel = _v6.a;
		var dashboardCmd = _v6.b;
		var _v7 = A3($author$project$Model$BotReport$initialModel, model, token, profile);
		var botReportModel = _v7.a;
		var botReportCmd = _v7.b;
		var _v8 = A3($author$project$Model$BotLog$initialModel, model, token, profile);
		var botLogModel = _v8.a;
		var botLogCmd = _v8.b;
		var _v9 = A3($author$project$Model$BotList$initialModel, model, token, profile);
		var botListModel = _v9.a;
		var botListCmd = _v9.b;
		var _v10 = A3($author$project$Model$BotDetail$initialModel, model, token, profile);
		var botDetailModel = _v10.a;
		var botDetailCmd = _v10.b;
		var _v11 = A3($author$project$Model$AuditLog$initialModel, model, token, profile);
		var auditLogModel = _v11.a;
		var auditLogCmd = _v11.b;
		var _v12 = A3($author$project$Model$AdminList$initialModel, model, token, profile);
		var adminListModel = _v12.a;
		var adminListCmd = _v12.b;
		var _v13 = A3($author$project$Model$AdminDetail$initialModel, model, token, profile);
		var adminDetailModel = _v13.a;
		var adminDetailCmd = _v13.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					aW: $elm$core$Maybe$Just(
						{
							hS: menuModel,
							h1: {gP: adminDetailModel, gQ: adminListModel, c7: auditLogModel, g0: botDetailModel, g1: botListModel, dk: botLogModel, dm: botReportModel, hd: dashboardModel, fD: profileModel, ix: superAdminDetailModel, iy: superAdminListModel, iK: tenantDetailModel, iL: tenantListModel},
							iQ: token
						}),
					bO: true
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Port$LocalStorage$saveLocalStorage(
						{
							ic: $author$project$Data$Role$roleToString(
								$author$project$Data$Role$getRole(profile)),
							iQ: token
						}),
						profileCmd,
						menuCmd,
						adminListCmd,
						adminDetailCmd,
						superAdminListCmd,
						superAdminDetailCmd,
						tenantListCmd,
						tenantDetailCmd,
						botListCmd,
						botDetailCmd,
						botLogCmd,
						botReportCmd,
						dashboardCmd,
						auditLogCmd
					])));
	});
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Data$Alert$Info = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $truqu$elm_md5$MD5$emptyWords = A2($elm$core$Array$repeat, 16, 0);
var $truqu$elm_md5$MD5$addUnsigned = F2(
	function (x, y) {
		return 4294967295 & (x + y);
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $truqu$elm_md5$MD5$rotateLeft = F2(
	function (bits, input) {
		return (input << bits) | (input >>> (32 - bits));
	});
var $truqu$elm_md5$MD5$cmn = F8(
	function (fun, a, b, c, d, x, s, ac) {
		return A2(
			$truqu$elm_md5$MD5$addUnsigned,
			b,
			A2(
				$truqu$elm_md5$MD5$rotateLeft,
				s,
				A2(
					$truqu$elm_md5$MD5$addUnsigned,
					a,
					A2(
						$truqu$elm_md5$MD5$addUnsigned,
						ac,
						A2(
							$truqu$elm_md5$MD5$addUnsigned,
							A3(fun, b, c, d),
							x)))));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $truqu$elm_md5$MD5$f = F3(
	function (x, y, z) {
		return z ^ (x & (y ^ z));
	});
var $truqu$elm_md5$MD5$ff = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$f, a, b, c, d, x, s, ac);
	});
var $truqu$elm_md5$MD5$g = F3(
	function (x, y, z) {
		return y ^ (z & (x ^ y));
	});
var $truqu$elm_md5$MD5$gg = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$g, a, b, c, d, x, s, ac);
	});
var $truqu$elm_md5$MD5$h = F3(
	function (x, y, z) {
		return z ^ (x ^ y);
	});
var $truqu$elm_md5$MD5$hh = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$h, a, b, c, d, x, s, ac);
	});
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $truqu$elm_md5$MD5$i = F3(
	function (x, y, z) {
		return y ^ (x | (~z));
	});
var $truqu$elm_md5$MD5$ii = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$i, a, b, c, d, x, s, ac);
	});
var $truqu$elm_md5$MD5$hex_ = F2(
	function (xs, acc) {
		var a = acc.bv;
		var b = acc.bx;
		var c = acc.dr;
		var d = acc.bD;
		if ((((((((((((((((xs.b && xs.b.b) && xs.b.b.b) && xs.b.b.b.b) && xs.b.b.b.b.b) && xs.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b) && (!xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b)) {
			var x0 = xs.a;
			var _v1 = xs.b;
			var x1 = _v1.a;
			var _v2 = _v1.b;
			var x2 = _v2.a;
			var _v3 = _v2.b;
			var x3 = _v3.a;
			var _v4 = _v3.b;
			var x4 = _v4.a;
			var _v5 = _v4.b;
			var x5 = _v5.a;
			var _v6 = _v5.b;
			var x6 = _v6.a;
			var _v7 = _v6.b;
			var x7 = _v7.a;
			var _v8 = _v7.b;
			var x8 = _v8.a;
			var _v9 = _v8.b;
			var x9 = _v9.a;
			var _v10 = _v9.b;
			var x10 = _v10.a;
			var _v11 = _v10.b;
			var x11 = _v11.a;
			var _v12 = _v11.b;
			var x12 = _v12.a;
			var _v13 = _v12.b;
			var x13 = _v13.a;
			var _v14 = _v13.b;
			var x14 = _v14.a;
			var _v15 = _v14.b;
			var x15 = _v15.a;
			var s44 = 21;
			var s43 = 15;
			var s42 = 10;
			var s41 = 6;
			var s34 = 23;
			var s33 = 16;
			var s32 = 11;
			var s31 = 4;
			var s24 = 20;
			var s23 = 14;
			var s22 = 9;
			var s21 = 5;
			var s14 = 22;
			var s13 = 17;
			var s12 = 12;
			var s11 = 7;
			var d00 = d;
			var c00 = c;
			var b00 = b;
			var a00 = a;
			var a01 = A7($truqu$elm_md5$MD5$ff, a00, b00, c00, d00, x0, s11, 3614090360);
			var d01 = A7($truqu$elm_md5$MD5$ff, d00, a01, b00, c00, x1, s12, 3905402710);
			var c01 = A7($truqu$elm_md5$MD5$ff, c00, d01, a01, b00, x2, s13, 606105819);
			var b01 = A7($truqu$elm_md5$MD5$ff, b00, c01, d01, a01, x3, s14, 3250441966);
			var a02 = A7($truqu$elm_md5$MD5$ff, a01, b01, c01, d01, x4, s11, 4118548399);
			var d02 = A7($truqu$elm_md5$MD5$ff, d01, a02, b01, c01, x5, s12, 1200080426);
			var c02 = A7($truqu$elm_md5$MD5$ff, c01, d02, a02, b01, x6, s13, 2821735955);
			var b02 = A7($truqu$elm_md5$MD5$ff, b01, c02, d02, a02, x7, s14, 4249261313);
			var a03 = A7($truqu$elm_md5$MD5$ff, a02, b02, c02, d02, x8, s11, 1770035416);
			var d03 = A7($truqu$elm_md5$MD5$ff, d02, a03, b02, c02, x9, s12, 2336552879);
			var c03 = A7($truqu$elm_md5$MD5$ff, c02, d03, a03, b02, x10, s13, 4294925233);
			var b03 = A7($truqu$elm_md5$MD5$ff, b02, c03, d03, a03, x11, s14, 2304563134);
			var a04 = A7($truqu$elm_md5$MD5$ff, a03, b03, c03, d03, x12, s11, 1804603682);
			var d04 = A7($truqu$elm_md5$MD5$ff, d03, a04, b03, c03, x13, s12, 4254626195);
			var c04 = A7($truqu$elm_md5$MD5$ff, c03, d04, a04, b03, x14, s13, 2792965006);
			var b04 = A7($truqu$elm_md5$MD5$ff, b03, c04, d04, a04, x15, s14, 1236535329);
			var a05 = A7($truqu$elm_md5$MD5$gg, a04, b04, c04, d04, x1, s21, 4129170786);
			var d05 = A7($truqu$elm_md5$MD5$gg, d04, a05, b04, c04, x6, s22, 3225465664);
			var c05 = A7($truqu$elm_md5$MD5$gg, c04, d05, a05, b04, x11, s23, 643717713);
			var b05 = A7($truqu$elm_md5$MD5$gg, b04, c05, d05, a05, x0, s24, 3921069994);
			var a06 = A7($truqu$elm_md5$MD5$gg, a05, b05, c05, d05, x5, s21, 3593408605);
			var d06 = A7($truqu$elm_md5$MD5$gg, d05, a06, b05, c05, x10, s22, 38016083);
			var c06 = A7($truqu$elm_md5$MD5$gg, c05, d06, a06, b05, x15, s23, 3634488961);
			var b06 = A7($truqu$elm_md5$MD5$gg, b05, c06, d06, a06, x4, s24, 3889429448);
			var a07 = A7($truqu$elm_md5$MD5$gg, a06, b06, c06, d06, x9, s21, 568446438);
			var d07 = A7($truqu$elm_md5$MD5$gg, d06, a07, b06, c06, x14, s22, 3275163606);
			var c07 = A7($truqu$elm_md5$MD5$gg, c06, d07, a07, b06, x3, s23, 4107603335);
			var b07 = A7($truqu$elm_md5$MD5$gg, b06, c07, d07, a07, x8, s24, 1163531501);
			var a08 = A7($truqu$elm_md5$MD5$gg, a07, b07, c07, d07, x13, s21, 2850285829);
			var d08 = A7($truqu$elm_md5$MD5$gg, d07, a08, b07, c07, x2, s22, 4243563512);
			var c08 = A7($truqu$elm_md5$MD5$gg, c07, d08, a08, b07, x7, s23, 1735328473);
			var b08 = A7($truqu$elm_md5$MD5$gg, b07, c08, d08, a08, x12, s24, 2368359562);
			var a09 = A7($truqu$elm_md5$MD5$hh, a08, b08, c08, d08, x5, s31, 4294588738);
			var d09 = A7($truqu$elm_md5$MD5$hh, d08, a09, b08, c08, x8, s32, 2272392833);
			var c09 = A7($truqu$elm_md5$MD5$hh, c08, d09, a09, b08, x11, s33, 1839030562);
			var b09 = A7($truqu$elm_md5$MD5$hh, b08, c09, d09, a09, x14, s34, 4259657740);
			var a10 = A7($truqu$elm_md5$MD5$hh, a09, b09, c09, d09, x1, s31, 2763975236);
			var d10 = A7($truqu$elm_md5$MD5$hh, d09, a10, b09, c09, x4, s32, 1272893353);
			var c10 = A7($truqu$elm_md5$MD5$hh, c09, d10, a10, b09, x7, s33, 4139469664);
			var b10 = A7($truqu$elm_md5$MD5$hh, b09, c10, d10, a10, x10, s34, 3200236656);
			var a11 = A7($truqu$elm_md5$MD5$hh, a10, b10, c10, d10, x13, s31, 681279174);
			var d11 = A7($truqu$elm_md5$MD5$hh, d10, a11, b10, c10, x0, s32, 3936430074);
			var c11 = A7($truqu$elm_md5$MD5$hh, c10, d11, a11, b10, x3, s33, 3572445317);
			var b11 = A7($truqu$elm_md5$MD5$hh, b10, c11, d11, a11, x6, s34, 76029189);
			var a12 = A7($truqu$elm_md5$MD5$hh, a11, b11, c11, d11, x9, s31, 3654602809);
			var d12 = A7($truqu$elm_md5$MD5$hh, d11, a12, b11, c11, x12, s32, 3873151461);
			var c12 = A7($truqu$elm_md5$MD5$hh, c11, d12, a12, b11, x15, s33, 530742520);
			var b12 = A7($truqu$elm_md5$MD5$hh, b11, c12, d12, a12, x2, s34, 3299628645);
			var a13 = A7($truqu$elm_md5$MD5$ii, a12, b12, c12, d12, x0, s41, 4096336452);
			var d13 = A7($truqu$elm_md5$MD5$ii, d12, a13, b12, c12, x7, s42, 1126891415);
			var c13 = A7($truqu$elm_md5$MD5$ii, c12, d13, a13, b12, x14, s43, 2878612391);
			var b13 = A7($truqu$elm_md5$MD5$ii, b12, c13, d13, a13, x5, s44, 4237533241);
			var a14 = A7($truqu$elm_md5$MD5$ii, a13, b13, c13, d13, x12, s41, 1700485571);
			var d14 = A7($truqu$elm_md5$MD5$ii, d13, a14, b13, c13, x3, s42, 2399980690);
			var c14 = A7($truqu$elm_md5$MD5$ii, c13, d14, a14, b13, x10, s43, 4293915773);
			var b14 = A7($truqu$elm_md5$MD5$ii, b13, c14, d14, a14, x1, s44, 2240044497);
			var a15 = A7($truqu$elm_md5$MD5$ii, a14, b14, c14, d14, x8, s41, 1873313359);
			var d15 = A7($truqu$elm_md5$MD5$ii, d14, a15, b14, c14, x15, s42, 4264355552);
			var c15 = A7($truqu$elm_md5$MD5$ii, c14, d15, a15, b14, x6, s43, 2734768916);
			var b15 = A7($truqu$elm_md5$MD5$ii, b14, c15, d15, a15, x13, s44, 1309151649);
			var a16 = A7($truqu$elm_md5$MD5$ii, a15, b15, c15, d15, x4, s41, 4149444226);
			var d16 = A7($truqu$elm_md5$MD5$ii, d15, a16, b15, c15, x11, s42, 3174756917);
			var c16 = A7($truqu$elm_md5$MD5$ii, c15, d16, a16, b15, x2, s43, 718787259);
			var b16 = A7($truqu$elm_md5$MD5$ii, b15, c16, d16, a16, x9, s44, 3951481745);
			var b17 = A2($truqu$elm_md5$MD5$addUnsigned, b00, b16);
			var c17 = A2($truqu$elm_md5$MD5$addUnsigned, c00, c16);
			var d17 = A2($truqu$elm_md5$MD5$addUnsigned, d00, d16);
			var a17 = A2($truqu$elm_md5$MD5$addUnsigned, a00, a16);
			return {bv: a17, bx: b17, dr: c17, bD: d17};
		} else {
			return acc;
		}
	});
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $truqu$elm_md5$MD5$iget = F2(
	function (index, array) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Array$get, index, array));
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $truqu$elm_md5$MD5$consume = F2(
	function (_char, _v0) {
		var hashState = _v0.a;
		var _v1 = _v0.b;
		var byteCount = _v1.a;
		var words = _v1.b;
		var totalByteCount = _v0.c;
		var wordCount = (byteCount / 4) | 0;
		var oldWord = A2($truqu$elm_md5$MD5$iget, wordCount, words);
		var bytePosition = 8 * (byteCount % 4);
		var code = _char << bytePosition;
		var newWord = oldWord | code;
		var newWords = A3($elm$core$Array$set, wordCount, newWord, words);
		return (byteCount === 63) ? _Utils_Tuple3(
			A2(
				$truqu$elm_md5$MD5$hex_,
				$elm$core$Array$toList(newWords),
				hashState),
			_Utils_Tuple2(0, $truqu$elm_md5$MD5$emptyWords),
			totalByteCount + 1) : _Utils_Tuple3(
			hashState,
			_Utils_Tuple2(byteCount + 1, newWords),
			totalByteCount + 1);
	});
var $truqu$elm_md5$MD5$finishUp = function (_v0) {
	var hashState = _v0.a;
	var _v1 = _v0.b;
	var byteCount = _v1.a;
	var words = _v1.b;
	var totalByteCount = _v0.c;
	var wordCount = (byteCount / 4) | 0;
	var oldWord = A2($truqu$elm_md5$MD5$iget, wordCount, words);
	var bytePosition = 8 * (byteCount % 4);
	var code = 128 << bytePosition;
	var newWord = oldWord | code;
	var newWords = A3($elm$core$Array$set, wordCount, newWord, words);
	return (wordCount < 14) ? function (x) {
		return A2($truqu$elm_md5$MD5$hex_, x, hashState);
	}(
		$elm$core$Array$toList(
			A3(
				$elm$core$Array$set,
				15,
				totalByteCount >>> 29,
				A3($elm$core$Array$set, 14, totalByteCount << 3, newWords)))) : function (x) {
		return A2(
			$truqu$elm_md5$MD5$hex_,
			x,
			A2(
				$truqu$elm_md5$MD5$hex_,
				$elm$core$Array$toList(newWords),
				hashState));
	}(
		$elm$core$Array$toList(
			A3(
				$elm$core$Array$set,
				15,
				totalByteCount >>> 29,
				A3($elm$core$Array$set, 14, totalByteCount << 3, $truqu$elm_md5$MD5$emptyWords))));
};
var $elm$core$String$foldl = _String_foldl;
var $zwilias$elm_utf_tools$String$UTF8$utf32ToUtf8 = F3(
	function (add, _char, acc) {
		return (_char < 128) ? A2(add, _char, acc) : ((_char < 2048) ? A2(
			add,
			128 | (63 & _char),
			A2(add, 192 | (_char >>> 6), acc)) : ((_char < 65536) ? A2(
			add,
			128 | (63 & _char),
			A2(
				add,
				128 | (63 & (_char >>> 6)),
				A2(add, 224 | (_char >>> 12), acc))) : A2(
			add,
			128 | (63 & _char),
			A2(
				add,
				128 | (63 & (_char >>> 6)),
				A2(
					add,
					128 | (63 & (_char >>> 12)),
					A2(add, 240 | (_char >>> 18), acc))))));
	});
var $zwilias$elm_utf_tools$String$UTF8$foldl = F3(
	function (op, initialAcc, input) {
		return A3(
			$elm$core$String$foldl,
			F2(
				function (_char, acc) {
					return A3(
						$zwilias$elm_utf_tools$String$UTF8$utf32ToUtf8,
						op,
						$elm$core$Char$toCode(_char),
						acc);
				}),
			initialAcc,
			input);
	});
var $truqu$elm_md5$MD5$State = F4(
	function (a, b, c, d) {
		return {bv: a, bx: b, dr: c, bD: d};
	});
var $truqu$elm_md5$MD5$initialHashState = A4($truqu$elm_md5$MD5$State, 1732584193, 4023233417, 2562383102, 271733878);
var $truqu$elm_md5$MD5$hash = function (input) {
	return $truqu$elm_md5$MD5$finishUp(
		A3(
			$zwilias$elm_utf_tools$String$UTF8$foldl,
			$truqu$elm_md5$MD5$consume,
			_Utils_Tuple3(
				$truqu$elm_md5$MD5$initialHashState,
				_Utils_Tuple2(0, $truqu$elm_md5$MD5$emptyWords),
				0),
			input));
};
var $truqu$elm_md5$MD5$bytes = function (string) {
	var _v0 = $truqu$elm_md5$MD5$hash(string);
	var a = _v0.bv;
	var b = _v0.bx;
	var c = _v0.dr;
	var d = _v0.bD;
	return _List_fromArray(
		[a & 255, (a >>> 8) & 255, (a >>> 16) & 255, (a >>> 24) & 255, b & 255, (b >>> 8) & 255, (b >>> 16) & 255, (b >>> 24) & 255, c & 255, (c >>> 8) & 255, (c >>> 16) & 255, (c >>> 24) & 255, d & 255, (d >>> 8) & 255, (d >>> 16) & 255, (d >>> 24) & 255]);
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $truqu$elm_md5$MD5$toHex = function (_byte) {
	switch (_byte) {
		case 0:
			return '0';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return 'a';
		case 11:
			return 'b';
		case 12:
			return 'c';
		case 13:
			return 'd';
		case 14:
			return 'e';
		case 15:
			return 'f';
		default:
			return _Utils_ap(
				$truqu$elm_md5$MD5$toHex((_byte / 16) | 0),
				$truqu$elm_md5$MD5$toHex(_byte % 16));
	}
};
var $truqu$elm_md5$MD5$hex = function (s) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (b, acc) {
				return _Utils_ap(
					acc,
					A3(
						$elm$core$String$padLeft,
						2,
						'0',
						$truqu$elm_md5$MD5$toHex(b)));
			}),
		'',
		$truqu$elm_md5$MD5$bytes(s));
};
var $author$project$Data$Alert$generateID = function (alert) {
	switch (alert.$) {
		case 0:
			var text = alert.a;
			return $truqu$elm_md5$MD5$hex('success-' + text);
		case 1:
			var text = alert.a;
			return $truqu$elm_md5$MD5$hex('info-' + text);
		case 2:
			var text = alert.a;
			return $truqu$elm_md5$MD5$hex('failure-' + text);
		case 3:
			var text = alert.a;
			return $truqu$elm_md5$MD5$hex('warning-' + text);
		default:
			var text = alert.a;
			return $truqu$elm_md5$MD5$hex('danger-' + text);
	}
};
var $author$project$Data$Alert$addAlert = F2(
	function (alert, _v0) {
		var alerts = _v0;
		return A3(
			$elm$core$Dict$insert,
			$author$project$Data$Alert$generateID(alert),
			alert,
			alerts);
	});
var $author$project$Data$Alert$addInfo = F2(
	function (text, alerts) {
		return A2(
			$author$project$Data$Alert$addAlert,
			$author$project$Data$Alert$Info(text),
			alerts);
	});
var $author$project$Port$LocalStorage$clearLocalStorage = _Platform_outgoingPort(
	'clearLocalStorage',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Port$LocalStorage$deleteLocalStorage = $author$project$Port$LocalStorage$clearLocalStorage(0);
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Data$Route$routeUrl = {
	gR: '/admins',
	c7: '/audit-log',
	dk: '/bot-log',
	dm: '/bot-report',
	g2: '/bots',
	dK: '/create-admin',
	dL: '/create-super-admin',
	dM: '/create-tenant',
	d0: function (id) {
		return '/edit-admin/' + $elm$core$String$fromInt(id);
	},
	d1: function (id) {
		return '/edit-bot/' + $elm$core$String$fromInt(id);
	},
	d2: function (id) {
		return '/edit-super-admin/' + $elm$core$String$fromInt(id);
	},
	d3: function (id) {
		return '/edit-tenant/' + $elm$core$String$fromInt(id);
	},
	es: '/',
	eY: '/login',
	fm: '/not-found',
	fD: '/profile',
	iz: '/super-admins',
	gj: '/super/login',
	iM: '/tenants'
};
var $author$project$Model$onLogout = F2(
	function (model, _v0) {
		var updatedModel = _Utils_update(
			model,
			{aW: $elm$core$Maybe$Nothing, eY: $author$project$Model$Login$initialModel});
		var authState = model.aW;
		if (!authState.$) {
			return _Utils_Tuple2(
				updatedModel,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Port$LocalStorage$deleteLocalStorage,
							A2($elm$browser$Browser$Navigation$pushUrl, model.ab, $author$project$Data$Route$routeUrl.eY)
						])));
		} else {
			return _Utils_Tuple2(
				updatedModel,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$browser$Browser$Navigation$pushUrl, model.ab, $author$project$Data$Route$routeUrl.eY),
							$author$project$Port$LocalStorage$deleteLocalStorage
						])));
		}
	});
var $author$project$Model$onCommonRequestError = F2(
	function (error, model) {
		if (!error) {
			return A2($author$project$Model$onLogout, model, $author$project$Data$Message$messages.hL);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.eG, model.ar)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Role$AdminProfile = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$onGetAdminProfileResult = F3(
	function (result, token, model) {
		if (result.$ === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{bO: true}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Port$LocalStorage$deleteLocalStorage,
							A2($elm$browser$Browser$Navigation$pushUrl, model.ab, $author$project$Data$Route$routeUrl.eY)
						])));
		} else {
			var admin = result.a;
			return A3(
				$author$project$Model$initialAuthState,
				token,
				$author$project$Data$Role$AdminProfile(admin),
				model);
		}
	});
var $author$project$Data$Role$SuperAdminProfile = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$onGetSuperAdminProfileResult = F3(
	function (result, token, model) {
		if (result.$ === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{bO: true}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Port$LocalStorage$deleteLocalStorage,
							A2($elm$browser$Browser$Navigation$pushUrl, model.ab, $author$project$Data$Route$routeUrl.gj)
						])));
		} else {
			var superAdmin = result.a;
			return A3(
				$author$project$Model$initialAuthState,
				token,
				$author$project$Data$Role$SuperAdminProfile(superAdmin),
				model);
		}
	});
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.fH;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.em,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.b6,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.fx,
					_Utils_ap(http, url.et)),
				url.h3)));
};
var $author$project$Model$Route$onInternalUrlRequest = F2(
	function (url, model) {
		var pushUrl = A2(
			$elm$browser$Browser$Navigation$pushUrl,
			model.ab,
			$elm$url$Url$toString(url));
		return _Utils_Tuple2(model, pushUrl);
	});
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Model$AdminDetail$mapState = F3(
	function (model, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		return _Utils_update(
			appModel,
			{
				aW: $elm$core$Maybe$Just(
					_Utils_update(
						authState,
						{
							h1: _Utils_update(
								pages,
								{gP: model})
						}))
			});
	});
var $author$project$Model$AdminDetail$loadByRoute = F2(
	function (authState, appModel) {
		var _v0 = authState.h1;
		var profile = _v0.fD;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (model_) {
				return A3($author$project$Model$AdminDetail$mapState, model_, authState, appModel);
			},
			A3($author$project$Model$AdminDetail$initialModel, appModel, authState.iQ, profile.fD));
	});
var $author$project$Model$AdminList$mapState = F3(
	function (model, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		return _Utils_update(
			appModel,
			{
				aW: $elm$core$Maybe$Just(
					_Utils_update(
						authState,
						{
							h1: _Utils_update(
								pages,
								{gQ: model})
						}))
			});
	});
var $author$project$Model$AdminList$loadByRoute = F2(
	function (authState, appModel) {
		var _v0 = authState.h1;
		var adminList = _v0.gQ;
		var profile = _v0.fD;
		var _v1 = adminList;
		var offset = _v1.fo;
		var limit = _v1.eV;
		var search = _v1.fU;
		var tenantID = _v1.gm;
		var tenantCmd = function () {
			var _v2 = profile.fD;
			if (!_v2.$) {
				var admin = _v2.a;
				return A2($author$project$Model$AdminList$getTenantCmd, admin.gm, authState.iQ);
			} else {
				return $author$project$Model$AdminList$getTenantsCmd(authState.iQ);
			}
		}();
		return _Utils_Tuple2(
			A3(
				$author$project$Model$AdminList$mapState,
				_Utils_update(
					adminList,
					{cQ: $author$project$Data$DataStatus$Downloading}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$author$project$Model$AdminList$getAdminsCmd,
						{eV: limit, fo: offset, fU: search, gm: tenantID.i3},
						authState.iQ),
						tenantCmd
					])));
	});
var $author$project$Model$AuditLog$mapState = F3(
	function (model, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		return _Utils_update(
			appModel,
			{
				aW: $elm$core$Maybe$Just(
					_Utils_update(
						authState,
						{
							h1: _Utils_update(
								pages,
								{c7: model})
						}))
			});
	});
var $author$project$Model$AuditLog$loadByRoute = F2(
	function (authState, appModel) {
		var _v0 = authState;
		var token = _v0.iQ;
		var pages = _v0.h1;
		var _v1 = pages;
		var auditLog = _v1.c7;
		var profile = _v1.fD;
		var _v2 = function () {
			var _v3 = profile.fD;
			if (!_v3.$) {
				return _Utils_Tuple2(
					$elm$core$Platform$Cmd$none,
					$author$project$Model$AuditLog$getAdminsCmd(token));
			} else {
				return _Utils_Tuple2(
					$author$project$Model$AuditLog$getSuperAdminsCmd(token),
					$author$project$Model$AuditLog$getAdminsCmd(token));
			}
		}();
		var superAdminCmd = _v2.a;
		var adminCmd = _v2.b;
		return _Utils_Tuple2(
			A3($author$project$Model$AuditLog$mapState, auditLog, authState, appModel),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						superAdminCmd,
						adminCmd,
						A2($author$project$Model$AuditLog$getAuditLogCmd, auditLog, token)
					])));
	});
var $author$project$Model$BotDetail$mapState = F3(
	function (model, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		return _Utils_update(
			appModel,
			{
				aW: $elm$core$Maybe$Just(
					_Utils_update(
						authState,
						{
							h1: _Utils_update(
								pages,
								{g0: model})
						}))
			});
	});
var $author$project$Model$BotDetail$loadByRoute = F2(
	function (authState, appModel) {
		var _v0 = authState.h1;
		var profile = _v0.fD;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (model_) {
				return A3($author$project$Model$BotDetail$mapState, model_, authState, appModel);
			},
			A3($author$project$Model$BotDetail$initialModel, appModel, authState.iQ, profile.fD));
	});
var $author$project$Model$BotList$mapState = F3(
	function (model, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		return _Utils_update(
			appModel,
			{
				aW: $elm$core$Maybe$Just(
					_Utils_update(
						authState,
						{
							h1: _Utils_update(
								pages,
								{g1: model})
						}))
			});
	});
var $author$project$Model$BotList$loadByRoute = F2(
	function (authState, appModel) {
		var _v0 = authState.h1;
		var botList = _v0.g1;
		var profile = _v0.fD;
		var tenantCmd = function () {
			var _v1 = profile.fD;
			if (!_v1.$) {
				var admin = _v1.a;
				return A2($author$project$Model$BotList$getTenantCmd, admin.gm, authState.iQ);
			} else {
				return $author$project$Model$BotList$getTenantsCmd(authState.iQ);
			}
		}();
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotList$mapState,
				_Utils_update(
					botList,
					{cQ: $author$project$Data$DataStatus$Downloading}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Model$BotList$getBotsCmd, botList, authState.iQ),
						tenantCmd
					])));
	});
var $author$project$Model$BotLog$mapState = F3(
	function (model, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		return _Utils_update(
			appModel,
			{
				aW: $elm$core$Maybe$Just(
					_Utils_update(
						authState,
						{
							h1: _Utils_update(
								pages,
								{dk: model})
						}))
			});
	});
var $author$project$Model$BotLog$loadByRoute = F2(
	function (authState, appModel) {
		var _v0 = authState;
		var token = _v0.iQ;
		var pages = _v0.h1;
		var _v1 = pages;
		var botLog = _v1.dk;
		var profile = _v1.fD;
		var tenantCmd = function () {
			var _v2 = profile.fD;
			if (!_v2.$) {
				return $elm$core$Platform$Cmd$none;
			} else {
				return $author$project$Model$BotLog$getTenantsCmd(token);
			}
		}();
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotLog$mapState,
				_Utils_update(
					botLog,
					{cQ: $author$project$Data$DataStatus$Downloading}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Model$BotLog$getLogsCmd, botLog, token),
						tenantCmd,
						A2($author$project$Model$BotLog$getBotsCmd, botLog, token)
					])));
	});
var $author$project$Model$BotReport$mapState = F3(
	function (model, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		return _Utils_update(
			appModel,
			{
				aW: $elm$core$Maybe$Just(
					_Utils_update(
						authState,
						{
							h1: _Utils_update(
								pages,
								{dm: model})
						}))
			});
	});
var $author$project$Model$BotReport$loadByRoute = F2(
	function (authState, appModel) {
		var _v0 = authState;
		var token = _v0.iQ;
		var pages = _v0.h1;
		var _v1 = pages;
		var botReport = _v1.dm;
		var profile = _v1.fD;
		var tenantCmd = function () {
			var _v4 = profile.fD;
			if (!_v4.$) {
				return $elm$core$Platform$Cmd$none;
			} else {
				return $author$project$Model$BotReport$getTenantsCmd(token);
			}
		}();
		var _v2 = botReport;
		var tenantID = _v2.gm;
		var languageCode = _v2.eT;
		var botID = _v2.di;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotReport$mapState,
				_Utils_update(
					botReport,
					{
						aI: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Data$DataStatus$Init,
							A2(
								$elm$core$Maybe$map,
								function (_v3) {
									return $author$project$Data$DataStatus$Downloading;
								},
								$elm$core$String$toInt(botID.i3)))
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Model$BotReport$getReportsCmd, botReport, token),
						tenantCmd,
						A3($author$project$Model$BotReport$getBotsCmd, tenantID.i3, languageCode.i3, token)
					])));
	});
var $author$project$Model$Dashboard$loadByRoute = F2(
	function (authState, appModel) {
		return _Utils_Tuple2(
			appModel,
			$author$project$Model$Dashboard$getDashboardCmd(authState.iQ));
	});
var $author$project$Model$SuperAdminDetail$mapState = F3(
	function (model, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		return _Utils_update(
			appModel,
			{
				aW: $elm$core$Maybe$Just(
					_Utils_update(
						authState,
						{
							h1: _Utils_update(
								pages,
								{ix: model})
						}))
			});
	});
var $author$project$Model$SuperAdminDetail$loadByRoute = F2(
	function (authState, appModel) {
		return A2(
			$elm$core$Tuple$mapFirst,
			function (model_) {
				return A3($author$project$Model$SuperAdminDetail$mapState, model_, authState, appModel);
			},
			A2($author$project$Model$SuperAdminDetail$initialModel, appModel, authState.iQ));
	});
var $author$project$Model$SuperAdminList$mapState = F3(
	function (model, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		return _Utils_update(
			appModel,
			{
				aW: $elm$core$Maybe$Just(
					_Utils_update(
						authState,
						{
							h1: _Utils_update(
								pages,
								{iy: model})
						}))
			});
	});
var $author$project$Model$SuperAdminList$loadByRoute = F2(
	function (authState, appModel) {
		var _v0 = authState.h1;
		var superAdminList = _v0.iy;
		var _v1 = superAdminList;
		var offset = _v1.fo;
		var limit = _v1.eV;
		var search = _v1.fU;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$SuperAdminList$mapState,
				_Utils_update(
					superAdminList,
					{cQ: $author$project$Data$DataStatus$Downloading}),
				authState,
				appModel),
			A2(
				$author$project$Model$SuperAdminList$getSuperAdminsCmd,
				{eV: limit, fo: offset, fU: search},
				authState.iQ));
	});
var $author$project$Model$TenantDetail$mapState = F3(
	function (model, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		return _Utils_update(
			appModel,
			{
				aW: $elm$core$Maybe$Just(
					_Utils_update(
						authState,
						{
							h1: _Utils_update(
								pages,
								{iK: model})
						}))
			});
	});
var $author$project$Model$TenantDetail$loadByRoute = F2(
	function (authState, appModel) {
		return A2(
			$elm$core$Tuple$mapFirst,
			function (model_) {
				return A3($author$project$Model$TenantDetail$mapState, model_, authState, appModel);
			},
			A2($author$project$Model$TenantDetail$initialModel, appModel, authState.iQ));
	});
var $author$project$Model$TenantList$mapState = F3(
	function (model, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		return _Utils_update(
			appModel,
			{
				aW: $elm$core$Maybe$Just(
					_Utils_update(
						authState,
						{
							h1: _Utils_update(
								pages,
								{iL: model})
						}))
			});
	});
var $author$project$Model$TenantList$loadByRoute = F2(
	function (authState, appModel) {
		var _v0 = authState.h1;
		var tenantList = _v0.iL;
		var _v1 = tenantList;
		var offset = _v1.fo;
		var limit = _v1.eV;
		var search = _v1.fU;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$TenantList$mapState,
				_Utils_update(
					tenantList,
					{cQ: $author$project$Data$DataStatus$Downloading}),
				authState,
				appModel),
			A2(
				$author$project$Model$TenantList$getTenantsCmd,
				{eV: limit, fo: offset, fU: search},
				authState.iQ));
	});
var $author$project$Model$Route$onUrlChange = F2(
	function (url, model_) {
		var route = $author$project$Data$Route$getRoute(url);
		var model = _Utils_update(
			model_,
			{cM: route, gC: url});
		var _v0 = model.aW;
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var authState = _v0.a;
			switch (route.$) {
				case 0:
					return A2($author$project$Model$Dashboard$loadByRoute, authState, model);
				case 4:
					return A2($author$project$Model$AdminList$loadByRoute, authState, model);
				case 5:
					return A2($author$project$Model$AdminDetail$loadByRoute, authState, model);
				case 6:
					return A2($author$project$Model$AdminDetail$loadByRoute, authState, model);
				case 7:
					return A2($author$project$Model$SuperAdminList$loadByRoute, authState, model);
				case 8:
					return A2($author$project$Model$SuperAdminDetail$loadByRoute, authState, model);
				case 9:
					return A2($author$project$Model$SuperAdminDetail$loadByRoute, authState, model);
				case 10:
					return A2($author$project$Model$TenantList$loadByRoute, authState, model);
				case 11:
					return A2($author$project$Model$TenantDetail$loadByRoute, authState, model);
				case 12:
					return A2($author$project$Model$TenantDetail$loadByRoute, authState, model);
				case 13:
					return A2($author$project$Model$BotList$loadByRoute, authState, model);
				case 14:
					return A2($author$project$Model$BotDetail$loadByRoute, authState, model);
				case 15:
					return A2($author$project$Model$BotLog$loadByRoute, authState, model);
				case 16:
					return A2($author$project$Model$BotReport$loadByRoute, authState, model);
				case 17:
					return A2($author$project$Model$AuditLog$loadByRoute, authState, model);
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Data$Alert$remove = F2(
	function (alert, _v0) {
		var alerts = _v0;
		return A2(
			$elm$core$Dict$remove,
			$author$project$Data$Alert$generateID(alert),
			alerts);
	});
var $author$project$Data$Route$routeToUrl = function (route) {
	switch (route.$) {
		case 1:
			return $author$project$Data$Route$routeUrl.eY;
		case 2:
			return $author$project$Data$Route$routeUrl.gj;
		case 0:
			return $author$project$Data$Route$routeUrl.es;
		case 3:
			return $author$project$Data$Route$routeUrl.fD;
		case 4:
			return $author$project$Data$Route$routeUrl.gR;
		case 5:
			return $author$project$Data$Route$routeUrl.dK;
		case 6:
			var id = route.a;
			return $author$project$Data$Route$routeUrl.d0(id);
		case 7:
			return $author$project$Data$Route$routeUrl.iz;
		case 8:
			return $author$project$Data$Route$routeUrl.dL;
		case 9:
			var id = route.a;
			return $author$project$Data$Route$routeUrl.d2(id);
		case 10:
			return $author$project$Data$Route$routeUrl.iM;
		case 11:
			return $author$project$Data$Route$routeUrl.dM;
		case 12:
			var id = route.a;
			return $author$project$Data$Route$routeUrl.d3(id);
		case 13:
			return $author$project$Data$Route$routeUrl.g2;
		case 14:
			var id = route.a;
			return $author$project$Data$Route$routeUrl.d1(id);
		case 15:
			return $author$project$Data$Route$routeUrl.dk;
		case 16:
			return $author$project$Data$Route$routeUrl.dm;
		case 17:
			return $author$project$Data$Route$routeUrl.c7;
		default:
			return $author$project$Data$Route$routeUrl.fm;
	}
};
var $author$project$Type$OnLogin = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Type$OnCommonRequestError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$OnInitAuth = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Data$Form$Submitted = 2;
var $author$project$Data$Alert$Danger = function (a) {
	return {$: 4, a: a};
};
var $author$project$Data$Alert$addDanger = F2(
	function (text, alerts) {
		return A2(
			$author$project$Data$Alert$addAlert,
			$author$project$Data$Alert$Danger(text),
			alerts);
	});
var $author$project$Api$AdminLogin$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid email';
		case 2:
			return 'Invalid password';
		case 3:
			return 'Admin not found';
		case 4:
			return 'Cannot generate session';
		default:
			return 'Missing error code';
	}
};
var $author$project$Api$Base$performCommonErrorMsg = F2(
	function (msg, error) {
		if (error.$ === 4) {
			var commonError = error.a;
			return A2(
				$elm$core$Task$perform,
				msg,
				$elm$core$Task$succeed(commonError));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Model$Login$onAdminLoginResult = F3(
	function (result, model, appModel) {
		if (result.$ === 1) {
			var error = result.a;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						ar: A2(
							$author$project$Data$Alert$addDanger,
							A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$AdminLogin$errorCodeString, error),
							$author$project$Data$Alert$clear),
						eY: _Utils_update(
							model,
							{J: 2})
					}),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var jwt = result.a.eP;
			var admin = result.a.gO;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.hM, $author$project$Data$Alert$clear),
						eY: _Utils_update(
							model,
							{J: 2})
					}),
				A2(
					$elm$core$Task$perform,
					$author$project$Type$OnInitAuth(jwt),
					$elm$core$Task$succeed(
						$author$project$Data$Role$AdminProfile(admin))));
		}
	});
var $author$project$Api$SuperAdminLogin$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid email';
		case 2:
			return 'Invalid password';
		case 3:
			return 'Super admin not found';
		case 4:
			return 'Cannot generate session';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$Login$onSuperAdminLoginResult = F3(
	function (result, model, appModel) {
		if (result.$ === 1) {
			var error = result.a;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						ar: A2(
							$author$project$Data$Alert$addDanger,
							A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$SuperAdminLogin$errorCodeString, error),
							$author$project$Data$Alert$clear),
						eY: _Utils_update(
							model,
							{J: 2})
					}),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var jwt = result.a.eP;
			var superAdmin = result.a.iw;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.hM, $author$project$Data$Alert$clear),
						eY: _Utils_update(
							model,
							{J: 2})
					}),
				A2(
					$elm$core$Task$perform,
					$author$project$Type$OnInitAuth(jwt),
					$elm$core$Task$succeed(
						$author$project$Data$Role$SuperAdminProfile(superAdmin))));
		}
	});
var $author$project$Type$Login$OnAdminLoginResult = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$Login$OnSuperAdminLoginResult = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Form$Submitting = 1;
var $author$project$Data$Login$AdminLogin = F2(
	function (jwt, admin) {
		return {gO: admin, eP: jwt};
	});
var $author$project$Api$Decoder$adminLogin = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Login$AdminLogin,
	A2($elm$json$Json$Decode$field, 'jwt', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'admin', $author$project$Api$Decoder$admin));
var $author$project$Api$Base$call = function (_v0) {
	var path = _v0.h3;
	var params = _v0.h2;
	var resolver = _v0.ia;
	return $elm$http$Http$task(
		{
			df: A2(
				$elm$http$Http$stringBody,
				'application/json',
				A2($elm$json$Json$Encode$encode, 0, params)),
			ep: _List_Nil,
			e4: 'POST',
			ia: resolver,
			gp: $elm$core$Maybe$Nothing,
			gC: _Utils_ap($author$project$Env$env.c5, path)
		});
};
var $author$project$Api$AdminLogin$AdminNotFound = 3;
var $author$project$Api$AdminLogin$CannotGenerateJWT = 4;
var $author$project$Api$AdminLogin$InvalidEmail = 1;
var $author$project$Api$AdminLogin$InvalidParams = 0;
var $author$project$Api$AdminLogin$InvalidPassword = 2;
var $author$project$Api$AdminLogin$MissingError = 5;
var $author$project$Api$AdminLogin$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$5:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidEmail':
					return 1;
				case 'InvalidPassword':
					return 2;
				case 'AdminNotFound':
					return 3;
				case 'CannotGenerateJWT':
					return 4;
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return 5;
};
var $author$project$Api$AdminLogin$exec = function (_v0) {
	var email = _v0.d4;
	var password = _v0.fu;
	var resolver = A2($author$project$Api$Base$standardResolver, $author$project$Api$AdminLogin$toErrorCode, $author$project$Api$Decoder$adminLogin);
	var params = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(email)),
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(password))
			]));
	return $author$project$Api$Base$call(
		{h2: params, h3: 'admin/login', ia: resolver});
};
var $author$project$Data$Login$SuperAdminLogin = F2(
	function (jwt, superAdmin) {
		return {eP: jwt, iw: superAdmin};
	});
var $author$project$Api$Decoder$superAdminLogin = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Login$SuperAdminLogin,
	A2($elm$json$Json$Decode$field, 'jwt', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'superAdmin', $author$project$Api$Decoder$superAdmin));
var $author$project$Api$SuperAdminLogin$CannotGenerateJWT = 4;
var $author$project$Api$SuperAdminLogin$InvalidEmail = 1;
var $author$project$Api$SuperAdminLogin$InvalidParams = 0;
var $author$project$Api$SuperAdminLogin$InvalidPassword = 2;
var $author$project$Api$SuperAdminLogin$MissingError = 5;
var $author$project$Api$SuperAdminLogin$SuperAdminNotFound = 3;
var $author$project$Api$SuperAdminLogin$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$5:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidEmail':
					return 1;
				case 'InvalidPassword':
					return 2;
				case 'SuperAdminNotFound':
					return 3;
				case 'CannotGenerateJWT':
					return 4;
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return 5;
};
var $author$project$Api$SuperAdminLogin$exec = function (_v0) {
	var email = _v0.d4;
	var password = _v0.fu;
	var resolver = A2($author$project$Api$Base$standardResolver, $author$project$Api$SuperAdminLogin$toErrorCode, $author$project$Api$Decoder$superAdminLogin);
	var params = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(email)),
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(password))
			]));
	return $author$project$Api$Base$call(
		{h2: params, h3: 'super-admin/login', ia: resolver});
};
var $author$project$Data$Form$isValidField = function (field) {
	var _v0 = field.bH;
	if (_v0.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Data$Form$isValidFields = function (lists) {
	var filterList = A2(
		$elm$core$List$filter,
		function (field) {
			return !$author$project$Data$Form$isValidField(field);
		},
		lists);
	return !$elm$core$List$length(filterList);
};
var $author$project$Model$Login$submitForm = F2(
	function (model, appModel) {
		var _v0 = model;
		var email = _v0.d4;
		var password = _v0.fu;
		if ($author$project$Data$Form$isValidFields(
			_List_fromArray(
				[email, password]))) {
			var updatedModel = _Utils_update(
				model,
				{J: 1});
			var cmd_ = function () {
				var _v1 = appModel.cM;
				if (_v1.$ === 2) {
					return A2(
						$elm$core$Task$attempt,
						A2($elm$core$Basics$composeL, $author$project$Type$OnLogin, $author$project$Type$Login$OnSuperAdminLoginResult),
						$author$project$Api$SuperAdminLogin$exec(
							{d4: email.i3, fu: password.i3}));
				} else {
					return A2(
						$elm$core$Task$attempt,
						A2($elm$core$Basics$composeL, $author$project$Type$OnLogin, $author$project$Type$Login$OnAdminLoginResult),
						$author$project$Api$AdminLogin$exec(
							{d4: email.i3, fu: password.i3}));
				}
			}();
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{eY: updatedModel}),
				cmd_);
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Data$Form$validateValue = F2(
	function (validators, value) {
		if (validators.b) {
			var validator = validators.a;
			var rest = validators.b;
			return A2(
				$elm$core$Result$andThen,
				function (_v1) {
					return A2($author$project$Data$Form$validateValue, rest, value);
				},
				validator(value));
		} else {
			return $elm$core$Result$Ok(value);
		}
	});
var $author$project$Data$Form$updateField = F2(
	function (field, value_) {
		var _v0 = field;
		var validators = _v0.gD;
		var validateResult = A2($author$project$Data$Form$validateValue, validators, value_);
		var error_ = function () {
			if (!validateResult.$) {
				return $elm$core$Maybe$Nothing;
			} else {
				var message = validateResult.a;
				return $elm$core$Maybe$Just(message);
			}
		}();
		return _Utils_update(
			field,
			{bH: error_, i3: value_});
	});
var $author$project$Model$Login$update = F2(
	function (msg, appModel) {
		var toAppTuple = function (_v3) {
			var model_ = _v3.a;
			var cmd_ = _v3.b;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{eY: model_}),
				A2($elm$core$Platform$Cmd$map, $author$project$Type$OnLogin, cmd_));
		};
		var model = appModel.eY;
		switch (msg.$) {
			case 3:
				var value = msg.a;
				var _v1 = model;
				var email = _v1.d4;
				return toAppTuple(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								d4: A2($author$project$Data$Form$updateField, email, value)
							}),
						$elm$core$Platform$Cmd$none));
			case 4:
				var value = msg.a;
				var _v2 = model;
				var password = _v2.fu;
				return toAppTuple(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								fu: A2($author$project$Data$Form$updateField, password, value)
							}),
						$elm$core$Platform$Cmd$none));
			case 0:
				return A2($author$project$Model$Login$submitForm, model, appModel);
			case 1:
				var response = msg.a;
				return A3($author$project$Model$Login$onSuperAdminLoginResult, response, model, appModel);
			default:
				var response = msg.a;
				return A3($author$project$Model$Login$onAdminLoginResult, response, model, appModel);
		}
	});
var $author$project$Data$Form$NotMatchPassword = 6;
var $author$project$Model$AdminDetail$onChangeConfirmPassword = F4(
	function (value, model, authState, appModel) {
		var _v0 = model;
		var confirmPassword = _v0.G;
		var updatedField = A2($author$project$Data$Form$updateField, confirmPassword, value);
		var _v1 = updatedField;
		var error = _v1.bH;
		if (error.$ === 1) {
			return ((value !== '') && (!_Utils_eq(model.fu.i3, value))) ? _Utils_Tuple2(
				A3(
					$author$project$Model$AdminDetail$mapState,
					_Utils_update(
						model,
						{
							G: _Utils_update(
								updatedField,
								{
									bH: $elm$core$Maybe$Just(6)
								})
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
				A3(
					$author$project$Model$AdminDetail$mapState,
					_Utils_update(
						model,
						{G: updatedField}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminDetail$mapState,
					_Utils_update(
						model,
						{G: updatedField}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$AdminDetail$OnCreateResult = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$AdminCreate$EmailExisted = 5;
var $author$project$Api$AdminCreate$InvalidEmail = 3;
var $author$project$Api$AdminCreate$InvalidName = 2;
var $author$project$Api$AdminCreate$InvalidParams = 0;
var $author$project$Api$AdminCreate$InvalidPassword = 4;
var $author$project$Api$AdminCreate$InvalidTenant = 1;
var $author$project$Api$AdminCreate$MissingError = 7;
var $author$project$Api$AdminCreate$TenantNotFound = 6;
var $author$project$Api$AdminCreate$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$7:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidTenant':
					return 1;
				case 'InvalidName':
					return 2;
				case 'InvalidEmail':
					return 3;
				case 'InvalidPassword':
					return 4;
				case 'EmailExisted':
					return 5;
				case 'TenantNotFound':
					return 6;
				default:
					break _v0$7;
			}
		} else {
			break _v0$7;
		}
	}
	return 7;
};
var $author$project$Api$AdminCreate$exec = F2(
	function (_v0, token) {
		var name = _v0.fg;
		var email = _v0.d4;
		var password = _v0.fu;
		var tenantID = _v0.gm;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$AdminCreate$toErrorCode,
			A2($elm$json$Json$Decode$field, 'admin', $author$project$Api$Decoder$admin));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email)),
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string(password)),
					_Utils_Tuple2(
					'tenantID',
					$elm$json$Json$Encode$int(tenantID))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'admin/create', ia: resolver, iQ: token});
	});
var $author$project$Model$AdminDetail$onCreate = F2(
	function (appModel, authState) {
		var _v0 = authState.h1;
		var adminDetail = _v0.gP;
		var _v1 = adminDetail;
		var name = _v1.fg;
		var email = _v1.d4;
		var tenantID = _v1.gm;
		var password = _v1.fu;
		var confirmPassword = _v1.G;
		var isSame = _Utils_eq(password.i3, confirmPassword.i3);
		var task = A2(
			$author$project$Api$AdminCreate$exec,
			{
				d4: email.i3,
				fg: name.i3,
				fu: password.i3,
				gm: A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(tenantID.i3))
			},
			authState.iQ);
		return ($author$project$Data$Form$isValidFields(
			_List_fromArray(
				[name, email, tenantID, password])) && isSame) ? _Utils_Tuple2(
			A3(
				$author$project$Model$AdminDetail$mapState,
				_Utils_update(
					adminDetail,
					{J: 1}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAdminDetail),
					$author$project$Type$AdminDetail$OnCreateResult),
				task)) : _Utils_Tuple2(
			A3($author$project$Model$AdminDetail$mapState, adminDetail, authState, appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Api$AdminCreate$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid tenant';
		case 2:
			return 'Invalid name';
		case 3:
			return 'Invalid email';
		case 4:
			return 'Invalid password';
		case 5:
			return 'Email existed';
		case 6:
			return 'Tenant not found';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$AdminDetail$onCreateResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var adminDetail = _v0.gP;
		var _v1 = adminDetail;
		var password = _v1.fu;
		var confirmPassword = _v1.G;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminDetail$mapState,
					_Utils_update(
						adminDetail,
						{J: 2}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$AdminCreate$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminDetail$mapState,
					_Utils_update(
						adminDetail,
						{
							gO: $author$project$Data$DataStatus$Downloaded(value),
							G: _Utils_update(
								confirmPassword,
								{bH: $elm$core$Maybe$Nothing, i3: ''}),
							J: 2,
							fu: _Utils_update(
								password,
								{bH: $elm$core$Maybe$Nothing, i3: ''})
						}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.g8, $author$project$Data$Alert$clear)
						})),
				A2(
					$elm$browser$Browser$Navigation$pushUrl,
					appModel.ab,
					$author$project$Data$Route$routeUrl.d0(value.eu)));
		}
	});
var $author$project$Data$DataStatus$Error = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$AdminDetail$onGetAdminResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var adminDetail = _v0.gP;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminDetail$mapState,
					_Utils_update(
						adminDetail,
						{
							gO: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			var _v2 = adminDetail;
			var name = _v2.fg;
			var email = _v2.d4;
			var tenantID = _v2.gm;
			var updatedModel = _Utils_update(
				adminDetail,
				{
					gO: $author$project$Data$DataStatus$Downloaded(value),
					d4: _Utils_update(
						email,
						{i3: value.d4}),
					fg: _Utils_update(
						name,
						{i3: value.fg}),
					gm: _Utils_update(
						tenantID,
						{
							i3: $elm$core$String$fromInt(value.gm)
						})
				});
			return _Utils_Tuple2(
				A3($author$project$Model$AdminDetail$mapState, updatedModel, authState, appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$AdminDetail$onGetTenantsResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var adminDetail = _v0.gP;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminDetail$mapState,
					_Utils_update(
						adminDetail,
						{
							iM: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminDetail$mapState,
					_Utils_update(
						adminDetail,
						{
							iM: $author$project$Data$DataStatus$Downloaded(value)
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$AdminDetail$OnUpdateResult = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$AdminUpdate$AdminNotFound = 2;
var $author$project$Api$AdminUpdate$CannotGetAdmin = 7;
var $author$project$Api$AdminUpdate$EmailExisted = 5;
var $author$project$Api$AdminUpdate$InvalidEmail = 4;
var $author$project$Api$AdminUpdate$InvalidName = 3;
var $author$project$Api$AdminUpdate$InvalidParams = 0;
var $author$project$Api$AdminUpdate$InvalidTenant = 1;
var $author$project$Api$AdminUpdate$MissingError = 8;
var $author$project$Api$AdminUpdate$TenantNotFound = 6;
var $author$project$Api$AdminUpdate$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$8:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidTenant':
					return 1;
				case 'AdminNotFound':
					return 2;
				case 'InvalidName':
					return 3;
				case 'InvalidEmail':
					return 4;
				case 'EmailExisted':
					return 5;
				case 'TenantNotFound':
					return 6;
				case 'CannotGetAdmin':
					return 7;
				default:
					break _v0$8;
			}
		} else {
			break _v0$8;
		}
	}
	return 8;
};
var $author$project$Api$AdminUpdate$exec = F2(
	function (_v0, token) {
		var id = _v0.eu;
		var name = _v0.fg;
		var email = _v0.d4;
		var tenantID = _v0.gm;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$AdminUpdate$toErrorCode,
			A2($elm$json$Json$Decode$field, 'admin', $author$project$Api$Decoder$admin));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(id)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email)),
					_Utils_Tuple2(
					'tenantID',
					$elm$json$Json$Encode$int(tenantID))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'admin/update', ia: resolver, iQ: token});
	});
var $author$project$Model$AdminDetail$onUpdate = F3(
	function (id, appModel, authState) {
		var _v0 = authState;
		var token = _v0.iQ;
		var pages = _v0.h1;
		var _v1 = pages;
		var adminDetail = _v1.gP;
		var _v2 = adminDetail;
		var name = _v2.fg;
		var email = _v2.d4;
		var tenantID = _v2.gm;
		var params = {
			d4: email.i3,
			eu: id,
			fg: name.i3,
			gm: A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(tenantID.i3))
		};
		return $author$project$Data$Form$isValidFields(
			_List_fromArray(
				[name, email, tenantID])) ? _Utils_Tuple2(
			A3(
				$author$project$Model$AdminDetail$mapState,
				_Utils_update(
					adminDetail,
					{J: 1}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAdminDetail),
					$author$project$Type$AdminDetail$OnUpdateResult),
				A2($author$project$Api$AdminUpdate$exec, params, token))) : _Utils_Tuple2(
			A3($author$project$Model$AdminDetail$mapState, adminDetail, authState, appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Type$AdminDetail$OnUpdatePasswordResult = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$AdminUpdatePassword$AdminNotFound = 2;
var $author$project$Api$AdminUpdatePassword$CannotGetAdmin = 4;
var $author$project$Api$AdminUpdatePassword$InvalidParams = 0;
var $author$project$Api$AdminUpdatePassword$InvalidPassword = 3;
var $author$project$Api$AdminUpdatePassword$InvalidTenant = 1;
var $author$project$Api$AdminUpdatePassword$MissingError = 5;
var $author$project$Api$AdminUpdatePassword$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$5:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidTenant':
					return 1;
				case 'AdminNotFound':
					return 2;
				case 'InvalidPassword':
					return 3;
				case 'CannotGetAdmin':
					return 4;
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return 5;
};
var $author$project$Api$AdminUpdatePassword$exec = F2(
	function (_v0, token) {
		var id = _v0.eu;
		var password = _v0.fu;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$AdminUpdatePassword$toErrorCode,
			$elm$json$Json$Decode$succeed(0));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(id)),
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string(password))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'admin/update-password', ia: resolver, iQ: token});
	});
var $author$project$Model$AdminDetail$onUpdatePassword = F3(
	function (id, appModel, authState) {
		var _v0 = authState.h1;
		var adminDetail = _v0.gP;
		var _v1 = adminDetail;
		var password = _v1.fu;
		var confirmPassword = _v1.G;
		var isSame = _Utils_eq(password.i3, confirmPassword.i3);
		return ($author$project$Data$Form$isValidFields(
			_List_fromArray(
				[confirmPassword, password])) && isSame) ? _Utils_Tuple2(
			A3(
				$author$project$Model$AdminDetail$mapState,
				_Utils_update(
					adminDetail,
					{J: 1}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAdminDetail),
					$author$project$Type$AdminDetail$OnUpdatePasswordResult),
				A2(
					$author$project$Api$AdminUpdatePassword$exec,
					{eu: id, fu: password.i3},
					authState.iQ))) : _Utils_Tuple2(
			A3($author$project$Model$AdminDetail$mapState, adminDetail, authState, appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$AdminDetail$onUpdatePasswordResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var adminDetail = _v0.gP;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminDetail$mapState,
					_Utils_update(
						adminDetail,
						{J: 2}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var _v2 = adminDetail;
			var password = _v2.fu;
			var confirmPassword = _v2.G;
			var updatedModel = _Utils_update(
				adminDetail,
				{
					G: _Utils_update(
						confirmPassword,
						{bH: $elm$core$Maybe$Nothing, i3: ''}),
					J: 2,
					fu: _Utils_update(
						password,
						{bH: $elm$core$Maybe$Nothing, i3: ''})
				});
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminDetail$mapState,
					updatedModel,
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.iX, $author$project$Data$Alert$clear)
						})),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$OnProfile = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$Profile$OnUpdateProfile = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$AdminUpdate$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid tenant';
		case 2:
			return 'Admin not found';
		case 3:
			return 'Invalid name';
		case 4:
			return 'Invalid email';
		case 5:
			return 'Email existed';
		case 6:
			return 'Tenant not found';
		case 7:
			return 'Cannot get admin';
		default:
			return 'Missing error code';
	}
};
var $author$project$Data$Role$getAdminID = function (profile) {
	if (profile.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var id = profile.a.eu;
		return $elm$core$Maybe$Just(id);
	}
};
var $author$project$Model$AdminDetail$onUpdateResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		var _v1 = pages;
		var adminDetail = _v1.gP;
		var profile = _v1.fD;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminDetail$mapState,
					_Utils_update(
						adminDetail,
						{J: 2}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$AdminUpdate$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			var okModel = _Utils_update(
				adminDetail,
				{
					gO: $author$project$Data$DataStatus$Downloaded(value),
					J: 2
				});
			var okAppModel = _Utils_update(
				appModel,
				{
					ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.iX, $author$project$Data$Alert$clear)
				});
			var isUpdateCurrentAdmin = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$eq(value.eu),
					$author$project$Data$Role$getAdminID(profile.fD)));
			var cmd = isUpdateCurrentAdmin ? A2(
				$elm$core$Task$perform,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnProfile),
					$author$project$Type$Profile$OnUpdateProfile),
				$elm$core$Task$succeed(
					$author$project$Data$Role$AdminProfile(value))) : $elm$core$Platform$Cmd$none;
			return _Utils_Tuple2(
				A3($author$project$Model$AdminDetail$mapState, okModel, authState, okAppModel),
				cmd);
		}
	});
var $author$project$Model$AdminDetail$update = F3(
	function (msg, authState, appModel) {
		var model = authState.h1.gP;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				var _v1 = model;
				var name = _v1.fg;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AdminDetail$mapState,
						_Utils_update(
							model,
							{
								fg: A2($author$project$Data$Form$updateField, name, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				var _v2 = model;
				var email = _v2.d4;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AdminDetail$mapState,
						_Utils_update(
							model,
							{
								d4: A2($author$project$Data$Form$updateField, email, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				var _v3 = model;
				var tenantID = _v3.gm;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AdminDetail$mapState,
						_Utils_update(
							model,
							{
								gm: A2($author$project$Data$Form$updateField, tenantID, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				var _v4 = model;
				var password = _v4.fu;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AdminDetail$mapState,
						_Utils_update(
							model,
							{
								fu: A2($author$project$Data$Form$updateField, password, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				return A4($author$project$Model$AdminDetail$onChangeConfirmPassword, value, model, authState, appModel);
			case 5:
				return A2($author$project$Model$AdminDetail$onCreate, appModel, authState);
			case 6:
				var response = msg.a;
				return A3($author$project$Model$AdminDetail$onCreateResult, response, authState, appModel);
			case 7:
				var id = msg.a;
				return A3($author$project$Model$AdminDetail$onUpdate, id, appModel, authState);
			case 8:
				var response = msg.a;
				return A3($author$project$Model$AdminDetail$onUpdateResult, response, authState, appModel);
			case 9:
				var id = msg.a;
				return A3($author$project$Model$AdminDetail$onUpdatePassword, id, appModel, authState);
			case 10:
				var response = msg.a;
				return A3($author$project$Model$AdminDetail$onUpdatePasswordResult, response, authState, appModel);
			case 12:
				var response = msg.a;
				return A3($author$project$Model$AdminDetail$onGetAdminResult, response, authState, appModel);
			default:
				var response = msg.a;
				return A3($author$project$Model$AdminDetail$onGetTenantsResult, response, authState, appModel);
		}
	});
var $author$project$Type$AdminList$OnSearch = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$AdminList$OnSearchDebounce = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ext$Debounce$config = function (msg) {
	return {
		is: $jinjor$elm_debounce$Debounce$later(500),
		iV: msg
	};
};
var $author$project$Model$AdminList$debounceConfig = $author$project$Ext$Debounce$config(
	A2(
		$elm$core$Basics$composeL,
		A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAdminList),
		$author$project$Type$AdminList$OnSearchDebounce));
var $jinjor$elm_debounce$Debounce$Flush = function (a) {
	return {$: 1, a: a};
};
var $jinjor$elm_debounce$Debounce$SendIfLengthNotChangedFrom = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Process$sleep = _Process_sleep;
var $jinjor$elm_debounce$Debounce$delayCmd = F2(
	function (delay, msg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return msg;
			},
			$elm$core$Process$sleep(delay));
	});
var $jinjor$elm_debounce$Debounce$length = function (_v0) {
	var input = _v0.hC;
	return $elm$core$List$length(input);
};
var $jinjor$elm_debounce$Debounce$push = F3(
	function (config, a, _v0) {
		var d = _v0;
		var newDebounce = _Utils_update(
			d,
			{
				hC: A2($elm$core$List$cons, a, d.hC)
			});
		var selfCmd = function () {
			var _v1 = config.is;
			switch (_v1.$) {
				case 0:
					var offset = _v1.a;
					return d.a8 ? $elm$core$Platform$Cmd$none : A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						offset,
						$jinjor$elm_debounce$Debounce$Flush($elm$core$Maybe$Nothing));
				case 1:
					var offset = _v1.a;
					var delay = _v1.b;
					return d.a8 ? $elm$core$Platform$Cmd$none : A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						offset,
						$jinjor$elm_debounce$Debounce$Flush(
							$elm$core$Maybe$Just(delay)));
				default:
					var delay = _v1.a;
					return A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						delay,
						$jinjor$elm_debounce$Debounce$SendIfLengthNotChangedFrom(
							$jinjor$elm_debounce$Debounce$length(newDebounce)));
			}
		}();
		return _Utils_Tuple2(
			newDebounce,
			A2($elm$core$Platform$Cmd$map, config.iV, selfCmd));
	});
var $author$project$Ext$Debounce$debouncePush = $jinjor$elm_debounce$Debounce$push;
var $jinjor$elm_debounce$Debounce$takeLast = F3(
	function (send, head, tail) {
		return _Utils_Tuple2(
			_List_Nil,
			send(head));
	});
var $author$project$Ext$Debounce$debounceTakeLast = $jinjor$elm_debounce$Debounce$takeLast;
var $jinjor$elm_debounce$Debounce$update = F4(
	function (config, send, msg, _v0) {
		var d = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(d, $elm$core$Platform$Cmd$none);
			case 1:
				var tryAgainAfter = msg.a;
				var _v2 = d.hC;
				if (_v2.b) {
					var head = _v2.a;
					var tail = _v2.b;
					var selfCmd = function () {
						if (!tryAgainAfter.$) {
							var delay = tryAgainAfter.a;
							return A2(
								$jinjor$elm_debounce$Debounce$delayCmd,
								delay,
								$jinjor$elm_debounce$Debounce$Flush(
									$elm$core$Maybe$Just(delay)));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					var _v3 = A2(send, head, tail);
					var input = _v3.a;
					var sendCmd = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							d,
							{hC: input, a8: true}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									sendCmd,
									A2($elm$core$Platform$Cmd$map, config.iV, selfCmd)
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							d,
							{a8: false}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var lastInputLength = msg.a;
				var _v5 = _Utils_Tuple2(
					_Utils_cmp(
						$elm$core$List$length(d.hC),
						lastInputLength) < 1,
					d.hC);
				if (_v5.a && _v5.b.b) {
					var _v6 = _v5.b;
					var head = _v6.a;
					var tail = _v6.b;
					var _v7 = A2(send, head, tail);
					var input = _v7.a;
					var cmd = _v7.b;
					return _Utils_Tuple2(
						_Utils_update(
							d,
							{hC: input}),
						cmd);
				} else {
					return _Utils_Tuple2(d, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Ext$Debounce$debounceUpdate = $jinjor$elm_debounce$Debounce$update;
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $author$project$Model$AdminList$onCheck = F3(
	function (admin, authState, appModel) {
		var _v0 = authState.h1;
		var adminList = _v0.gQ;
		var _v1 = adminList;
		var checkedList = _v1.F;
		var isExisted = A2(
			$elm$core$List$filter,
			function (item) {
				return _Utils_eq(item.eu, admin.eu);
			},
			checkedList);
		return ($elm$core$List$length(isExisted) > 0) ? _Utils_Tuple2(
			A3(
				$author$project$Model$AdminList$mapState,
				_Utils_update(
					adminList,
					{
						F: A2(
							$elm$core$List$filter,
							function (item) {
								return !_Utils_eq(item.eu, admin.eu);
							},
							checkedList)
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
			A3(
				$author$project$Model$AdminList$mapState,
				_Utils_update(
					adminList,
					{
						F: A2(
							$elm$core$List$append,
							checkedList,
							_List_fromArray(
								[admin]))
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$AdminList$onCheckAll = F2(
	function (authState, appModel) {
		var model = authState.h1.gQ;
		var _v0 = model;
		var status = _v0.cQ;
		var checkedList = _v0.F;
		if (status.$ === 4) {
			var data = status.a;
			return _Utils_eq(
				$elm$core$List$length(data),
				$elm$core$List$length(checkedList)) ? _Utils_Tuple2(
				A3(
					$author$project$Model$AdminList$mapState,
					_Utils_update(
						model,
						{F: _List_Nil}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
				A3(
					$author$project$Model$AdminList$mapState,
					_Utils_update(
						model,
						{F: data}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				A3($author$project$Model$AdminList$mapState, model, authState, appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$DataStatus$Deleting = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$AdminList$OnDeleteResult = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Api$AdminDelete$CannotDeleteAdmin = 2;
var $author$project$Api$AdminDelete$CannotDeleteYourself = 1;
var $author$project$Api$AdminDelete$InvalidParams = 0;
var $author$project$Api$AdminDelete$MissingError = 3;
var $author$project$Api$AdminDelete$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$3:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'CannotDeleteYourself':
					return 1;
				case 'CannotDeleteAdmin':
					return 2;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 3;
};
var $author$project$Api$AdminDelete$exec = F2(
	function (_v0, token) {
		var ids = _v0.ev;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$AdminDelete$toErrorCode,
			$elm$json$Json$Decode$succeed(0));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ids',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, ids))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'admin/delete', ia: resolver, iQ: token});
	});
var $author$project$Model$AdminList$onDelete = F3(
	function (data, authState, appModel) {
		var model = authState.h1.gQ;
		var _v0 = model;
		var checkedList = _v0.F;
		var ids = A2(
			$elm$core$List$map,
			function (item) {
				return item.eu;
			},
			checkedList);
		return ($elm$core$List$length(ids) > 0) ? _Utils_Tuple2(
			A3(
				$author$project$Model$AdminList$mapState,
				_Utils_update(
					model,
					{
						bQ: false,
						cQ: $author$project$Data$DataStatus$Deleting(data)
					}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAdminList),
					$author$project$Type$AdminList$OnDeleteResult(data)),
				A2(
					$author$project$Api$AdminDelete$exec,
					{ev: ids},
					authState.iQ))) : _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
	});
var $author$project$Api$AdminDelete$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Cannot delete yourself';
		case 2:
			return 'Cannot delete admin';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$AdminList$onDeleteResult = F4(
	function (data, response, authState, appModel) {
		var model = authState.h1.gQ;
		var _v0 = model;
		var offset = _v0.fo;
		var limit = _v0.eV;
		var search = _v0.fU;
		var tenantID = _v0.gm;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminList$mapState,
					_Utils_update(
						model,
						{
							cQ: $author$project$Data$DataStatus$Downloaded(data)
						}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$AdminDelete$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminList$mapState,
					_Utils_update(
						model,
						{F: _List_Nil, cQ: $author$project$Data$DataStatus$Downloading}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.hi, $author$project$Data$Alert$clear)
						})),
				A2(
					$author$project$Model$AdminList$getAdminsCmd,
					{eV: limit, fo: offset, fU: search, gm: tenantID.i3},
					authState.iQ));
		}
	});
var $author$project$Type$AdminList$OnDeleteSingleResult = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Model$AdminList$onDeleteSingle = F4(
	function (id, data, authState, appModel) {
		var model = authState.h1.gQ;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$AdminList$mapState,
				_Utils_update(
					model,
					{
						cQ: $author$project$Data$DataStatus$Deleting(data)
					}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAdminList),
					$author$project$Type$AdminList$OnDeleteSingleResult(data)),
				A2(
					$author$project$Api$AdminDelete$exec,
					{
						ev: _List_fromArray(
							[id])
					},
					authState.iQ)));
	});
var $author$project$Model$AdminList$onDeleteSingleResult = F4(
	function (data, response, authState, appModel) {
		var model = authState.h1.gQ;
		var _v0 = model;
		var offset = _v0.fo;
		var limit = _v0.eV;
		var search = _v0.fU;
		var checkedList = _v0.F;
		var selectedAdmin = _v0.bf;
		var tenantID = _v0.gm;
		var updateCheckedList = A2(
			$elm$core$List$filter,
			function (item) {
				return !_Utils_eq(item.eu, selectedAdmin);
			},
			checkedList);
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminList$mapState,
					_Utils_update(
						model,
						{
							bf: 0,
							cQ: $author$project$Data$DataStatus$Downloaded(data)
						}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$AdminDelete$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminList$mapState,
					_Utils_update(
						model,
						{F: updateCheckedList, bf: 0, cQ: $author$project$Data$DataStatus$Downloading}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.hk, $author$project$Data$Alert$clear)
						})),
				A2(
					$author$project$Model$AdminList$getAdminsCmd,
					{eV: limit, fo: offset, fU: search, gm: tenantID.i3},
					authState.iQ));
		}
	});
var $author$project$Model$AdminList$onGetAdminsResult = F3(
	function (response, authState, appModel) {
		var model = authState.h1.gQ;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminList$mapState,
					_Utils_update(
						model,
						{
							cQ: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var data = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminList$mapState,
					_Utils_update(
						model,
						{
							cQ: $author$project$Data$DataStatus$Downloaded(data.gR),
							iR: data.iR
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$AdminList$onGetTenantResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var adminList = _v0.gQ;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminList$mapState,
					_Utils_update(
						adminList,
						{iM: _List_Nil}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var tenant = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminList$mapState,
					_Utils_update(
						adminList,
						{
							iM: _List_fromArray(
								[
									{hH: tenant.fg, i3: tenant.eu}
								])
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$AdminList$onGetTenantsResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var adminList = _v0.gQ;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminList$mapState,
					_Utils_update(
						adminList,
						{iM: _List_Nil}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AdminList$mapState,
					_Utils_update(
						adminList,
						{iM: value}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$AdminList$update = F3(
	function (msg, authState, appModel) {
		var model = authState.h1.gQ;
		switch (msg.$) {
			case 2:
				var value = msg.a;
				var _v1 = model;
				var searchDebounce = _v1.be;
				var _v2 = A3($author$project$Ext$Debounce$debouncePush, $author$project$Model$AdminList$debounceConfig, value, searchDebounce);
				var debounce = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AdminList$mapState,
						_Utils_update(
							model,
							{fU: value, be: debounce}),
						authState,
						appModel),
					cmd);
			case 3:
				var value = msg.a;
				var _v3 = model;
				var limit = _v3.eV;
				var search = _v3.fU;
				var tenantID = _v3.gm;
				var offset = _v3.fo;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AdminList$mapState,
						_Utils_update(
							model,
							{
								cQ: $author$project$Data$DataStatus$Downloading,
								gm: A2($author$project$Data$Form$updateField, tenantID, value)
							}),
						authState,
						appModel),
					A2(
						$author$project$Model$AdminList$getAdminsCmd,
						{eV: limit, fo: offset, fU: search, gm: value},
						authState.iQ));
			case 0:
				var msg_ = msg.a;
				var _v4 = model;
				var searchDebounce = _v4.be;
				var _v5 = A4(
					$author$project$Ext$Debounce$debounceUpdate,
					$author$project$Model$AdminList$debounceConfig,
					$author$project$Ext$Debounce$debounceTakeLast(
						function (s) {
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAdminList),
									$author$project$Type$AdminList$OnSearch),
								$elm$core$Task$succeed(s));
						}),
					msg_,
					searchDebounce);
				var debounce = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AdminList$mapState,
						_Utils_update(
							model,
							{be: debounce}),
						authState,
						appModel),
					cmd);
			case 1:
				var value = msg.a;
				var _v6 = model;
				var offset = _v6.fo;
				var limit = _v6.eV;
				var tenantID = _v6.gm;
				return _Utils_Tuple2(
					appModel,
					A2(
						$author$project$Model$AdminList$getAdminsCmd,
						{eV: limit, fo: offset, fU: value, gm: tenantID.i3},
						authState.iQ));
			case 4:
				return A2($author$project$Model$AdminList$onCheckAll, authState, appModel);
			case 5:
				var admin = msg.a;
				return A3($author$project$Model$AdminList$onCheck, admin, authState, appModel);
			case 7:
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AdminList$mapState,
						_Utils_update(
							model,
							{bQ: false}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AdminList$mapState,
						_Utils_update(
							model,
							{bQ: true}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 8:
				var value = msg.a;
				var _v7 = model;
				var limit = _v7.eV;
				var search = _v7.fU;
				var tenantID = _v7.gm;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AdminList$mapState,
						_Utils_update(
							model,
							{fo: value, cQ: $author$project$Data$DataStatus$Downloading}),
						authState,
						appModel),
					A2(
						$author$project$Model$AdminList$getAdminsCmd,
						{eV: limit, fo: value, fU: search, gm: tenantID.i3},
						authState.iQ));
			case 9:
				var data = msg.a;
				return A3($author$project$Model$AdminList$onDelete, data, authState, appModel);
			case 10:
				var data = msg.a;
				var response = msg.b;
				return A4($author$project$Model$AdminList$onDeleteResult, data, response, authState, appModel);
			case 11:
				var id = msg.a;
				var data = msg.b;
				return A4($author$project$Model$AdminList$onDeleteSingle, id, data, authState, appModel);
			case 12:
				var data = msg.a;
				var response = msg.b;
				return A4($author$project$Model$AdminList$onDeleteSingleResult, data, response, authState, appModel);
			case 13:
				var response = msg.a;
				return A3($author$project$Model$AdminList$onGetAdminsResult, response, authState, appModel);
			case 15:
				var response = msg.a;
				return A3($author$project$Model$AdminList$onGetTenantResult, response, authState, appModel);
			case 14:
				var response = msg.a;
				return A3($author$project$Model$AdminList$onGetTenantsResult, response, authState, appModel);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AdminList$mapState,
						_Utils_update(
							model,
							{bf: value}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$AuditLog$OnAutocomplete = function (a) {
	return {$: 18, a: a};
};
var $author$project$Type$AuditLog$OnSearch = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$AuditLog$OnSearchDebounce = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$AuditLog$debounceConfig = $author$project$Ext$Debounce$config(
	A2(
		$elm$core$Basics$composeL,
		A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAuditLog),
		$author$project$Type$AuditLog$OnSearchDebounce));
var $author$project$Type$AuditLog$OnExportResult = function (a) {
	return {$: 16, a: a};
};
var $elm$http$Http$bytesResolver = A2(_Http_expect, 'arraybuffer', _Http_toDataView);
var $elm$bytes$Bytes$BE = 1;
var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$andThen = F2(
	function (callback, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var newOffset = _v1.a;
				var a = _v1.b;
				var _v2 = callback(a);
				var decodeB = _v2;
				return A2(decodeB, bites, newOffset);
			});
	});
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0;
		return A2(_Bytes_decode, decoder, bs);
	});
var $elm$bytes$Bytes$Decode$string = function (n) {
	return _Bytes_read_string(n);
};
var $elm$bytes$Bytes$Decode$unsignedInt32 = function (endianness) {
	return _Bytes_read_u32(!endianness);
};
var $author$project$Data$Decode$decodeBytes = function (bytes) {
	var sizedString = A2(
		$elm$bytes$Bytes$Decode$andThen,
		$elm$bytes$Bytes$Decode$string,
		$elm$bytes$Bytes$Decode$unsignedInt32(1));
	return A2($elm$bytes$Bytes$Decode$decode, sizedString, bytes);
};
var $author$project$Api$Base$fileDownloadResolver = function (errorCodeDecoder) {
	return $elm$http$Http$bytesResolver(
		function (response) {
			switch (response.$) {
				case 0:
					var str = response.a;
					return $elm$core$Result$Err(
						$author$project$Api$Base$UnknownError(str));
				case 1:
					return $elm$core$Result$Err($author$project$Api$Base$NetworkError);
				case 2:
					return $elm$core$Result$Err($author$project$Api$Base$NetworkError);
				case 3:
					var bytes = response.b;
					var _v1 = $author$project$Data$Decode$decodeBytes(bytes);
					if (!_v1.$) {
						var string = _v1.a;
						var _v2 = A2(
							$elm$json$Json$Decode$decodeString,
							$author$project$Api$Base$errDecoder(errorCodeDecoder),
							string);
						if (!_v2.$) {
							var error = _v2.a;
							return $elm$core$Result$Err(error);
						} else {
							return $elm$core$Result$Err($author$project$Api$Base$DecodeError);
						}
					} else {
						return $elm$core$Result$Err($author$project$Api$Base$DecodeError);
					}
				default:
					var body = response.b;
					return $elm$core$Result$Ok(body);
			}
		});
};
var $author$project$Api$AuditLogExport$ExportFail = 1;
var $author$project$Api$AuditLogExport$InvalidParams = 0;
var $author$project$Api$AuditLogExport$MissingError = 2;
var $author$project$Api$AuditLogExport$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'ExportFail':
					return 1;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 2;
};
var $author$project$Api$AuditLogExport$exec = F2(
	function (_v0, token) {
		var roleCase = _v0.fO;
		var search = _v0.fU;
		var apiUrl = _v0.c6;
		var startTime = _v0.gc;
		var endTime = _v0.d8;
		var orderBy = _v0.fr;
		var resolver = $author$project$Api$Base$fileDownloadResolver($author$project$Api$AuditLogExport$toErrorCode);
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'roleCase',
					$author$project$Api$Encoder$auditRole(roleCase)),
					_Utils_Tuple2(
					'search',
					$elm$json$Json$Encode$string(search)),
					_Utils_Tuple2(
					'apiUrl',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, apiUrl))),
					_Utils_Tuple2(
					'startTime',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Encode$int),
							startTime))),
					_Utils_Tuple2(
					'endTime',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Encode$int),
							endTime))),
					_Utils_Tuple2(
					'orderBy',
					$author$project$Api$Encoder$auditLogOrderBy(orderBy))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'audit/export', ia: resolver, iQ: token});
	});
var $author$project$Model$AuditLog$exportAuditLogCmd = F2(
	function (model, token) {
		var _v0 = model;
		var role = _v0.ic;
		var orderBy = _v0.fr;
		var search = _v0.fU;
		var autocompleteState = _v0.P;
		var adminID = _v0.N;
		var superAdminID = _v0.V;
		var startTime = _v0.gc;
		var endTime = _v0.d8;
		var apiUrl = $futureworkz$elm_autocomplete$Autocomplete$query(autocompleteState);
		var roleCase = A3(
			$author$project$Data$AuditLog$generateRoleCase,
			role.i3,
			$elm$core$String$toInt(superAdminID.i3),
			$elm$core$String$toInt(adminID.i3));
		var params = {
			c6: (apiUrl === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(apiUrl),
			d8: A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$time$Time$posixToMillis,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Basics$add((((24 * 60) * 60) * 1000) - 1),
						$elm$time$Time$millisToPosix)),
				$elm$core$Result$toMaybe(
					$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(endTime.i3))),
			fr: orderBy,
			fO: roleCase,
			fU: search,
			gc: $elm$core$Result$toMaybe(
				$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(startTime.i3))
		};
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAuditLog),
				$author$project$Type$AuditLog$OnExportResult),
			A2($author$project$Api$AuditLogExport$exec, params, token));
	});
var $author$project$Model$AuditLog$onExport = F2(
	function (authState, appModel) {
		var _v0 = authState;
		var token = _v0.iQ;
		var pages = _v0.h1;
		var _v1 = pages;
		var auditLog = _v1.c7;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$AuditLog$mapState,
				_Utils_update(
					auditLog,
					{a1: $author$project$Data$DataStatus$Downloading}),
				authState,
				appModel),
			A2($author$project$Model$AuditLog$exportAuditLogCmd, auditLog, token));
	});
var $elm$file$File$Download$bytes = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(
				_File_download,
				name,
				mime,
				_File_makeBytesSafeForInternetExplorer(content)));
	});
var $author$project$Model$AuditLog$onExportResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var auditLog = _v0.c7;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AuditLog$mapState,
					_Utils_update(
						auditLog,
						{
							a1: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var bytes = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AuditLog$mapState,
					_Utils_update(
						auditLog,
						{
							a1: $author$project$Data$DataStatus$Downloaded(0)
						}),
					authState,
					appModel),
				A3($elm$file$File$Download$bytes, 'audit_log.csv', 'text/csv', bytes));
		}
	});
var $author$project$Model$AuditLog$onGetAdminsResult = F3(
	function (response, authState, appModel) {
		var model = authState.h1.c7;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AuditLog$mapState,
					_Utils_update(
						model,
						{gR: _List_Nil}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AuditLog$mapState,
					_Utils_update(
						model,
						{gR: value}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$AuditLog$onGetAuditLogList = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var auditLog = _v0.c7;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AuditLog$mapState,
					_Utils_update(
						auditLog,
						{
							cQ: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var data = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AuditLog$mapState,
					_Utils_update(
						auditLog,
						{
							cQ: $author$project$Data$DataStatus$Downloaded(data.gX),
							iR: data.iR
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$AuditLog$onGetSuperAdminsResult = F3(
	function (response, authState, appModel) {
		var model = authState.h1.c7;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AuditLog$mapState,
					_Utils_update(
						model,
						{iz: _List_Nil}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$AuditLog$mapState,
					_Utils_update(
						model,
						{iz: value}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$AuditLog$onSubmit = F2(
	function (authState, appModel) {
		var _v0 = authState;
		var token = _v0.iQ;
		var pages = _v0.h1;
		var _v1 = pages;
		var auditLog = _v1.c7;
		var updatedModel = _Utils_update(
			auditLog,
			{fo: 0, cQ: $author$project$Data$DataStatus$Downloading});
		return _Utils_Tuple2(
			A3($author$project$Model$AuditLog$mapState, updatedModel, authState, appModel),
			A2($author$project$Model$AuditLog$getAuditLogCmd, updatedModel, token));
	});
var $futureworkz$elm_autocomplete$Autocomplete$reset = F2(
	function (c, _v0) {
		var s = _v0;
		return A2($futureworkz$elm_autocomplete$Autocomplete$init, c, s.bI);
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $futureworkz$elm_autocomplete$Autocomplete$selectedValue = function (_v0) {
	var s = _v0;
	return A2(
		$elm$core$Maybe$andThen,
		$elm$core$List$head,
		A2(
			$elm$core$Maybe$map,
			function (i) {
				return A2($elm$core$List$drop, i, s.bC);
			},
			s.ij));
};
var $futureworkz$elm_autocomplete$Internal$DoFetch = function (a) {
	return {$: 1, a: a};
};
var $futureworkz$elm_autocomplete$Autocomplete$Error = function (a) {
	return {$: 2, a: a};
};
var $futureworkz$elm_autocomplete$Autocomplete$FetchedChoices = {$: 3};
var $futureworkz$elm_autocomplete$Autocomplete$Fetching = {$: 1};
var $futureworkz$elm_autocomplete$Internal$OnFetch = function (a) {
	return {$: 2, a: a};
};
var $futureworkz$elm_autocomplete$Internal$wrapAround = F2(
	function (len, index) {
		return (index < 0) ? (len - 1) : ((_Utils_cmp(index, len) > -1) ? 0 : index);
	});
var $futureworkz$elm_autocomplete$Internal$calculateIndex = F3(
	function (len, currentIndex, keyDown) {
		if (len <= 0) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = _Utils_Tuple2(currentIndex, keyDown);
			switch (_v0.b) {
				case 0:
					if (_v0.a.$ === 1) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return $elm$core$Maybe$Just(len - 1);
					} else {
						var i = _v0.a.a;
						var _v5 = _v0.b;
						return $elm$core$Maybe$Just(
							A2($futureworkz$elm_autocomplete$Internal$wrapAround, len, i - 1));
					}
				case 1:
					if (_v0.a.$ === 1) {
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return $elm$core$Maybe$Just(0);
					} else {
						var i = _v0.a.a;
						var _v6 = _v0.b;
						return $elm$core$Maybe$Just(
							A2($futureworkz$elm_autocomplete$Internal$wrapAround, len, i + 1));
					}
				default:
					var _v7 = _v0.b;
					return currentIndex;
			}
		}
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $futureworkz$elm_autocomplete$Autocomplete$update = F2(
	function (msg, _v0) {
		var state = _v0;
		switch (msg.$) {
			case 0:
				var q = msg.a;
				var _v2 = A3($jinjor$elm_debounce$Debounce$push, state.bE, q, state.aw);
				var debounceState = _v2.a;
				var debounceCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{aw: debounceState, b6: q, ij: $elm$core$Maybe$Nothing, aT: $futureworkz$elm_autocomplete$Autocomplete$Fetching}),
					debounceCmd);
			case 6:
				var debouceMsg = msg.a;
				var doFetchCmd = function (s) {
					return A2(
						$elm$core$Task$perform,
						$futureworkz$elm_autocomplete$Internal$DoFetch,
						$elm$core$Task$succeed(
							{bC: state.bC, cw: state.cw, b6: s}));
				};
				var _v3 = A4(
					$jinjor$elm_debounce$Debounce$update,
					state.bE,
					$jinjor$elm_debounce$Debounce$takeLast(doFetchCmd),
					debouceMsg,
					state.aw);
				var debounceState = _v3.a;
				var debounceCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{aw: debounceState}),
					debounceCmd);
			case 1:
				var c = msg.a;
				return _Utils_Tuple2(
					state,
					A2(
						$elm$core$Task$attempt,
						$futureworkz$elm_autocomplete$Internal$OnFetch,
						state.bI(c)));
			case 2:
				var result = msg.a;
				if (result.$ === 1) {
					var s = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							state,
							{
								aT: $futureworkz$elm_autocomplete$Autocomplete$Error(s)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var c = result.a;
					return _Utils_eq(c.b6, state.b6) ? _Utils_Tuple2(
						_Utils_update(
							state,
							{
								bC: A2(
									$elm$core$List$filter,
									function (i) {
										return !A2($elm$core$List$member, i, c.cw);
									},
									c.bC),
								cw: c.cw,
								aT: $futureworkz$elm_autocomplete$Autocomplete$FetchedChoices
							}),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
				}
			case 3:
				var keyDown = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{
							ij: A3(
								$futureworkz$elm_autocomplete$Internal$calculateIndex,
								$elm$core$List$length(state.bC),
								state.ij,
								keyDown)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var index = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{
							a9: $elm$core$Maybe$Just(index)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var upIndex = msg.a;
				return _Utils_eq(
					state.a9,
					$elm$core$Maybe$Just(upIndex)) ? _Utils_Tuple2(
					_Utils_update(
						state,
						{
							a9: $elm$core$Maybe$Nothing,
							ij: $elm$core$Maybe$Just(upIndex)
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$AuditLog$update = F3(
	function (msg, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		var model = pages.c7;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				var _v2 = model;
				var searchDebounce = _v2.be;
				var _v3 = A3($author$project$Ext$Debounce$debouncePush, $author$project$Model$AuditLog$debounceConfig, value, searchDebounce);
				var debounce = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AuditLog$mapState,
						_Utils_update(
							model,
							{fU: value, be: debounce}),
						authState,
						appModel),
					cmd);
			case 1:
				var msg_ = msg.a;
				var _v4 = model;
				var searchDebounce = _v4.be;
				var _v5 = A4(
					$author$project$Ext$Debounce$debounceUpdate,
					$author$project$Model$AuditLog$debounceConfig,
					$author$project$Ext$Debounce$debounceTakeLast(
						function (s) {
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAuditLog),
									$author$project$Type$AuditLog$OnSearch),
								$elm$core$Task$succeed(s));
						}),
					msg_,
					searchDebounce);
				var debounce = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AuditLog$mapState,
						_Utils_update(
							model,
							{be: debounce}),
						authState,
						appModel),
					cmd);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AuditLog$mapState,
						_Utils_update(
							model,
							{fU: value}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				var _v6 = model;
				var role = _v6.ic;
				var superAdminID = _v6.V;
				var adminID = _v6.N;
				var updatedModel = _Utils_update(
					model,
					{
						N: A2($author$project$Data$Form$updateField, adminID, ''),
						ic: A2($author$project$Data$Form$updateField, role, value),
						V: A2($author$project$Data$Form$updateField, superAdminID, '')
					});
				return _Utils_Tuple2(
					A3($author$project$Model$AuditLog$mapState, updatedModel, authState, appModel),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				var _v7 = model;
				var role = _v7.ic;
				var superAdminID = _v7.V;
				var adminID = _v7.N;
				var updatedModel = _Utils_update(
					model,
					{
						N: A2($author$project$Data$Form$updateField, adminID, ''),
						ic: A2($author$project$Data$Form$updateField, role, 'SuperAdmin'),
						V: A2($author$project$Data$Form$updateField, superAdminID, value)
					});
				return _Utils_Tuple2(
					A3($author$project$Model$AuditLog$mapState, updatedModel, authState, appModel),
					$elm$core$Platform$Cmd$none);
			case 5:
				var value = msg.a;
				var _v8 = model;
				var role = _v8.ic;
				var superAdminID = _v8.V;
				var adminID = _v8.N;
				var updatedModel = _Utils_update(
					model,
					{
						N: A2($author$project$Data$Form$updateField, adminID, value),
						ic: A2($author$project$Data$Form$updateField, role, 'Admin'),
						V: A2($author$project$Data$Form$updateField, superAdminID, '')
					});
				return _Utils_Tuple2(
					A3($author$project$Model$AuditLog$mapState, updatedModel, authState, appModel),
					$elm$core$Platform$Cmd$none);
			case 6:
				var value = msg.a;
				var _v9 = model;
				var startTime = _v9.gc;
				var updatedModel = _Utils_update(
					model,
					{
						gc: A2($author$project$Data$Form$updateField, startTime, value)
					});
				return _Utils_Tuple2(
					A3($author$project$Model$AuditLog$mapState, updatedModel, authState, appModel),
					$elm$core$Platform$Cmd$none);
			case 7:
				var value = msg.a;
				var _v10 = model;
				var endTime = _v10.d8;
				var updatedModel = _Utils_update(
					model,
					{
						d8: A2($author$project$Data$Form$updateField, endTime, value)
					});
				return _Utils_Tuple2(
					A3($author$project$Model$AuditLog$mapState, updatedModel, authState, appModel),
					$elm$core$Platform$Cmd$none);
			case 8:
				var value = msg.a;
				var updatedModel = _Utils_update(
					model,
					{fo: value, cQ: $author$project$Data$DataStatus$Downloading});
				return _Utils_Tuple2(
					A3($author$project$Model$AuditLog$mapState, updatedModel, authState, appModel),
					A2($author$project$Model$AuditLog$getAuditLogCmd, updatedModel, authState.iQ));
			case 9:
				var value = msg.a;
				var updatedModel = _Utils_update(
					model,
					{fr: value, cQ: $author$project$Data$DataStatus$Downloading});
				return _Utils_Tuple2(
					A3($author$project$Model$AuditLog$mapState, updatedModel, authState, appModel),
					A2($author$project$Model$AuditLog$getAuditLogCmd, updatedModel, authState.iQ));
			case 10:
				var response = msg.a;
				return A3($author$project$Model$AuditLog$onGetSuperAdminsResult, response, authState, appModel);
			case 11:
				var response = msg.a;
				return A3($author$project$Model$AuditLog$onGetAdminsResult, response, authState, appModel);
			case 12:
				var value = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AuditLog$mapState,
						_Utils_update(
							model,
							{f_: value}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 14:
				var response = msg.a;
				return A3($author$project$Model$AuditLog$onGetAuditLogList, response, authState, appModel);
			case 13:
				return A2($author$project$Model$AuditLog$onSubmit, authState, appModel);
			case 15:
				return A2($author$project$Model$AuditLog$onExport, authState, appModel);
			case 16:
				var response = msg.a;
				return A3($author$project$Model$AuditLog$onExportResult, response, authState, appModel);
			case 17:
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AuditLog$mapState,
						_Utils_update(
							model,
							{a1: $author$project$Data$DataStatus$Init}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 18:
				var autocompleteMsg = msg.a;
				var _v11 = A2($futureworkz$elm_autocomplete$Autocomplete$update, autocompleteMsg, model.P);
				var newAutocompleteState = _v11.a;
				var autoCompleteCmd = _v11.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$AuditLog$mapState,
						_Utils_update(
							model,
							{P: newAutocompleteState}),
						authState,
						appModel),
					A2(
						$elm$core$Platform$Cmd$map,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAuditLog),
							$author$project$Type$AuditLog$OnAutocomplete),
						autoCompleteCmd));
			case 19:
				var _v12 = model;
				var autocompleteState = _v12.P;
				var query = $futureworkz$elm_autocomplete$Autocomplete$query(autocompleteState);
				var selectedValue = $futureworkz$elm_autocomplete$Autocomplete$selectedValue(autocompleteState);
				var updatedModel = _Utils_update(
					model,
					{
						P: A2(
							$futureworkz$elm_autocomplete$Autocomplete$reset,
							{
								bC: _List_Nil,
								cw: _List_Nil,
								b6: A2($elm$core$Maybe$withDefault, query, selectedValue)
							},
							autocompleteState)
					});
				return _Utils_Tuple2(
					A3($author$project$Model$AuditLog$mapState, updatedModel, authState, appModel),
					$elm$core$Platform$Cmd$none);
			default:
				var _v13 = model;
				var autocompleteState = _v13.P;
				var updatedModel = _Utils_update(
					model,
					{
						P: A2(
							$futureworkz$elm_autocomplete$Autocomplete$reset,
							{
								bC: _List_Nil,
								cw: _List_Nil,
								b6: $futureworkz$elm_autocomplete$Autocomplete$query(autocompleteState)
							},
							autocompleteState)
					});
				return _Utils_Tuple2(
					A3($author$project$Model$AuditLog$mapState, updatedModel, authState, appModel),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Alert$Success = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Alert$addSuccess = F2(
	function (text, alerts) {
		return A2(
			$author$project$Data$Alert$addAlert,
			$author$project$Data$Alert$Success(text),
			alerts);
	});
var $author$project$Data$Bot$nodeKindEncoder = function (kind) {
	return $elm$json$Json$Encode$string('Text');
};
var $author$project$Data$Bot$apiNodeEncode = function (_v0) {
	var kind = _v0.eR;
	var data = _v0.dP;
	var children = _v0.bB;
	var childrenEncode = function () {
		var apiNodes = children;
		return A2($elm$json$Json$Encode$list, $author$project$Data$Bot$apiNodeEncode, apiNodes);
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'kind',
				$author$project$Data$Bot$nodeKindEncoder(kind)),
				_Utils_Tuple2('data', data),
				_Utils_Tuple2('children', childrenEncode)
			]));
};
var $elm$file$File$Download$string = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(_File_download, name, mime, content));
	});
var $author$project$Data$BotTree$leafToChildren = function (leaf) {
	return _List_Nil;
};
var $author$project$Data$BotTree$toChildren = function (branch) {
	if (!branch.$) {
		var label = branch.a.hH;
		var leaf = branch.a.bT;
		return {
			bB: $author$project$Data$BotTree$leafToChildren(leaf),
			dP: $elm$json$Json$Encode$string(label),
			eR: 0
		};
	} else {
		var label = branch.a.hH;
		var branches = branch.a.a;
		return {
			bB: A2($elm$core$List$map, $author$project$Data$BotTree$toChildren, branches),
			dP: $elm$json$Json$Encode$string(label),
			eR: 0
		};
	}
};
var $author$project$Data$BotTree$export = F2(
	function (name, _v0) {
		var root = _v0;
		var nodeJsonString = A2(
			$elm$json$Json$Encode$encode,
			0,
			$author$project$Data$Bot$apiNodeEncode(
				{
					bB: A2($elm$core$List$map, $author$project$Data$BotTree$toChildren, root.a),
					dP: $elm$json$Json$Encode$string(root.hH),
					eR: 0
				}));
		return A3($elm$file$File$Download$string, name, 'application/json', nodeJsonString);
	});
var $author$project$Model$BotDetail$onBotTreeExport = F3(
	function (bot, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		var _v1 = botDetail;
		var name = _v1.fg;
		return _Utils_Tuple2(
			_Utils_update(
				appModel,
				{
					ar: A2($author$project$Data$Alert$addSuccess, $author$project$Data$Message$messages.hr, $author$project$Data$Alert$clear)
				}),
			A2($author$project$Data$BotTree$export, name.i3, bot.cW));
	});
var $author$project$Type$BotDetail$OnBotTreeImportSelectFile = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $author$project$Model$BotDetail$onBotTreeImport = F3(
	function (bot, _v0, appModel) {
		return _Utils_Tuple2(
			appModel,
			A2(
				$elm$file$File$Select$file,
				_List_fromArray(
					['application/json']),
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotDetail),
					$author$project$Type$BotDetail$OnBotTreeImportSelectFile(bot))));
	});
var $author$project$Data$BotTree$Root = $elm$core$Basics$identity;
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Data$BotTree$asString = function (value) {
	return A2(
		$elm$core$Result$withDefault,
		'',
		A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value));
};
var $author$project$Data$BotTree$LastBranch = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$BotTree$TextBranch = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$BotTree$childrenLength = function (_v0) {
	var nodes = _v0;
	return $elm$core$List$length(nodes);
};
var $author$project$Data$BotTree$toChildrenList = function (_v0) {
	var nodes = _v0;
	return nodes;
};
var $author$project$Data$BotTree$TextLeaf = $elm$core$Basics$identity;
var $author$project$Data$BotTree$toLeaf = function (node) {
	var _v0 = node.eR;
	return {
		cT: $author$project$Data$BotTree$asString(node.dP)
	};
};
var $author$project$Data$BotTree$toBranch = function (node) {
	return ($author$project$Data$BotTree$childrenLength(node.bB) > 0) ? $author$project$Data$BotTree$TextBranch(
		{
			a: A2(
				$author$project$Data$BotTree$toBranches,
				_List_Nil,
				$author$project$Data$BotTree$toChildrenList(node.bB)),
			hH: $author$project$Data$BotTree$asString(node.dP),
			al: true,
			h: false,
			aR: true
		}) : $author$project$Data$BotTree$LastBranch(
		{
			hH: $author$project$Data$BotTree$asString(node.dP),
			bT: $author$project$Data$BotTree$toLeaf(node),
			h: false
		});
};
var $author$project$Data$BotTree$toBranches = F2(
	function (result, nodes) {
		toBranches:
		while (true) {
			if (nodes.b) {
				var node = nodes.a;
				var rest = nodes.b;
				var $temp$result = A2(
					$elm$core$List$append,
					result,
					_List_fromArray(
						[
							$author$project$Data$BotTree$toBranch(node)
						])),
					$temp$nodes = rest;
				result = $temp$result;
				nodes = $temp$nodes;
				continue toBranches;
			} else {
				return result;
			}
		}
	});
var $author$project$Data$BotTree$toTree = function (_v0) {
	var data = _v0.dP;
	var children = _v0.bB;
	return {
		a: A2(
			$author$project$Data$BotTree$toBranches,
			_List_Nil,
			$author$project$Data$BotTree$toChildrenList(children)),
		hH: $author$project$Data$BotTree$asString(data),
		h: false
	};
};
var $author$project$Data$BotTree$import_ = F2(
	function (data, _v0) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$Data$BotTree$toTree,
			$elm$core$Result$toMaybe(
				A2($elm$json$Json$Decode$decodeString, $author$project$Data$Bot$apiNodeDecoder, data)));
	});
var $author$project$Model$BotDetail$onBotTreeImportResult = F4(
	function (bot, data, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		var _v1 = A2($author$project$Data$BotTree$import_, data, bot.cW);
		if (_v1.$ === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						ar: A2($author$project$Data$Alert$addDanger, $author$project$Data$Message$messages.hF, $author$project$Data$Alert$clear)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var tree = _v1.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotDetail$mapState,
					_Utils_update(
						botDetail,
						{
							j: $author$project$Data$DataStatus$Downloaded(
								_Utils_update(
									bot,
									{eI: true, cW: tree}))
						}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addSuccess, $author$project$Data$Message$messages.hy, $author$project$Data$Alert$clear)
						})),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$BotDetail$OnBotTreeImportResult = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $elm$file$File$toString = _File_toString;
var $author$project$Model$BotDetail$onBotTreeImportSelectFile = F4(
	function (bot, file, _v0, appModel) {
		return _Utils_Tuple2(
			appModel,
			A2(
				$elm$core$Task$perform,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotDetail),
					$author$project$Type$BotDetail$OnBotTreeImportResult(bot)),
				$elm$file$File$toString(file)));
	});
var $author$project$Data$BotTree$recursive = F3(
	function (path, fn, branches) {
		if (path.b) {
			if (!path.b.b) {
				var head = path.a;
				return A2(fn, head, branches);
			} else {
				var head = path.a;
				var rest = path.b;
				return A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, branch) {
							if (_Utils_eq(index, head)) {
								if (!branch.$) {
									return branch;
								} else {
									var textBranch = branch.a;
									return $author$project$Data$BotTree$TextBranch(
										_Utils_update(
											textBranch,
											{
												a: A3($author$project$Data$BotTree$recursive, rest, fn, textBranch.a)
											}));
								}
							} else {
								return branch;
							}
						}),
					branches);
			}
		} else {
			return branches;
		}
	});
var $author$project$Data$BotTree$update = F3(
	function (path, updatedBranch, _v0) {
		var root = _v0;
		var fn = F2(
			function (lastPath, currentBranches) {
				return A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, branch) {
							return _Utils_eq(index, lastPath) ? updatedBranch : branch;
						}),
					currentBranches);
			});
		return _Utils_update(
			root,
			{
				a: A3($author$project$Data$BotTree$recursive, path, fn, root.a)
			});
	});
var $author$project$Data$BotTree$openClose = F4(
	function (open, path, branch, _v0) {
		var root = _v0;
		var fn = function (branch_) {
			if (!branch_.$) {
				return branch_;
			} else {
				var textBranch = branch_.a;
				return $author$project$Data$BotTree$TextBranch(
					_Utils_update(
						textBranch,
						{
							a: A2($elm$core$List$map, fn, textBranch.a),
							al: open
						}));
			}
		};
		if (branch.$ === 1) {
			var textBranch = branch.a;
			var updatedTextBranch = $author$project$Data$BotTree$TextBranch(
				_Utils_update(
					textBranch,
					{
						a: A2($elm$core$List$map, fn, textBranch.a),
						h: false
					}));
			return A3($author$project$Data$BotTree$update, path, updatedTextBranch, root);
		} else {
			return root;
		}
	});
var $author$project$Data$BotTree$closeAll = F3(
	function (path, branch, tree) {
		return A4($author$project$Data$BotTree$openClose, false, path, branch, tree);
	});
var $author$project$Model$BotDetail$onBranchCollapseAll = F5(
	function (path, branch, bot, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						j: $author$project$Data$DataStatus$Downloaded(
							_Utils_update(
								bot,
								{
									cW: A3($author$project$Data$BotTree$closeAll, path, branch, bot.cW)
								}))
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Data$BotTree$delete = F2(
	function (path, _v0) {
		var root = _v0;
		var fn = F2(
			function (lastPath, currentBranches) {
				return A2(
					$elm$core$List$filterMap,
					function (_v1) {
						var index = _v1.a;
						var branch = _v1.b;
						return _Utils_eq(index, lastPath) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(branch);
					},
					A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, currentBranches));
			});
		return _Utils_update(
			root,
			{
				a: A3($author$project$Data$BotTree$recursive, path, fn, root.a)
			});
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Data$BotTree$getInvalidBranchePaths = F3(
	function (path, _v0, result) {
		var index = _v0.a;
		var branch = _v0.b;
		if (branch.$ === 1) {
			var textBranch = branch.a;
			var updatedPath = A2(
				$elm$core$List$append,
				path,
				_List_fromArray(
					[index]));
			var updatedResult = $elm$core$List$isEmpty(textBranch.a) ? A2(
				$elm$core$List$append,
				result,
				_List_fromArray(
					[updatedPath])) : result;
			return A3(
				$elm$core$List$foldl,
				$author$project$Data$BotTree$getInvalidBranchePaths(updatedPath),
				updatedResult,
				A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, textBranch.a));
		} else {
			return result;
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Data$BotTree$setValidByPath = F4(
	function (valid, paths, path, _v0) {
		var index = _v0.a;
		var branch = _v0.b;
		if (!branch.$) {
			return branch;
		} else {
			var textBranch = branch.a;
			var updatedPath = A2(
				$elm$core$List$append,
				path,
				_List_fromArray(
					[index]));
			var updatedBranches = A2(
				$elm$core$List$map,
				A3($author$project$Data$BotTree$setValidByPath, valid, paths, updatedPath),
				A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, textBranch.a));
			var length = $elm$core$List$length(updatedPath);
			var paths_ = A2(
				$elm$core$List$filter,
				function (p) {
					return _Utils_eq(
						A2($elm$core$List$take, length, p),
						updatedPath);
				},
				paths);
			return (A2($elm$core$List$member, updatedPath, paths) || (!$elm$core$List$isEmpty(paths_))) ? $author$project$Data$BotTree$TextBranch(
				_Utils_update(
					textBranch,
					{a: updatedBranches, aR: valid})) : $author$project$Data$BotTree$TextBranch(
				_Utils_update(
					textBranch,
					{a: updatedBranches, aR: !valid}));
		}
	});
var $author$project$Data$BotTree$validate = function (_v0) {
	var root = _v0;
	var paths = A3(
		$elm$core$List$foldl,
		$author$project$Data$BotTree$getInvalidBranchePaths(_List_Nil),
		_List_Nil,
		A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, root.a));
	var updatedBranchs = A2(
		$elm$core$List$map,
		A3($author$project$Data$BotTree$setValidByPath, false, paths, _List_Nil),
		A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, root.a));
	return _Utils_update(
		root,
		{a: updatedBranchs});
};
var $author$project$Model$BotDetail$onBranchDelete = F3(
	function (bot, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		var _v1 = botDetail;
		var branchForm = _v1.k;
		var _v2 = branchForm;
		var deletePath = _v2.a$;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						j: $author$project$Data$DataStatus$Downloaded(
							_Utils_update(
								bot,
								{
									eI: true,
									cW: $author$project$Data$BotTree$validate(
										A2($author$project$Data$BotTree$delete, deletePath, bot.cW))
								})),
						k: _Utils_update(
							branchForm,
							{a$: _List_Nil, b_: false})
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Data$BotTree$openAll = F3(
	function (path, branch, tree) {
		return A4($author$project$Data$BotTree$openClose, true, path, branch, tree);
	});
var $author$project$Model$BotDetail$onBranchExpandAll = F5(
	function (path, branch, bot, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						j: $author$project$Data$DataStatus$Downloaded(
							_Utils_update(
								bot,
								{
									cW: A3($author$project$Data$BotTree$openAll, path, branch, bot.cW)
								}))
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$BotDetail$onBranchFormClose = F2(
	function (authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		var _v1 = botDetail;
		var branchForm = _v1.k;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						k: _Utils_update(
							branchForm,
							{al: false})
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$BotDetail$onBranchFormKindChange = F3(
	function (value, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		var _v1 = botDetail;
		var branchForm = _v1.k;
		var _v2 = branchForm;
		var kind = _v2.eR;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						k: _Utils_update(
							branchForm,
							{
								eR: A2($author$project$Data$Form$updateField, kind, value)
							})
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Data$Form$ValueExisted = 8;
var $author$project$Data$Form$addError = F2(
	function (error, field) {
		return _Utils_update(
			field,
			{
				bH: $elm$core$Maybe$Just(error)
			});
	});
var $author$project$Data$BotTree$getBranchs = F2(
	function (path, branches) {
		if (path.b) {
			var head = path.a;
			var rest = path.b;
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (branches_) {
						return A2($author$project$Data$BotTree$getBranchs, rest, branches_);
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filterMap,
							function (_v1) {
								var index = _v1.a;
								var branch = _v1.b;
								if (_Utils_eq(index, head)) {
									if (!branch.$) {
										return $elm$core$Maybe$Nothing;
									} else {
										var textBranch = branch.a;
										return $elm$core$Maybe$Just(textBranch.a);
									}
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, branches)))));
		} else {
			return branches;
		}
	});
var $author$project$Data$BotTree$getLabel = function (branch) {
	if (!branch.$) {
		var lastBranch = branch.a;
		return lastBranch.hH;
	} else {
		var textBranch = branch.a;
		return textBranch.hH;
	}
};
var $author$project$Data$BotTree$getChildrenLabels = F2(
	function (path, _v0) {
		var root = _v0;
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, branch) {
					return _Utils_Tuple2(
						A2(
							$elm$core$List$append,
							path,
							_List_fromArray(
								[index])),
						$author$project$Data$BotTree$getLabel(branch));
				}),
			A2($author$project$Data$BotTree$getBranchs, path, root.a));
	});
var $author$project$Model$BotDetail$onBranchFormLabelChange = F4(
	function (bot, value, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		var _v1 = botDetail;
		var branchForm = _v1.k;
		var _v2 = branchForm;
		var label = _v2.hH;
		var path = _v2.h3;
		var branch = _v2.a_;
		var parentPath = function () {
			if (branch.$ === 1) {
				return path;
			} else {
				return $elm$core$List$reverse(
					A2(
						$elm$core$List$drop,
						1,
						$elm$core$List$reverse(path)));
			}
		}();
		var isExisted = !$elm$core$List$isEmpty(
			A2(
				$elm$core$List$filter,
				function (_v3) {
					var path_ = _v3.a;
					var label_ = _v3.b;
					return (!_Utils_eq(path_, path)) && _Utils_eq(label_, value);
				},
				A2($author$project$Data$BotTree$getChildrenLabels, parentPath, bot.cW)));
		var updatedLabel = isExisted ? A2(
			$author$project$Data$Form$addError,
			8,
			A2($author$project$Data$Form$updateField, label, value)) : A2($author$project$Data$Form$updateField, label, value);
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						k: _Utils_update(
							branchForm,
							{hH: updatedLabel})
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Data$BotTree$closeAllMenu_ = function (branch) {
	if (!branch.$) {
		var lastBranch = branch.a;
		return $author$project$Data$BotTree$LastBranch(
			_Utils_update(
				lastBranch,
				{h: false}));
	} else {
		var textBranch = branch.a;
		return $author$project$Data$BotTree$TextBranch(
			_Utils_update(
				textBranch,
				{
					a: A2($elm$core$List$map, $author$project$Data$BotTree$closeAllMenu_, textBranch.a),
					h: false
				}));
	}
};
var $author$project$Data$BotTree$closeAllMenu = function (_v0) {
	var root = _v0;
	var updatedRoot = _Utils_update(
		root,
		{
			a: A2($elm$core$List$map, $author$project$Data$BotTree$closeAllMenu_, root.a),
			h: false
		});
	return _Utils_update(
		updatedRoot,
		{h: false});
};
var $author$project$Data$BotTree$LastBranchKind = 0;
var $author$project$Data$BotTree$TextBranchKind = 1;
var $author$project$Data$BotTree$toBranchKindString = function (branchKind) {
	if (branchKind === 1) {
		return 'TextBranchKind';
	} else {
		return 'LastBranchKind';
	}
};
var $author$project$Data$BotTree$getBranchKindString = function (branch) {
	if (!branch.$) {
		return $author$project$Data$BotTree$toBranchKindString(0);
	} else {
		return $author$project$Data$BotTree$toBranchKindString(1);
	}
};
var $author$project$Data$BotTree$getChildren = F2(
	function (path, _v0) {
		var root = _v0;
		return A2($author$project$Data$BotTree$getBranchs, path, root.a);
	});
var $author$project$Model$BotDetail$getDefaultKindForBranchForm = F3(
	function (bot, path, branch) {
		var parentPath = function () {
			if (branch.$ === 1) {
				return path;
			} else {
				return $elm$core$List$reverse(
					A2(
						$elm$core$List$drop,
						1,
						$elm$core$List$reverse(path)));
			}
		}();
		var _v0 = $elm$core$List$head(
			A2($author$project$Data$BotTree$getChildren, parentPath, bot.cW));
		if (_v0.$ === 1) {
			return $author$project$Data$BotTree$toBranchKindString(1);
		} else {
			var branch_ = _v0.a;
			return $author$project$Data$BotTree$getBranchKindString(branch_);
		}
	});
var $author$project$Port$Editor$setMarkdown = _Platform_outgoingPort('setMarkdown', $elm$json$Json$Encode$string);
var $author$project$Model$BotDetail$onBranchFormOpen = F5(
	function (path, branch, bot, authState, appModel) {
		var defaultKind = A3($author$project$Model$BotDetail$getDefaultKindForBranchForm, bot, path, branch);
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		var _v1 = botDetail;
		var branchForm = _v1.k;
		var _v2 = branchForm;
		var label = _v2.hH;
		var kind = _v2.eR;
		var _v3 = function () {
			if (branch.$ === 1) {
				return _Utils_Tuple2(
					{
						bH: $elm$core$Maybe$Nothing,
						gD: _List_fromArray(
							[$author$project$Data$Form$isNotEmpty]),
						i3: ''
					},
					{
						bH: $elm$core$Maybe$Nothing,
						gD: _List_fromArray(
							[$author$project$Data$Form$isNotEmpty]),
						i3: defaultKind
					});
			} else {
				var branch_ = branch.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Data$Form$updateField,
						label,
						$author$project$Data$BotTree$getLabel(branch_)),
					A2(
						$author$project$Data$Form$updateField,
						kind,
						$author$project$Data$BotTree$getBranchKindString(branch_)));
			}
		}();
		var label_ = _v3.a;
		var kind_ = _v3.b;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						j: $author$project$Data$DataStatus$Downloaded(
							_Utils_update(
								bot,
								{
									cW: $author$project$Data$BotTree$closeAllMenu(bot.cW)
								})),
						k: _Utils_update(
							branchForm,
							{a_: branch, eR: kind_, hH: label_, al: true, h3: path})
					}),
				authState,
				appModel),
			$author$project$Port$Editor$setMarkdown(label_.i3));
	});
var $author$project$Data$BotTree$addBranchToRoot = F2(
	function (newBranch, _v0) {
		var root = _v0;
		return _Utils_update(
			root,
			{
				a: A2(
					$elm$core$List$append,
					root.a,
					_List_fromArray(
						[newBranch]))
			});
	});
var $author$project$Data$BotTree$create = F3(
	function (path, newBranch, _v0) {
		var root = _v0;
		var fn = F2(
			function (lastPath, currentBranches) {
				return A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, branch) {
							if (_Utils_eq(index, lastPath)) {
								if (!branch.$) {
									return branch;
								} else {
									var textBranch = branch.a;
									return $author$project$Data$BotTree$TextBranch(
										_Utils_update(
											textBranch,
											{
												a: A2(
													$elm$core$List$append,
													textBranch.a,
													_List_fromArray(
														[newBranch]))
											}));
								}
							} else {
								return branch;
							}
						}),
					currentBranches);
			});
		return _Utils_update(
			root,
			{
				a: A3($author$project$Data$BotTree$recursive, path, fn, root.a)
			});
	});
var $author$project$Data$BotTree$toBranchKind = function (string) {
	if (string === 'TextBranchKind') {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$Data$BotTree$initBranch = F2(
	function (label, kind) {
		var _v0 = $author$project$Data$BotTree$toBranchKind(kind);
		if (_v0 === 1) {
			return $author$project$Data$BotTree$TextBranch(
				{a: _List_Nil, hH: label, al: true, h: false, aR: false});
		} else {
			return $author$project$Data$BotTree$LastBranch(
				{
					hH: label,
					bT: {cT: label},
					h: false
				});
		}
	});
var $author$project$Data$BotTree$updateBranch = F3(
	function (branch, label, kind) {
		var _v0 = $author$project$Data$BotTree$toBranchKind(kind);
		if (_v0 === 1) {
			var branches = function () {
				if (branch.$ === 1) {
					var textBranch = branch.a;
					return textBranch.a;
				} else {
					return _List_Nil;
				}
			}();
			return $author$project$Data$BotTree$TextBranch(
				{a: branches, hH: label, al: true, h: false, aR: false});
		} else {
			return $author$project$Data$BotTree$LastBranch(
				{
					hH: label,
					bT: {cT: label},
					h: false
				});
		}
	});
var $author$project$Model$BotDetail$onBranchFormSubmit = F3(
	function (bot, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		var _v1 = botDetail;
		var branchForm = _v1.k;
		var _v2 = branchForm;
		var label = _v2.hH;
		var kind = _v2.eR;
		var path = _v2.h3;
		var branch = _v2.a_;
		var updatedTree = function () {
			var _v3 = _Utils_Tuple2(
				$elm$core$List$isEmpty(path),
				branch);
			_v3$0:
			while (true) {
				if (_v3.b.$ === 1) {
					if (_v3.a) {
						break _v3$0;
					} else {
						var _v4 = _v3.b;
						return A3(
							$author$project$Data$BotTree$create,
							path,
							A2($author$project$Data$BotTree$initBranch, label.i3, kind.i3),
							bot.cW);
					}
				} else {
					if (_v3.a) {
						break _v3$0;
					} else {
						var branch_ = _v3.b.a;
						return A3(
							$author$project$Data$BotTree$update,
							path,
							A3($author$project$Data$BotTree$updateBranch, branch_, label.i3, kind.i3),
							bot.cW);
					}
				}
			}
			return A2(
				$author$project$Data$BotTree$addBranchToRoot,
				A2($author$project$Data$BotTree$initBranch, label.i3, kind.i3),
				bot.cW);
		}();
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						j: $author$project$Data$DataStatus$Downloaded(
							_Utils_update(
								bot,
								{
									eI: true,
									cW: $author$project$Data$BotTree$validate(updatedTree)
								})),
						k: _Utils_update(
							branchForm,
							{al: false})
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Data$BotTree$getBranch = F2(
	function (path, branches) {
		if (path.b) {
			if (!path.b.b) {
				var head = path.a;
				return $elm$core$List$head(
					A2(
						$elm$core$List$filterMap,
						function (_v1) {
							var index = _v1.a;
							var branch_ = _v1.b;
							return _Utils_eq(index, head) ? $elm$core$Maybe$Just(branch_) : $elm$core$Maybe$Nothing;
						},
						A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, branches)));
			} else {
				var head = path.a;
				var rest = path.b;
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						function (branch_) {
							if (!branch_.$) {
								return $elm$core$Maybe$Nothing;
							} else {
								var textBranch = branch_.a;
								return A2($author$project$Data$BotTree$getBranch, rest, textBranch.a);
							}
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filterMap,
								function (_v2) {
									var index = _v2.a;
									var branch_ = _v2.b;
									return _Utils_eq(index, head) ? $elm$core$Maybe$Just(branch_) : $elm$core$Maybe$Nothing;
								},
								A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, branches)))));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Data$BotTree$setShowMenu = F2(
	function (showMenu, branch) {
		if (!branch.$) {
			var lastBranch = branch.a;
			return $author$project$Data$BotTree$LastBranch(
				_Utils_update(
					lastBranch,
					{h: showMenu}));
		} else {
			var textBranch = branch.a;
			return $author$project$Data$BotTree$TextBranch(
				_Utils_update(
					textBranch,
					{h: showMenu}));
		}
	});
var $author$project$Data$BotTree$move = F4(
	function (path, upDown, movingBranch, _v0) {
		var root = _v0;
		var swapBranch = F3(
			function (_v3, _v4, branches) {
				var x = _v3.a;
				var xBranch = _v3.b;
				var y = _v4.a;
				var yBranch = _v4.b;
				return A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, branch) {
							return _Utils_eq(index, x) ? xBranch : (_Utils_eq(index, y) ? yBranch : branch);
						}),
					branches);
			});
		var parentPath = $elm$core$List$reverse(
			A2(
				$elm$core$List$drop,
				1,
				$elm$core$List$reverse(path)));
		var parent = A2($author$project$Data$BotTree$getBranch, parentPath, root.a);
		var movingBranch_ = A2($author$project$Data$BotTree$setShowMenu, false, movingBranch);
		var currentIndex = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$head(
				$elm$core$List$reverse(path)));
		var anotherBranch = A2(
			$author$project$Data$BotTree$getBranch,
			A2(
				$elm$core$List$append,
				parentPath,
				_List_fromArray(
					[currentIndex + upDown])),
			root.a);
		var _v1 = _Utils_Tuple2(parent, anotherBranch);
		_v1$2:
		while (true) {
			if (!_v1.a.$) {
				if ((_v1.a.a.$ === 1) && (!_v1.b.$)) {
					var parent_ = _v1.a.a.a;
					var anotherBranch_ = _v1.b.a;
					return A3(
						$author$project$Data$BotTree$update,
						parentPath,
						$author$project$Data$BotTree$TextBranch(
							_Utils_update(
								parent_,
								{
									a: A3(
										swapBranch,
										_Utils_Tuple2(currentIndex + upDown, movingBranch_),
										_Utils_Tuple2(currentIndex, anotherBranch_),
										parent_.a)
								})),
						root);
				} else {
					break _v1$2;
				}
			} else {
				if (!_v1.b.$) {
					var _v2 = _v1.a;
					var anotherBranch_ = _v1.b.a;
					return _Utils_update(
						root,
						{
							a: A3(
								swapBranch,
								_Utils_Tuple2(currentIndex + upDown, movingBranch_),
								_Utils_Tuple2(currentIndex, anotherBranch_),
								root.a)
						});
				} else {
					break _v1$2;
				}
			}
		}
		return root;
	});
var $author$project$Data$BotTree$moveDown = F3(
	function (path, movingBranch, tree) {
		return A4($author$project$Data$BotTree$move, path, 1, movingBranch, tree);
	});
var $author$project$Model$BotDetail$onBranchMoveDown = F5(
	function (path, branch, bot, authState, appModel) {
		var updatedTree = $author$project$Data$BotTree$closeAllMenu(bot.cW);
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						j: $author$project$Data$DataStatus$Downloaded(
							_Utils_update(
								bot,
								{
									eI: true,
									cW: A3($author$project$Data$BotTree$moveDown, path, branch, updatedTree)
								}))
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Data$BotTree$moveUp = F3(
	function (path, movingBranch, tree) {
		return A4($author$project$Data$BotTree$move, path, -1, movingBranch, tree);
	});
var $author$project$Model$BotDetail$onBranchMoveUp = F5(
	function (path, branch, bot, authState, appModel) {
		var updatedTree = $author$project$Data$BotTree$closeAllMenu(bot.cW);
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						j: $author$project$Data$DataStatus$Downloaded(
							_Utils_update(
								bot,
								{
									eI: true,
									cW: A3($author$project$Data$BotTree$moveUp, path, branch, updatedTree)
								}))
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Data$BotTree$updateOpen = F3(
	function (path, branch, tree) {
		if (!branch.$) {
			return tree;
		} else {
			var textBranch = branch.a;
			return A3(
				$author$project$Data$BotTree$update,
				path,
				$author$project$Data$BotTree$TextBranch(
					_Utils_update(
						textBranch,
						{al: !textBranch.al})),
				tree);
		}
	});
var $author$project$Model$BotDetail$onChangeBranchOpen = F5(
	function (path, branch, bot, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						j: $author$project$Data$DataStatus$Downloaded(
							_Utils_update(
								bot,
								{
									cW: A3($author$project$Data$BotTree$updateOpen, path, branch, bot.cW)
								}))
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Data$BotTree$updateShowMenu = F3(
	function (path, branch, _v0) {
		var root = _v0;
		var updatedTree = _Utils_update(
			root,
			{
				a: A2($elm$core$List$map, $author$project$Data$BotTree$closeAllMenu_, root.a),
				h: false
			});
		if (!branch.$) {
			var lastBranch = branch.a;
			return A3(
				$author$project$Data$BotTree$update,
				path,
				$author$project$Data$BotTree$LastBranch(
					_Utils_update(
						lastBranch,
						{h: !lastBranch.h})),
				updatedTree);
		} else {
			var textBranch = branch.a;
			return A3(
				$author$project$Data$BotTree$update,
				path,
				$author$project$Data$BotTree$TextBranch(
					_Utils_update(
						textBranch,
						{
							a: A2($elm$core$List$map, $author$project$Data$BotTree$closeAllMenu_, textBranch.a),
							h: !textBranch.h
						})),
				updatedTree);
		}
	});
var $author$project$Model$BotDetail$onChangeBranchShowMenu = F5(
	function (path, branch, bot, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						j: $author$project$Data$DataStatus$Downloaded(
							_Utils_update(
								bot,
								{
									cW: A3($author$project$Data$BotTree$updateShowMenu, path, branch, bot.cW)
								}))
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$BotDetail$onCloseAllMenu = F3(
	function (bot, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						j: $author$project$Data$DataStatus$Downloaded(
							_Utils_update(
								bot,
								{
									cW: $author$project$Data$BotTree$closeAllMenu(bot.cW)
								}))
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$BotDetail$onDeleteBranchClose = F2(
	function (authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		var _v1 = botDetail;
		var branchForm = _v1.k;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						k: _Utils_update(
							branchForm,
							{a$: _List_Nil, b_: false})
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$BotDetail$onDeleteBranchOpen = F5(
	function (deletePath, branch, bot, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		var _v1 = botDetail;
		var branchForm = _v1.k;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						j: $author$project$Data$DataStatus$Downloaded(
							_Utils_update(
								bot,
								{
									cW: A3($author$project$Data$BotTree$updateShowMenu, deletePath, branch, bot.cW)
								})),
						k: _Utils_update(
							branchForm,
							{a$: deletePath, b_: true})
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Data$Form$boolToString = function (bool) {
	return bool ? 'True' : 'False';
};
var $author$project$Data$BotTree$fromBot = function (_v0) {
	var id = _v0.eu;
	var tenantID = _v0.gm;
	var languageCode = _v0.eT;
	var name = _v0.fg;
	var host = _v0.et;
	var nodeJson = _v0.fl;
	var isPublished = _v0.eJ;
	return {
		et: host,
		eu: id,
		eI: false,
		eJ: isPublished,
		eT: languageCode,
		fg: name,
		gm: tenantID,
		cW: $author$project$Data$BotTree$toTree(nodeJson)
	};
};
var $author$project$Model$BotDetail$onGetBotResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotDetail$mapState,
					_Utils_update(
						botDetail,
						{
							j: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			var bot = $author$project$Data$BotTree$fromBot(value);
			var _v2 = botDetail;
			var languageCode = _v2.eT;
			var name = _v2.fg;
			var isPublished = _v2.eJ;
			var tenantID = _v2.gm;
			var host = _v2.et;
			var updatedModel = _Utils_update(
				botDetail,
				{
					j: $author$project$Data$DataStatus$Downloaded(bot),
					et: _Utils_update(
						host,
						{i3: bot.et}),
					eJ: _Utils_update(
						isPublished,
						{
							i3: $author$project$Data$Form$boolToString(bot.eJ)
						}),
					eT: _Utils_update(
						languageCode,
						{i3: bot.eT}),
					fg: _Utils_update(
						name,
						{i3: bot.fg}),
					gm: _Utils_update(
						tenantID,
						{
							i3: $elm$core$String$fromInt(bot.gm)
						})
				});
			return _Utils_Tuple2(
				A3($author$project$Model$BotDetail$mapState, updatedModel, authState, appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Api$TenantDetail$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Cannot get tenant';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$BotDetail$onGetTenantResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotDetail$mapState,
					botDetail,
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$TenantDetail$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotDetail$mapState,
					_Utils_update(
						botDetail,
						{
							iM: $author$project$Data$DataStatus$Downloaded(
								_List_fromArray(
									[value]))
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$BotDetail$onGetTenantsResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotDetail$mapState,
					_Utils_update(
						botDetail,
						{
							iM: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotDetail$mapState,
					_Utils_update(
						botDetail,
						{
							iM: $author$project$Data$DataStatus$Downloaded(value.iM)
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$BotDetail$OnBranchFormLabelChange = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Type$BotDetail$OnRootFormLabelChange = function (a) {
	return {$: 22, a: a};
};
var $author$project$Model$BotDetail$onMarkdownEditor = F3(
	function (value, _v0, appModel) {
		var pages = _v0.h1;
		var _v1 = pages.g0.j;
		if (_v1.$ === 4) {
			var bot_ = _v1.a;
			var _v2 = pages.g0;
			var branchForm = _v2.k;
			var rootForm = _v2.ae;
			var cmd = rootForm.al ? A2(
				$elm$core$Task$perform,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotDetail),
					$author$project$Type$BotDetail$OnRootFormLabelChange),
				$elm$core$Task$succeed(value)) : (branchForm.al ? A2(
				$elm$core$Task$perform,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotDetail),
					$author$project$Type$BotDetail$OnBranchFormLabelChange(bot_)),
				$elm$core$Task$succeed(value)) : $elm$core$Platform$Cmd$none);
			return _Utils_Tuple2(appModel, cmd);
		} else {
			return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$BotDetail$onRootAddChildren = F3(
	function (bot, authState, appModel) {
		var defaultKind = A3($author$project$Model$BotDetail$getDefaultKindForBranchForm, bot, _List_Nil, $elm$core$Maybe$Nothing);
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		var _v1 = botDetail;
		var branchForm = _v1.k;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						j: $author$project$Data$DataStatus$Downloaded(
							_Utils_update(
								bot,
								{
									cW: $author$project$Data$BotTree$closeAllMenu(bot.cW)
								})),
						k: _Utils_update(
							branchForm,
							{
								a_: $elm$core$Maybe$Nothing,
								eR: {
									bH: $elm$core$Maybe$Nothing,
									gD: _List_fromArray(
										[$author$project$Data$Form$isNotEmpty]),
									i3: defaultKind
								},
								hH: {
									bH: $elm$core$Maybe$Nothing,
									gD: _List_fromArray(
										[$author$project$Data$Form$isNotEmpty]),
									i3: ''
								},
								al: true,
								h3: _List_Nil
							})
					}),
				authState,
				appModel),
			$author$project$Port$Editor$setMarkdown(''));
	});
var $author$project$Data$BotTree$setOpen = F2(
	function (open, branch) {
		if (!branch.$) {
			return branch;
		} else {
			var textBranch = branch.a;
			return $author$project$Data$BotTree$TextBranch(
				_Utils_update(
					textBranch,
					{al: open}));
		}
	});
var $author$project$Data$BotTree$closeRoot = function (tree) {
	var root = tree;
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v1, updatedTree) {
				var index = _v1.a;
				var branch = _v1.b;
				return A3(
					$author$project$Data$BotTree$closeAll,
					_List_fromArray(
						[index]),
					A2($author$project$Data$BotTree$setOpen, false, branch),
					updatedTree);
			}),
		_Utils_update(
			root,
			{h: false}),
		A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, root.a));
};
var $author$project$Model$BotDetail$onRootCollapseAll = F3(
	function (bot, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						j: $author$project$Data$DataStatus$Downloaded(
							_Utils_update(
								bot,
								{
									cW: $author$project$Data$BotTree$closeRoot(bot.cW)
								}))
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Data$BotTree$openRoot = function (tree) {
	var root = tree;
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v1, updatedTree) {
				var index = _v1.a;
				var branch = _v1.b;
				return A3(
					$author$project$Data$BotTree$openAll,
					_List_fromArray(
						[index]),
					A2($author$project$Data$BotTree$setOpen, true, branch),
					updatedTree);
			}),
		_Utils_update(
			root,
			{h: false}),
		A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, root.a));
};
var $author$project$Model$BotDetail$onRootExpandAll = F3(
	function (bot, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						j: $author$project$Data$DataStatus$Downloaded(
							_Utils_update(
								bot,
								{
									cW: $author$project$Data$BotTree$openRoot(bot.cW)
								}))
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$BotDetail$onRootFormLabelChange = F3(
	function (value, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		var _v1 = botDetail;
		var rootForm = _v1.ae;
		var _v2 = rootForm;
		var label = _v2.hH;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						ae: _Utils_update(
							rootForm,
							{
								hH: A2($author$project$Data$Form$updateField, label, value)
							})
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$BotDetail$onRootFormOpen = F4(
	function (open, value, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		var _v1 = botDetail;
		var rootForm = _v1.ae;
		var _v2 = rootForm;
		var label = _v2.hH;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						ae: _Utils_update(
							rootForm,
							{
								hH: A2($author$project$Data$Form$updateField, label, value),
								al: open
							})
					}),
				authState,
				appModel),
			$author$project$Port$Editor$setMarkdown(value));
	});
var $author$project$Data$BotTree$updateRootLabel = F2(
	function (label, _v0) {
		var root = _v0;
		return _Utils_update(
			root,
			{hH: label});
	});
var $author$project$Model$BotDetail$onRootFormSubmit = F3(
	function (bot, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		var _v1 = botDetail;
		var rootForm = _v1.ae;
		var _v2 = rootForm;
		var label = _v2.hH;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						j: $author$project$Data$DataStatus$Downloaded(
							_Utils_update(
								bot,
								{
									eI: true,
									cW: $author$project$Data$BotTree$validate(
										A2($author$project$Data$BotTree$updateRootLabel, label.i3, bot.cW))
								})),
						ae: _Utils_update(
							rootForm,
							{al: false})
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Data$BotTree$updateRootShowMenu = function (_v0) {
	var root = _v0;
	var updatedRoot = _Utils_update(
		root,
		{
			a: A2($elm$core$List$map, $author$project$Data$BotTree$closeAllMenu_, root.a),
			h: false
		});
	return _Utils_update(
		updatedRoot,
		{h: !root.h});
};
var $author$project$Model$BotDetail$onRootShowMenu = F3(
	function (bot, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{
						j: $author$project$Data$DataStatus$Downloaded(
							_Utils_update(
								bot,
								{
									cW: $author$project$Data$BotTree$updateRootShowMenu(bot.cW)
								}))
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Type$BotDetail$OnUpdateResult = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$BotUpdate$BotExisted = 5;
var $author$project$Api$BotUpdate$CannotGetAdmin = 3;
var $author$project$Api$BotUpdate$InvalidHost = 6;
var $author$project$Api$BotUpdate$InvalidLanguageCode = 4;
var $author$project$Api$BotUpdate$InvalidNodeJson = 2;
var $author$project$Api$BotUpdate$InvalidParams = 0;
var $author$project$Api$BotUpdate$InvalidTenant = 1;
var $author$project$Api$BotUpdate$MissingError = 8;
var $author$project$Api$BotUpdate$TenantNotFound = 7;
var $author$project$Api$BotUpdate$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$8:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidTenant':
					return 1;
				case 'InvalidNodeJson':
					return 2;
				case 'CannotGetAdmin':
					return 3;
				case 'InvalidLanguageCode':
					return 4;
				case 'BotExisted':
					return 5;
				case 'InvalidHost':
					return 6;
				case 'TenantNotFound':
					return 7;
				default:
					break _v0$8;
			}
		} else {
			break _v0$8;
		}
	}
	return 8;
};
var $author$project$Api$BotUpdate$exec = F2(
	function (_v0, token) {
		var id = _v0.eu;
		var tenantID = _v0.gm;
		var languageCode = _v0.eT;
		var name = _v0.fg;
		var host = _v0.et;
		var nodeJson = _v0.fl;
		var isPublished = _v0.eJ;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$BotUpdate$toErrorCode,
			A2($elm$json$Json$Decode$field, 'bot', $author$project$Api$Decoder$bot));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(id)),
					_Utils_Tuple2(
					'tenantID',
					$elm$json$Json$Encode$int(tenantID)),
					_Utils_Tuple2(
					'languageCode',
					$elm$json$Json$Encode$string(languageCode)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name)),
					_Utils_Tuple2(
					'host',
					$elm$json$Json$Encode$string(host)),
					_Utils_Tuple2(
					'nodeJson',
					$author$project$Data$Bot$apiNodeEncode(nodeJson)),
					_Utils_Tuple2(
					'isPublished',
					$elm$json$Json$Encode$bool(isPublished))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'bot/update', ia: resolver, iQ: token});
	});
var $author$project$Data$BotTree$getBranchCount_ = F2(
	function (branch, result) {
		if (branch.$ === 1) {
			var textBranch = branch.a;
			return A3($elm$core$List$foldl, $author$project$Data$BotTree$getBranchCount_, result + 1, textBranch.a);
		} else {
			return result + 1;
		}
	});
var $author$project$Data$BotTree$getBranchCount = function (_v0) {
	var root = _v0;
	return A3($elm$core$List$foldl, $author$project$Data$BotTree$getBranchCount_, 0, root.a);
};
var $author$project$Data$Form$stringToBool = function (string) {
	switch (string) {
		case 'True':
			return $elm$core$Maybe$Just(true);
		case 'False':
			return $elm$core$Maybe$Just(false);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$BotTree$toBot = function (_v0) {
	var id = _v0.eu;
	var tenantID = _v0.gm;
	var languageCode = _v0.eT;
	var name = _v0.fg;
	var host = _v0.et;
	var tree = _v0.cW;
	var isPublished = _v0.eJ;
	var label = tree.hH;
	var branches = tree.a;
	return {
		et: host,
		eu: id,
		eJ: isPublished,
		eT: languageCode,
		fg: name,
		fl: {
			bB: A2($elm$core$List$map, $author$project$Data$BotTree$toChildren, branches),
			dP: $elm$json$Json$Encode$string(label),
			eR: 0
		},
		gm: tenantID
	};
};
var $author$project$Model$BotDetail$onUpdate = F3(
	function (bot, appModel, authState) {
		var allNodes = $author$project$Data$BotTree$getBranchCount(bot.cW);
		var _v0 = authState;
		var token = _v0.iQ;
		var pages = _v0.h1;
		var _v1 = pages;
		var botDetail = _v1.g0;
		var _v2 = botDetail;
		var languageCode = _v2.eT;
		var name = _v2.fg;
		var host = _v2.et;
		var isPublished = _v2.eJ;
		var tenantID = _v2.gm;
		var tenants = _v2.iM;
		var params = $author$project$Data$BotTree$toBot(
			{
				et: host.i3,
				eu: bot.eu,
				eI: false,
				eJ: A2(
					$elm$core$Maybe$withDefault,
					false,
					$author$project$Data$Form$stringToBool(isPublished.i3)),
				eT: languageCode.i3,
				fg: name.i3,
				gm: A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(tenantID.i3)),
				cW: bot.cW
			});
		var maxNodes = function () {
			if (tenants.$ === 4) {
				var tenants_ = tenants.a;
				return A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.e1;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (_v4) {
									var id = _v4.eu;
									return _Utils_eq(
										$elm$core$String$fromInt(id),
										tenantID.i3);
								},
								tenants_))));
			} else {
				return 0;
			}
		}();
		return ($author$project$Data$Form$isValidFields(
			_List_fromArray(
				[languageCode, isPublished, tenantID])) && (_Utils_cmp(maxNodes, allNodes) > -1)) ? _Utils_Tuple2(
			A3(
				$author$project$Model$BotDetail$mapState,
				_Utils_update(
					botDetail,
					{J: 1, cE: false}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotDetail),
					$author$project$Type$BotDetail$OnUpdateResult),
				A2($author$project$Api$BotUpdate$exec, params, token))) : _Utils_Tuple2(
			A3($author$project$Model$BotDetail$mapState, botDetail, authState, appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Api$BotUpdate$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid tenant';
		case 2:
			return 'Invalid node data';
		case 3:
			return 'Cannot get admin';
		case 4:
			return 'Invalid language code';
		case 5:
			return 'Bot already exists';
		case 6:
			return 'Invalid host';
		case 7:
			return 'Tenant not found';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$BotDetail$onUpdateResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var botDetail = _v0.g0;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotDetail$mapState,
					_Utils_update(
						botDetail,
						{J: 2}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$BotUpdate$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			var okAppModel = _Utils_update(
				appModel,
				{
					ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.iY, $author$project$Data$Alert$clear)
				});
			var bot = $author$project$Data$BotTree$fromBot(value);
			var okModel = _Utils_update(
				botDetail,
				{
					j: $author$project$Data$DataStatus$Downloaded(bot),
					J: 2
				});
			return _Utils_Tuple2(
				A3($author$project$Model$BotDetail$mapState, okModel, authState, okAppModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$BotDetail$update = F3(
	function (msg, authState, appModel) {
		var model = authState.h1.g0;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				var _v1 = model;
				var languageCode = _v1.eT;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotDetail$mapState,
						_Utils_update(
							model,
							{
								eT: A2($author$project$Data$Form$updateField, languageCode, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				var _v2 = model;
				var name = _v2.fg;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotDetail$mapState,
						_Utils_update(
							model,
							{
								fg: A2($author$project$Data$Form$updateField, name, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				var _v3 = model;
				var host = _v3.et;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotDetail$mapState,
						_Utils_update(
							model,
							{
								et: A2($author$project$Data$Form$updateField, host, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				var _v4 = model;
				var isPublished = _v4.eJ;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotDetail$mapState,
						_Utils_update(
							model,
							{
								eJ: A2($author$project$Data$Form$updateField, isPublished, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				var _v5 = model;
				var tenantID = _v5.gm;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotDetail$mapState,
						_Utils_update(
							model,
							{
								gm: A2($author$project$Data$Form$updateField, tenantID, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 5:
				var bot = msg.a;
				return A3($author$project$Model$BotDetail$onUpdate, bot, appModel, authState);
			case 6:
				var response = msg.a;
				return A3($author$project$Model$BotDetail$onUpdateResult, response, authState, appModel);
			case 9:
				var response = msg.a;
				return A3($author$project$Model$BotDetail$onGetBotResult, response, authState, appModel);
			case 7:
				var response = msg.a;
				return A3($author$project$Model$BotDetail$onGetTenantsResult, response, authState, appModel);
			case 8:
				var response = msg.a;
				return A3($author$project$Model$BotDetail$onGetTenantResult, response, authState, appModel);
			case 10:
				var value = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotDetail$mapState,
						_Utils_update(
							model,
							{cE: value}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 11:
				var bot = msg.a;
				return A3($author$project$Model$BotDetail$onBotTreeExport, bot, authState, appModel);
			case 12:
				var bot = msg.a;
				return A3($author$project$Model$BotDetail$onBotTreeImport, bot, authState, appModel);
			case 13:
				var bot = msg.a;
				var file = msg.b;
				return A4($author$project$Model$BotDetail$onBotTreeImportSelectFile, bot, file, authState, appModel);
			case 14:
				var bot = msg.a;
				var string = msg.b;
				return A4($author$project$Model$BotDetail$onBotTreeImportResult, bot, string, authState, appModel);
			case 15:
				var bot = msg.a;
				return A3($author$project$Model$BotDetail$onCloseAllMenu, bot, authState, appModel);
			case 16:
				var value = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotDetail$mapState,
						_Utils_update(
							model,
							{fU: value}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 17:
				var bot = msg.a;
				return A3($author$project$Model$BotDetail$onRootShowMenu, bot, authState, appModel);
			case 18:
				var bot = msg.a;
				return A3($author$project$Model$BotDetail$onRootExpandAll, bot, authState, appModel);
			case 19:
				var bot = msg.a;
				return A3($author$project$Model$BotDetail$onRootCollapseAll, bot, authState, appModel);
			case 20:
				var bot = msg.a;
				return A3($author$project$Model$BotDetail$onRootAddChildren, bot, authState, appModel);
			case 21:
				var value = msg.a;
				var label = msg.b;
				return A4($author$project$Model$BotDetail$onRootFormOpen, value, label, authState, appModel);
			case 22:
				var value = msg.a;
				return A3($author$project$Model$BotDetail$onRootFormLabelChange, value, authState, appModel);
			case 23:
				var bot = msg.a;
				return A3($author$project$Model$BotDetail$onRootFormSubmit, bot, authState, appModel);
			case 24:
				var path = msg.a;
				var branch = msg.b;
				var bot = msg.c;
				return A5($author$project$Model$BotDetail$onChangeBranchOpen, path, branch, bot, authState, appModel);
			case 25:
				var path = msg.a;
				var branch = msg.b;
				var bot = msg.c;
				return A5($author$project$Model$BotDetail$onChangeBranchShowMenu, path, branch, bot, authState, appModel);
			case 26:
				var path = msg.a;
				var branch = msg.b;
				var bot = msg.c;
				return A5($author$project$Model$BotDetail$onBranchFormOpen, path, branch, bot, authState, appModel);
			case 27:
				return A2($author$project$Model$BotDetail$onBranchFormClose, authState, appModel);
			case 28:
				var bot = msg.a;
				var value = msg.b;
				return A4($author$project$Model$BotDetail$onBranchFormLabelChange, bot, value, authState, appModel);
			case 29:
				var value = msg.a;
				return A3($author$project$Model$BotDetail$onBranchFormKindChange, value, authState, appModel);
			case 30:
				var bot = msg.a;
				return A3($author$project$Model$BotDetail$onBranchFormSubmit, bot, authState, appModel);
			case 31:
				var bot = msg.a;
				return A3($author$project$Model$BotDetail$onBranchDelete, bot, authState, appModel);
			case 32:
				var path = msg.a;
				var branch = msg.b;
				var bot = msg.c;
				return A5($author$project$Model$BotDetail$onBranchMoveUp, path, branch, bot, authState, appModel);
			case 33:
				var path = msg.a;
				var branch = msg.b;
				var bot = msg.c;
				return A5($author$project$Model$BotDetail$onBranchMoveDown, path, branch, bot, authState, appModel);
			case 34:
				var path = msg.a;
				var branch = msg.b;
				var bot = msg.c;
				return A5($author$project$Model$BotDetail$onBranchExpandAll, path, branch, bot, authState, appModel);
			case 35:
				var path = msg.a;
				var branch = msg.b;
				var bot = msg.c;
				return A5($author$project$Model$BotDetail$onBranchCollapseAll, path, branch, bot, authState, appModel);
			case 36:
				var deletePath = msg.a;
				var branch = msg.b;
				var bot = msg.c;
				return A5($author$project$Model$BotDetail$onDeleteBranchOpen, deletePath, branch, bot, authState, appModel);
			case 37:
				return A2($author$project$Model$BotDetail$onDeleteBranchClose, authState, appModel);
			default:
				var value = msg.a;
				return A3($author$project$Model$BotDetail$onMarkdownEditor, value, authState, appModel);
		}
	});
var $author$project$Type$BotList$OnSearch = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$BotList$OnSearchDebounce = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BotList$debounceConfig = $author$project$Ext$Debounce$config(
	A2(
		$elm$core$Basics$composeL,
		A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotList),
		$author$project$Type$BotList$OnSearchDebounce));
var $author$project$Model$BotList$onCheck = F3(
	function (bot, authState, appModel) {
		var _v0 = authState.h1;
		var botList = _v0.g1;
		var _v1 = botList;
		var checkedList = _v1.F;
		var isExisted = A2(
			$elm$core$List$filter,
			function (item) {
				return _Utils_eq(item.eu, bot.eu);
			},
			checkedList);
		return ($elm$core$List$length(isExisted) > 0) ? _Utils_Tuple2(
			A3(
				$author$project$Model$BotList$mapState,
				_Utils_update(
					botList,
					{
						F: A2(
							$elm$core$List$filter,
							function (item) {
								return !_Utils_eq(item.eu, bot.eu);
							},
							checkedList)
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
			A3(
				$author$project$Model$BotList$mapState,
				_Utils_update(
					botList,
					{
						F: A2(
							$elm$core$List$append,
							checkedList,
							_List_fromArray(
								[bot]))
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$BotList$onCheckAll = F2(
	function (authState, appModel) {
		var model = authState.h1.g1;
		var _v0 = model;
		var status = _v0.cQ;
		var checkedList = _v0.F;
		if (status.$ === 4) {
			var data = status.a;
			return _Utils_eq(
				$elm$core$List$length(data),
				$elm$core$List$length(checkedList)) ? _Utils_Tuple2(
				A3(
					$author$project$Model$BotList$mapState,
					_Utils_update(
						model,
						{F: _List_Nil}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
				A3(
					$author$project$Model$BotList$mapState,
					_Utils_update(
						model,
						{F: data}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				A3($author$project$Model$BotList$mapState, model, authState, appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$BotList$OnDeleteResult = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Api$BotDelete$CannotDeleteBot = 3;
var $author$project$Api$BotDelete$CannotGetBot = 2;
var $author$project$Api$BotDelete$InvalidParams = 0;
var $author$project$Api$BotDelete$InvalidTenant = 1;
var $author$project$Api$BotDelete$MissingError = 4;
var $author$project$Api$BotDelete$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$4:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidTenant':
					return 1;
				case 'CannotGetBot':
					return 2;
				case 'CannotDeleteBot':
					return 3;
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return 4;
};
var $author$project$Api$BotDelete$exec = F2(
	function (ids, token) {
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$BotDelete$toErrorCode,
			$elm$json$Json$Decode$succeed(0));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ids',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, ids))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'bot/delete', ia: resolver, iQ: token});
	});
var $author$project$Model$BotList$onDelete = F3(
	function (data, authState, appModel) {
		var model = authState.h1.g1;
		var _v0 = model;
		var checkedList = _v0.F;
		var ids = A2(
			$elm$core$List$map,
			function (item) {
				return item.eu;
			},
			checkedList);
		return ($elm$core$List$length(ids) > 0) ? _Utils_Tuple2(
			A3(
				$author$project$Model$BotList$mapState,
				_Utils_update(
					model,
					{
						bQ: false,
						cQ: $author$project$Data$DataStatus$Deleting(data)
					}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotList),
					$author$project$Type$BotList$OnDeleteResult(data)),
				A2($author$project$Api$BotDelete$exec, ids, authState.iQ))) : _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
	});
var $author$project$Api$BotDelete$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid tanent';
		case 2:
			return 'Cannot get Bot';
		case 3:
			return 'Cannot delete Bot';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$BotList$onDeleteResult = F4(
	function (data, response, authState, appModel) {
		var model = authState.h1.g1;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotList$mapState,
					_Utils_update(
						model,
						{
							cQ: $author$project$Data$DataStatus$Downloaded(data)
						}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$BotDelete$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotList$mapState,
					_Utils_update(
						model,
						{F: _List_Nil, cQ: $author$project$Data$DataStatus$Downloading}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.hj, $author$project$Data$Alert$clear)
						})),
				A2($author$project$Model$BotList$getBotsCmd, model, authState.iQ));
		}
	});
var $author$project$Type$BotList$OnDeleteSingleResult = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Model$BotList$onDeleteSingle = F4(
	function (id, data, authState, appModel) {
		var model = authState.h1.g1;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotList$mapState,
				_Utils_update(
					model,
					{
						cQ: $author$project$Data$DataStatus$Deleting(data)
					}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotList),
					$author$project$Type$BotList$OnDeleteSingleResult(data)),
				A2(
					$author$project$Api$BotDelete$exec,
					_List_fromArray(
						[id]),
					authState.iQ)));
	});
var $author$project$Model$BotList$onDeleteSingleResult = F4(
	function (data, response, authState, appModel) {
		var model = authState.h1.g1;
		var _v0 = model;
		var checkedList = _v0.F;
		var selectedDeleteBot = _v0.bg;
		var updateCheckedList = A2(
			$elm$core$List$filter,
			function (item) {
				return !_Utils_eq(item.eu, selectedDeleteBot);
			},
			checkedList);
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotList$mapState,
					_Utils_update(
						model,
						{
							bg: 0,
							cQ: $author$project$Data$DataStatus$Downloaded(data)
						}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$BotDelete$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotList$mapState,
					_Utils_update(
						model,
						{F: updateCheckedList, bg: 0, cQ: $author$project$Data$DataStatus$Downloading}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.hk, $author$project$Data$Alert$clear)
						})),
				A2($author$project$Model$BotList$getBotsCmd, model, authState.iQ));
		}
	});
var $author$project$Model$BotList$onGetBotsResult = F3(
	function (response, authState, appModel) {
		var model = authState.h1.g1;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotList$mapState,
					_Utils_update(
						model,
						{
							cQ: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var data = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotList$mapState,
					_Utils_update(
						model,
						{
							cQ: $author$project$Data$DataStatus$Downloaded(data.g2),
							iR: data.iR
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$BotList$onGetTenantResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var botList = _v0.g1;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotList$mapState,
					_Utils_update(
						botList,
						{iM: _List_Nil}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var id = response.a.eu;
			var name = response.a.fg;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotList$mapState,
					_Utils_update(
						botList,
						{
							iM: _List_fromArray(
								[
									{hH: name, i3: id}
								])
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$BotList$onGetTenantsResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var botList = _v0.g1;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotList$mapState,
					_Utils_update(
						botList,
						{iM: _List_Nil}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotList$mapState,
					_Utils_update(
						botList,
						{iM: value}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$BotList$OnSubmitFormResult = function (a) {
	return {$: 23, a: a};
};
var $author$project$Api$BotCreate$BotExisted = 4;
var $author$project$Api$BotCreate$CannotGetBots = 6;
var $author$project$Api$BotCreate$InvalidHost = 5;
var $author$project$Api$BotCreate$InvalidLanguageCode = 3;
var $author$project$Api$BotCreate$InvalidNodeJson = 2;
var $author$project$Api$BotCreate$InvalidParams = 0;
var $author$project$Api$BotCreate$InvalidTenant = 1;
var $author$project$Api$BotCreate$MaxBotCreated = 7;
var $author$project$Api$BotCreate$MissingError = 9;
var $author$project$Api$BotCreate$TenantNotFound = 8;
var $author$project$Api$BotCreate$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$9:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidTenant':
					return 1;
				case 'InvalidNodeJson':
					return 2;
				case 'InvalidLanguageCode':
					return 3;
				case 'BotExisted':
					return 4;
				case 'InvalidHost':
					return 5;
				case 'CannotGetBots':
					return 6;
				case 'MaxBotCreated':
					return 7;
				case 'TenantNotFound':
					return 8;
				default:
					break _v0$9;
			}
		} else {
			break _v0$9;
		}
	}
	return 9;
};
var $author$project$Api$BotCreate$exec = F2(
	function (_v0, token) {
		var tenantID = _v0.gm;
		var languageCode = _v0.eT;
		var name = _v0.fg;
		var host = _v0.et;
		var nodeJson = _v0.fl;
		var isPublished = _v0.eJ;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$BotCreate$toErrorCode,
			A2($elm$json$Json$Decode$field, 'bot', $author$project$Api$Decoder$bot));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tenantID',
					$elm$json$Json$Encode$int(tenantID)),
					_Utils_Tuple2(
					'languageCode',
					$elm$json$Json$Encode$string(languageCode)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name)),
					_Utils_Tuple2(
					'host',
					$elm$json$Json$Encode$string(host)),
					_Utils_Tuple2(
					'nodeJson',
					$author$project$Data$Bot$apiNodeEncode(nodeJson)),
					_Utils_Tuple2(
					'isPublished',
					$elm$json$Json$Encode$bool(isPublished))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'bot/create', ia: resolver, iQ: token});
	});
var $author$project$Model$BotList$onSubmitForm = F2(
	function (authState, appModel) {
		var _v0 = authState.h1;
		var profile = _v0.fD;
		var _v1 = authState.h1;
		var botList = _v1.g1;
		var _v2 = botList;
		var form = _v2.t;
		var _v3 = form;
		var languageCode = _v3.eT;
		var tenantID = _v3.gm;
		var name = _v3.fg;
		var host = _v3.et;
		var _v4 = function () {
			var _v5 = profile.fD;
			if (!_v5.$) {
				var value = _v5.a;
				return _Utils_Tuple2(
					$author$project$Data$Form$isValidFields(
						_List_fromArray(
							[languageCode, name, host])),
					value.gm);
			} else {
				return _Utils_Tuple2(
					$author$project$Data$Form$isValidFields(
						_List_fromArray(
							[languageCode, name, host, tenantID])),
					A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$String$toInt(tenantID.i3)));
			}
		}();
		var isValidField = _v4.a;
		var tenantValue = _v4.b;
		var task = A2(
			$author$project$Api$BotCreate$exec,
			{
				et: host.i3,
				eJ: false,
				eT: languageCode.i3,
				fg: name.i3,
				fl: {
					bB: _List_Nil,
					dP: $elm$json$Json$Encode$string('How can I help you?'),
					eR: 0
				},
				gm: tenantValue
			},
			authState.iQ);
		return isValidField ? _Utils_Tuple2(
			A3(
				$author$project$Model$BotList$mapState,
				_Utils_update(
					botList,
					{
						t: _Utils_update(
							form,
							{cQ: 1})
					}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotList),
					$author$project$Type$BotList$OnSubmitFormResult),
				task)) : _Utils_Tuple2(
			A3($author$project$Model$BotList$mapState, botList, authState, appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$BotList$onSubmitFormResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var botList = _v0.g1;
		var _v1 = botList;
		var form = _v1.t;
		var _v2 = form;
		var languageCode = _v2.eT;
		var tenantID = _v2.gm;
		var name = _v2.fg;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotList$mapState,
					_Utils_update(
						botList,
						{
							t: _Utils_update(
								form,
								{
									cq: $elm$core$Maybe$Just(error),
									cQ: 2
								})
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotList$mapState,
					_Utils_update(
						botList,
						{
							t: _Utils_update(
								form,
								{
									cq: $elm$core$Maybe$Nothing,
									eT: _Utils_update(
										languageCode,
										{i3: ''}),
									fg: _Utils_update(
										name,
										{i3: ''}),
									cQ: 0,
									gm: _Utils_update(
										tenantID,
										{i3: ''})
								}),
							cy: false
						}),
					authState,
					appModel),
				A2(
					$elm$browser$Browser$Navigation$pushUrl,
					appModel.ab,
					$author$project$Data$Route$routeUrl.d1(value.eu)));
		}
	});
var $author$project$Model$BotList$update = F3(
	function (msg, authState, appModel) {
		var model = authState.h1.g1;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				var _v1 = model;
				var searchDebounce = _v1.be;
				var _v2 = A3($author$project$Ext$Debounce$debouncePush, $author$project$Model$BotList$debounceConfig, value, searchDebounce);
				var debounce = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotList$mapState,
						_Utils_update(
							model,
							{fU: value, be: debounce}),
						authState,
						appModel),
					cmd);
			case 1:
				var msg_ = msg.a;
				var _v3 = model;
				var searchDebounce = _v3.be;
				var _v4 = A4(
					$author$project$Ext$Debounce$debounceUpdate,
					$author$project$Model$BotList$debounceConfig,
					$author$project$Ext$Debounce$debounceTakeLast(
						function (s) {
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotList),
									$author$project$Type$BotList$OnSearch),
								$elm$core$Task$succeed(s));
						}),
					msg_,
					searchDebounce);
				var debounce = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotList$mapState,
						_Utils_update(
							model,
							{be: debounce}),
						authState,
						appModel),
					cmd);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					appModel,
					A2(
						$author$project$Model$BotList$getBotsCmd,
						_Utils_update(
							model,
							{fU: value}),
						authState.iQ));
			case 3:
				var value = msg.a;
				var _v5 = model;
				var tenantID = _v5.gm;
				var updatedModel = _Utils_update(
					model,
					{
						cQ: $author$project$Data$DataStatus$Downloading,
						gm: A2($author$project$Data$Form$updateField, tenantID, value)
					});
				return _Utils_Tuple2(
					A3($author$project$Model$BotList$mapState, updatedModel, authState, appModel),
					A2($author$project$Model$BotList$getBotsCmd, updatedModel, authState.iQ));
			case 4:
				var value = msg.a;
				var _v6 = model;
				var languageCode = _v6.eT;
				var updatedModel = _Utils_update(
					model,
					{
						eT: A2($author$project$Data$Form$updateField, languageCode, value),
						cQ: $author$project$Data$DataStatus$Downloading
					});
				return _Utils_Tuple2(
					A3($author$project$Model$BotList$mapState, updatedModel, authState, appModel),
					A2($author$project$Model$BotList$getBotsCmd, updatedModel, authState.iQ));
			case 5:
				return A2($author$project$Model$BotList$onCheckAll, authState, appModel);
			case 6:
				var bot = msg.a;
				return A3($author$project$Model$BotList$onCheck, bot, authState, appModel);
			case 8:
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotList$mapState,
						_Utils_update(
							model,
							{bQ: false}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotList$mapState,
						_Utils_update(
							model,
							{bQ: true}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 10:
				var data = msg.a;
				return A3($author$project$Model$BotList$onDelete, data, authState, appModel);
			case 11:
				var data = msg.a;
				var response = msg.b;
				return A4($author$project$Model$BotList$onDeleteResult, data, response, authState, appModel);
			case 12:
				var id = msg.a;
				var data = msg.b;
				return A4($author$project$Model$BotList$onDeleteSingle, id, data, authState, appModel);
			case 13:
				var data = msg.a;
				var response = msg.b;
				return A4($author$project$Model$BotList$onDeleteSingleResult, data, response, authState, appModel);
			case 9:
				var value = msg.a;
				var updatedModel = _Utils_update(
					model,
					{fo: value, cQ: $author$project$Data$DataStatus$Downloading});
				return _Utils_Tuple2(
					A3($author$project$Model$BotList$mapState, updatedModel, authState, appModel),
					A2($author$project$Model$BotList$getBotsCmd, updatedModel, authState.iQ));
			case 14:
				var response = msg.a;
				return A3($author$project$Model$BotList$onGetBotsResult, response, authState, appModel);
			case 16:
				var response = msg.a;
				return A3($author$project$Model$BotList$onGetTenantResult, response, authState, appModel);
			case 15:
				var response = msg.a;
				return A3($author$project$Model$BotList$onGetTenantsResult, response, authState, appModel);
			case 17:
				var value = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotList$mapState,
						_Utils_update(
							model,
							{cy: value}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 18:
				var value = msg.a;
				var _v7 = model;
				var form = _v7.t;
				var _v8 = form;
				var languageCode = _v8.eT;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotList$mapState,
						_Utils_update(
							model,
							{
								t: _Utils_update(
									form,
									{
										eT: A2($author$project$Data$Form$updateField, languageCode, value)
									})
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 19:
				var value = msg.a;
				var _v9 = model;
				var form = _v9.t;
				var _v10 = form;
				var name = _v10.fg;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotList$mapState,
						_Utils_update(
							model,
							{
								t: _Utils_update(
									form,
									{
										fg: A2($author$project$Data$Form$updateField, name, value)
									})
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 20:
				var value = msg.a;
				var _v11 = model;
				var form = _v11.t;
				var _v12 = form;
				var host = _v12.et;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotList$mapState,
						_Utils_update(
							model,
							{
								t: _Utils_update(
									form,
									{
										et: A2($author$project$Data$Form$updateField, host, value)
									})
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 21:
				var value = msg.a;
				var _v13 = model;
				var form = _v13.t;
				var _v14 = form;
				var tenantID = _v14.gm;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotList$mapState,
						_Utils_update(
							model,
							{
								t: _Utils_update(
									form,
									{
										gm: A2($author$project$Data$Form$updateField, tenantID, value)
									})
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 22:
				return A2($author$project$Model$BotList$onSubmitForm, authState, appModel);
			case 23:
				var result = msg.a;
				return A3($author$project$Model$BotList$onSubmitFormResult, result, authState, appModel);
			case 24:
				var value = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotList$mapState,
						_Utils_update(
							model,
							{bg: value}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotList$mapState,
						_Utils_update(
							model,
							{fZ: value}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$BotLog$OnAutocomplete = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Model$BotLog$onAutocomplete = F4(
	function (kind, autocompleteMsg, authState, appModel) {
		var _v0 = authState.h1;
		var botLog = _v0.dk;
		if (!kind) {
			var _v2 = A2($futureworkz$elm_autocomplete$Autocomplete$update, autocompleteMsg, botLog.U);
			var newAutocompleteState = _v2.a;
			var autoCompleteCmd = _v2.b;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						botLog,
						{U: newAutocompleteState}),
					authState,
					appModel),
				A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotLog),
						$author$project$Type$BotLog$OnAutocomplete(kind)),
					autoCompleteCmd));
		} else {
			var _v3 = A2($futureworkz$elm_autocomplete$Autocomplete$update, autocompleteMsg, botLog.R);
			var newAutocompleteState = _v3.a;
			var autoCompleteCmd = _v3.b;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						botLog,
						{R: newAutocompleteState}),
					authState,
					appModel),
				A2(
					$elm$core$Platform$Cmd$map,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotLog),
						$author$project$Type$BotLog$OnAutocomplete(kind)),
					autoCompleteCmd));
		}
	});
var $author$project$Model$BotLog$onAutocompleteClose = F3(
	function (kind, authState, appModel) {
		var updateAutocomplete = function (autocomplete) {
			return A2(
				$futureworkz$elm_autocomplete$Autocomplete$reset,
				{
					bC: _List_Nil,
					cw: _List_Nil,
					b6: $futureworkz$elm_autocomplete$Autocomplete$query(autocomplete)
				},
				autocomplete);
		};
		var _v0 = authState.h1;
		var botLog = _v0.dk;
		if (!kind) {
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						botLog,
						{
							U: updateAutocomplete(botLog.U)
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						botLog,
						{
							R: updateAutocomplete(botLog.R)
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$BotLog$onAutocompleteSelect = F3(
	function (kind, authState, appModel) {
		var updateAutocomplete = function (autocomplete) {
			var selectedValue = $futureworkz$elm_autocomplete$Autocomplete$selectedValue(autocomplete);
			var query = $futureworkz$elm_autocomplete$Autocomplete$query(autocomplete);
			return A2(
				$futureworkz$elm_autocomplete$Autocomplete$reset,
				{
					bC: _List_Nil,
					cw: _List_Nil,
					b6: A2($elm$core$Maybe$withDefault, query, selectedValue)
				},
				autocomplete);
		};
		var _v0 = authState.h1;
		var botLog = _v0.dk;
		if (!kind) {
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						botLog,
						{
							U: updateAutocomplete(botLog.U)
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						botLog,
						{
							R: updateAutocomplete(botLog.R)
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$BotLog$OnExportResult = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$BotLogExport$CannotGetBot = 2;
var $author$project$Api$BotLogExport$ExportFail = 1;
var $author$project$Api$BotLogExport$InvalidParams = 0;
var $author$project$Api$BotLogExport$MissingError = 3;
var $author$project$Api$BotLogExport$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$3:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'ExportFail':
					return 1;
				case 'CannotGetBot':
					return 2;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 3;
};
var $author$project$Api$BotLogExport$exec = F2(
	function (_v0, token) {
		var tenantID = _v0.gm;
		var languageCode = _v0.eT;
		var botID = _v0.di;
		var email = _v0.d4;
		var sessionID = _v0.f1;
		var startTime = _v0.gc;
		var endTime = _v0.d8;
		var orderBy = _v0.fr;
		var resolver = $author$project$Api$Base$fileDownloadResolver($author$project$Api$BotLogExport$toErrorCode);
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tenantID',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, tenantID))),
					_Utils_Tuple2(
					'languageCode',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, languageCode))),
					_Utils_Tuple2(
					'botID',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, botID))),
					_Utils_Tuple2(
					'email',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, email))),
					_Utils_Tuple2(
					'startTime',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Encode$int),
							startTime))),
					_Utils_Tuple2(
					'endTime',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Encode$int),
							endTime))),
					_Utils_Tuple2(
					'sessionID',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, sessionID))),
					_Utils_Tuple2(
					'orderBy',
					$author$project$Api$Encoder$botLogOrderBy(orderBy))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'bot/logs/export', ia: resolver, iQ: token});
	});
var $author$project$Model$BotLog$onExport = F2(
	function (authState, appModel) {
		var _v0 = authState;
		var token = _v0.iQ;
		var pages = _v0.h1;
		var _v1 = pages;
		var botLog = _v1.dk;
		var _v2 = botLog;
		var tenantID = _v2.gm;
		var languageCode = _v2.eT;
		var botID = _v2.di;
		var sessionIDAutocomplete = _v2.U;
		var emailAutocomplete = _v2.R;
		var startTime = _v2.gc;
		var endTime = _v2.d8;
		var orderBy = _v2.fr;
		var email = $futureworkz$elm_autocomplete$Autocomplete$query(emailAutocomplete);
		var sessionID = $futureworkz$elm_autocomplete$Autocomplete$query(sessionIDAutocomplete);
		var params = {
			di: $elm$core$String$toInt(botID.i3),
			d4: (email === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(email),
			d8: A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$time$Time$posixToMillis,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Basics$add((((24 * 60) * 60) * 1000) - 1),
						$elm$time$Time$millisToPosix)),
				$elm$core$Result$toMaybe(
					$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(endTime.i3))),
			eT: (languageCode.i3 === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(languageCode.i3),
			fr: orderBy,
			f1: (sessionID === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(sessionID),
			gc: $elm$core$Result$toMaybe(
				$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(startTime.i3)),
			gm: $elm$core$String$toInt(tenantID.i3)
		};
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotLog$mapState,
				_Utils_update(
					botLog,
					{a1: $author$project$Data$DataStatus$Downloading}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotLog),
					$author$project$Type$BotLog$OnExportResult),
				A2($author$project$Api$BotLogExport$exec, params, token)));
	});
var $author$project$Model$BotLog$onExportResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var botLog = _v0.dk;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						botLog,
						{
							a1: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var bytes = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						botLog,
						{
							a1: $author$project$Data$DataStatus$Downloaded(0)
						}),
					authState,
					appModel),
				A3($elm$file$File$Download$bytes, 'bot_log.csv', 'text/csv', bytes));
		}
	});
var $author$project$Model$BotLog$onGetBotSessionListResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var botLog = _v0.dk;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						botLog,
						{
							aZ: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						botLog,
						{
							aZ: $author$project$Data$DataStatus$Downloaded(value.dl)
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$BotLog$onGetBotsResult = F3(
	function (response, authState, appModel) {
		var model = authState.h1.dk;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						model,
						{g2: _List_Nil}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			var botNames = A3(
				$elm$core$List$foldl,
				F2(
					function (item, all) {
						return A3($elm$core$Dict$insert, item.i3, item.hH, all);
					}),
				model.cg,
				value);
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						model,
						{cg: botNames, g2: value}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$BotLog$onGetLogsResult = F3(
	function (response, authState, appModel) {
		var model = authState.h1.dk;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						model,
						{
							cQ: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var botLogs = response.a.dl;
			var total = response.a.iR;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						model,
						{
							cQ: $author$project$Data$DataStatus$Downloaded(botLogs),
							iR: total
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$BotLog$onGetTenantResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var botLog = _v0.dk;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						botLog,
						{iM: _List_Nil}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var tenant = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						botLog,
						{
							iM: _List_fromArray(
								[
									{hH: tenant.fg, i3: tenant.eu}
								])
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$BotLog$onGetTenantsResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var botLog = _v0.dk;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						botLog,
						{iM: _List_Nil}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotLog$mapState,
					_Utils_update(
						botLog,
						{iM: value}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$BotLog$OnGetBotSessionListResult = function (a) {
	return {$: 13, a: a};
};
var $author$project$Data$BotLog$SessionListResponse = function (botLogs) {
	return {dl: botLogs};
};
var $author$project$Api$Decoder$botLogSessionList = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$BotLog$SessionListResponse,
	A2(
		$elm$json$Json$Decode$field,
		'botLogs',
		$elm$json$Json$Decode$list($author$project$Api$Decoder$botLog)));
var $author$project$Api$BotLogSessionList$CannotGetLogs = 1;
var $author$project$Api$BotLogSessionList$InvalidParams = 0;
var $author$project$Api$BotLogSessionList$MissingError = 2;
var $author$project$Api$BotLogSessionList$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'CannotGetLogs':
					return 1;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 2;
};
var $author$project$Api$BotLogSessionList$exec = F2(
	function (_v0, token) {
		var sessionID = _v0.f1;
		var resolver = A2($author$project$Api$Base$standardResolver, $author$project$Api$BotLogSessionList$toErrorCode, $author$project$Api$Decoder$botLogSessionList);
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sessionID',
					$elm$json$Json$Encode$string(sessionID))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'bot/logs/session', ia: resolver, iQ: token});
	});
var $author$project$Model$BotLog$onShowBotSessions = F3(
	function (sessionID, authState, appModel) {
		var _v0 = authState;
		var token = _v0.iQ;
		var pages = _v0.h1;
		var _v1 = pages;
		var botLog = _v1.dk;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotLog$mapState,
				_Utils_update(
					botLog,
					{
						aZ: $author$project$Data$DataStatus$Downloading,
						dN: $elm$core$Maybe$Just(sessionID),
						cO: true
					}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotLog),
					$author$project$Type$BotLog$OnGetBotSessionListResult),
				A2(
					$author$project$Api$BotLogSessionList$exec,
					{f1: sessionID},
					token)));
	});
var $author$project$Model$BotLog$onSubmit = F2(
	function (authState, appModel) {
		var _v0 = authState;
		var token = _v0.iQ;
		var pages = _v0.h1;
		var _v1 = pages;
		var botLog = _v1.dk;
		var updatedModel = _Utils_update(
			botLog,
			{fo: 0, cQ: $author$project$Data$DataStatus$Downloading});
		return _Utils_Tuple2(
			A3($author$project$Model$BotLog$mapState, updatedModel, authState, appModel),
			A2($author$project$Model$BotLog$getLogsCmd, updatedModel, token));
	});
var $author$project$Model$BotLog$update = F3(
	function (msg, authState, appModel) {
		var _v0 = authState;
		var token = _v0.iQ;
		var pages = _v0.h1;
		var model = pages.dk;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				var _v2 = model;
				var tenantID = _v2.gm;
				var botID = _v2.di;
				var updatedModel = _Utils_update(
					model,
					{
						di: A2($author$project$Data$Form$updateField, botID, ''),
						gm: A2($author$project$Data$Form$updateField, tenantID, value)
					});
				return _Utils_Tuple2(
					A3($author$project$Model$BotLog$mapState, updatedModel, authState, appModel),
					A2($author$project$Model$BotLog$getBotsCmd, updatedModel, token));
			case 1:
				var value = msg.a;
				var _v3 = model;
				var languageCode = _v3.eT;
				var botID = _v3.di;
				var updatedModel = _Utils_update(
					model,
					{
						di: A2($author$project$Data$Form$updateField, botID, ''),
						eT: A2($author$project$Data$Form$updateField, languageCode, value)
					});
				return _Utils_Tuple2(
					A3($author$project$Model$BotLog$mapState, updatedModel, authState, appModel),
					A2($author$project$Model$BotLog$getBotsCmd, updatedModel, token));
			case 2:
				var value = msg.a;
				var _v4 = model;
				var botID = _v4.di;
				var updatedModel = _Utils_update(
					model,
					{
						di: A2($author$project$Data$Form$updateField, botID, value)
					});
				return _Utils_Tuple2(
					A3($author$project$Model$BotLog$mapState, updatedModel, authState, appModel),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				var _v5 = model;
				var startTime = _v5.gc;
				var updatedModel = _Utils_update(
					model,
					{
						gc: A2($author$project$Data$Form$updateField, startTime, value)
					});
				return _Utils_Tuple2(
					A3($author$project$Model$BotLog$mapState, updatedModel, authState, appModel),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				var _v6 = model;
				var endTime = _v6.d8;
				var updatedModel = _Utils_update(
					model,
					{
						d8: A2($author$project$Data$Form$updateField, endTime, value)
					});
				return _Utils_Tuple2(
					A3($author$project$Model$BotLog$mapState, updatedModel, authState, appModel),
					$elm$core$Platform$Cmd$none);
			case 5:
				var value = msg.a;
				var updatedModel = _Utils_update(
					model,
					{fo: value, cQ: $author$project$Data$DataStatus$Downloading});
				return _Utils_Tuple2(
					A3($author$project$Model$BotLog$mapState, updatedModel, authState, appModel),
					A2($author$project$Model$BotLog$getLogsCmd, updatedModel, token));
			case 6:
				var value = msg.a;
				var updatedModel = _Utils_update(
					model,
					{fr: value, cQ: $author$project$Data$DataStatus$Downloading});
				return _Utils_Tuple2(
					A3($author$project$Model$BotLog$mapState, updatedModel, authState, appModel),
					A2($author$project$Model$BotLog$getLogsCmd, updatedModel, token));
			case 10:
				var response = msg.a;
				return A3($author$project$Model$BotLog$onGetLogsResult, response, authState, appModel);
			case 9:
				var response = msg.a;
				return A3($author$project$Model$BotLog$onGetBotsResult, response, authState, appModel);
			case 7:
				var response = msg.a;
				return A3($author$project$Model$BotLog$onGetTenantsResult, response, authState, appModel);
			case 8:
				var response = msg.a;
				return A3($author$project$Model$BotLog$onGetTenantResult, response, authState, appModel);
			case 11:
				var value = msg.a;
				return A3($author$project$Model$BotLog$onShowBotSessions, value, authState, appModel);
			case 12:
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotLog$mapState,
						_Utils_update(
							model,
							{aZ: $author$project$Data$DataStatus$Init, cO: false}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 13:
				var response = msg.a;
				return A3($author$project$Model$BotLog$onGetBotSessionListResult, response, authState, appModel);
			case 14:
				return A2($author$project$Model$BotLog$onSubmit, authState, appModel);
			case 15:
				return A2($author$project$Model$BotLog$onExport, authState, appModel);
			case 16:
				var response = msg.a;
				return A3($author$project$Model$BotLog$onExportResult, response, authState, appModel);
			case 17:
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotLog$mapState,
						_Utils_update(
							model,
							{a1: $author$project$Data$DataStatus$Init}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 18:
				var kind = msg.a;
				var autocompleteMsg = msg.b;
				return A4($author$project$Model$BotLog$onAutocomplete, kind, autocompleteMsg, authState, appModel);
			case 19:
				var kind = msg.a;
				return A3($author$project$Model$BotLog$onAutocompleteSelect, kind, authState, appModel);
			default:
				var kind = msg.a;
				return A3($author$project$Model$BotLog$onAutocompleteClose, kind, authState, appModel);
		}
	});
var $author$project$Type$BotReport$OnExportResult = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$BotReportExport$CannotGetAdmin = 2;
var $author$project$Api$BotReportExport$ExportFail = 1;
var $author$project$Api$BotReportExport$InvalidParams = 0;
var $author$project$Api$BotReportExport$MissingError = 3;
var $author$project$Api$BotReportExport$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$3:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'ExportFail':
					return 1;
				case 'CannotGetAdmin':
					return 2;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 3;
};
var $author$project$Api$BotReportExport$exec = F2(
	function (_v0, token) {
		var botID = _v0.di;
		var startTime = _v0.gc;
		var endTime = _v0.d8;
		var resolver = $author$project$Api$Base$fileDownloadResolver($author$project$Api$BotReportExport$toErrorCode);
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'botID',
					$elm$json$Json$Encode$int(botID)),
					_Utils_Tuple2(
					'startTime',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Encode$int),
							startTime))),
					_Utils_Tuple2(
					'endTime',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Encode$int),
							endTime)))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'report/export', ia: resolver, iQ: token});
	});
var $author$project$Model$BotReport$onExport = F2(
	function (authState, appModel) {
		var _v0 = authState;
		var token = _v0.iQ;
		var pages = _v0.h1;
		var _v1 = pages;
		var botReport = _v1.dm;
		var _v2 = botReport;
		var botID = _v2.di;
		var cmd_ = function () {
			var _v3 = $elm$core$String$toInt(botID.i3);
			if (!_v3.$) {
				var botID_ = _v3.a;
				var _v4 = botReport;
				var startTime = _v4.gc;
				var endTime = _v4.d8;
				var params = {
					di: botID_,
					d8: A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$time$Time$posixToMillis,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Basics$add((((24 * 60) * 60) * 1000) - 1),
								$elm$time$Time$millisToPosix)),
						$elm$core$Result$toMaybe(
							$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(endTime.i3))),
					gc: $elm$core$Result$toMaybe(
						$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(startTime.i3))
				};
				return A2(
					$elm$core$Task$attempt,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotReport),
						$author$project$Type$BotReport$OnExportResult),
					A2($author$project$Api$BotReportExport$exec, params, token));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotReport$mapState,
				_Utils_update(
					botReport,
					{a1: $author$project$Data$DataStatus$Downloading}),
				authState,
				appModel),
			cmd_);
	});
var $author$project$Model$BotReport$onExportResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState.h1;
		var botReport = _v0.dm;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotReport$mapState,
					_Utils_update(
						botReport,
						{
							a1: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var bytes = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotReport$mapState,
					_Utils_update(
						botReport,
						{
							a1: $author$project$Data$DataStatus$Downloaded(0)
						}),
					authState,
					appModel),
				A3($elm$file$File$Download$bytes, 'bot_report.csv', 'text/csv', bytes));
		}
	});
var $author$project$Model$BotReport$onGetBotsResult = F3(
	function (response, authState, appModel) {
		var model = authState.h1.dm;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotReport$mapState,
					_Utils_update(
						model,
						{
							g2: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotReport$mapState,
					_Utils_update(
						model,
						{
							g2: $author$project$Data$DataStatus$Downloaded(value)
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$BotReport$onGetReportsResult = F3(
	function (response, authState, appModel) {
		var model = authState.h1.dm;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotReport$mapState,
					_Utils_update(
						model,
						{
							aI: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var rows = response.a.ie;
			var total = response.a.iR;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotReport$mapState,
					_Utils_update(
						model,
						{
							aI: $author$project$Data$DataStatus$Downloaded(rows),
							iR: total
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$BotReport$onGetTenantResult = F3(
	function (response, authState, appModel) {
		var model = authState.h1.dm;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3($author$project$Model$BotReport$mapState, model, authState, appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var name = response.a.fg;
			var id = response.a.eu;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotReport$mapState,
					_Utils_update(
						model,
						{
							iM: $author$project$Data$DataStatus$Downloaded(
								_List_fromArray(
									[
										{hH: name, i3: id}
									]))
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$BotReport$onGetTenantsResult = F3(
	function (response, authState, appModel) {
		var model = authState.h1.dm;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotReport$mapState,
					_Utils_update(
						model,
						{
							iM: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$BotReport$mapState,
					_Utils_update(
						model,
						{
							iM: $author$project$Data$DataStatus$Downloaded(value)
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$BotReport$onSubmit = F2(
	function (authState, appModel) {
		var _v0 = authState;
		var token = _v0.iQ;
		var pages = _v0.h1;
		var model = pages.dm;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$BotReport$mapState,
				_Utils_update(
					model,
					{aI: $author$project$Data$DataStatus$Downloading}),
				authState,
				appModel),
			A2($author$project$Model$BotReport$getReportsCmd, model, token));
	});
var $author$project$Model$BotReport$update = F3(
	function (msg, authState, appModel) {
		var _v0 = authState;
		var token = _v0.iQ;
		var pages = _v0.h1;
		var model = pages.dm;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				var _v2 = model;
				var tenantID = _v2.gm;
				var botID = _v2.di;
				var languageCode = _v2.eT;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotReport$mapState,
						_Utils_update(
							model,
							{
								di: A2($author$project$Data$Form$updateField, botID, ''),
								gm: A2($author$project$Data$Form$updateField, tenantID, value)
							}),
						authState,
						appModel),
					A3($author$project$Model$BotReport$getBotsCmd, value, languageCode.i3, token));
			case 1:
				var value = msg.a;
				var _v3 = model;
				var languageCode = _v3.eT;
				var botID = _v3.di;
				var tenantID = _v3.gm;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotReport$mapState,
						_Utils_update(
							model,
							{
								di: A2($author$project$Data$Form$updateField, botID, ''),
								eT: A2($author$project$Data$Form$updateField, languageCode, value)
							}),
						authState,
						appModel),
					A3($author$project$Model$BotReport$getBotsCmd, tenantID.i3, value, token));
			case 2:
				var value = msg.a;
				var _v4 = model;
				var botID = _v4.di;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotReport$mapState,
						_Utils_update(
							model,
							{
								di: A2($author$project$Data$Form$updateField, botID, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				var _v5 = model;
				var startTime = _v5.gc;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotReport$mapState,
						_Utils_update(
							model,
							{
								gc: A2($author$project$Data$Form$updateField, startTime, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				var _v6 = model;
				var endTime = _v6.d8;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotReport$mapState,
						_Utils_update(
							model,
							{
								d8: A2($author$project$Data$Form$updateField, endTime, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 5:
				var value = msg.a;
				var updatedModel = _Utils_update(
					model,
					{fo: value, aI: $author$project$Data$DataStatus$Downloading});
				return _Utils_Tuple2(
					A3($author$project$Model$BotReport$mapState, updatedModel, authState, appModel),
					A2($author$project$Model$BotReport$getReportsCmd, updatedModel, token));
			case 9:
				var response = msg.a;
				return A3($author$project$Model$BotReport$onGetReportsResult, response, authState, appModel);
			case 8:
				var response = msg.a;
				return A3($author$project$Model$BotReport$onGetBotsResult, response, authState, appModel);
			case 6:
				var response = msg.a;
				return A3($author$project$Model$BotReport$onGetTenantsResult, response, authState, appModel);
			case 7:
				var response = msg.a;
				return A3($author$project$Model$BotReport$onGetTenantResult, response, authState, appModel);
			case 10:
				return A2($author$project$Model$BotReport$onSubmit, authState, appModel);
			case 11:
				return A2($author$project$Model$BotReport$onExport, authState, appModel);
			case 12:
				var response = msg.a;
				return A3($author$project$Model$BotReport$onExportResult, response, authState, appModel);
			default:
				return _Utils_Tuple2(
					A3(
						$author$project$Model$BotReport$mapState,
						_Utils_update(
							model,
							{a1: $author$project$Data$DataStatus$Init}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Api$Dashboard$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Cannot get super admin data';
		case 2:
			return 'Cannot get admin data';
		case 3:
			return 'Cannot get tenant data';
		case 4:
			return 'Cannot get bot data';
		case 5:
			return 'Cannot get bot log data';
		case 6:
			return 'Cannot get user data';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$Dashboard$mapState = F3(
	function (model, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		return _Utils_update(
			appModel,
			{
				aW: $elm$core$Maybe$Just(
					_Utils_update(
						authState,
						{
							h1: _Utils_update(
								pages,
								{hd: model})
						}))
			});
	});
var $author$project$Model$Dashboard$onGetDashboardResult = F3(
	function (result, authState, appModel) {
		var model = authState.h1.hd;
		if (result.$ === 1) {
			var error = result.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$Dashboard$mapState,
					_Utils_update(
						model,
						{
							dP: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$Dashboard$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var data = result.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$Dashboard$mapState,
					_Utils_update(
						model,
						{
							dP: $author$project$Data$DataStatus$Downloaded(data)
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Dashboard$update = F3(
	function (msg, authState, appModel) {
		var result = msg;
		return A3($author$project$Model$Dashboard$onGetDashboardResult, result, authState, appModel);
	});
var $author$project$Model$Menu$mapState = F3(
	function (menuModel, authState, appModel) {
		return _Utils_update(
			appModel,
			{
				aW: $elm$core$Maybe$Just(
					_Utils_update(
						authState,
						{hS: menuModel}))
			});
	});
var $author$project$Model$Menu$update = F3(
	function (msg, authState, appModel) {
		var model = authState.hS;
		if (!msg.$) {
			var value = msg.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$Menu$mapState,
					_Utils_update(
						model,
						{eL: value}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		} else {
			var value = msg.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$Menu$mapState,
					_Utils_update(
						model,
						{f3: value}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Profile$mapState = F3(
	function (profileModel, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		return _Utils_update(
			appModel,
			{
				aW: $elm$core$Maybe$Just(
					_Utils_update(
						authState,
						{
							h1: _Utils_update(
								pages,
								{fD: profileModel})
						}))
			});
	});
var $author$project$Api$AdminProfileUpdatePassword$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Admin not found';
		case 2:
			return 'Invalid password';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$Profile$onUpdateAdminPasswordResult = F3(
	function (result, authState, appModel) {
		var profile = authState.h1.fD;
		var _v0 = profile;
		var password = _v0.fu;
		var confirmPassword = _v0.G;
		var updatedConfirmPassword = _Utils_update(
			confirmPassword,
			{i3: ''});
		var updatedPassword = _Utils_update(
			password,
			{i3: ''});
		var updatedForm = _Utils_update(
			profile,
			{G: updatedConfirmPassword, J: 2, fu: updatedPassword});
		if (result.$ === 1) {
			var error = result.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$Profile$mapState,
					_Utils_update(
						profile,
						{J: 2}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$AdminProfileUpdatePassword$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			return _Utils_Tuple2(
				A3(
					$author$project$Model$Profile$mapState,
					updatedForm,
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addSuccess, $author$project$Data$Message$messages.i_, $author$project$Data$Alert$clear)
						})),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Api$AdminProfileUpdate$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 5:
			return 'Tenant not found';
		case 1:
			return 'Admin not found';
		case 2:
			return 'Invalid name';
		case 3:
			return 'Invalid email';
		case 4:
			return 'Email existed';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$Profile$onUpdateAdminResult = F3(
	function (result, authState, appModel) {
		var profile = authState.h1.fD;
		var _v0 = profile;
		var name = _v0.fg;
		var email = _v0.d4;
		if (result.$ === 1) {
			var error = result.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$Profile$mapState,
					_Utils_update(
						profile,
						{J: 2}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$AdminProfileUpdate$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var admin = result.a;
			var updatedForm = _Utils_update(
				profile,
				{
					d4: _Utils_update(
						email,
						{i3: admin.d4}),
					J: 2,
					fg: _Utils_update(
						name,
						{i3: admin.fg}),
					fD: $author$project$Data$Role$AdminProfile(admin)
				});
			return _Utils_Tuple2(
				A3(
					$author$project$Model$Profile$mapState,
					updatedForm,
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addSuccess, $author$project$Data$Message$messages.i$, $author$project$Data$Alert$clear)
						})),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Api$SuperAdminProfileUpdatePassword$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid password';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$Profile$onUpdateSuperAdminPasswordResult = F3(
	function (result, authState, appModel) {
		var profile = authState.h1.fD;
		var _v0 = profile;
		var password = _v0.fu;
		var confirmPassword = _v0.G;
		var updatedConfirmPassword = _Utils_update(
			confirmPassword,
			{i3: ''});
		var updatedPassword = _Utils_update(
			password,
			{i3: ''});
		var updatedForm = _Utils_update(
			profile,
			{G: updatedConfirmPassword, J: 2, fu: updatedPassword});
		if (result.$ === 1) {
			var error = result.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$Profile$mapState,
					_Utils_update(
						profile,
						{J: 2}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$SuperAdminProfileUpdatePassword$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			return _Utils_Tuple2(
				A3(
					$author$project$Model$Profile$mapState,
					updatedForm,
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addSuccess, $author$project$Data$Message$messages.i_, $author$project$Data$Alert$clear)
						})),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Api$SuperAdminProfileUpdate$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid name';
		case 2:
			return 'Invalid email';
		case 3:
			return 'Email existed';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$Profile$onUpdateSuperAdminResult = F3(
	function (result, authState, appModel) {
		var profile = authState.h1.fD;
		var _v0 = profile;
		var name = _v0.fg;
		var email = _v0.d4;
		if (result.$ === 1) {
			var error = result.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$Profile$mapState,
					_Utils_update(
						profile,
						{J: 2}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$SuperAdminProfileUpdate$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var superAdmin = result.a;
			var updatedForm = _Utils_update(
				profile,
				{
					d4: _Utils_update(
						email,
						{i3: superAdmin.d4}),
					J: 2,
					fg: _Utils_update(
						name,
						{i3: superAdmin.fg}),
					fD: $author$project$Data$Role$SuperAdminProfile(superAdmin)
				});
			return _Utils_Tuple2(
				A3(
					$author$project$Model$Profile$mapState,
					updatedForm,
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addSuccess, $author$project$Data$Message$messages.i$, $author$project$Data$Alert$clear)
						})),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Profile$updateModel = F2(
	function (profile, model) {
		var _v0 = function () {
			if (profile.$ === 1) {
				var value = profile.a;
				return _Utils_Tuple2(value.fg, value.d4);
			} else {
				var value = profile.a;
				return _Utils_Tuple2(value.fg, value.d4);
			}
		}();
		var profileName = _v0.a;
		var profileEmail = _v0.b;
		var _v2 = model;
		var name = _v2.fg;
		var email = _v2.d4;
		return _Utils_update(
			model,
			{
				d4: _Utils_update(
					email,
					{i3: profileEmail}),
				fg: _Utils_update(
					name,
					{i3: profileName}),
				fD: profile
			});
	});
var $author$project$Type$Profile$OnUpdateAdminPasswordResult = function (a) {
	return {$: 10, a: a};
};
var $author$project$Type$Profile$OnUpdateSuperAdminPasswordResult = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$AdminProfileUpdatePassword$AdminNotFound = 1;
var $author$project$Api$AdminProfileUpdatePassword$InvalidParams = 0;
var $author$project$Api$AdminProfileUpdatePassword$InvalidPassword = 2;
var $author$project$Api$AdminProfileUpdatePassword$MissingError = 3;
var $author$project$Api$AdminProfileUpdatePassword$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$3:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'AdminNotFound':
					return 1;
				case 'InvalidPassword':
					return 2;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 3;
};
var $author$project$Api$AdminProfileUpdatePassword$exec = F2(
	function (_v0, token) {
		var password = _v0.fu;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$AdminProfileUpdatePassword$toErrorCode,
			$elm$json$Json$Decode$succeed(0));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string(password))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'admin/profile-update-password', ia: resolver, iQ: token});
	});
var $author$project$Api$SuperAdminProfileUpdatePassword$InvalidParams = 0;
var $author$project$Api$SuperAdminProfileUpdatePassword$InvalidPassword = 1;
var $author$project$Api$SuperAdminProfileUpdatePassword$MissingError = 2;
var $author$project$Api$SuperAdminProfileUpdatePassword$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidPassword':
					return 1;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 2;
};
var $author$project$Api$SuperAdminProfileUpdatePassword$exec = F2(
	function (_v0, token) {
		var password = _v0.fu;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$SuperAdminProfileUpdatePassword$toErrorCode,
			$elm$json$Json$Decode$succeed(0));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string(password))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'super-admin/profile-update-password', ia: resolver, iQ: token});
	});
var $author$project$Model$Profile$updatePasswordCmd = F2(
	function (model, authState) {
		var _v0 = model;
		var password = _v0.fu;
		var profile = _v0.fD;
		if (profile.$ === 1) {
			return A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnProfile),
					$author$project$Type$Profile$OnUpdateSuperAdminPasswordResult),
				A2(
					$author$project$Api$SuperAdminProfileUpdatePassword$exec,
					{fu: password.i3},
					authState.iQ));
		} else {
			return A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnProfile),
					$author$project$Type$Profile$OnUpdateAdminPasswordResult),
				A2(
					$author$project$Api$AdminProfileUpdatePassword$exec,
					{fu: password.i3},
					authState.iQ));
		}
	});
var $author$project$Model$Profile$updatePassword = F2(
	function (authState, appModel) {
		var profile = authState.h1.fD;
		var _v0 = profile;
		var password = _v0.fu;
		var confirmPassword = _v0.G;
		var confirmPasswordValue = confirmPassword.i3;
		var passwordValue = password.i3;
		return (!_Utils_eq(passwordValue, confirmPasswordValue)) ? _Utils_Tuple2(
			A3($author$project$Model$Profile$mapState, profile, authState, appModel),
			$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
			A3(
				$author$project$Model$Profile$mapState,
				_Utils_update(
					profile,
					{J: 1}),
				authState,
				appModel),
			A2($author$project$Model$Profile$updatePasswordCmd, profile, authState));
	});
var $author$project$Type$Profile$OnUpdateAdminResult = function (a) {
	return {$: 7, a: a};
};
var $author$project$Type$Profile$OnUpdateSuperAdminResult = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$AdminProfileUpdate$AdminNotFound = 1;
var $author$project$Api$AdminProfileUpdate$EmailExisted = 4;
var $author$project$Api$AdminProfileUpdate$InvalidEmail = 3;
var $author$project$Api$AdminProfileUpdate$InvalidName = 2;
var $author$project$Api$AdminProfileUpdate$InvalidParams = 0;
var $author$project$Api$AdminProfileUpdate$MissingError = 6;
var $author$project$Api$AdminProfileUpdate$TenantNotFound = 5;
var $author$project$Api$AdminProfileUpdate$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$6:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'TenantNotFound':
					return 5;
				case 'AdminNotFound':
					return 1;
				case 'InvalidName':
					return 2;
				case 'InvalidEmail':
					return 3;
				case 'EmailExisted':
					return 4;
				default:
					break _v0$6;
			}
		} else {
			break _v0$6;
		}
	}
	return 6;
};
var $author$project$Api$AdminProfileUpdate$exec = F2(
	function (_v0, token) {
		var name = _v0.fg;
		var email = _v0.d4;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$AdminProfileUpdate$toErrorCode,
			A2($elm$json$Json$Decode$field, 'admin', $author$project$Api$Decoder$admin));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'admin/profile-update', ia: resolver, iQ: token});
	});
var $author$project$Api$SuperAdminProfileUpdate$EmailExisted = 3;
var $author$project$Api$SuperAdminProfileUpdate$InvalidEmail = 2;
var $author$project$Api$SuperAdminProfileUpdate$InvalidName = 1;
var $author$project$Api$SuperAdminProfileUpdate$InvalidParams = 0;
var $author$project$Api$SuperAdminProfileUpdate$MissingError = 4;
var $author$project$Api$SuperAdminProfileUpdate$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$4:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidName':
					return 1;
				case 'InvalidEmail':
					return 2;
				case 'EmailExisted':
					return 3;
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return 4;
};
var $author$project$Api$SuperAdminProfileUpdate$exec = F2(
	function (_v0, token) {
		var name = _v0.fg;
		var email = _v0.d4;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$SuperAdminProfileUpdate$toErrorCode,
			A2($elm$json$Json$Decode$field, 'superAdmin', $author$project$Api$Decoder$superAdmin));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'super-admin/profile-update', ia: resolver, iQ: token});
	});
var $author$project$Model$Profile$updateProfileCmd = F2(
	function (model, authState) {
		var _v0 = model;
		var name = _v0.fg;
		var email = _v0.d4;
		var profile = _v0.fD;
		if (profile.$ === 1) {
			return A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnProfile),
					$author$project$Type$Profile$OnUpdateSuperAdminResult),
				A2(
					$author$project$Api$SuperAdminProfileUpdate$exec,
					{d4: email.i3, fg: name.i3},
					authState.iQ));
		} else {
			return A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnProfile),
					$author$project$Type$Profile$OnUpdateAdminResult),
				A2(
					$author$project$Api$AdminProfileUpdate$exec,
					{d4: email.i3, fg: name.i3},
					authState.iQ));
		}
	});
var $author$project$Model$Profile$updateProfile = F3(
	function (appModel, model, authState) {
		var updatedModel = _Utils_update(
			model,
			{J: 1});
		var _v0 = model;
		var email = _v0.d4;
		var name = _v0.fg;
		return $author$project$Data$Form$isValidFields(
			_List_fromArray(
				[email, name])) ? _Utils_Tuple2(
			A3($author$project$Model$Profile$mapState, updatedModel, authState, appModel),
			A2($author$project$Model$Profile$updateProfileCmd, model, authState)) : _Utils_Tuple2(
			A3($author$project$Model$Profile$mapState, model, authState, appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$Profile$update = F3(
	function (msg, authState, appModel) {
		var model = authState.h1.fD;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				var _v1 = model;
				var name = _v1.fg;
				var updatedField = A2($author$project$Data$Form$updateField, name, value);
				return _Utils_Tuple2(
					A3(
						$author$project$Model$Profile$mapState,
						_Utils_update(
							model,
							{fg: updatedField}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				var _v2 = model;
				var email = _v2.d4;
				var updatedField = A2($author$project$Data$Form$updateField, email, value);
				return _Utils_Tuple2(
					A3(
						$author$project$Model$Profile$mapState,
						_Utils_update(
							model,
							{d4: updatedField}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				var _v3 = model;
				var password = _v3.fu;
				var updatedField = A2($author$project$Data$Form$updateField, password, value);
				return _Utils_Tuple2(
					A3(
						$author$project$Model$Profile$mapState,
						_Utils_update(
							model,
							{fu: updatedField}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				var _v4 = model;
				var confirmPassword = _v4.G;
				var updatedField = A2($author$project$Data$Form$updateField, confirmPassword, value);
				var _v5 = updatedField;
				var error = _v5.bH;
				if (error.$ === 1) {
					var _v7 = model;
					var password = _v7.fu;
					return ((value !== '') && (!_Utils_eq(password.i3, value))) ? _Utils_Tuple2(
						A3(
							$author$project$Model$Profile$mapState,
							_Utils_update(
								model,
								{
									G: _Utils_update(
										updatedField,
										{
											bH: $elm$core$Maybe$Just(6)
										})
								}),
							authState,
							appModel),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						A3(
							$author$project$Model$Profile$mapState,
							_Utils_update(
								model,
								{G: updatedField}),
							authState,
							appModel),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						A3(
							$author$project$Model$Profile$mapState,
							_Utils_update(
								model,
								{G: updatedField}),
							authState,
							appModel),
						$elm$core$Platform$Cmd$none);
				}
			case 4:
				return A3($author$project$Model$Profile$updateProfile, appModel, model, authState);
			case 5:
				var profile = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$Profile$mapState,
						A2($author$project$Model$Profile$updateModel, profile, model),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 6:
				var response = msg.a;
				return A3($author$project$Model$Profile$onUpdateSuperAdminResult, response, authState, appModel);
			case 7:
				var response = msg.a;
				return A3($author$project$Model$Profile$onUpdateAdminResult, response, authState, appModel);
			case 8:
				return A2($author$project$Model$Profile$updatePassword, authState, appModel);
			case 9:
				var response = msg.a;
				return A3($author$project$Model$Profile$onUpdateSuperAdminPasswordResult, response, authState, appModel);
			default:
				var response = msg.a;
				return A3($author$project$Model$Profile$onUpdateAdminPasswordResult, response, authState, appModel);
		}
	});
var $author$project$Model$SuperAdminDetail$onChangeConfirmPassword = F4(
	function (value, model, authState, appModel) {
		var _v0 = model;
		var confirmPassword = _v0.G;
		var updatedField = A2($author$project$Data$Form$updateField, confirmPassword, value);
		var _v1 = updatedField;
		var error = _v1.bH;
		if (error.$ === 1) {
			return ((value !== '') && (!_Utils_eq(model.fu.i3, value))) ? _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminDetail$mapState,
					_Utils_update(
						model,
						{
							G: _Utils_update(
								updatedField,
								{
									bH: $elm$core$Maybe$Just(6)
								})
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminDetail$mapState,
					_Utils_update(
						model,
						{G: updatedField}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminDetail$mapState,
					_Utils_update(
						model,
						{G: updatedField}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$SuperAdminDetail$OnCreateResult = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$SuperAdminCreate$EmailExisted = 4;
var $author$project$Api$SuperAdminCreate$InvalidEmail = 2;
var $author$project$Api$SuperAdminCreate$InvalidName = 1;
var $author$project$Api$SuperAdminCreate$InvalidParams = 0;
var $author$project$Api$SuperAdminCreate$InvalidPassword = 3;
var $author$project$Api$SuperAdminCreate$MissingError = 5;
var $author$project$Api$SuperAdminCreate$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$5:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidName':
					return 1;
				case 'InvalidEmail':
					return 2;
				case 'InvalidPassword':
					return 3;
				case 'EmailExisted':
					return 4;
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return 5;
};
var $author$project$Api$SuperAdminCreate$exec = F2(
	function (_v0, token) {
		var name = _v0.fg;
		var email = _v0.d4;
		var password = _v0.fu;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$SuperAdminCreate$toErrorCode,
			A2($elm$json$Json$Decode$field, 'superAdmin', $author$project$Api$Decoder$superAdmin));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email)),
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string(password))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'super-admin/create', ia: resolver, iQ: token});
	});
var $author$project$Model$SuperAdminDetail$onCreate = F2(
	function (appModel, authState) {
		var _v0 = authState;
		var pages = _v0.h1;
		var _v1 = pages;
		var superAdminDetail = _v1.ix;
		var _v2 = superAdminDetail;
		var name = _v2.fg;
		var email = _v2.d4;
		var password = _v2.fu;
		var confirmPassword = _v2.G;
		var isSame = _Utils_eq(password.i3, confirmPassword.i3);
		if ($author$project$Data$Form$isValidFields(
			_List_fromArray(
				[name, email, password])) && isSame) {
			var task = A2(
				$author$project$Api$SuperAdminCreate$exec,
				{d4: email.i3, fg: name.i3, fu: password.i3},
				authState.iQ);
			return _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminDetail$mapState,
					_Utils_update(
						superAdminDetail,
						{J: 1}),
					authState,
					appModel),
				A2(
					$elm$core$Task$attempt,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnSuperAdminDetail),
						$author$project$Type$SuperAdminDetail$OnCreateResult),
					task));
		} else {
			return _Utils_Tuple2(
				A3($author$project$Model$SuperAdminDetail$mapState, superAdminDetail, authState, appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Api$SuperAdminCreate$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid name';
		case 2:
			return 'Invalid email';
		case 3:
			return 'Invalid password';
		case 4:
			return 'Email existed';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$SuperAdminDetail$onCreateResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		var _v1 = pages;
		var superAdminDetail = _v1.ix;
		var _v2 = superAdminDetail;
		var password = _v2.fu;
		var confirmPassword = _v2.G;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminDetail$mapState,
					_Utils_update(
						superAdminDetail,
						{J: 2}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$SuperAdminCreate$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminDetail$mapState,
					_Utils_update(
						superAdminDetail,
						{
							G: _Utils_update(
								confirmPassword,
								{bH: $elm$core$Maybe$Nothing, i3: ''}),
							J: 2,
							fu: _Utils_update(
								password,
								{bH: $elm$core$Maybe$Nothing, i3: ''}),
							iw: $author$project$Data$DataStatus$Downloaded(value)
						}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.ha, $author$project$Data$Alert$clear)
						})),
				A2(
					$elm$browser$Browser$Navigation$pushUrl,
					appModel.ab,
					$author$project$Data$Route$routeUrl.d2(value.eu)));
		}
	});
var $author$project$Model$SuperAdminDetail$onGetSuperAdminResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		var _v1 = pages;
		var superAdminDetail = _v1.ix;
		var _v2 = superAdminDetail;
		var name = _v2.fg;
		var email = _v2.d4;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminDetail$mapState,
					_Utils_update(
						superAdminDetail,
						{
							iw: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminDetail$mapState,
					_Utils_update(
						superAdminDetail,
						{
							d4: _Utils_update(
								email,
								{i3: value.d4}),
							fg: _Utils_update(
								name,
								{i3: value.fg}),
							iw: $author$project$Data$DataStatus$Downloaded(value)
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$SuperAdminDetail$OnUpdateResult = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$SuperAdminUpdate$EmailExisted = 3;
var $author$project$Api$SuperAdminUpdate$InvalidEmail = 2;
var $author$project$Api$SuperAdminUpdate$InvalidName = 1;
var $author$project$Api$SuperAdminUpdate$InvalidParams = 0;
var $author$project$Api$SuperAdminUpdate$MissingError = 4;
var $author$project$Api$SuperAdminUpdate$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$4:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidName':
					return 1;
				case 'InvalidEmail':
					return 2;
				case 'EmailExisted':
					return 3;
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return 4;
};
var $author$project$Api$SuperAdminUpdate$exec = F2(
	function (_v0, token) {
		var id = _v0.eu;
		var name = _v0.fg;
		var email = _v0.d4;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$SuperAdminUpdate$toErrorCode,
			A2($elm$json$Json$Decode$field, 'superAdmin', $author$project$Api$Decoder$superAdmin));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(id)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'super-admin/update', ia: resolver, iQ: token});
	});
var $author$project$Model$SuperAdminDetail$onUpdate = F3(
	function (id, appModel, authState) {
		var _v0 = authState;
		var pages = _v0.h1;
		var token = _v0.iQ;
		var _v1 = pages;
		var superAdminDetail = _v1.ix;
		var _v2 = superAdminDetail;
		var name = _v2.fg;
		var email = _v2.d4;
		if ($author$project$Data$Form$isValidFields(
			_List_fromArray(
				[name, email]))) {
			var params = {d4: email.i3, eu: id, fg: name.i3};
			return _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminDetail$mapState,
					_Utils_update(
						superAdminDetail,
						{J: 1}),
					authState,
					appModel),
				A2(
					$elm$core$Task$attempt,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnSuperAdminDetail),
						$author$project$Type$SuperAdminDetail$OnUpdateResult),
					A2($author$project$Api$SuperAdminUpdate$exec, params, token)));
		} else {
			return _Utils_Tuple2(
				A3($author$project$Model$SuperAdminDetail$mapState, superAdminDetail, authState, appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$SuperAdminDetail$OnUpdatePasswordResult = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$SuperAdminUpdatePassword$InvalidParams = 0;
var $author$project$Api$SuperAdminUpdatePassword$InvalidPassword = 1;
var $author$project$Api$SuperAdminUpdatePassword$MissingError = 2;
var $author$project$Api$SuperAdminUpdatePassword$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidPassword':
					return 1;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 2;
};
var $author$project$Api$SuperAdminUpdatePassword$exec = F2(
	function (_v0, token) {
		var id = _v0.eu;
		var password = _v0.fu;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$SuperAdminUpdatePassword$toErrorCode,
			$elm$json$Json$Decode$succeed(0));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(id)),
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string(password))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'super-admin/update-password', ia: resolver, iQ: token});
	});
var $author$project$Model$SuperAdminDetail$onUpdatePassword = F3(
	function (id, appModel, authState) {
		var _v0 = authState;
		var pages = _v0.h1;
		var _v1 = pages;
		var superAdminDetail = _v1.ix;
		var _v2 = superAdminDetail;
		var password = _v2.fu;
		var confirmPassword = _v2.G;
		var isSame = _Utils_eq(password.i3, confirmPassword.i3);
		return ($author$project$Data$Form$isValidFields(
			_List_fromArray(
				[confirmPassword, password])) && isSame) ? _Utils_Tuple2(
			A3(
				$author$project$Model$SuperAdminDetail$mapState,
				_Utils_update(
					superAdminDetail,
					{J: 1}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnSuperAdminDetail),
					$author$project$Type$SuperAdminDetail$OnUpdatePasswordResult),
				A2(
					$author$project$Api$SuperAdminUpdatePassword$exec,
					{eu: id, fu: password.i3},
					authState.iQ))) : _Utils_Tuple2(
			A3($author$project$Model$SuperAdminDetail$mapState, superAdminDetail, authState, appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Api$SuperAdminUpdatePassword$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid password';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$SuperAdminDetail$onUpdatePasswordResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		var _v1 = pages;
		var superAdminDetail = _v1.ix;
		var _v2 = superAdminDetail;
		var password = _v2.fu;
		var confirmPassword = _v2.G;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminDetail$mapState,
					_Utils_update(
						superAdminDetail,
						{J: 2}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$SuperAdminUpdatePassword$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var updatedModel = _Utils_update(
				superAdminDetail,
				{
					G: _Utils_update(
						confirmPassword,
						{bH: $elm$core$Maybe$Nothing, i3: ''}),
					J: 2,
					fu: _Utils_update(
						password,
						{bH: $elm$core$Maybe$Nothing, i3: ''})
				});
			return _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminDetail$mapState,
					updatedModel,
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.i0, $author$project$Data$Alert$clear)
						})),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Api$SuperAdminUpdate$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid name';
		case 2:
			return 'Invalid email';
		case 3:
			return 'Email existed';
		default:
			return 'Missing error code';
	}
};
var $author$project$Data$Role$getSuperAdminID = function (profile) {
	if (profile.$ === 1) {
		var id = profile.a.eu;
		return $elm$core$Maybe$Just(id);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$SuperAdminDetail$onUpdateResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		var _v1 = pages;
		var profile = _v1.fD;
		var _v2 = pages;
		var superAdminDetail = _v2.ix;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminDetail$mapState,
					_Utils_update(
						superAdminDetail,
						{J: 2}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$SuperAdminUpdate$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			var okModel = _Utils_update(
				superAdminDetail,
				{
					J: 2,
					iw: $author$project$Data$DataStatus$Downloaded(value)
				});
			var okAppModel = _Utils_update(
				appModel,
				{
					ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.i0, $author$project$Data$Alert$clear)
				});
			var isUpdateCurrentSuperAdmin = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$eq(value.eu),
					$author$project$Data$Role$getSuperAdminID(profile.fD)));
			var cmd = isUpdateCurrentSuperAdmin ? A2(
				$elm$core$Task$perform,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnProfile),
					$author$project$Type$Profile$OnUpdateProfile),
				$elm$core$Task$succeed(
					$author$project$Data$Role$SuperAdminProfile(value))) : $elm$core$Platform$Cmd$none;
			return _Utils_Tuple2(
				A3($author$project$Model$SuperAdminDetail$mapState, okModel, authState, okAppModel),
				cmd);
		}
	});
var $author$project$Model$SuperAdminDetail$update = F3(
	function (msg, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		var model = pages.ix;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				var _v2 = model;
				var name = _v2.fg;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$SuperAdminDetail$mapState,
						_Utils_update(
							model,
							{
								fg: A2($author$project$Data$Form$updateField, name, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				var _v3 = model;
				var email = _v3.d4;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$SuperAdminDetail$mapState,
						_Utils_update(
							model,
							{
								d4: A2($author$project$Data$Form$updateField, email, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				var _v4 = model;
				var password = _v4.fu;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$SuperAdminDetail$mapState,
						_Utils_update(
							model,
							{
								fu: A2($author$project$Data$Form$updateField, password, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				return A4($author$project$Model$SuperAdminDetail$onChangeConfirmPassword, value, model, authState, appModel);
			case 4:
				return A2($author$project$Model$SuperAdminDetail$onCreate, appModel, authState);
			case 5:
				var response = msg.a;
				return A3($author$project$Model$SuperAdminDetail$onCreateResult, response, authState, appModel);
			case 6:
				var id = msg.a;
				return A3($author$project$Model$SuperAdminDetail$onUpdate, id, appModel, authState);
			case 7:
				var response = msg.a;
				return A3($author$project$Model$SuperAdminDetail$onUpdateResult, response, authState, appModel);
			case 8:
				var id = msg.a;
				return A3($author$project$Model$SuperAdminDetail$onUpdatePassword, id, appModel, authState);
			case 9:
				var response = msg.a;
				return A3($author$project$Model$SuperAdminDetail$onUpdatePasswordResult, response, authState, appModel);
			default:
				var response = msg.a;
				return A3($author$project$Model$SuperAdminDetail$onGetSuperAdminResult, response, authState, appModel);
		}
	});
var $author$project$Type$SuperAdminList$OnSearch = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$SuperAdminList$OnSearchDebounce = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$SuperAdminList$debounceConfig = $author$project$Ext$Debounce$config(
	A2(
		$elm$core$Basics$composeL,
		A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnSuperAdminList),
		$author$project$Type$SuperAdminList$OnSearchDebounce));
var $author$project$Model$SuperAdminList$onCheck = F3(
	function (superAdmin, authState, appModel) {
		var _v0 = authState.h1;
		var superAdminList = _v0.iy;
		var _v1 = superAdminList;
		var checkedList = _v1.F;
		var isExisted = A2(
			$elm$core$List$filter,
			function (item) {
				return _Utils_eq(item.eu, superAdmin.eu);
			},
			checkedList);
		return ($elm$core$List$length(isExisted) > 0) ? _Utils_Tuple2(
			A3(
				$author$project$Model$SuperAdminList$mapState,
				_Utils_update(
					superAdminList,
					{
						F: A2(
							$elm$core$List$filter,
							function (item) {
								return !_Utils_eq(item.eu, superAdmin.eu);
							},
							checkedList)
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
			A3(
				$author$project$Model$SuperAdminList$mapState,
				_Utils_update(
					superAdminList,
					{
						F: A2(
							$elm$core$List$append,
							checkedList,
							_List_fromArray(
								[superAdmin]))
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$SuperAdminList$onCheckAll = F2(
	function (authState, appModel) {
		var model = authState.h1.iy;
		var _v0 = model;
		var status = _v0.cQ;
		var checkedList = _v0.F;
		if (status.$ === 4) {
			var data = status.a;
			return _Utils_eq(
				$elm$core$List$length(data),
				$elm$core$List$length(checkedList)) ? _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminList$mapState,
					_Utils_update(
						model,
						{F: _List_Nil}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminList$mapState,
					_Utils_update(
						model,
						{F: data}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				A3($author$project$Model$SuperAdminList$mapState, model, authState, appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$SuperAdminList$OnDeleteResult = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Api$SuperAdminDelete$CannotDeleteSuperAdmin = 2;
var $author$project$Api$SuperAdminDelete$CannotDeleteYourself = 1;
var $author$project$Api$SuperAdminDelete$InvalidParams = 0;
var $author$project$Api$SuperAdminDelete$MissingError = 3;
var $author$project$Api$SuperAdminDelete$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$3:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'CannotDeleteYourself':
					return 1;
				case 'CannotDeleteSuperAdmin':
					return 2;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 3;
};
var $author$project$Api$SuperAdminDelete$exec = F2(
	function (_v0, token) {
		var ids = _v0.ev;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$SuperAdminDelete$toErrorCode,
			$elm$json$Json$Decode$succeed(0));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ids',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, ids))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'super-admin/delete', ia: resolver, iQ: token});
	});
var $author$project$Model$SuperAdminList$onDelete = F3(
	function (data, authState, appModel) {
		var model = authState.h1.iy;
		var _v0 = model;
		var checkedList = _v0.F;
		var ids = A2(
			$elm$core$List$map,
			function (item) {
				return item.eu;
			},
			checkedList);
		return ($elm$core$List$length(ids) > 0) ? _Utils_Tuple2(
			A3(
				$author$project$Model$SuperAdminList$mapState,
				_Utils_update(
					model,
					{
						bQ: false,
						cQ: $author$project$Data$DataStatus$Deleting(data)
					}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnSuperAdminList),
					$author$project$Type$SuperAdminList$OnDeleteResult(data)),
				A2(
					$author$project$Api$SuperAdminDelete$exec,
					{ev: ids},
					authState.iQ))) : _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
	});
var $author$project$Api$SuperAdminDelete$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Cannot delete yourself';
		case 2:
			return 'Cannot delete super admin';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$SuperAdminList$onDeleteResult = F4(
	function (data, response, authState, appModel) {
		var model = authState.h1.iy;
		var _v0 = model;
		var offset = _v0.fo;
		var limit = _v0.eV;
		var search = _v0.fU;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminList$mapState,
					_Utils_update(
						model,
						{
							cQ: $author$project$Data$DataStatus$Downloaded(data)
						}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$SuperAdminDelete$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			return _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminList$mapState,
					_Utils_update(
						model,
						{F: _List_Nil, cQ: $author$project$Data$DataStatus$Downloading}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.hk, $author$project$Data$Alert$clear)
						})),
				A2(
					$author$project$Model$SuperAdminList$getSuperAdminsCmd,
					{eV: limit, fo: offset, fU: search},
					authState.iQ));
		}
	});
var $author$project$Type$SuperAdminList$OnDeleteSingleResult = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Model$SuperAdminList$onDeleteSingle = F4(
	function (id, data, authState, appModel) {
		var model = authState.h1.iy;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$SuperAdminList$mapState,
				_Utils_update(
					model,
					{
						cQ: $author$project$Data$DataStatus$Deleting(data)
					}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnSuperAdminList),
					$author$project$Type$SuperAdminList$OnDeleteSingleResult(data)),
				A2(
					$author$project$Api$SuperAdminDelete$exec,
					{
						ev: _List_fromArray(
							[id])
					},
					authState.iQ)));
	});
var $author$project$Model$SuperAdminList$onDeleteSingleResult = F4(
	function (data, response, authState, appModel) {
		var model = authState.h1.iy;
		var _v0 = model;
		var offset = _v0.fo;
		var limit = _v0.eV;
		var search = _v0.fU;
		var checkedList = _v0.F;
		var selectedSuperAdmin = _v0.bh;
		var updateCheckedList = A2(
			$elm$core$List$filter,
			function (item) {
				return !_Utils_eq(item.eu, selectedSuperAdmin);
			},
			checkedList);
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminList$mapState,
					_Utils_update(
						model,
						{
							bh: 0,
							cQ: $author$project$Data$DataStatus$Downloaded(data)
						}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$SuperAdminDelete$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			return _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminList$mapState,
					_Utils_update(
						model,
						{F: updateCheckedList, bh: 0, cQ: $author$project$Data$DataStatus$Downloading}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.hk, $author$project$Data$Alert$clear)
						})),
				A2(
					$author$project$Model$SuperAdminList$getSuperAdminsCmd,
					{eV: limit, fo: offset, fU: search},
					authState.iQ));
		}
	});
var $author$project$Model$SuperAdminList$onGetSuperAdminsResult = F3(
	function (response, authState, appModel) {
		var model = authState.h1.iy;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminList$mapState,
					_Utils_update(
						model,
						{
							cQ: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var superAdmins = response.a.iz;
			var total = response.a.iR;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$SuperAdminList$mapState,
					_Utils_update(
						model,
						{
							cQ: $author$project$Data$DataStatus$Downloaded(superAdmins),
							iR: total
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$SuperAdminList$update = F3(
	function (msg, authState, appModel) {
		var model = authState.h1.iy;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				var _v1 = model;
				var searchDebounce = _v1.be;
				var _v2 = A3($author$project$Ext$Debounce$debouncePush, $author$project$Model$SuperAdminList$debounceConfig, value, searchDebounce);
				var debounce = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$SuperAdminList$mapState,
						_Utils_update(
							model,
							{fU: value, be: debounce}),
						authState,
						appModel),
					cmd);
			case 1:
				var msg_ = msg.a;
				var _v3 = model;
				var searchDebounce = _v3.be;
				var _v4 = A4(
					$author$project$Ext$Debounce$debounceUpdate,
					$author$project$Model$SuperAdminList$debounceConfig,
					$author$project$Ext$Debounce$debounceTakeLast(
						function (s) {
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnSuperAdminList),
									$author$project$Type$SuperAdminList$OnSearch),
								$elm$core$Task$succeed(s));
						}),
					msg_,
					searchDebounce);
				var debounce = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$SuperAdminList$mapState,
						_Utils_update(
							model,
							{be: debounce}),
						authState,
						appModel),
					cmd);
			case 2:
				var value = msg.a;
				var _v5 = model;
				var offset = _v5.fo;
				var limit = _v5.eV;
				return _Utils_Tuple2(
					appModel,
					A2(
						$author$project$Model$SuperAdminList$getSuperAdminsCmd,
						{eV: limit, fo: offset, fU: value},
						authState.iQ));
			case 3:
				return A2($author$project$Model$SuperAdminList$onCheckAll, authState, appModel);
			case 4:
				var superAdmin = msg.a;
				return A3($author$project$Model$SuperAdminList$onCheck, superAdmin, authState, appModel);
			case 6:
				return _Utils_Tuple2(
					A3(
						$author$project$Model$SuperAdminList$mapState,
						_Utils_update(
							model,
							{bQ: false}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					A3(
						$author$project$Model$SuperAdminList$mapState,
						_Utils_update(
							model,
							{bQ: true}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 7:
				var value = msg.a;
				var _v6 = model;
				var limit = _v6.eV;
				var search = _v6.fU;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$SuperAdminList$mapState,
						_Utils_update(
							model,
							{fo: value, cQ: $author$project$Data$DataStatus$Downloading}),
						authState,
						appModel),
					A2(
						$author$project$Model$SuperAdminList$getSuperAdminsCmd,
						{eV: limit, fo: value, fU: search},
						authState.iQ));
			case 8:
				var data = msg.a;
				return A3($author$project$Model$SuperAdminList$onDelete, data, authState, appModel);
			case 9:
				var data = msg.a;
				var response = msg.b;
				return A4($author$project$Model$SuperAdminList$onDeleteResult, data, response, authState, appModel);
			case 10:
				var id = msg.a;
				var data = msg.b;
				return A4($author$project$Model$SuperAdminList$onDeleteSingle, id, data, authState, appModel);
			case 11:
				var data = msg.a;
				var response = msg.b;
				return A4($author$project$Model$SuperAdminList$onDeleteSingleResult, data, response, authState, appModel);
			case 12:
				var response = msg.a;
				return A3($author$project$Model$SuperAdminList$onGetSuperAdminsResult, response, authState, appModel);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$SuperAdminList$mapState,
						_Utils_update(
							model,
							{bh: value}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$TenantDetail$OnCreateTenantResult = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$TenantCreate$InvalidMaxBots = 2;
var $author$project$Api$TenantCreate$InvalidMaxNodes = 3;
var $author$project$Api$TenantCreate$InvalidName = 1;
var $author$project$Api$TenantCreate$InvalidParams = 0;
var $author$project$Api$TenantCreate$MissingError = 5;
var $author$project$Api$TenantCreate$NameExisted = 4;
var $author$project$Api$TenantCreate$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$5:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'InvalidName':
					return 1;
				case 'InvalidMaxBots':
					return 2;
				case 'InvalidMaxNodes':
					return 3;
				case 'NameExisted':
					return 4;
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return 5;
};
var $author$project$Api$TenantCreate$exec = F2(
	function (_v0, token) {
		var name = _v0.fg;
		var maxBots = _v0.e0;
		var maxNodes = _v0.e1;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$TenantCreate$toErrorCode,
			A2($elm$json$Json$Decode$field, 'tenant', $author$project$Api$Decoder$tenant));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name)),
					_Utils_Tuple2(
					'maxBots',
					$elm$json$Json$Encode$int(maxBots)),
					_Utils_Tuple2(
					'maxNodes',
					$elm$json$Json$Encode$int(maxNodes))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'tenant/create', ia: resolver, iQ: token});
	});
var $author$project$Model$TenantDetail$onCreate = F2(
	function (appModel, authState) {
		var _v0 = authState;
		var pages = _v0.h1;
		var _v1 = pages;
		var tenantDetail = _v1.iK;
		var _v2 = tenantDetail;
		var name = _v2.fg;
		var maxNodes = _v2.e1;
		var maxBots = _v2.e0;
		return $author$project$Data$Form$isValidFields(
			_List_fromArray(
				[name, maxNodes, maxBots])) ? _Utils_Tuple2(
			A3(
				$author$project$Model$TenantDetail$mapState,
				_Utils_update(
					tenantDetail,
					{J: 1}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnTenantDetail),
					$author$project$Type$TenantDetail$OnCreateTenantResult),
				A2(
					$author$project$Api$TenantCreate$exec,
					{
						e0: A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(maxBots.i3)),
						e1: A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(maxNodes.i3)),
						fg: name.i3
					},
					authState.iQ))) : _Utils_Tuple2(
			A3($author$project$Model$TenantDetail$mapState, tenantDetail, authState, appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Api$TenantCreate$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid name';
		case 2:
			return 'Max bot should be a positive number';
		case 3:
			return 'Max bot child should be a positive number';
		case 4:
			return 'Name existed';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$TenantDetail$onCreateResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		var _v1 = pages;
		var tenantDetail = _v1.iK;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$TenantDetail$mapState,
					_Utils_update(
						tenantDetail,
						{J: 2}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$TenantCreate$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$TenantDetail$mapState,
					_Utils_update(
						tenantDetail,
						{
							J: 2,
							bm: $author$project$Data$DataStatus$Downloaded(value)
						}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.hb, $author$project$Data$Alert$clear)
						})),
				A2(
					$elm$browser$Browser$Navigation$pushUrl,
					appModel.ab,
					$author$project$Data$Route$routeUrl.d3(value.eu)));
		}
	});
var $author$project$Model$TenantDetail$onGetTenantResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		var _v1 = pages;
		var tenantDetail = _v1.iK;
		var _v2 = tenantDetail;
		var name = _v2.fg;
		var maxNodes = _v2.e1;
		var maxBots = _v2.e0;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$TenantDetail$mapState,
					_Utils_update(
						tenantDetail,
						{
							bm: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$TenantDetail$mapState,
					_Utils_update(
						tenantDetail,
						{
							e0: _Utils_update(
								maxBots,
								{
									i3: $elm$core$String$fromInt(value.e0)
								}),
							e1: _Utils_update(
								maxNodes,
								{
									i3: $elm$core$String$fromInt(value.e1)
								}),
							fg: _Utils_update(
								name,
								{i3: value.fg}),
							bm: $author$project$Data$DataStatus$Downloaded(value)
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$TenantDetail$OnUpdateResult = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$TenantUpdate$HostExisted = 6;
var $author$project$Api$TenantUpdate$InvalidHost = 3;
var $author$project$Api$TenantUpdate$InvalidMaxNodes = 4;
var $author$project$Api$TenantUpdate$InvalidName = 2;
var $author$project$Api$TenantUpdate$InvalidParams = 0;
var $author$project$Api$TenantUpdate$MissingError = 7;
var $author$project$Api$TenantUpdate$NameExisted = 5;
var $author$project$Api$TenantUpdate$TenantNotFound = 1;
var $author$project$Api$TenantUpdate$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$7:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'TenantNotFound':
					return 1;
				case 'InvalidName':
					return 2;
				case 'InvalidHost':
					return 3;
				case 'InvalidMaxNodes':
					return 4;
				case 'NameExisted':
					return 5;
				case 'HostExisted':
					return 6;
				default:
					break _v0$7;
			}
		} else {
			break _v0$7;
		}
	}
	return 7;
};
var $author$project$Api$TenantUpdate$exec = F2(
	function (_v0, token) {
		var id = _v0.eu;
		var name = _v0.fg;
		var maxBots = _v0.e0;
		var maxNodes = _v0.e1;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$TenantUpdate$toErrorCode,
			A2($elm$json$Json$Decode$field, 'tenant', $author$project$Api$Decoder$tenant));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(id)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name)),
					_Utils_Tuple2(
					'maxBots',
					$elm$json$Json$Encode$int(maxBots)),
					_Utils_Tuple2(
					'maxNodes',
					$elm$json$Json$Encode$int(maxNodes))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'tenant/update', ia: resolver, iQ: token});
	});
var $author$project$Model$TenantDetail$onUpdate = F3(
	function (id, appModel, authState) {
		var _v0 = authState;
		var pages = _v0.h1;
		var token = _v0.iQ;
		var _v1 = pages;
		var tenantDetail = _v1.iK;
		var _v2 = tenantDetail;
		var name = _v2.fg;
		var maxNodes = _v2.e1;
		var maxBots = _v2.e0;
		var params = {
			eu: id,
			e0: A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(maxBots.i3)),
			e1: A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(maxNodes.i3)),
			fg: name.i3
		};
		return $author$project$Data$Form$isValidFields(
			_List_fromArray(
				[name, maxBots, maxNodes])) ? _Utils_Tuple2(
			A3(
				$author$project$Model$TenantDetail$mapState,
				_Utils_update(
					tenantDetail,
					{J: 1}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnTenantDetail),
					$author$project$Type$TenantDetail$OnUpdateResult),
				A2($author$project$Api$TenantUpdate$exec, params, token))) : _Utils_Tuple2(
			A3($author$project$Model$TenantDetail$mapState, tenantDetail, authState, appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Api$TenantUpdate$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Tenant not found';
		case 2:
			return 'Invalid name';
		case 3:
			return 'Invalid host';
		case 4:
			return 'Max bot child should be a positive number';
		case 5:
			return 'Name existed';
		case 6:
			return 'Host existed';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$TenantDetail$onUpdateResult = F3(
	function (response, authState, appModel) {
		var _v0 = authState;
		var pages = _v0.h1;
		var _v1 = pages;
		var tenantDetail = _v1.iK;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$TenantDetail$mapState,
					_Utils_update(
						tenantDetail,
						{J: 2}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$TenantUpdate$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var value = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$TenantDetail$mapState,
					_Utils_update(
						tenantDetail,
						{
							J: 2,
							bm: $author$project$Data$DataStatus$Downloaded(value)
						}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.i1, $author$project$Data$Alert$clear)
						})),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$TenantDetail$update = F3(
	function (msg, authState, appModel) {
		var model = authState.h1.iK;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				var _v1 = model;
				var name = _v1.fg;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$TenantDetail$mapState,
						_Utils_update(
							model,
							{
								fg: A2($author$project$Data$Form$updateField, name, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				var _v2 = model;
				var maxBots = _v2.e0;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$TenantDetail$mapState,
						_Utils_update(
							model,
							{
								e0: A2($author$project$Data$Form$updateField, maxBots, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				var _v3 = model;
				var maxNodes = _v3.e1;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$TenantDetail$mapState,
						_Utils_update(
							model,
							{
								e1: A2($author$project$Data$Form$updateField, maxNodes, value)
							}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 3:
				return A2($author$project$Model$TenantDetail$onCreate, appModel, authState);
			case 4:
				var response = msg.a;
				return A3($author$project$Model$TenantDetail$onCreateResult, response, authState, appModel);
			case 5:
				var id = msg.a;
				return A3($author$project$Model$TenantDetail$onUpdate, id, appModel, authState);
			case 6:
				var response = msg.a;
				return A3($author$project$Model$TenantDetail$onUpdateResult, response, authState, appModel);
			default:
				var response = msg.a;
				return A3($author$project$Model$TenantDetail$onGetTenantResult, response, authState, appModel);
		}
	});
var $author$project$Type$TenantList$OnSearch = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$TenantList$OnSearchDebounce = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$TenantList$debounceConfig = $author$project$Ext$Debounce$config(
	A2(
		$elm$core$Basics$composeL,
		A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnTenantList),
		$author$project$Type$TenantList$OnSearchDebounce));
var $author$project$Model$TenantList$onCheck = F3(
	function (tenant, authState, appModel) {
		var _v0 = authState.h1;
		var tenantList = _v0.iL;
		var _v1 = tenantList;
		var checkedList = _v1.F;
		var isExisted = A2(
			$elm$core$List$filter,
			function (item) {
				return _Utils_eq(item.eu, tenant.eu);
			},
			checkedList);
		return ($elm$core$List$length(isExisted) > 0) ? _Utils_Tuple2(
			A3(
				$author$project$Model$TenantList$mapState,
				_Utils_update(
					tenantList,
					{
						F: A2(
							$elm$core$List$filter,
							function (item) {
								return !_Utils_eq(item.eu, tenant.eu);
							},
							checkedList)
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
			A3(
				$author$project$Model$TenantList$mapState,
				_Utils_update(
					tenantList,
					{
						F: A2(
							$elm$core$List$append,
							checkedList,
							_List_fromArray(
								[tenant]))
					}),
				authState,
				appModel),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Model$TenantList$onCheckAll = F2(
	function (authState, appModel) {
		var model = authState.h1.iL;
		var _v0 = model;
		var checkedList = _v0.F;
		var status = _v0.cQ;
		if (status.$ === 4) {
			var data = status.a;
			return _Utils_eq(
				$elm$core$List$length(data),
				$elm$core$List$length(checkedList)) ? _Utils_Tuple2(
				A3(
					$author$project$Model$TenantList$mapState,
					_Utils_update(
						model,
						{F: _List_Nil}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
				A3(
					$author$project$Model$TenantList$mapState,
					_Utils_update(
						model,
						{F: data}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				A3($author$project$Model$TenantList$mapState, model, authState, appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$TenantList$OnDeleteResult = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Api$TenantDelete$CannotDeleteTenantContainedAdmin = 3;
var $author$project$Api$TenantDelete$CannotDeleteTenantContainedBot = 4;
var $author$project$Api$TenantDelete$CannotGetAdminCount = 1;
var $author$project$Api$TenantDelete$CannotGetBotCount = 2;
var $author$project$Api$TenantDelete$InvalidParams = 0;
var $author$project$Api$TenantDelete$MissingError = 5;
var $author$project$Api$TenantDelete$toErrorCode = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	_v0$5:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'InvalidParams':
					return 0;
				case 'CannotGetAdminCount':
					return 1;
				case 'CannotGetBotCount':
					return 2;
				case 'CannotDeleteTenantContainedAdmin':
					return 3;
				case 'CannotDeleteTenantContainedBot':
					return 4;
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return 5;
};
var $author$project$Api$TenantDelete$exec = F2(
	function (_v0, token) {
		var ids = _v0.ev;
		var resolver = A2(
			$author$project$Api$Base$standardResolver,
			$author$project$Api$TenantDelete$toErrorCode,
			$elm$json$Json$Decode$succeed(0));
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ids',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, ids))
				]));
		return $author$project$Api$Base$authCall(
			{h2: params, h3: 'tenant/delete', ia: resolver, iQ: token});
	});
var $author$project$Model$TenantList$onDelete = F3(
	function (data, authState, appModel) {
		var model = authState.h1.iL;
		var _v0 = model;
		var checkedList = _v0.F;
		var ids = A2(
			$elm$core$List$map,
			function (item) {
				return item.eu;
			},
			checkedList);
		return ($elm$core$List$length(ids) > 0) ? _Utils_Tuple2(
			A3(
				$author$project$Model$TenantList$mapState,
				_Utils_update(
					model,
					{
						bQ: false,
						cQ: $author$project$Data$DataStatus$Deleting(data)
					}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnTenantList),
					$author$project$Type$TenantList$OnDeleteResult(data)),
				A2(
					$author$project$Api$TenantDelete$exec,
					{ev: ids},
					authState.iQ))) : _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
	});
var $author$project$Api$TenantDelete$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Cannot delete tenant';
		case 2:
			return 'Cannot delete tenant';
		case 3:
			return 'Tenant contains admin';
		case 4:
			return 'Tenant contains Bot';
		default:
			return 'Missing error code';
	}
};
var $author$project$Model$TenantList$onDeleteResult = F4(
	function (data, response, authState, appModel) {
		var model = authState.h1.iL;
		var _v0 = model;
		var offset = _v0.fo;
		var limit = _v0.eV;
		var search = _v0.fU;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$TenantList$mapState,
					_Utils_update(
						model,
						{
							cQ: $author$project$Data$DataStatus$Downloaded(data)
						}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$TenantDelete$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			return _Utils_Tuple2(
				A3(
					$author$project$Model$TenantList$mapState,
					_Utils_update(
						model,
						{F: _List_Nil, cQ: $author$project$Data$DataStatus$Downloading}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.hl, $author$project$Data$Alert$clear)
						})),
				A2(
					$author$project$Model$TenantList$getTenantsCmd,
					{eV: limit, fo: offset, fU: search},
					authState.iQ));
		}
	});
var $author$project$Type$TenantList$OnDeleteSingleResult = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Model$TenantList$onDeleteSingle = F4(
	function (id, data, authState, appModel) {
		var model = authState.h1.iL;
		return _Utils_Tuple2(
			A3(
				$author$project$Model$TenantList$mapState,
				_Utils_update(
					model,
					{
						cQ: $author$project$Data$DataStatus$Deleting(data)
					}),
				authState,
				appModel),
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnTenantList),
					$author$project$Type$TenantList$OnDeleteSingleResult(data)),
				A2(
					$author$project$Api$TenantDelete$exec,
					{
						ev: _List_fromArray(
							[id])
					},
					authState.iQ)));
	});
var $author$project$Model$TenantList$onDeleteSingleResult = F4(
	function (data, response, authState, appModel) {
		var model = authState.h1.iL;
		var _v0 = model;
		var offset = _v0.fo;
		var limit = _v0.eV;
		var search = _v0.fU;
		var checkedList = _v0.F;
		var selectedTenant = _v0.bi;
		var updateCheckedList = A2(
			$elm$core$List$filter,
			function (item) {
				return !_Utils_eq(item.eu, selectedTenant);
			},
			checkedList);
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$TenantList$mapState,
					_Utils_update(
						model,
						{
							bi: 0,
							cQ: $author$project$Data$DataStatus$Downloaded(data)
						}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2(
								$author$project$Data$Alert$addDanger,
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$TenantDelete$errorCodeString, error),
								$author$project$Data$Alert$clear)
						})),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			return _Utils_Tuple2(
				A3(
					$author$project$Model$TenantList$mapState,
					_Utils_update(
						model,
						{F: updateCheckedList, bi: 0, cQ: $author$project$Data$DataStatus$Downloading}),
					authState,
					_Utils_update(
						appModel,
						{
							ar: A2($author$project$Data$Alert$addInfo, $author$project$Data$Message$messages.hk, $author$project$Data$Alert$clear)
						})),
				A2(
					$author$project$Model$TenantList$getTenantsCmd,
					{eV: limit, fo: offset, fU: search},
					authState.iQ));
		}
	});
var $author$project$Model$TenantList$onGetTenantsResult = F3(
	function (response, authState, appModel) {
		var model = authState.h1.iL;
		if (response.$ === 1) {
			var error = response.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$TenantList$mapState,
					_Utils_update(
						model,
						{
							cQ: $author$project$Data$DataStatus$Error(error)
						}),
					authState,
					appModel),
				A2($author$project$Api$Base$performCommonErrorMsg, $author$project$Type$OnCommonRequestError, error));
		} else {
			var tenants = response.a.iM;
			var total = response.a.iR;
			return _Utils_Tuple2(
				A3(
					$author$project$Model$TenantList$mapState,
					_Utils_update(
						model,
						{
							cQ: $author$project$Data$DataStatus$Downloaded(tenants),
							iR: total
						}),
					authState,
					appModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$TenantList$update = F3(
	function (msg, authState, appModel) {
		var model = authState.h1.iL;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				var _v1 = model;
				var searchDebounce = _v1.be;
				var _v2 = A3($author$project$Ext$Debounce$debouncePush, $author$project$Model$TenantList$debounceConfig, value, searchDebounce);
				var debounce = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$TenantList$mapState,
						_Utils_update(
							model,
							{fU: value, be: debounce}),
						authState,
						appModel),
					cmd);
			case 1:
				var msg_ = msg.a;
				var _v3 = model;
				var searchDebounce = _v3.be;
				var _v4 = A4(
					$author$project$Ext$Debounce$debounceUpdate,
					$author$project$Model$TenantList$debounceConfig,
					$author$project$Ext$Debounce$debounceTakeLast(
						function (s) {
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnTenantList),
									$author$project$Type$TenantList$OnSearch),
								$elm$core$Task$succeed(s));
						}),
					msg_,
					searchDebounce);
				var debounce = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$TenantList$mapState,
						_Utils_update(
							model,
							{be: debounce}),
						authState,
						appModel),
					cmd);
			case 2:
				var value = msg.a;
				var _v5 = model;
				var offset = _v5.fo;
				var limit = _v5.eV;
				return _Utils_Tuple2(
					appModel,
					A2(
						$author$project$Model$TenantList$getTenantsCmd,
						{eV: limit, fo: offset, fU: value},
						authState.iQ));
			case 3:
				return A2($author$project$Model$TenantList$onCheckAll, authState, appModel);
			case 4:
				var tenant = msg.a;
				return A3($author$project$Model$TenantList$onCheck, tenant, authState, appModel);
			case 6:
				return _Utils_Tuple2(
					A3(
						$author$project$Model$TenantList$mapState,
						_Utils_update(
							model,
							{bQ: false}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					A3(
						$author$project$Model$TenantList$mapState,
						_Utils_update(
							model,
							{bQ: true}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
			case 7:
				var value = msg.a;
				var _v6 = model;
				var limit = _v6.eV;
				var search = _v6.fU;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$TenantList$mapState,
						_Utils_update(
							model,
							{fo: value, cQ: $author$project$Data$DataStatus$Downloading}),
						authState,
						appModel),
					A2(
						$author$project$Model$TenantList$getTenantsCmd,
						{eV: limit, fo: value, fU: search},
						authState.iQ));
			case 8:
				var data = msg.a;
				return A3($author$project$Model$TenantList$onDelete, data, authState, appModel);
			case 9:
				var data = msg.a;
				var response = msg.b;
				return A4($author$project$Model$TenantList$onDeleteResult, data, response, authState, appModel);
			case 10:
				var id = msg.a;
				var data = msg.b;
				return A4($author$project$Model$TenantList$onDeleteSingle, id, data, authState, appModel);
			case 11:
				var data = msg.a;
				var response = msg.b;
				return A4($author$project$Model$TenantList$onDeleteSingleResult, data, response, authState, appModel);
			case 12:
				var response = msg.a;
				return A3($author$project$Model$TenantList$onGetTenantsResult, response, authState, appModel);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Model$TenantList$mapState,
						_Utils_update(
							model,
							{bi: value}),
						authState,
						appModel),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$updateAuthState = F3(
	function (authorizedMsg, authState, model) {
		switch (authorizedMsg.$) {
			case 0:
				var profileMsg = authorizedMsg.a;
				return A3($author$project$Model$Profile$update, profileMsg, authState, model);
			case 1:
				var menuMsg = authorizedMsg.a;
				return A3($author$project$Model$Menu$update, menuMsg, authState, model);
			case 2:
				var adminsMsg = authorizedMsg.a;
				return A3($author$project$Model$AdminList$update, adminsMsg, authState, model);
			case 3:
				var adminMsg = authorizedMsg.a;
				return A3($author$project$Model$AdminDetail$update, adminMsg, authState, model);
			case 4:
				var superAdminsMsg = authorizedMsg.a;
				return A3($author$project$Model$SuperAdminList$update, superAdminsMsg, authState, model);
			case 5:
				var superAdminMsg = authorizedMsg.a;
				return A3($author$project$Model$SuperAdminDetail$update, superAdminMsg, authState, model);
			case 6:
				var tenantsMsg = authorizedMsg.a;
				return A3($author$project$Model$TenantList$update, tenantsMsg, authState, model);
			case 7:
				var tenantMsg = authorizedMsg.a;
				return A3($author$project$Model$TenantDetail$update, tenantMsg, authState, model);
			case 8:
				var botsMsg = authorizedMsg.a;
				return A3($author$project$Model$BotList$update, botsMsg, authState, model);
			case 9:
				var botMsg = authorizedMsg.a;
				return A3($author$project$Model$BotDetail$update, botMsg, authState, model);
			case 10:
				var botLogMsg = authorizedMsg.a;
				return A3($author$project$Model$BotLog$update, botLogMsg, authState, model);
			case 11:
				var botReportMsg = authorizedMsg.a;
				return A3($author$project$Model$BotReport$update, botReportMsg, authState, model);
			case 12:
				var dashboarMsg = authorizedMsg.a;
				return A3($author$project$Model$Dashboard$update, dashboarMsg, authState, model);
			default:
				var auditLogMsg = authorizedMsg.a;
				return A3($author$project$Model$AuditLog$update, auditLogMsg, authState, model);
		}
	});
var $author$project$Model$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var url = msg.a;
				return A2($author$project$Model$Route$onUrlChange, url, model);
			case 1:
				var urlRequest = msg.a;
				if (!urlRequest.$) {
					var url = urlRequest.a;
					return function (_v2) {
						var updatedModel = _v2.a;
						var cmd = _v2.b;
						return _Utils_Tuple2(
							_Utils_update(
								updatedModel,
								{ar: $author$project$Data$Alert$clear}),
							cmd);
					}(
						A2($author$project$Model$Route$onInternalUrlRequest, url, model));
				} else {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(url));
				}
			case 2:
				var error = msg.a;
				return A2($author$project$Model$onCommonRequestError, error, model);
			case 3:
				var loginMsg = msg.a;
				return A2($author$project$Model$Login$update, loginMsg, model);
			case 6:
				var token = msg.a;
				var result = msg.b;
				return A3($author$project$Model$onGetSuperAdminProfileResult, result, token, model);
			case 7:
				var token = msg.a;
				var result = msg.b;
				return A3($author$project$Model$onGetAdminProfileResult, result, token, model);
			case 8:
				return A2($author$project$Model$onLogout, model, $author$project$Data$Message$messages.hL);
			case 4:
				return A2($author$project$Model$onLogout, model, $author$project$Data$Message$messages.hO);
			case 5:
				var token = msg.a;
				var profile = msg.b;
				var routeCmd = function () {
					var _v3 = model.cM;
					switch (_v3.$) {
						case 1:
							return A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.ab,
								$author$project$Data$Route$routeToUrl($author$project$Data$Route$HomeRoute));
						case 2:
							return A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.ab,
								$author$project$Data$Route$routeToUrl($author$project$Data$Route$HomeRoute));
						default:
							return A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.ab,
								$author$project$Data$Route$routeToUrl(model.cM));
					}
				}();
				return A2(
					$elm$core$Tuple$mapSecond,
					function (cmd) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[routeCmd, cmd]));
					},
					A3($author$project$Model$initialAuthState, token, profile, model));
			case 9:
				var authorizedMsg = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (authState) {
							return A3($author$project$Model$updateAuthState, authorizedMsg, authState, model);
						},
						model.aW));
			case 10:
				var alert = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ar: A2($author$project$Data$Alert$remove, alert, model.ar)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$View$Layout$NoAuthLayout = {$: 0};
var $author$project$View$Layout$AuthLayout = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$a = $rtfeldman$elm_css$Html$Styled$node('a');
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.hf) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.fg, record.hf, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{hf: decl, fg: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactDeclarations = function (declarations) {
	var _v0 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v0.a;
	var compactedDeclarations = _v0.b;
	return A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
};
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.dw;
	var imports = _v0.ex;
	var namespaces = _v0.fh;
	var declarations = _v0.hg;
	return {
		dw: charset,
		hg: $rtfeldman$elm_css$Css$Structure$compactDeclarations(declarations),
		ex: imports,
		fh: namespaces
	};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$String$mapJoinHelp = F4(
	function (map, sep, strs, result) {
		mapJoinHelp:
		while (true) {
			if (!strs.b) {
				return result;
			} else {
				if (!strs.b.b) {
					var first = strs.a;
					return result + (map(first) + '');
				} else {
					var first = strs.a;
					var rest = strs.b;
					var $temp$map = map,
						$temp$sep = sep,
						$temp$strs = rest,
						$temp$result = result + (map(first) + (sep + ''));
					map = $temp$map;
					sep = $temp$sep;
					strs = $temp$strs;
					result = $temp$result;
					continue mapJoinHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$Css$String$mapJoin = F3(
	function (map, sep, strs) {
		return A4($rtfeldman$elm_css$Css$String$mapJoinHelp, map, sep, strs, '');
	});
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.ef + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.i3)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, ' and ', expressions);
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
		'\n',
		mediaQueries);
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		function (_v0) {
			var prop = _v0;
			return prop + ';';
		},
		'',
		properties);
};
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors);
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return $rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator) + (' ' + $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement));
	return A2(
		$elm$core$String$append,
		A2($elm$core$String$join, ' ', segments),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = function (_v0) {
	var firstSelector = _v0.a;
	var otherSelectors = _v0.b;
	var properties = _v0.c;
	var selectorStr = A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
		',',
		A2($elm$core$List$cons, firstSelector, otherSelectors));
	return selectorStr + ('{' + ($rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties) + '}'));
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, ', ', mediaQueries);
			var blocks = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, '\n', styleBlocks);
			return '@media ' + (query + ('{' + (blocks + '}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.fg;
			var declaration = decl.a.hf;
			return '@keyframes ' + (name + ('{' + (declaration + '}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.dw;
	var imports = _v0.ex;
	var namespaces = _v0.fh;
	var declarations = _v0.hg;
	return $rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$importToString, '\n', imports) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, '\n', namespaces) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, '\n', declarations) + '')));
};
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Property = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $robinheghan$murmur3$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {au: charsProcessed, aB: hash, C: seed, aJ: shift};
	});
var $robinheghan$murmur3$Murmur3$c1 = 3432918353;
var $robinheghan$murmur3$Murmur3$c2 = 461845907;
var $robinheghan$murmur3$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $robinheghan$murmur3$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $robinheghan$murmur3$Murmur3$finalize = function (data) {
	var acc = (!(!data.aB)) ? (data.C ^ A2(
		$robinheghan$murmur3$Murmur3$multiplyBy,
		$robinheghan$murmur3$Murmur3$c2,
		A2(
			$robinheghan$murmur3$Murmur3$rotlBy,
			15,
			A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, data.aB)))) : data.C;
	var h0 = acc ^ data.au;
	var h1 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $robinheghan$murmur3$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$robinheghan$murmur3$Murmur3$multiplyBy,
			5,
			A2(
				$robinheghan$murmur3$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$robinheghan$murmur3$Murmur3$multiplyBy,
					$robinheghan$murmur3$Murmur3$c2,
					A2(
						$robinheghan$murmur3$Murmur3$rotlBy,
						15,
						A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, k1))))) + 3864292196;
	});
var $robinheghan$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.aB | ((255 & $elm$core$Char$toCode(c)) << data.aJ);
		var _v0 = data.aJ;
		if (_v0 === 24) {
			return {
				au: data.au + 1,
				aB: 0,
				C: A2($robinheghan$murmur3$Murmur3$mix, data.C, res),
				aJ: 0
			};
		} else {
			return {au: data.au + 1, aB: res, C: data.C, aJ: data.aJ + 8};
		}
	});
var $robinheghan$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return $robinheghan$murmur3$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$robinheghan$murmur3$Murmur3$hashFold,
				A4($robinheghan$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$initialSeed = 15739;
var $elm$core$String$fromList = _String_fromList;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($robinheghan$murmur3$Murmur3$hashString, $rtfeldman$elm_css$Hash$initialSeed, str)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$PageRule(properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{hf: str, fg: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$PageRule(properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.dw;
	var imports = _v0.ex;
	var namespaces = _v0.fh;
	var snippets = _v0.f9;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {dw: charset, hg: declarations, ex: imports, fh: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {dw: $elm$core$Maybe$Nothing, ex: _List_Nil, fh: _List_Nil, f9: snippets};
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin = '\u0007';
var $rtfeldman$elm_css$VirtualDom$Styled$templateSelector = $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$ClassSelector($rtfeldman$elm_css$VirtualDom$Styled$classnameStandin)
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate = function (styles) {
	if (!styles.b) {
		return '';
	} else {
		var otherwise = styles;
		return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$VirtualDom$Styled$makeSnippet, styles, $rtfeldman$elm_css$VirtualDom$Styled$templateSelector)
					])));
	}
};
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var cssTemplate = $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate(styles);
	var classProperty = A2($elm$virtual_dom$VirtualDom$attribute, '', '');
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, true, cssTemplate);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $rtfeldman$elm_css$Html$Styled$h2 = $rtfeldman$elm_css$Html$Styled$node('h2');
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$href = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'href', url);
};
var $author$project$View$Theme$image = {c8: '/images/avatar.svg', eZ: '/images/logo.png', hN: '/images/logo.png'};
var $rtfeldman$elm_css$Html$Styled$img = $rtfeldman$elm_css$Html$Styled$node('img');
var $rtfeldman$elm_css$Html$Styled$Attributes$src = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'src', url);
};
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$batch = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $author$project$Tailwind$Utilities$bg_white = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-bg-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(255, 255, 255, var(--tw-bg-opacity))')
		]));
var $author$project$Tailwind$Utilities$cursor_pointer = A2($rtfeldman$elm_css$Css$property, 'cursor', 'pointer');
var $author$project$Tailwind$Utilities$flex = A2($rtfeldman$elm_css$Css$property, 'display', 'flex');
var $author$project$Tailwind$Utilities$h_12 = A2($rtfeldman$elm_css$Css$property, 'height', '3rem');
var $author$project$Tailwind$Utilities$items_center = A2($rtfeldman$elm_css$Css$property, 'align-items', 'center');
var $author$project$Tailwind$Utilities$justify_center = A2($rtfeldman$elm_css$Css$property, 'justify-content', 'center');
var $author$project$Tailwind$Utilities$max_w_md = A2($rtfeldman$elm_css$Css$property, 'max-width', '28rem');
var $author$project$Tailwind$Utilities$mt_2 = A2($rtfeldman$elm_css$Css$property, 'margin-top', '0.5rem');
var $author$project$Tailwind$Utilities$mx_auto = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'margin-left', 'auto'),
			A2($rtfeldman$elm_css$Css$property, 'margin-right', 'auto')
		]));
var $author$project$Tailwind$Utilities$no_underline = A2($rtfeldman$elm_css$Css$property, 'text-decoration', 'none');
var $author$project$Tailwind$Utilities$px_10 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-left', '2.5rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-right', '2.5rem')
		]));
var $author$project$Tailwind$Utilities$px_4 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-left', '1rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-right', '1rem')
		]));
var $author$project$Tailwind$Utilities$py_12 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-top', '3rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-bottom', '3rem')
		]));
var $author$project$Tailwind$Utilities$py_8 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-top', '2rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-bottom', '2rem')
		]));
var $author$project$Tailwind$Utilities$rounded_lg = A2($rtfeldman$elm_css$Css$property, 'border-radius', '0.5rem');
var $author$project$Tailwind$Utilities$shadow = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-shadow', '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', 'var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)')
		]));
var $rtfeldman$elm_css$Css$Structure$CustomQuery = function (a) {
	return {$: 3, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$WithMedia = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Media$withMediaQuery = function (queries) {
	return $rtfeldman$elm_css$Css$Preprocess$WithMedia(
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$CustomQuery, queries));
};
var $author$project$Tailwind$Breakpoints$sm = $rtfeldman$elm_css$Css$Media$withMediaQuery(
	_List_fromArray(
		['(min-width: 640px)']));
var $rtfeldman$elm_css$Css$Structure$Child = 2;
var $rtfeldman$elm_css$Css$Preprocess$NestSnippet = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Global$children = $rtfeldman$elm_css$Css$Preprocess$NestSnippet(2);
var $rtfeldman$elm_css$Css$Global$selector = F2(
	function (selectorStr, styles) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			A2($rtfeldman$elm_css$Css$Structure$CustomSelector, selectorStr, _List_Nil));
	});
var $author$project$Tailwind$Utilities$space_y_6 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Global$children(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$Global$selector,
					':not([hidden]) ~ :not([hidden])',
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, '--tw-space-y-reverse', '0'),
							A2($rtfeldman$elm_css$Css$property, 'margin-top', 'calc(1.5rem * calc(1 - var(--tw-space-y-reverse)))'),
							A2($rtfeldman$elm_css$Css$property, 'margin-bottom', 'calc(1.5rem * var(--tw-space-y-reverse))')
						]))
				]))
		]));
var $author$project$Tailwind$Utilities$space_y_8 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Global$children(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$Global$selector,
					':not([hidden]) ~ :not([hidden])',
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, '--tw-space-y-reverse', '0'),
							A2($rtfeldman$elm_css$Css$property, 'margin-top', 'calc(2rem * calc(1 - var(--tw-space-y-reverse)))'),
							A2($rtfeldman$elm_css$Css$property, 'margin-bottom', 'calc(2rem * var(--tw-space-y-reverse))')
						]))
				]))
		]));
var $author$project$Tailwind$Utilities$text_3xl = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-size', '1.875rem'),
			A2($rtfeldman$elm_css$Css$property, 'line-height', '2.25rem')
		]));
var $author$project$Tailwind$Utilities$text_gray_900 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-text-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(17, 24, 39, var(--tw-text-opacity))')
		]));
var $author$project$Tailwind$Utilities$text_indigo_600 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-text-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(79, 70, 229, var(--tw-text-opacity))')
		]));
var $author$project$Tailwind$Utilities$w_auto = A2($rtfeldman$elm_css$Css$property, 'width', 'auto');
var $author$project$Tailwind$Utilities$w_full = A2($rtfeldman$elm_css$Css$property, 'width', '100%');
var $author$project$Page$Login$styles = {
	dg: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$bg_white,
			$author$project$Tailwind$Utilities$py_8,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$shadow,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$rounded_lg, $author$project$Tailwind$Utilities$px_10]))
		]),
	cm: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_full, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$justify_center]),
	dq: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_full, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$justify_center]),
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$justify_center, $author$project$Tailwind$Utilities$py_12, $author$project$Tailwind$Utilities$px_4]),
	ek: _List_fromArray(
		[$author$project$Tailwind$Utilities$space_y_6]),
	el: _List_fromArray(
		[$author$project$Tailwind$Utilities$max_w_md, $author$project$Tailwind$Utilities$w_full, $author$project$Tailwind$Utilities$space_y_8]),
	cx: _List_fromArray(
		[$author$project$Tailwind$Utilities$mx_auto, $author$project$Tailwind$Utilities$h_12, $author$project$Tailwind$Utilities$w_auto]),
	eW: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_indigo_600, $author$project$Tailwind$Utilities$no_underline, $author$project$Tailwind$Utilities$cursor_pointer]),
	aP: _List_fromArray(
		[$author$project$Tailwind$Utilities$mt_2, $author$project$Tailwind$Utilities$text_3xl, $author$project$Tailwind$Utilities$text_gray_900]),
	gJ: _List_fromArray(
		[$author$project$Tailwind$Utilities$max_w_md])
};
var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 4, a: a};
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		$elm$virtual_dom$VirtualDom$text(str));
};
var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $author$project$Page$Login$loggedIn = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.dI)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.gJ)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.cx),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$image.eZ)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.aP)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('You are already logged in!')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.eW),
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.es)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Go back to Dashboard!')
								]))
						]))
				]))
		]));
var $author$project$Type$Login$OnEmailChange = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$Login$OnPasswordChange = function (a) {
	return {$: 4, a: a};
};
var $author$project$Type$Login$SubmitForm = {$: 0};
var $rtfeldman$elm_css$Html$Styled$button = $rtfeldman$elm_css$Html$Styled$node('button');
var $author$project$Tailwind$Utilities$bg_gray_50 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-bg-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(249, 250, 251, var(--tw-bg-opacity))')
		]));
var $author$project$Tailwind$Utilities$bg_indigo_600 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-bg-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(79, 70, 229, var(--tw-bg-opacity))')
		]));
var $author$project$Tailwind$Utilities$bg_indigo_700 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-bg-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(67, 56, 202, var(--tw-bg-opacity))')
		]));
var $author$project$Tailwind$Utilities$bg_red_600 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-bg-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(220, 38, 38, var(--tw-bg-opacity))')
		]));
var $author$project$Tailwind$Utilities$bg_red_700 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-bg-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(185, 28, 28, var(--tw-bg-opacity))')
		]));
var $author$project$Tailwind$Utilities$border = A2($rtfeldman$elm_css$Css$property, 'border-width', '1px');
var $author$project$Tailwind$Utilities$border_gray_300 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-border-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'border-color', 'rgba(209, 213, 219, var(--tw-border-opacity))')
		]));
var $author$project$Tailwind$Utilities$border_transparent = A2($rtfeldman$elm_css$Css$property, 'border-color', 'transparent');
var $author$project$Tailwind$Utilities$cursor_not_allowed = A2($rtfeldman$elm_css$Css$property, 'cursor', 'not-allowed');
var $rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Css$pseudoClass = function (_class) {
	return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
		$rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
};
var $rtfeldman$elm_css$Css$disabled = $rtfeldman$elm_css$Css$pseudoClass('disabled');
var $rtfeldman$elm_css$Css$focus = $rtfeldman$elm_css$Css$pseudoClass('focus');
var $author$project$Tailwind$Utilities$font_medium = A2($rtfeldman$elm_css$Css$property, 'font-weight', '500');
var $author$project$Tailwind$Utilities$font_semibold = A2($rtfeldman$elm_css$Css$property, 'font-weight', '600');
var $rtfeldman$elm_css$Css$hover = $rtfeldman$elm_css$Css$pseudoClass('hover');
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.i3);
	});
var $rtfeldman$elm_css$Css$margin = $rtfeldman$elm_css$Css$prop1('margin');
var $author$project$Tailwind$Utilities$opacity_30 = A2($rtfeldman$elm_css$Css$property, 'opacity', '0.3');
var $author$project$Tailwind$Utilities$outline_none = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'outline', '2px solid transparent'),
			A2($rtfeldman$elm_css$Css$property, 'outline-offset', '2px')
		]));
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.i3 + (' ' + argB.i3));
	});
var $rtfeldman$elm_css$Css$padding2 = $rtfeldman$elm_css$Css$prop2('padding');
var $rtfeldman$elm_css$Css$PxUnits = 0;
var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
var $elm$core$String$fromFloat = _String_fromNumber;
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			c_: 0,
			ds: 0,
			ay: 0,
			u: 0,
			a5: 0,
			aE: 0,
			aa: 0,
			aF: 0,
			aG: 0,
			aj: 0,
			ak: 0,
			S: 0,
			ac: numericValue,
			aN: 0,
			aQ: unitLabel,
			bt: units,
			i3: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var $author$project$Tailwind$Utilities$ring_2 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-ring-offset-shadow', 'var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)'),
			A2($rtfeldman$elm_css$Css$property, '--tw-ring-shadow', 'var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', 'var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)')
		]));
var $author$project$Tailwind$Utilities$ring_indigo_500 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-ring-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, '--tw-ring-color', 'rgba(99, 102, 241, var(--tw-ring-opacity))')
		]));
var $author$project$Tailwind$Utilities$ring_offset_2 = A2($rtfeldman$elm_css$Css$property, '--tw-ring-offset-width', '2px');
var $author$project$Tailwind$Utilities$ring_red_500 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-ring-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, '--tw-ring-color', 'rgba(239, 68, 68, var(--tw-ring-opacity))')
		]));
var $author$project$Tailwind$Utilities$rounded_md = A2($rtfeldman$elm_css$Css$property, 'border-radius', '0.375rem');
var $author$project$Tailwind$Utilities$text_2xl = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-size', '1.5rem'),
			A2($rtfeldman$elm_css$Css$property, 'line-height', '2rem')
		]));
var $author$project$Tailwind$Utilities$text_gray_700 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-text-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(55, 65, 81, var(--tw-text-opacity))')
		]));
var $author$project$Tailwind$Utilities$text_sm = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-size', '0.875rem'),
			A2($rtfeldman$elm_css$Css$property, 'line-height', '1.25rem')
		]));
var $author$project$Tailwind$Utilities$text_white = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-text-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(255, 255, 255, var(--tw-text-opacity))')
		]));
var $rtfeldman$elm_css$Css$UnitlessInteger = 0;
var $rtfeldman$elm_css$Css$zero = {a5: 0, aE: 0, aa: 0, aF: 0, aG: 0, aj: 0, ak: 0, hX: 0, ac: 0, b3: 0, aQ: '', bt: 0, i3: '0'};
var $author$project$View$Theme$defaultStyles = {
	g_: $rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$property, '--tw-divide-opacity', '1'),
				A2($rtfeldman$elm_css$Css$property, 'border-top-color', 'rgba(229, 231, 235, var(--tw-divide-opacity))')
			])),
	g$: A2($rtfeldman$elm_css$Css$property, 'border-top-style', 'solid'),
	dt: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$border,
			$author$project$Tailwind$Utilities$border_transparent,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$rounded_md,
			$author$project$Tailwind$Utilities$text_white,
			$author$project$Tailwind$Utilities$border_gray_300,
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(7),
			$rtfeldman$elm_css$Css$px(12)),
			$author$project$Tailwind$Utilities$cursor_pointer,
			$author$project$Tailwind$Utilities$text_gray_700,
			$author$project$Tailwind$Utilities$bg_white,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$outline_none, $author$project$Tailwind$Utilities$ring_indigo_500])),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_gray_50])),
			$rtfeldman$elm_css$Css$disabled(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$cursor_not_allowed, $author$project$Tailwind$Utilities$opacity_30]))
		]),
	co: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$border,
			$author$project$Tailwind$Utilities$border_transparent,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$rounded_md,
			$author$project$Tailwind$Utilities$text_white,
			$author$project$Tailwind$Utilities$bg_red_600,
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(7),
			$rtfeldman$elm_css$Css$px(12)),
			$author$project$Tailwind$Utilities$cursor_pointer,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$outline_none, $author$project$Tailwind$Utilities$ring_2, $author$project$Tailwind$Utilities$ring_offset_2, $author$project$Tailwind$Utilities$ring_red_500])),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_red_700])),
			$rtfeldman$elm_css$Css$disabled(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$cursor_not_allowed, $author$project$Tailwind$Utilities$opacity_30]))
		]),
	hu: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$text_2xl,
			$author$project$Tailwind$Utilities$font_semibold,
			$author$project$Tailwind$Utilities$text_gray_900,
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero)
		]),
	fz: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$border,
			$author$project$Tailwind$Utilities$border_transparent,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$rounded_md,
			$author$project$Tailwind$Utilities$text_white,
			$author$project$Tailwind$Utilities$bg_indigo_600,
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(7),
			$rtfeldman$elm_css$Css$px(12)),
			$author$project$Tailwind$Utilities$cursor_pointer,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$outline_none, $author$project$Tailwind$Utilities$ring_2, $author$project$Tailwind$Utilities$ring_offset_2, $author$project$Tailwind$Utilities$ring_indigo_500])),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_indigo_700])),
			$rtfeldman$elm_css$Css$disabled(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$cursor_not_allowed, $author$project$Tailwind$Utilities$opacity_30]))
		])
};
var $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$disabled = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('disabled');
var $rtfeldman$elm_css$Html$Styled$form = $rtfeldman$elm_css$Html$Styled$node('form');
var $rtfeldman$elm_css$Html$Styled$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $rtfeldman$elm_css$VirtualDom$Styled$on = F2(
	function (eventName, handler) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$on, eventName, handler),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onSubmit = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$rtfeldman$elm_css$Html$Styled$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$type_ = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('type');
var $author$project$Data$Form$errorCodeToString = function (errorCode) {
	switch (errorCode) {
		case 0:
			return 'Field should not be empty.';
		case 1:
			return 'Email is invalid.';
		case 2:
			return 'Field must be at least 6 characters long.';
		case 3:
			return 'No spaces. Username must only contain letters and numbers.';
		case 4:
			return 'Field can only contains numbers.';
		case 5:
			return 'Field can only contains letters and numbers.';
		case 6:
			return 'Confirm password and password do not match.';
		case 8:
			return 'Value existed.';
		default:
			return 'Field can only contains positive numbers';
	}
};
var $author$project$Tailwind$Utilities$block = A2($rtfeldman$elm_css$Css$property, 'display', 'block');
var $author$project$Tailwind$Utilities$border_indigo_500 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-border-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'border-color', 'rgba(99, 102, 241, var(--tw-border-opacity))')
		]));
var $author$project$Tailwind$Utilities$border_solid = A2($rtfeldman$elm_css$Css$property, 'border-style', 'solid');
var $author$project$Tailwind$Utilities$box_border = A2($rtfeldman$elm_css$Css$property, 'box-sizing', 'border-box');
var $author$project$Tailwind$Utilities$h_9 = A2($rtfeldman$elm_css$Css$property, 'height', '2.25rem');
var $author$project$Tailwind$Utilities$my_2 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'margin-top', '0.5rem'),
			A2($rtfeldman$elm_css$Css$property, 'margin-bottom', '0.5rem')
		]));
var $rtfeldman$elm_css$Css$Structure$PseudoElement = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$pseudoElement = function (element) {
	return $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement(element);
};
var $author$project$Tailwind$Utilities$placeholder_gray_400 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$pseudoElement,
			'placeholder',
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$property, '--tw-placeholder-opacity', '1'),
					A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(156, 163, 175, var(--tw-placeholder-opacity))')
				]))
		]));
var $author$project$Tailwind$Utilities$px_3 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-left', '0.75rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-right', '0.75rem')
		]));
var $author$project$Tailwind$Utilities$py_1 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-top', '0.25rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-bottom', '0.25rem')
		]));
var $author$project$Tailwind$Utilities$py_2 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-top', '0.5rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-bottom', '0.5rem')
		]));
var $author$project$Tailwind$Utilities$ring_blue_600 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-ring-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, '--tw-ring-color', 'rgba(37, 99, 235, var(--tw-ring-opacity))')
		]));
var $author$project$Tailwind$Utilities$shadow_sm = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-shadow', '0 1px 2px 0 rgba(0, 0, 0, 0.05)'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', 'var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)')
		]));
var $author$project$Tailwind$Utilities$text_left = A2($rtfeldman$elm_css$Css$property, 'text-align', 'left');
var $author$project$Tailwind$Utilities$text_red_600 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-text-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(220, 38, 38, var(--tw-text-opacity))')
		]));
var $author$project$View$Form$Input$styles = {
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_full]),
	bH: _List_fromArray(
		[$author$project$Tailwind$Utilities$py_1, $author$project$Tailwind$Utilities$text_left]),
	d9: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$text_red_600]),
	hC: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$box_border,
			$author$project$Tailwind$Utilities$block,
			$author$project$Tailwind$Utilities$border_solid,
			$author$project$Tailwind$Utilities$w_full,
			$author$project$Tailwind$Utilities$h_9,
			$author$project$Tailwind$Utilities$px_3,
			$author$project$Tailwind$Utilities$py_2,
			$author$project$Tailwind$Utilities$border,
			$author$project$Tailwind$Utilities$border_gray_300,
			$author$project$Tailwind$Utilities$rounded_md,
			$author$project$Tailwind$Utilities$shadow_sm,
			$author$project$Tailwind$Utilities$placeholder_gray_400,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$outline_none, $author$project$Tailwind$Utilities$ring_blue_600, $author$project$Tailwind$Utilities$border_indigo_500])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$text_sm]))
		]),
	hH: _List_fromArray(
		[$author$project$Tailwind$Utilities$block, $author$project$Tailwind$Utilities$text_left, $author$project$Tailwind$Utilities$my_2, $author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_700])
};
var $author$project$View$Form$Input$displayValidationError = function (error) {
	if (error.$ === 1) {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		var errCode = error.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Input$styles.bH)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Input$styles.d9)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Data$Form$errorCodeToString(errCode))
						]))
				]));
	}
};
var $rtfeldman$elm_css$Html$Styled$Attributes$for = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('htmlFor');
var $rtfeldman$elm_css$Html$Styled$input = $rtfeldman$elm_css$Html$Styled$node('input');
var $rtfeldman$elm_css$Html$Styled$label = $rtfeldman$elm_css$Html$Styled$node('label');
var $rtfeldman$elm_css$Html$Styled$Attributes$name = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('name');
var $rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue)));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$placeholder = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('placeholder');
var $rtfeldman$elm_css$Html$Styled$Attributes$required = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('required');
var $rtfeldman$elm_css$Html$Styled$Attributes$value = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
var $author$project$View$Form$Input$view = function (_v0) {
	var name_ = _v0.bX;
	var field = _v0.bJ;
	var label_ = _v0.bS;
	var inputType = _v0.bL;
	var isRequired = _v0.bP;
	var placeholder_ = _v0.b5;
	var onChange = _v0.bZ;
	var labelView = $elm$core$String$isEmpty(label_) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
		$rtfeldman$elm_css$Html$Styled$label,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$for(name_),
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Input$styles.hH)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(label_)
			]));
	var fieldValue = field.i3;
	var _v1 = field;
	var error = _v1.bH;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Input$styles.dI)
			]),
		_List_fromArray(
			[
				labelView,
				A2(
				$rtfeldman$elm_css$Html$Styled$input,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$name(name_),
						$rtfeldman$elm_css$Html$Styled$Attributes$type_(inputType),
						$rtfeldman$elm_css$Html$Styled$Attributes$required(isRequired),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Input$styles.hC),
						$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(placeholder_),
						$rtfeldman$elm_css$Html$Styled$Events$onInput(onChange),
						$rtfeldman$elm_css$Html$Styled$Attributes$value(fieldValue)
					]),
				_List_Nil),
				$author$project$View$Form$Input$displayValidationError(error)
			]));
};
var $author$project$Page$Login$showForm = function (_v0) {
	var login = _v0.eY;
	var route = _v0.cM;
	var authState = _v0.aW;
	var title = function () {
		if (route.$ === 2) {
			return 'Sign in to Super Admin account';
		} else {
			return 'Sign in to your account';
		}
	}();
	var _v1 = login;
	var email = _v1.d4;
	var password = _v1.fu;
	var formStatus = _v1.J;
	var isSubmitting = formStatus === 1;
	var submitText = isSubmitting ? 'Submitting...' : 'Sign in';
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.dI)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.el)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.cx),
										$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$image.eZ)
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$h2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.aP)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(title)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.dg)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$form,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.ek),
												$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
												$author$project$Type$OnLogin($author$project$Type$Login$SubmitForm))
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$View$Form$Input$view(
														{
															bJ: email,
															bL: 'email',
															bP: true,
															bS: 'Email address:',
															bX: 'email',
															bZ: A2($elm$core$Basics$composeL, $author$project$Type$OnLogin, $author$project$Type$Login$OnEmailChange),
															b5: 'Email address'
														}),
														$author$project$View$Form$Input$view(
														{
															bJ: password,
															bL: 'password',
															bP: true,
															bS: 'Password:',
															bX: 'password',
															bZ: A2($elm$core$Basics$composeL, $author$project$Type$OnLogin, $author$project$Type$Login$OnPasswordChange),
															b5: 'Password'
														})
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.dq)
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$button,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$type_('submit'),
																$rtfeldman$elm_css$Html$Styled$Attributes$css(
																A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.fz, $author$project$Page$Login$styles.cm)),
																$rtfeldman$elm_css$Html$Styled$Attributes$disabled(isSubmitting)
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(submitText)
															]))
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Page$Login$view = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Page$Login$showForm(model),
		A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return $author$project$Page$Login$loggedIn;
			},
			model.aW));
};
var $author$project$View$authPage = F2(
	function (model, pageView) {
		var _v0 = model.aW;
		if (_v0.$ === 1) {
			return _Utils_Tuple2(
				$author$project$View$Layout$NoAuthLayout,
				$author$project$Page$Login$view(model));
		} else {
			var authState = _v0.a;
			return _Utils_Tuple2(
				$author$project$View$Layout$AuthLayout(authState),
				A2(pageView, model, authState));
		}
	});
var $author$project$Api$AdminDetail$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Cannot get admin';
		default:
			return 'Missing error code';
	}
};
var $author$project$Api$Options$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Cannot get option data';
		default:
			return 'Missing error code';
	}
};
var $author$project$Type$AdminDetail$OnChangeEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$AdminDetail$OnChangeName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$AdminDetail$OnChangeTenant = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$AdminDetail$OnCreate = {$: 5};
var $author$project$Type$AdminDetail$OnUpdate = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Html$Styled$h3 = $rtfeldman$elm_css$Html$Styled$node('h3');
var $author$project$Data$Form$isEmptyFields = function (lists) {
	var filterList = A2(
		$elm$core$List$filter,
		function (_v0) {
			var value = _v0.i3;
			return !$elm$core$String$length(value);
		},
		lists);
	return !$elm$core$List$length(filterList);
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$on = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Type$AdminDetail$OnChangeConfirmPassword = function (a) {
	return {$: 4, a: a};
};
var $author$project$Type$AdminDetail$OnChangePassword = function (a) {
	return {$: 3, a: a};
};
var $author$project$Tailwind$Utilities$border_b_0 = A2($rtfeldman$elm_css$Css$property, 'border-bottom-width', '0px');
var $author$project$Tailwind$Utilities$border_gray_200 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-border-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'border-color', 'rgba(229, 231, 235, var(--tw-border-opacity))')
		]));
var $author$project$Tailwind$Utilities$border_l_0 = A2($rtfeldman$elm_css$Css$property, 'border-left-width', '0px');
var $author$project$Tailwind$Utilities$border_r_0 = A2($rtfeldman$elm_css$Css$property, 'border-right-width', '0px');
var $author$project$Tailwind$Utilities$border_t = A2($rtfeldman$elm_css$Css$property, 'border-top-width', '1px');
var $rtfeldman$elm_css$Css$calcExpressionToString = function (expression) {
	if (!expression) {
		return '+';
	} else {
		return '-';
	}
};
var $rtfeldman$elm_css$Css$cssFunction = F2(
	function (funcName, args) {
		return funcName + ('(' + (A2($elm$core$String$join, ',', args) + ')'));
	});
var $rtfeldman$elm_css$Css$calc = F3(
	function (firstExpr, expression, secondExpr) {
		var withoutCalcStr = function (l) {
			return A2($elm$core$String$startsWith, 'calc(', l.i3) ? A2($elm$core$String$dropLeft, 4, l.i3) : l.i3;
		};
		var calcs = withoutCalcStr(firstExpr) + (' ' + ($rtfeldman$elm_css$Css$calcExpressionToString(expression) + (' ' + withoutCalcStr(secondExpr))));
		var value = A2(
			$rtfeldman$elm_css$Css$cssFunction,
			'calc',
			_List_fromArray(
				[calcs]));
		return {ds: 0, ay: 0, u: 0, a5: 0, aE: 0, aa: 0, aF: 0, aG: 0, aj: 0, ak: 0, S: 0, aN: 0, i3: value};
	});
var $author$project$Tailwind$Utilities$flex_col = A2($rtfeldman$elm_css$Css$property, 'flex-direction', 'column');
var $author$project$Tailwind$Utilities$flex_row = A2($rtfeldman$elm_css$Css$property, 'flex-direction', 'row');
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $author$project$Tailwind$Utilities$items_start = A2($rtfeldman$elm_css$Css$property, 'align-items', 'flex-start');
var $author$project$Tailwind$Utilities$leading_6 = A2($rtfeldman$elm_css$Css$property, 'line-height', '1.5rem');
var $author$project$Tailwind$Breakpoints$lg = $rtfeldman$elm_css$Css$Media$withMediaQuery(
	_List_fromArray(
		['(min-width: 1024px)']));
var $author$project$Tailwind$Utilities$m_0 = A2($rtfeldman$elm_css$Css$property, 'margin', '0px');
var $author$project$Tailwind$Utilities$mb_2 = A2($rtfeldman$elm_css$Css$property, 'margin-bottom', '0.5rem');
var $rtfeldman$elm_css$Css$Subtraction = 1;
var $rtfeldman$elm_css$Css$minus = 1;
var $author$project$Tailwind$Utilities$mt_px = A2($rtfeldman$elm_css$Css$property, 'margin-top', '1px');
var $author$project$Tailwind$Utilities$overflow_auto = A2($rtfeldman$elm_css$Css$property, 'overflow', 'auto');
var $author$project$Tailwind$Utilities$pb_4 = A2($rtfeldman$elm_css$Css$property, 'padding-bottom', '1rem');
var $author$project$Tailwind$Utilities$pt_2 = A2($rtfeldman$elm_css$Css$property, 'padding-top', '0.5rem');
var $author$project$Tailwind$Utilities$pt_8 = A2($rtfeldman$elm_css$Css$property, 'padding-top', '2rem');
var $author$project$Tailwind$Utilities$px_6 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-left', '1.5rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-right', '1.5rem')
		]));
var $author$project$Tailwind$Utilities$px_8 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-left', '2rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-right', '2rem')
		]));
var $author$project$Tailwind$Utilities$text_lg = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-size', '1.125rem'),
			A2($rtfeldman$elm_css$Css$property, 'line-height', '1.75rem')
		]));
var $rtfeldman$elm_css$Css$VhUnits = 0;
var $rtfeldman$elm_css$Css$vh = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'vh');
var $author$project$Tailwind$Utilities$w_4over12 = A2($rtfeldman$elm_css$Css$property, 'width', '33.333333%');
var $author$project$Page$AdminDetail$styles = {
	cj: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_4over12, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$rounded_md, $author$project$Tailwind$Utilities$h_9]),
	$7: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_row, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$border_t, $author$project$Tailwind$Utilities$border_solid, $author$project$Tailwind$Utilities$border_b_0, $author$project$Tailwind$Utilities$border_l_0, $author$project$Tailwind$Utilities$border_r_0, $author$project$Tailwind$Utilities$border_gray_200, $author$project$Tailwind$Utilities$py_8, $author$project$Tailwind$Utilities$mb_2]),
	dI: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$vh(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(10))),
			$author$project$Tailwind$Utilities$overflow_auto
		]),
	ek: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$py_8,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6]))
		]),
	aC: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_row, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$border_t, $author$project$Tailwind$Utilities$border_solid, $author$project$Tailwind$Utilities$border_b_0, $author$project$Tailwind$Utilities$border_l_0, $author$project$Tailwind$Utilities$border_r_0, $author$project$Tailwind$Utilities$border_gray_200, $author$project$Tailwind$Utilities$py_8, $author$project$Tailwind$Utilities$mb_2]),
	hC: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$block,
			$author$project$Tailwind$Utilities$w_full,
			$author$project$Tailwind$Utilities$border_solid,
			$author$project$Tailwind$Utilities$shadow_sm,
			$author$project$Tailwind$Utilities$border_gray_200,
			$author$project$Tailwind$Utilities$rounded_md,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$ring_indigo_500, $author$project$Tailwind$Utilities$border_indigo_500])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$text_sm]))
		]),
	aD: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_4over12, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col, $author$project$Tailwind$Utilities$rounded_md, $author$project$Tailwind$Utilities$shadow_sm, $author$project$Tailwind$Utilities$h_9]),
	hH: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$block,
			$author$project$Tailwind$Utilities$text_left,
			$author$project$Tailwind$Utilities$w_4over12,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$text_gray_700,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_px, $author$project$Tailwind$Utilities$pt_2]))
		]),
	fv: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$py_12,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6])),
			$author$project$Tailwind$Utilities$border_t,
			$author$project$Tailwind$Utilities$border_solid,
			$author$project$Tailwind$Utilities$border_b_0,
			$author$project$Tailwind$Utilities$border_l_0,
			$author$project$Tailwind$Utilities$border_r_0,
			$author$project$Tailwind$Utilities$border_gray_200,
			$author$project$Tailwind$Utilities$pt_8,
			$author$project$Tailwind$Utilities$space_y_6
		]),
	aP: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$leading_6, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900, $author$project$Tailwind$Utilities$m_0, $author$project$Tailwind$Utilities$pb_4]),
	cV: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col, $author$project$Tailwind$Utilities$items_start]),
	cZ: _List_fromArray(
		[$author$project$Tailwind$Utilities$px_4]),
	gB: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_row, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$border_t, $author$project$Tailwind$Utilities$border_solid, $author$project$Tailwind$Utilities$border_b_0, $author$project$Tailwind$Utilities$border_l_0, $author$project$Tailwind$Utilities$border_r_0, $author$project$Tailwind$Utilities$border_gray_200, $author$project$Tailwind$Utilities$pt_8])
};
var $author$project$Page$AdminDetail$toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAdminDetail);
var $author$project$Page$AdminDetail$passwordFields = function (adminDetail) {
	var _v0 = adminDetail;
	var password = _v0.fu;
	var confirmPassword = _v0.G;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.aC)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.hH)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Password')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.aD)
							]),
						_List_fromArray(
							[
								$author$project$View$Form$Input$view(
								{
									bJ: password,
									bL: 'password',
									bP: true,
									bS: '',
									bX: 'password',
									bZ: A2($elm$core$Basics$composeL, $author$project$Page$AdminDetail$toAppMsg, $author$project$Type$AdminDetail$OnChangePassword),
									b5: 'Password'
								})
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.aC)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.hH)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Confirm password')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.aD)
							]),
						_List_fromArray(
							[
								$author$project$View$Form$Input$view(
								{
									bJ: confirmPassword,
									bL: 'password',
									bP: true,
									bS: '',
									bX: 'confirmPassword',
									bZ: A2($elm$core$Basics$composeL, $author$project$Page$AdminDetail$toAppMsg, $author$project$Type$AdminDetail$OnChangeConfirmPassword),
									b5: 'Confirm password'
								})
							]))
					]))
			]));
};
var $author$project$Tailwind$Utilities$appearance_none = A2($rtfeldman$elm_css$Css$property, 'appearance', 'none');
var $rtfeldman$elm_css$Css$backgroundImage = $rtfeldman$elm_css$Css$prop1('background-image');
var $rtfeldman$elm_css$Css$backgroundSize2 = $rtfeldman$elm_css$Css$prop2('background-size');
var $author$project$Tailwind$Utilities$bg_no_repeat = A2($rtfeldman$elm_css$Css$property, 'background-repeat', 'no-repeat');
var $author$project$Tailwind$Utilities$bg_right = A2($rtfeldman$elm_css$Css$property, 'background-position', 'right');
var $author$project$View$Form$Select$dropdownIcon = '\"data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%236b7280\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'M6 8l4 4 4-4\'/%3e%3c/svg%3e\"';
var $rtfeldman$elm_css$Css$EmUnits = 0;
var $rtfeldman$elm_css$Css$em = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'em');
var $author$project$Tailwind$Utilities$pr_10 = A2($rtfeldman$elm_css$Css$property, 'padding-right', '2.5rem');
var $author$project$Tailwind$Utilities$px_2 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-left', '0.5rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-right', '0.5rem')
		]));
var $rtfeldman$elm_css$Css$url = function (urlValue) {
	return {as: 0, i3: 'url(' + (urlValue + ')')};
};
var $author$project$View$Form$Select$styles = {
	dI: _List_Nil,
	bH: _List_fromArray(
		[$author$project$Tailwind$Utilities$py_2, $author$project$Tailwind$Utilities$text_left]),
	d9: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$text_red_600]),
	fX: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$appearance_none,
			$rtfeldman$elm_css$Css$backgroundImage(
			$rtfeldman$elm_css$Css$url($author$project$View$Form$Select$dropdownIcon)),
			$author$project$Tailwind$Utilities$bg_right,
			$author$project$Tailwind$Utilities$bg_no_repeat,
			A2(
			$rtfeldman$elm_css$Css$backgroundSize2,
			$rtfeldman$elm_css$Css$em(2.5),
			$rtfeldman$elm_css$Css$em(1.5)),
			$author$project$Tailwind$Utilities$pr_10,
			$author$project$Tailwind$Utilities$h_9,
			$author$project$Tailwind$Utilities$w_full,
			$author$project$Tailwind$Utilities$shadow_sm,
			$author$project$Tailwind$Utilities$border_gray_300,
			$author$project$Tailwind$Utilities$rounded_md,
			$author$project$Tailwind$Utilities$px_2,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$ring_indigo_500, $author$project$Tailwind$Utilities$border_indigo_500])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$text_sm]))
		])
};
var $author$project$View$Form$Select$displayValidationError = function (error) {
	if (error.$ === 1) {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		var errCode = error.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Select$styles.bH)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Select$styles.d9)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Data$Form$errorCodeToString(errCode))
						]))
				]));
	}
};
var $rtfeldman$elm_css$Html$Styled$option = $rtfeldman$elm_css$Html$Styled$node('option');
var $rtfeldman$elm_css$Html$Styled$Attributes$selected = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('selected');
var $author$project$View$Form$Select$renderOption = F2(
	function (value_, params) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$option,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$value(params.i3),
					$rtfeldman$elm_css$Html$Styled$Attributes$selected(
					_Utils_eq(value_, params.i3)),
					$rtfeldman$elm_css$Html$Styled$Attributes$disabled(params.d_)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(params.hH)
				]));
	});
var $rtfeldman$elm_css$Html$Styled$select = $rtfeldman$elm_css$Html$Styled$node('select');
var $author$project$View$Form$Select$view = function (_v0) {
	var options = _v0.h0;
	var value_ = _v0.i4;
	var onChange_ = _v0.hY;
	var fieldValue = value_.i3;
	var _v1 = value_;
	var error = _v1.bH;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Select$styles.dI)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$select,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Select$styles.fX),
						$rtfeldman$elm_css$Html$Styled$Events$onInput(onChange_)
					]),
				A2(
					$elm$core$List$map,
					$author$project$View$Form$Select$renderOption(fieldValue),
					options)),
				$author$project$View$Form$Select$displayValidationError(error)
			]));
};
var $author$project$Page$AdminDetail$fieldsView = F4(
	function (tenants, admin, adminDetail, authState) {
		var tenantOptions = A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					{d_: false, hH: 'Select Tenant', i3: ''}
				]),
			A2(
				$elm$core$List$map,
				function (_v5) {
					var label = _v5.hH;
					var value = _v5.i3;
					return {
						d_: false,
						hH: label,
						i3: $elm$core$String$fromInt(value)
					};
				},
				tenants));
		var _v0 = authState.h1;
		var profile = _v0.fD;
		var role = $author$project$Data$Role$getRole(profile.fD);
		var _v1 = adminDetail;
		var name = _v1.fg;
		var email = _v1.d4;
		var tenantID = _v1.gm;
		var formStatus = _v1.J;
		var password = _v1.fu;
		var confirmPassword = _v1.G;
		var _v2 = function () {
			if (!admin.$) {
				var admin_ = admin.a;
				return {
					ck: $author$project$Page$AdminDetail$toAppMsg(
						$author$project$Type$AdminDetail$OnUpdate(admin_.eu)),
					cl: 'Update',
					cG: A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					cS: $author$project$Data$Form$isEmptyFields(
						_List_fromArray(
							[name, email, tenantID])) && ($author$project$Data$Form$isValidFields(
						_List_fromArray(
							[name, email, tenantID])) && (1 !== formStatus)),
					aP: 'Edit Admin: ' + admin_.fg
				};
			} else {
				return {
					ck: $author$project$Page$AdminDetail$toAppMsg($author$project$Type$AdminDetail$OnCreate),
					cl: 'Create',
					cG: $author$project$Page$AdminDetail$passwordFields(adminDetail),
					cS: $author$project$Data$Form$isEmptyFields(
						_List_fromArray(
							[name, email, tenantID, password, confirmPassword])) && (($author$project$Data$Form$isValidFields(
						_List_fromArray(
							[name, email, tenantID, password, confirmPassword])) && _Utils_eq(password.i3, confirmPassword.i3)) && (1 !== formStatus)),
					aP: 'Create New Admin'
				};
			}
		}();
		var title = _v2.aP;
		var passwordView = _v2.cG;
		var btnTitle = _v2.cl;
		var btnMsg = _v2.ck;
		var submitable = _v2.cS;
		var tenantView = function () {
			if (role === 1) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.aC)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Tenant')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.aD)
								]),
							_List_fromArray(
								[
									$author$project$View$Form$Select$view(
									{
										hY: A2($elm$core$Basics$composeL, $author$project$Page$AdminDetail$toAppMsg, $author$project$Type$AdminDetail$OnChangeTenant),
										h0: tenantOptions,
										i4: tenantID
									})
								]))
						]));
			} else {
				return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.ek)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.cV)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.aP)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(title)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.aC)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Name')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.aD)
								]),
							_List_fromArray(
								[
									$author$project$View$Form$Input$view(
									{
										bJ: name,
										bL: 'text',
										bP: true,
										bS: '',
										bX: 'name',
										bZ: A2($elm$core$Basics$composeL, $author$project$Page$AdminDetail$toAppMsg, $author$project$Type$AdminDetail$OnChangeName),
										b5: 'Name'
									})
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.aC)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Email')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.aD)
								]),
							_List_fromArray(
								[
									$author$project$View$Form$Input$view(
									{
										bJ: email,
										bL: 'email',
										bP: true,
										bS: '',
										bX: 'email',
										bZ: A2($elm$core$Basics$composeL, $author$project$Page$AdminDetail$toAppMsg, $author$project$Type$AdminDetail$OnChangeEmail),
										b5: 'Email'
									})
								]))
						])),
					tenantView,
					passwordView,
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.$7)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.hH)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.cj)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('submit'),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.fz, $author$project$Page$AdminDetail$styles.cZ)),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(btnMsg),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!submitable)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(btnTitle)
										]))
								]))
						]))
				]));
	});
var $author$project$Type$AdminDetail$OnUpdatePassword = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$AdminDetail$updatePasswordFieldsView = F2(
	function (id, model) {
		var _v0 = model;
		var password = _v0.fu;
		var confirmPassword = _v0.G;
		var formStatus = _v0.J;
		var submitable = $author$project$Data$Form$isValidFields(
			_List_fromArray(
				[password, confirmPassword])) && (_Utils_eq(password.i3, confirmPassword.i3) && (1 !== formStatus));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.fv)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.cV)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h3,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.aP)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Update Password')
										]))
								])),
							$author$project$Page$AdminDetail$passwordFields(model),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.gB)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.hH)
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.cj)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$button,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('submit'),
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.fz, $author$project$Page$AdminDetail$styles.cZ)),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Page$AdminDetail$toAppMsg(
														$author$project$Type$AdminDetail$OnUpdatePassword(id))),
													$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!submitable)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Update Password')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$AdminDetail$formView = F4(
	function (tenants, admin, adminDetail, authState) {
		var updatePasswordView = function () {
			if (!admin.$) {
				var admin_ = admin.a;
				return A2($author$project$Page$AdminDetail$updatePasswordFieldsView, admin_.eu, adminDetail);
			} else {
				return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminDetail$styles.dI)
				]),
			_List_fromArray(
				[
					A4($author$project$Page$AdminDetail$fieldsView, tenants, admin, adminDetail, authState),
					updatePasswordView
				]));
	});
var $rtfeldman$elm_css$Html$Styled$p = $rtfeldman$elm_css$Html$Styled$node('p');
var $author$project$View$Error$styles = {
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$justify_center, $author$project$Tailwind$Utilities$items_center]),
	gz: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_red_600])
};
var $author$project$View$Error$view = function (error) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Error$styles.dI)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Error$styles.gz)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(error)
					]))
			]));
};
var $rtfeldman$elm_css$Svg$Styled$Internal$css = function (styles) {
	var cssTemplate = $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate(styles);
	var classAttribute = A2($elm$virtual_dom$VirtualDom$attribute, '', '');
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classAttribute, true, cssTemplate);
};
var $rtfeldman$elm_css$Svg$Styled$Attributes$css = $rtfeldman$elm_css$Svg$Styled$Internal$css;
var $rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$attribute, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Svg$Styled$Attributes$d = $rtfeldman$elm_css$VirtualDom$Styled$attribute('d');
var $rtfeldman$elm_css$Svg$Styled$Attributes$fill = $rtfeldman$elm_css$VirtualDom$Styled$attribute('fill');
var $rtfeldman$elm_css$VirtualDom$Styled$NodeNS = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$nodeNS = $rtfeldman$elm_css$VirtualDom$Styled$NodeNS;
var $rtfeldman$elm_css$Svg$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$nodeNS('http://www.w3.org/2000/svg');
var $rtfeldman$elm_css$Svg$Styled$path = $rtfeldman$elm_css$Svg$Styled$node('path');
var $rtfeldman$elm_css$Css$Preprocess$WithKeyframes = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$animationName = function (arg) {
	return ((arg.i3 === 'none') || ((arg.i3 === 'inherit') || ((arg.i3 === 'unset') || (arg.i3 === 'initial')))) ? A2($rtfeldman$elm_css$Css$prop1, 'animation-name', arg) : $rtfeldman$elm_css$Css$Preprocess$WithKeyframes(arg.i3);
};
var $rtfeldman$elm_css$Css$Internal$printKeyframeSelector = function (_v0) {
	var percentage = _v0.a;
	var properties = _v0.b;
	var propertiesStr = A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		function (_v1) {
			var prop = _v1;
			return prop + ';';
		},
		'',
		properties);
	var percentageStr = $elm$core$String$fromInt(percentage) + '%';
	return percentageStr + ('{' + (propertiesStr + '}'));
};
var $rtfeldman$elm_css$Css$Internal$compileKeyframes = function (tuples) {
	return A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Internal$printKeyframeSelector, '', tuples);
};
var $rtfeldman$elm_css$Css$Animations$keyframes = function (tuples) {
	return $elm$core$List$isEmpty(tuples) ? {cz: 0, cC: 0, i3: 'none'} : {
		cz: 0,
		cC: 0,
		i3: $rtfeldman$elm_css$Css$Internal$compileKeyframes(tuples)
	};
};
var $rtfeldman$elm_css$Css$Internal$Property = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Animations$property = F2(
	function (key, value) {
		return key + (':' + value);
	});
var $author$project$Tailwind$Utilities$animate_spin = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'animation', '1s linear infinite'),
			$rtfeldman$elm_css$Css$animationName(
			$rtfeldman$elm_css$Css$Animations$keyframes(
				_List_fromArray(
					[
						_Utils_Tuple2(
						100,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'rotate(360deg)')
							]))
					])))
		]));
var $author$project$Tailwind$Utilities$h_8 = A2($rtfeldman$elm_css$Css$property, 'height', '2rem');
var $author$project$Tailwind$Utilities$mr_2 = A2($rtfeldman$elm_css$Css$property, 'margin-right', '0.5rem');
var $author$project$Tailwind$Utilities$p_10 = A2($rtfeldman$elm_css$Css$property, 'padding', '2.5rem');
var $author$project$Tailwind$Utilities$text_gray_200 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-text-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(229, 231, 235, var(--tw-text-opacity))')
		]));
var $author$project$Tailwind$Utilities$w_8 = A2($rtfeldman$elm_css$Css$property, 'width', '2rem');
var $author$project$View$Loading$styles = {
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col, $author$project$Tailwind$Utilities$justify_center, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$p_10]),
	eX: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_8, $author$project$Tailwind$Utilities$h_8, $author$project$Tailwind$Utilities$mr_2, $author$project$Tailwind$Utilities$text_gray_200, $author$project$Tailwind$Utilities$animate_spin])
};
var $rtfeldman$elm_css$Svg$Styled$svg = $rtfeldman$elm_css$Svg$Styled$node('svg');
var $rtfeldman$elm_css$Svg$Styled$Attributes$viewBox = $rtfeldman$elm_css$VirtualDom$Styled$attribute('viewBox');
var $author$project$View$Loading$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Loading$styles.dI)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$View$Loading$styles.eX),
					$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 100 101'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('blue')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$fill('currentColor')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$fill('currentFill')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Page$AdminDetail$view = F2(
	function (_v0, authState) {
		var _v1 = authState.h1;
		var adminDetail = _v1.gP;
		var _v2 = adminDetail;
		var admin = _v2.gO;
		var tenants = _v2.iM;
		var _v3 = _Utils_Tuple2(tenants, admin);
		_v3$1:
		while (true) {
			_v3$2:
			while (true) {
				_v3$3:
				while (true) {
					switch (_v3.a.$) {
						case 2:
							var error = _v3.a.a;
							return $author$project$View$Error$view(
								A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$Options$errorCodeString, error));
						case 1:
							switch (_v3.b.$) {
								case 2:
									break _v3$1;
								case 1:
									break _v3$2;
								default:
									break _v3$2;
							}
						case 4:
							switch (_v3.b.$) {
								case 2:
									break _v3$1;
								case 1:
									break _v3$3;
								case 4:
									var tenantList = _v3.a.a;
									var admin_ = _v3.b.a;
									return A4(
										$author$project$Page$AdminDetail$formView,
										tenantList,
										$elm$core$Maybe$Just(admin_),
										adminDetail,
										authState);
								default:
									var tenantList = _v3.a.a;
									return A4($author$project$Page$AdminDetail$formView, tenantList, $elm$core$Maybe$Nothing, adminDetail, authState);
							}
						default:
							switch (_v3.b.$) {
								case 2:
									break _v3$1;
								case 1:
									break _v3$3;
								default:
									return $author$project$View$Loading$view;
							}
					}
				}
				var _v5 = _v3.b;
				return $author$project$View$Loading$view;
			}
			var _v4 = _v3.a;
			return $author$project$View$Loading$view;
		}
		var error = _v3.b.a;
		return $author$project$View$Error$view(
			A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$AdminDetail$errorCodeString, error));
	});
var $rtfeldman$elm_css$Html$Styled$h1 = $rtfeldman$elm_css$Html$Styled$node('h1');
var $author$project$Type$AdminList$OnChangeSearch = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$AdminList$OnChangeTenant = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$AdminList$OnOpenModal = {$: 6};
var $author$project$Tailwind$Utilities$absolute = A2($rtfeldman$elm_css$Css$property, 'position', 'absolute');
var $author$project$Tailwind$Utilities$bg_gray_100 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-bg-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(243, 244, 246, var(--tw-bg-opacity))')
		]));
var $author$project$Tailwind$Utilities$flex_grow = A2($rtfeldman$elm_css$Css$property, 'flex-grow', '1');
var $author$project$Tailwind$Utilities$flex_wrap = A2($rtfeldman$elm_css$Css$property, 'flex-wrap', 'wrap');
var $author$project$Tailwind$Utilities$gap_3 = A2($rtfeldman$elm_css$Css$property, 'gap', '0.75rem');
var $author$project$Tailwind$Utilities$grid = A2($rtfeldman$elm_css$Css$property, 'display', 'grid');
var $author$project$Tailwind$Utilities$grid_cols_2 = A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', 'repeat(2, minmax(0, 1fr))');
var $author$project$Tailwind$Utilities$grid_flow_row_dense = A2($rtfeldman$elm_css$Css$property, 'grid-auto-flow', 'row dense');
var $author$project$Tailwind$Utilities$h_screen = A2($rtfeldman$elm_css$Css$property, 'height', '100vh');
var $rtfeldman$elm_css$Css$hidden = {y: 0, aH: 0, i3: 'hidden', bu: 0};
var $author$project$Tailwind$Utilities$justify_between = A2($rtfeldman$elm_css$Css$property, 'justify-content', 'space-between');
var $author$project$Tailwind$Utilities$left_12 = A2($rtfeldman$elm_css$Css$property, 'left', '3rem');
var $author$project$Tailwind$Utilities$left_16 = A2($rtfeldman$elm_css$Css$property, 'left', '4rem');
var $author$project$Tailwind$Utilities$max_w_7xl = A2($rtfeldman$elm_css$Css$property, 'max-width', '80rem');
var $author$project$Tailwind$Breakpoints$md = $rtfeldman$elm_css$Css$Media$withMediaQuery(
	_List_fromArray(
		['(min-width: 768px)']));
var $author$project$Tailwind$Utilities$ml_3 = A2($rtfeldman$elm_css$Css$property, 'margin-left', '0.75rem');
var $author$project$Tailwind$Utilities$mr_4 = A2($rtfeldman$elm_css$Css$property, 'margin-right', '1rem');
var $author$project$Tailwind$Utilities$mt_3 = A2($rtfeldman$elm_css$Css$property, 'margin-top', '0.75rem');
var $author$project$Tailwind$Utilities$mt_5 = A2($rtfeldman$elm_css$Css$property, 'margin-top', '1.25rem');
var $author$project$Tailwind$Utilities$mt_6 = A2($rtfeldman$elm_css$Css$property, 'margin-top', '1.5rem');
var $rtfeldman$elm_css$Css$overflow = $rtfeldman$elm_css$Css$prop1('overflow');
var $author$project$Tailwind$Utilities$pb_2 = A2($rtfeldman$elm_css$Css$property, 'padding-bottom', '0.5rem');
var $author$project$Tailwind$Utilities$py_4 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-top', '1rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-bottom', '1rem')
		]));
var $author$project$Tailwind$Utilities$space_x_3 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Global$children(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$Global$selector,
					':not([hidden]) ~ :not([hidden])',
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, '--tw-space-x-reverse', '0'),
							A2($rtfeldman$elm_css$Css$property, 'margin-right', 'calc(0.75rem * var(--tw-space-x-reverse))'),
							A2($rtfeldman$elm_css$Css$property, 'margin-left', 'calc(0.75rem * calc(1 - var(--tw-space-x-reverse)))')
						]))
				]))
		]));
var $author$project$Tailwind$Utilities$text_center = A2($rtfeldman$elm_css$Css$property, 'text-align', 'center');
var $author$project$Tailwind$Utilities$text_gray_500 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-text-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(107, 114, 128, var(--tw-text-opacity))')
		]));
var $author$project$Tailwind$Utilities$top_0 = A2($rtfeldman$elm_css$Css$property, 'top', '0px');
var $author$project$Tailwind$Utilities$w_60 = A2($rtfeldman$elm_css$Css$property, 'width', '15rem');
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $author$project$Tailwind$Utilities$z_10 = A2($rtfeldman$elm_css$Css$property, 'z-index', '10');
var $author$project$Page$AdminList$styles = {
	c1: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$justify_between, $author$project$Tailwind$Utilities$flex_wrap, $author$project$Tailwind$Utilities$mb_2]),
	ce: _List_fromArray(
		[$author$project$Tailwind$Utilities$no_underline, $author$project$Tailwind$Utilities$text_white, $author$project$Tailwind$Utilities$px_4, $author$project$Tailwind$Utilities$py_2]),
	dg: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$px_2,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$flex_col,
			$author$project$Tailwind$Utilities$flex_grow,
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6]))
		]),
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_gray_100, $author$project$Tailwind$Utilities$h_screen, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col]),
	dR: _List_fromArray(
		[$author$project$Tailwind$Utilities$ml_3]),
	dS: _List_fromArray(
		[$author$project$Tailwind$Utilities$mr_4]),
	dU: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$text_gray_500]),
	eh: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$items_center]),
	eo: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_gray_50]),
	cH: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$mt_5,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_6, $author$project$Tailwind$Utilities$grid, $author$project$Tailwind$Utilities$grid_cols_2, $author$project$Tailwind$Utilities$gap_3, $author$project$Tailwind$Utilities$grid_flow_row_dense]))
		]),
	cI: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(400))
		]),
	cJ: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$leading_6, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900]),
	cK: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$mt_3,
			$author$project$Tailwind$Utilities$text_center,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_5]))
		]),
	fV: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_60, $author$project$Tailwind$Utilities$mb_2]),
	fY: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_60, $author$project$Tailwind$Utilities$px_3, $author$project$Tailwind$Utilities$pb_2]),
	ii: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$absolute,
			$author$project$Tailwind$Utilities$top_0,
			$author$project$Tailwind$Utilities$left_12,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$h_12,
			$author$project$Tailwind$Utilities$z_10,
			$author$project$Tailwind$Utilities$items_center,
			$author$project$Tailwind$Utilities$space_x_3,
			$author$project$Tailwind$Utilities$bg_gray_50,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$left_16]))
		]),
	cV: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$max_w_7xl,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_4,
			$author$project$Tailwind$Breakpoints$md(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6])),
			$author$project$Tailwind$Utilities$text_left
		])
};
var $author$project$Page$AdminList$toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAdminList);
var $author$project$Page$AdminList$searchArea = F2(
	function (role, _v0) {
		var search = _v0.fU;
		var tenants = _v0.iM;
		var tenantID = _v0.gm;
		var checkedList = _v0.F;
		var tenantOptions = A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					{d_: false, hH: 'Select Tenant', i3: ''}
				]),
			A2(
				$elm$core$List$map,
				function (_v2) {
					var label = _v2.hH;
					var value = _v2.i3;
					return {
						d_: false,
						hH: label,
						i3: $elm$core$String$fromInt(value)
					};
				},
				tenants));
		var showDelete = ($elm$core$List$length(checkedList) > 0) ? A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.co, $author$project$Page$AdminList$styles.dS)),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Page$AdminList$toAppMsg($author$project$Type$AdminList$OnOpenModal))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.ce),
							$rtfeldman$elm_css$Html$Styled$Attributes$href('#')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Delete All')
						]))
				])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
		var selectView = function () {
			if (role === 1) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.fY)
						]),
					_List_fromArray(
						[
							$author$project$View$Form$Select$view(
							{
								hY: A2($elm$core$Basics$composeL, $author$project$Page$AdminList$toAppMsg, $author$project$Type$AdminList$OnChangeTenant),
								h0: tenantOptions,
								i4: tenantID
							})
						]));
			} else {
				return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.c1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.eh)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.fV)
								]),
							_List_fromArray(
								[
									$author$project$View$Form$Input$view(
									{
										bJ: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: search},
										bL: 'name',
										bP: false,
										bS: '',
										bX: 'search',
										bZ: A2($elm$core$Basics$composeL, $author$project$Page$AdminList$toAppMsg, $author$project$Type$AdminList$OnChangeSearch),
										b5: 'Search'
									})
								])),
							selectView
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							showDelete,
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.fz)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.dK),
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.ce)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Create Admin')
										]))
								]))
						]))
				]));
	});
var $author$project$Type$AdminList$OnChangeOffset = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$AdminList$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid limit';
		case 2:
			return 'Invalid offset';
		case 3:
			return 'Cannot get admin';
		default:
			return 'Missing error code';
	}
};
var $author$project$Type$AdminList$OnCheckAll = {$: 4};
var $author$project$Type$AdminList$OnCloseModal = {$: 7};
var $author$project$Type$AdminList$OnSelectAdmin = function (a) {
	return {$: 16, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Attributes$checked = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('checked');
var $author$project$Type$AdminList$OnDelete = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$AdminList$renderDeleteAdmins = function (admin) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.dU)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('- ' + admin.fg)
			]));
};
var $author$project$Page$AdminList$renderDeletePopup = F2(
	function (data, checkedList) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.cI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.cK)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.cJ)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Do you want to delete these admins?')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					A2($elm$core$List$map, $author$project$Page$AdminList$renderDeleteAdmins, checkedList)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.cH)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.dt),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$AdminList$toAppMsg($author$project$Type$AdminList$OnCloseModal))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Cancel')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.co),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$AdminList$toAppMsg(
										$author$project$Type$AdminList$OnDelete(data)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Type$AdminList$OnDeleteSingle = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Page$AdminList$renderDeleteSinglePopup = F2(
	function (id, data) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.cI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.cK)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.cJ)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Do you want to delete this admin?')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.cH)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.dt),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$AdminList$toAppMsg(
										$author$project$Type$AdminList$OnSelectAdmin(0)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Cancel')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.co),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$AdminList$toAppMsg(
										A2($author$project$Type$AdminList$OnDeleteSingle, id, data)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Type$AdminList$OnCheck = function (a) {
	return {$: 5, a: a};
};
var $author$project$Tailwind$Utilities$align_middle = A2($rtfeldman$elm_css$Css$property, 'vertical-align', 'middle');
var $author$project$Tailwind$Utilities$bg_gray_200 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-bg-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(229, 231, 235, var(--tw-bg-opacity))')
		]));
var $author$project$Tailwind$Utilities$divide_gray_200 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Global$children(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$Global$selector,
					':not([hidden]) ~ :not([hidden])',
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, '--tw-divide-opacity', '1'),
							A2($rtfeldman$elm_css$Css$property, 'border-color', 'rgba(229, 231, 235, var(--tw-divide-opacity))')
						]))
				]))
		]));
var $author$project$Tailwind$Utilities$divide_gray_300 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Global$children(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$Global$selector,
					':not([hidden]) ~ :not([hidden])',
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, '--tw-divide-opacity', '1'),
							A2($rtfeldman$elm_css$Css$property, 'border-color', 'rgba(209, 213, 219, var(--tw-divide-opacity))')
						]))
				]))
		]));
var $author$project$Tailwind$Utilities$divide_y = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Global$children(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$Global$selector,
					':not([hidden]) ~ :not([hidden])',
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, '--tw-divide-y-reverse', '0'),
							A2($rtfeldman$elm_css$Css$property, 'border-top-width', 'calc(1px * calc(1 - var(--tw-divide-y-reverse)))'),
							A2($rtfeldman$elm_css$Css$property, 'border-bottom-width', 'calc(1px * var(--tw-divide-y-reverse))')
						]))
				]))
		]));
var $author$project$Tailwind$Utilities$flex_none = A2($rtfeldman$elm_css$Css$property, 'flex', 'none');
var $author$project$Tailwind$Utilities$h_10 = A2($rtfeldman$elm_css$Css$property, 'height', '2.5rem');
var $author$project$Tailwind$Utilities$h_3 = A2($rtfeldman$elm_css$Css$property, 'height', '0.75rem');
var $author$project$Tailwind$Utilities$h_4 = A2($rtfeldman$elm_css$Css$property, 'height', '1rem');
var $author$project$Tailwind$Utilities$inline_block = A2($rtfeldman$elm_css$Css$property, 'display', 'inline-block');
var $author$project$Tailwind$Utilities$inline_flex = A2($rtfeldman$elm_css$Css$property, 'display', 'inline-flex');
var $author$project$Tailwind$Utilities$inset_y_0 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'top', '0px'),
			A2($rtfeldman$elm_css$Css$property, 'bottom', '0px')
		]));
var $author$project$Tailwind$Utilities$left_0 = A2($rtfeldman$elm_css$Css$property, 'left', '0px');
var $author$project$Tailwind$Utilities$left_6 = A2($rtfeldman$elm_css$Css$property, 'left', '1.5rem');
var $rtfeldman$elm_css$Css$maxWidth = $rtfeldman$elm_css$Css$prop1('max-width');
var $author$project$Tailwind$Utilities$mb_8 = A2($rtfeldman$elm_css$Css$property, 'margin-bottom', '2rem');
var $rtfeldman$elm_css$Css$minWidth = $rtfeldman$elm_css$Css$prop1('min-width');
var $author$project$Tailwind$Utilities$min_w_full = A2($rtfeldman$elm_css$Css$property, 'min-width', '100%');
var $author$project$Tailwind$Utilities$ml_2 = A2($rtfeldman$elm_css$Css$property, 'margin-left', '0.5rem');
var $author$project$Tailwind$Utilities$mt_4 = A2($rtfeldman$elm_css$Css$property, 'margin-top', '1rem');
var $author$project$Tailwind$Utilities$mx_2 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'margin-left', '0.5rem'),
			A2($rtfeldman$elm_css$Css$property, 'margin-right', '0.5rem')
		]));
var $author$project$Tailwind$Utilities$neg_mx_4 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'margin-left', '-1rem'),
			A2($rtfeldman$elm_css$Css$property, 'margin-right', '-1rem')
		]));
var $author$project$Tailwind$Utilities$neg_mx_6 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'margin-left', '-1.5rem'),
			A2($rtfeldman$elm_css$Css$property, 'margin-right', '-1.5rem')
		]));
var $author$project$Tailwind$Utilities$neg_mx_8 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'margin-left', '-2rem'),
			A2($rtfeldman$elm_css$Css$property, 'margin-right', '-2rem')
		]));
var $author$project$Tailwind$Utilities$neg_top_2 = A2($rtfeldman$elm_css$Css$property, 'top', '-0.5rem');
var $author$project$Tailwind$Utilities$overflow_ellipsis = A2($rtfeldman$elm_css$Css$property, 'text-overflow', 'ellipsis');
var $author$project$Tailwind$Utilities$overflow_visible = A2($rtfeldman$elm_css$Css$property, 'overflow', 'visible');
var $author$project$Tailwind$Utilities$pl_3 = A2($rtfeldman$elm_css$Css$property, 'padding-left', '0.75rem');
var $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1('position');
var $author$project$Tailwind$Utilities$pr_1 = A2($rtfeldman$elm_css$Css$property, 'padding-right', '0.25rem');
var $author$project$Tailwind$Utilities$pr_4 = A2($rtfeldman$elm_css$Css$property, 'padding-right', '1rem');
var $author$project$Tailwind$Utilities$pr_6 = A2($rtfeldman$elm_css$Css$property, 'padding-right', '1.5rem');
var $author$project$Tailwind$Utilities$px_2_dot_5 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-left', '0.625rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-right', '0.625rem')
		]));
var $author$project$Tailwind$Utilities$py_1_dot_5 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-top', '0.375rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-bottom', '0.375rem')
		]));
var $author$project$Tailwind$Utilities$py_3_dot_5 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-top', '0.875rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-bottom', '0.875rem')
		]));
var $author$project$Tailwind$Utilities$relative = A2($rtfeldman$elm_css$Css$property, 'position', 'relative');
var $author$project$Tailwind$Utilities$ring_1 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-ring-offset-shadow', 'var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)'),
			A2($rtfeldman$elm_css$Css$property, '--tw-ring-shadow', 'var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', 'var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)')
		]));
var $author$project$Tailwind$Utilities$ring_black = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-ring-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, '--tw-ring-color', 'rgba(0, 0, 0, var(--tw-ring-opacity))')
		]));
var $author$project$Tailwind$Utilities$ring_opacity_5 = A2($rtfeldman$elm_css$Css$property, '--tw-ring-opacity', '0.05');
var $author$project$Tailwind$Utilities$rounded = A2($rtfeldman$elm_css$Css$property, 'border-radius', '0.25rem');
var $author$project$Tailwind$Utilities$sr_only = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'position', 'absolute'),
			A2($rtfeldman$elm_css$Css$property, 'width', '1px'),
			A2($rtfeldman$elm_css$Css$property, 'height', '1px'),
			A2($rtfeldman$elm_css$Css$property, 'padding', '0'),
			A2($rtfeldman$elm_css$Css$property, 'margin', '-1px'),
			A2($rtfeldman$elm_css$Css$property, 'overflow', 'hidden'),
			A2($rtfeldman$elm_css$Css$property, 'clip', 'rect(0, 0, 0, 0)'),
			A2($rtfeldman$elm_css$Css$property, 'white-space', 'nowrap'),
			A2($rtfeldman$elm_css$Css$property, 'border-width', '0')
		]));
var $rtfeldman$elm_css$Css$sticky = {bc: 0, i3: 'sticky'};
var $author$project$Tailwind$Utilities$table_fixed = A2($rtfeldman$elm_css$Css$property, 'table-layout', 'fixed');
var $author$project$Tailwind$Utilities$text_indigo_900 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-text-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(49, 46, 129, var(--tw-text-opacity))')
		]));
var $author$project$Tailwind$Utilities$text_red_900 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-text-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(127, 29, 29, var(--tw-text-opacity))')
		]));
var $author$project$Tailwind$Utilities$text_xs = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-size', '0.75rem'),
			A2($rtfeldman$elm_css$Css$property, 'line-height', '1rem')
		]));
var $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1('top');
var $author$project$Tailwind$Utilities$underline = A2($rtfeldman$elm_css$Css$property, 'text-decoration', 'underline');
var $author$project$Tailwind$Utilities$w_0_dot_5 = A2($rtfeldman$elm_css$Css$property, 'width', '0.125rem');
var $author$project$Tailwind$Utilities$w_10 = A2($rtfeldman$elm_css$Css$property, 'width', '2.5rem');
var $author$project$Tailwind$Utilities$w_12 = A2($rtfeldman$elm_css$Css$property, 'width', '3rem');
var $author$project$Tailwind$Utilities$w_4 = A2($rtfeldman$elm_css$Css$property, 'width', '1rem');
var $author$project$Tailwind$Utilities$w_5 = A2($rtfeldman$elm_css$Css$property, 'width', '1.25rem');
var $author$project$Tailwind$Utilities$whitespace_nowrap = A2($rtfeldman$elm_css$Css$property, 'white-space', 'nowrap');
var $author$project$View$Table$tableStyles = {
	dx: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$h_4,
			$author$project$Tailwind$Utilities$w_4,
			$author$project$Tailwind$Utilities$rounded,
			$author$project$Tailwind$Utilities$border_gray_300,
			$author$project$Tailwind$Utilities$text_indigo_600,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$ring_indigo_500])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$left_6]))
		]),
	dy: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$w_12,
			$author$project$Tailwind$Utilities$text_center,
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(50))
		]),
	dI: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$flex_col,
			$author$project$Tailwind$Utilities$mt_4,
			$author$project$Tailwind$Utilities$mb_8,
			$author$project$Tailwind$Utilities$flex_grow,
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden)
		]),
	dR: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$text_red_600,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$text_red_900])),
			$author$project$Tailwind$Utilities$cursor_pointer
		]),
	dS: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$inline_flex,
			$author$project$Tailwind$Utilities$items_center,
			$author$project$Tailwind$Utilities$rounded,
			$author$project$Tailwind$Utilities$border,
			$author$project$Tailwind$Utilities$border_gray_300,
			$author$project$Tailwind$Utilities$bg_white,
			$author$project$Tailwind$Utilities$px_2_dot_5,
			$author$project$Tailwind$Utilities$py_1_dot_5,
			$author$project$Tailwind$Utilities$text_xs,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$text_gray_700,
			$author$project$Tailwind$Utilities$shadow_sm,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$outline_none, $author$project$Tailwind$Utilities$ring_2, $author$project$Tailwind$Utilities$ring_indigo_500, $author$project$Tailwind$Utilities$ring_offset_2])),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_gray_50]))
		]),
	hn: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$text_indigo_600,
			$author$project$Tailwind$Utilities$no_underline,
			$author$project$Tailwind$Utilities$cursor_pointer,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$text_indigo_900]))
		]),
	hI: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$neg_top_2,
			$author$project$Tailwind$Utilities$neg_mx_4,
			$author$project$Tailwind$Utilities$w_full,
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$neg_mx_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$neg_mx_6]))
		]),
	hJ: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex_grow, $author$project$Tailwind$Utilities$overflow_auto, $author$project$Tailwind$Utilities$bg_white]),
	fr: _List_fromArray(
		[$author$project$Tailwind$Utilities$ml_2, $author$project$Tailwind$Utilities$flex_none, $author$project$Tailwind$Utilities$rounded, $author$project$Tailwind$Utilities$bg_gray_200, $author$project$Tailwind$Utilities$w_10, $author$project$Tailwind$Utilities$h_10]),
	fs: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_5, $author$project$Tailwind$Utilities$h_3, $author$project$Tailwind$Utilities$pr_1]),
	id: _List_fromArray(
		[$author$project$Tailwind$Utilities$absolute, $author$project$Tailwind$Utilities$inset_y_0, $author$project$Tailwind$Utilities$left_0, $author$project$Tailwind$Utilities$w_0_dot_5, $author$project$Tailwind$Utilities$bg_indigo_600]),
	ik: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_gray_50]),
	il: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_indigo_600]),
	io: _List_fromArray(
		[$author$project$Tailwind$Utilities$sr_only]),
	ip: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900, $author$project$Tailwind$Utilities$mx_2]),
	iA: _List_fromArray(
		[$author$project$Tailwind$Utilities$min_w_full, $author$project$Tailwind$Utilities$table_fixed, $author$project$Tailwind$Utilities$divide_y, $author$project$Tailwind$Utilities$divide_gray_300, $author$project$Tailwind$Utilities$bg_white]),
	iB: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$relative,
			$author$project$Tailwind$Utilities$ring_1,
			$author$project$Tailwind$Utilities$ring_black,
			$author$project$Tailwind$Utilities$ring_opacity_5,
			$author$project$Tailwind$Utilities$shadow,
			$author$project$Tailwind$Breakpoints$md(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$rounded_lg]))
		]),
	iC: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$inline_block,
			$author$project$Tailwind$Utilities$min_w_full,
			$author$project$Tailwind$Utilities$pt_2,
			$author$project$Tailwind$Utilities$align_middle,
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$md(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6]))
		]),
	iE: _List_fromArray(
		[$author$project$Tailwind$Utilities$divide_y, $author$project$Tailwind$Utilities$divide_gray_200, $author$project$Tailwind$Utilities$bg_white]),
	aL: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$text_gray_900,
			$author$project$Tailwind$Utilities$py_2,
			$author$project$Tailwind$Utilities$px_3,
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(300)),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden)
		]),
	iF: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$whitespace_nowrap]),
	iG: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(300)),
			$author$project$Tailwind$Utilities$whitespace_nowrap,
			$author$project$Tailwind$Utilities$overflow_ellipsis
		]),
	iH: _List_fromArray(
		[$author$project$Tailwind$Utilities$whitespace_nowrap]),
	iI: _List_fromArray(
		[$author$project$Tailwind$Utilities$whitespace_nowrap, $author$project$Tailwind$Utilities$underline, $author$project$Tailwind$Utilities$cursor_pointer]),
	iJ: _List_fromArray(
		[$author$project$Tailwind$Utilities$overflow_visible]),
	bn: _List_fromArray(
		[$author$project$Tailwind$Utilities$py_3_dot_5, $author$project$Tailwind$Utilities$px_3, $author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$font_semibold, $author$project$Tailwind$Utilities$text_gray_900, $author$project$Tailwind$Utilities$text_left, $author$project$Tailwind$Utilities$whitespace_nowrap]),
	iN: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$relative,
			$author$project$Tailwind$Utilities$py_3_dot_5,
			$author$project$Tailwind$Utilities$pl_3,
			$author$project$Tailwind$Utilities$pr_4,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$pr_6]))
		]),
	go: _List_fromArray(
		[$author$project$Tailwind$Utilities$cursor_pointer]),
	iO: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$bg_gray_50,
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$sticky),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(0))
		])
};
var $rtfeldman$elm_css$Html$Styled$td = $rtfeldman$elm_css$Html$Styled$node('td');
var $rtfeldman$elm_css$Html$Styled$tr = $rtfeldman$elm_css$Html$Styled$node('tr');
var $author$project$Page$AdminList$renderItem = F3(
	function (tenants, checkedList, admin) {
		var _v0 = admin;
		var id = _v0.eu;
		var name = _v0.fg;
		var tenantID = _v0.gm;
		var email = _v0.d4;
		var existedAdmin = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.eu;
				},
				$elm$core$Basics$eq(id)),
			checkedList);
		var checked = $elm$core$List$length(existedAdmin) > 0;
		var checkedRowCss = checked ? $rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.eo) : $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil);
		var rowMarker = checked ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.id)
				]),
			_List_Nil) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
		var selectedCss = checked ? $rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap($author$project$View$Table$tableStyles.aL, $author$project$View$Table$tableStyles.il)) : $rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL);
		var tenantName = A2(
			$elm$core$Maybe$withDefault,
			'...',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.hH;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.i3;
							},
							$elm$core$Basics$eq(tenantID)),
						tenants))));
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[checkedRowCss]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dy)
						]),
					_List_fromArray(
						[
							rowMarker,
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dx),
									$rtfeldman$elm_css$Html$Styled$Attributes$checked(checked),
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									function (_v1) {
										return $author$project$Page$AdminList$toAppMsg(
											$author$project$Type$AdminList$OnCheck(admin));
									})
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[selectedCss]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(id))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(name)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(email)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(tenantName)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$View$Table$tableStyles.aL, $author$project$View$Table$tableStyles.iF))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									$author$project$Data$Route$routeUrl.d0(id)),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.hn)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Edit')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.ip)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(' | ')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dR),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$AdminList$toAppMsg(
										$author$project$Type$AdminList$OnSelectAdmin(id)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Delete')
								]))
						]))
				]));
	});
var $rtfeldman$elm_css$Html$Styled$table = $rtfeldman$elm_css$Html$Styled$node('table');
var $rtfeldman$elm_css$Html$Styled$tbody = $rtfeldman$elm_css$Html$Styled$node('tbody');
var $rtfeldman$elm_css$Html$Styled$th = $rtfeldman$elm_css$Html$Styled$node('th');
var $rtfeldman$elm_css$Html$Styled$thead = $rtfeldman$elm_css$Html$Styled$node('thead');
var $rtfeldman$elm_css$Svg$Styled$Attributes$stroke = $rtfeldman$elm_css$VirtualDom$Styled$attribute('stroke');
var $rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap = $rtfeldman$elm_css$VirtualDom$Styled$attribute('stroke-linecap');
var $rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin = $rtfeldman$elm_css$VirtualDom$Styled$attribute('stroke-linejoin');
var $rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth = $rtfeldman$elm_css$VirtualDom$Styled$attribute('stroke-width');
var $author$project$Tailwind$Utilities$bg_gray_500 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-bg-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(107, 114, 128, var(--tw-bg-opacity))')
		]));
var $author$project$Tailwind$Utilities$bg_opacity_75 = A2($rtfeldman$elm_css$Css$property, '--tw-bg-opacity', '0.75');
var $author$project$Tailwind$Utilities$border_0 = A2($rtfeldman$elm_css$Css$property, 'border-width', '0px');
var $author$project$Tailwind$Utilities$fixed = A2($rtfeldman$elm_css$Css$property, 'position', 'fixed');
var $author$project$Tailwind$Utilities$h_6 = A2($rtfeldman$elm_css$Css$property, 'height', '1.5rem');
var $author$project$Tailwind$Utilities$hidden = A2($rtfeldman$elm_css$Css$property, 'display', 'none');
var $author$project$Tailwind$Utilities$inset_0 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'top', '0px'),
			A2($rtfeldman$elm_css$Css$property, 'right', '0px'),
			A2($rtfeldman$elm_css$Css$property, 'bottom', '0px'),
			A2($rtfeldman$elm_css$Css$property, 'left', '0px')
		]));
var $author$project$Tailwind$Utilities$items_end = A2($rtfeldman$elm_css$Css$property, 'align-items', 'flex-end');
var $author$project$Tailwind$Utilities$min_h_full = A2($rtfeldman$elm_css$Css$property, 'min-height', '100%');
var $author$project$Tailwind$Utilities$my_8 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'margin-top', '2rem'),
			A2($rtfeldman$elm_css$Css$property, 'margin-bottom', '2rem')
		]));
var $author$project$Tailwind$Utilities$overflow_hidden = A2($rtfeldman$elm_css$Css$property, 'overflow', 'hidden');
var $author$project$Tailwind$Utilities$overflow_y_auto = A2($rtfeldman$elm_css$Css$property, 'overflow-y', 'auto');
var $author$project$Tailwind$Utilities$p_0 = A2($rtfeldman$elm_css$Css$property, 'padding', '0px');
var $author$project$Tailwind$Utilities$p_4 = A2($rtfeldman$elm_css$Css$property, 'padding', '1rem');
var $author$project$Tailwind$Utilities$p_6 = A2($rtfeldman$elm_css$Css$property, 'padding', '1.5rem');
var $author$project$Tailwind$Utilities$pt_4 = A2($rtfeldman$elm_css$Css$property, 'padding-top', '1rem');
var $author$project$Tailwind$Utilities$right_0 = A2($rtfeldman$elm_css$Css$property, 'right', '0px');
var $author$project$Tailwind$Utilities$shadow_xl = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-shadow', '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', 'var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)')
		]));
var $author$project$Tailwind$Utilities$text_gray_400 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-text-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(156, 163, 175, var(--tw-text-opacity))')
		]));
var $author$project$Tailwind$Utilities$transform = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-translate-x', '0'),
			A2($rtfeldman$elm_css$Css$property, '--tw-translate-y', '0'),
			A2($rtfeldman$elm_css$Css$property, '--tw-rotate', '0'),
			A2($rtfeldman$elm_css$Css$property, '--tw-skew-x', '0'),
			A2($rtfeldman$elm_css$Css$property, '--tw-skew-y', '0'),
			A2($rtfeldman$elm_css$Css$property, '--tw-scale-x', '1'),
			A2($rtfeldman$elm_css$Css$property, '--tw-scale-y', '1'),
			A2($rtfeldman$elm_css$Css$property, 'transform', 'translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))')
		]));
var $author$project$Tailwind$Utilities$transition_all = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'transition-property', 'all'),
			A2($rtfeldman$elm_css$Css$property, 'transition-timing-function', 'cubic-bezier(0.4, 0, 0.2, 1)'),
			A2($rtfeldman$elm_css$Css$property, 'transition-duration', '150ms')
		]));
var $author$project$Tailwind$Utilities$transition_opacity = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'transition-property', 'opacity'),
			A2($rtfeldman$elm_css$Css$property, 'transition-timing-function', 'cubic-bezier(0.4, 0, 0.2, 1)'),
			A2($rtfeldman$elm_css$Css$property, 'transition-duration', '150ms')
		]));
var $author$project$Tailwind$Utilities$w_6 = A2($rtfeldman$elm_css$Css$property, 'width', '1.5rem');
var $author$project$View$Popup$styles = {
	c9: _List_fromArray(
		[$author$project$Tailwind$Utilities$fixed, $author$project$Tailwind$Utilities$z_10, $author$project$Tailwind$Utilities$inset_0, $author$project$Tailwind$Utilities$overflow_y_auto]),
	df: _List_fromArray(
		[$author$project$Tailwind$Utilities$relative, $author$project$Tailwind$Utilities$bg_white, $author$project$Tailwind$Utilities$rounded_lg, $author$project$Tailwind$Utilities$text_left, $author$project$Tailwind$Utilities$overflow_hidden, $author$project$Tailwind$Utilities$shadow_xl, $author$project$Tailwind$Utilities$transform, $author$project$Tailwind$Utilities$transition_all, $author$project$Tailwind$Utilities$my_8, $author$project$Tailwind$Utilities$p_6]),
	dg: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$items_end,
			$author$project$Tailwind$Utilities$justify_center,
			$author$project$Tailwind$Utilities$min_h_full,
			$author$project$Tailwind$Utilities$p_4,
			$author$project$Tailwind$Utilities$text_center,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$p_0]))
		]),
	dB: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$bg_white,
			$author$project$Tailwind$Utilities$rounded_md,
			$author$project$Tailwind$Utilities$text_gray_400,
			$author$project$Tailwind$Utilities$border_0,
			$author$project$Tailwind$Utilities$cursor_pointer,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$outline_none, $author$project$Tailwind$Utilities$ring_2, $author$project$Tailwind$Utilities$ring_offset_2, $author$project$Tailwind$Utilities$ring_indigo_500])),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$text_gray_500]))
		]),
	dD: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$hidden,
			$author$project$Tailwind$Utilities$absolute,
			$author$project$Tailwind$Utilities$top_0,
			$author$project$Tailwind$Utilities$right_0,
			$author$project$Tailwind$Utilities$pt_4,
			$author$project$Tailwind$Utilities$pr_4,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$block]))
		]),
	dF: _List_fromArray(
		[$author$project$Tailwind$Utilities$h_6, $author$project$Tailwind$Utilities$w_6]),
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$fixed, $author$project$Tailwind$Utilities$inset_0, $author$project$Tailwind$Utilities$bg_gray_500, $author$project$Tailwind$Utilities$bg_opacity_75, $author$project$Tailwind$Utilities$transition_opacity]),
	dY: _List_fromArray(
		[$author$project$Tailwind$Utilities$relative, $author$project$Tailwind$Utilities$z_10])
};
var $author$project$View$Popup$view = function (_v0) {
	var isShow = _v0.eK;
	var onClose = _v0.fp;
	var content = _v0.dJ;
	return isShow ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Popup$styles.dY)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Popup$styles.dI)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Popup$styles.c9)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Popup$styles.dg)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Popup$styles.df)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Popup$styles.dD)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$button,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Popup$styles.dB),
														$rtfeldman$elm_css$Html$Styled$Events$onClick(onClose)
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Svg$Styled$svg,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$View$Popup$styles.dF),
																$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none'),
																$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24'),
																$rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('2'),
																$rtfeldman$elm_css$Svg$Styled$Attributes$stroke('currentColor')
															]),
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Svg$Styled$path,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
																		$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('round'),
																		$rtfeldman$elm_css$Svg$Styled$Attributes$d('M6 18L18 6M6 6l12 12')
																	]),
																_List_Nil)
															]))
													]))
											])),
										content
									]))
							]))
					]))
			])) : $rtfeldman$elm_css$Html$Styled$text('');
};
var $author$project$Page$AdminList$table = F2(
	function (_v0, data) {
		var checkedList = _v0.F;
		var isShowModal = _v0.bQ;
		var tenants = _v0.iM;
		var selectedAdmin = _v0.bf;
		var checked = ($elm$core$List$length(checkedList) > 0) && _Utils_eq(
			$elm$core$List$length(checkedList),
			$elm$core$List$length(data));
		return A2(
			$rtfeldman$elm_css$Html$Styled$table,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iA)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$thead,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iO)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dy)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$input,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dx),
													$rtfeldman$elm_css$Html$Styled$Attributes$checked(checked),
													$rtfeldman$elm_css$Html$Styled$Events$onInput(
													function (_v1) {
														return $author$project$Page$AdminList$toAppMsg($author$project$Type$AdminList$OnCheckAll);
													})
												]),
											_List_Nil)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('ID')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Name')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Email')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Tenant')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Action')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$tbody,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iE)
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Page$AdminList$renderItem, tenants, checkedList),
						data)),
					$author$project$View$Popup$view(
					{
						dJ: A2($author$project$Page$AdminList$renderDeletePopup, data, checkedList),
						eK: isShowModal,
						fp: $author$project$Page$AdminList$toAppMsg($author$project$Type$AdminList$OnCloseModal)
					}),
					$author$project$View$Popup$view(
					{
						dJ: A2($author$project$Page$AdminList$renderDeleteSinglePopup, selectedAdmin, data),
						eK: !(!selectedAdmin),
						fp: $author$project$Page$AdminList$toAppMsg(
							$author$project$Type$AdminList$OnSelectAdmin(0))
					})
				]));
	});
var $rtfeldman$elm_css$Svg$Styled$Attributes$clipRule = $rtfeldman$elm_css$VirtualDom$Styled$attribute('clip-rule');
var $rtfeldman$elm_css$Svg$Styled$Attributes$fillRule = $rtfeldman$elm_css$VirtualDom$Styled$attribute('fill-rule');
var $author$project$View$Pagination$moveEnd = 'M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z M4.293 15.707a1 1 0 010-1.414L8.586 10 4.293 5.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z';
var $author$project$View$Pagination$moveStart = 'M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414zm-6 0a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L5.414 10l4.293 4.293a1 1 0 010 1.414z';
var $rtfeldman$elm_css$Html$Styled$nav = $rtfeldman$elm_css$Html$Styled$node('nav');
var $author$project$View$Pagination$next = 'M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z';
var $author$project$View$Pagination$prev = 'M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z';
var $author$project$Tailwind$Utilities$bg_indigo_50 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-bg-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(238, 242, 255, var(--tw-bg-opacity))')
		]));
var $author$project$Tailwind$Utilities$border_none = A2($rtfeldman$elm_css$Css$property, 'border-style', 'none');
var $author$project$Tailwind$Utilities$flex_1 = A2($rtfeldman$elm_css$Css$property, 'flex', '1 1 0%');
var $author$project$Tailwind$Utilities$h_5 = A2($rtfeldman$elm_css$Css$property, 'height', '1.25rem');
var $author$project$Tailwind$Utilities$px_1 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-left', '0.25rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-right', '0.25rem')
		]));
var $author$project$Tailwind$Utilities$py_3 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-top', '0.75rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-bottom', '0.75rem')
		]));
var $author$project$Tailwind$Utilities$rounded_l_md = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'border-top-left-radius', '0.375rem'),
			A2($rtfeldman$elm_css$Css$property, 'border-bottom-left-radius', '0.375rem')
		]));
var $author$project$Tailwind$Utilities$rounded_r_md = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'border-top-right-radius', '0.375rem'),
			A2($rtfeldman$elm_css$Css$property, 'border-bottom-right-radius', '0.375rem')
		]));
var $author$project$View$Pagination$styles = {
	c$: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_indigo_50, $author$project$Tailwind$Utilities$border_indigo_500, $author$project$Tailwind$Utilities$text_indigo_600, $author$project$Tailwind$Utilities$relative, $author$project$Tailwind$Utilities$inline_flex, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$px_4, $author$project$Tailwind$Utilities$py_2, $author$project$Tailwind$Utilities$border, $author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$no_underline]),
	dI: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$bg_white,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_3,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$items_center,
			$author$project$Tailwind$Utilities$justify_between,
			$author$project$Tailwind$Utilities$border_t,
			$author$project$Tailwind$Utilities$border_gray_200,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6]))
		]),
	a0: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$relative,
			$author$project$Tailwind$Utilities$inline_flex,
			$author$project$Tailwind$Utilities$items_center,
			$author$project$Tailwind$Utilities$px_2,
			$author$project$Tailwind$Utilities$py_2,
			$author$project$Tailwind$Utilities$rounded_r_md,
			$author$project$Tailwind$Utilities$border,
			$author$project$Tailwind$Utilities$border_gray_300,
			$author$project$Tailwind$Utilities$bg_white,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$text_gray_500,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_gray_50, $author$project$Tailwind$Utilities$cursor_pointer])),
			$author$project$Tailwind$Utilities$border_none,
			$rtfeldman$elm_css$Css$disabled(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$cursor_not_allowed, $author$project$Tailwind$Utilities$opacity_30]))
		]),
	dZ: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$flex_1,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$justify_between,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$hidden]))
		]),
	eM: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$bg_white,
			$author$project$Tailwind$Utilities$border_gray_300,
			$author$project$Tailwind$Utilities$text_gray_500,
			$author$project$Tailwind$Utilities$relative,
			$author$project$Tailwind$Utilities$inline_flex,
			$author$project$Tailwind$Utilities$items_center,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_2,
			$author$project$Tailwind$Utilities$border,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$no_underline,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_gray_50]))
		]),
	bV: _List_fromArray(
		[$author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$px_1]),
	fk: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$ml_3,
			$author$project$Tailwind$Utilities$relative,
			$author$project$Tailwind$Utilities$inline_flex,
			$author$project$Tailwind$Utilities$items_center,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_2,
			$author$project$Tailwind$Utilities$border,
			$author$project$Tailwind$Utilities$border_gray_300,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$rounded_md,
			$author$project$Tailwind$Utilities$text_gray_700,
			$author$project$Tailwind$Utilities$bg_white,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_gray_50]))
		]),
	ft: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$relative,
			$author$project$Tailwind$Utilities$inline_flex,
			$author$project$Tailwind$Utilities$items_center,
			$author$project$Tailwind$Utilities$px_2,
			$author$project$Tailwind$Utilities$py_2,
			$author$project$Tailwind$Utilities$rounded_l_md,
			$author$project$Tailwind$Utilities$border,
			$author$project$Tailwind$Utilities$border_gray_300,
			$author$project$Tailwind$Utilities$bg_white,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$text_gray_500,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_gray_50]))
		]),
	fy: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$relative,
			$author$project$Tailwind$Utilities$inline_flex,
			$author$project$Tailwind$Utilities$items_center,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_2,
			$author$project$Tailwind$Utilities$border,
			$author$project$Tailwind$Utilities$border_gray_300,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$rounded_md,
			$author$project$Tailwind$Utilities$text_gray_700,
			$author$project$Tailwind$Utilities$bg_white,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_gray_50]))
		]),
	f5: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$text_gray_700]),
	gb: _List_fromArray(
		[$author$project$Tailwind$Utilities$sr_only, $author$project$Tailwind$Utilities$px_1]),
	bk: _List_fromArray(
		[$author$project$Tailwind$Utilities$h_5, $author$project$Tailwind$Utilities$w_5]),
	gr: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$hidden,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$flex_1, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$justify_between]))
		])
};
var $author$project$View$Pagination$renderItem = F3(
	function (offset, number, onChange) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href('#'),
					_Utils_eq(offset + 1, number) ? $rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.c$) : $rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.eM),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					onChange(number - 1))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$elm$core$String$fromInt(number))
				]));
	});
var $author$project$View$Pagination$renderList = F3(
	function (offset, end, onChange) {
		var headList = (offset <= 4) ? A2($elm$core$List$range, 1, offset) : A2($elm$core$List$range, offset - 3, offset);
		var behindList = (_Utils_cmp(offset + 4, end) > -1) ? A2($elm$core$List$range, offset + 1, end) : A2($elm$core$List$range, offset + 1, offset + 5);
		var list = A2($elm$core$List$append, headList, behindList);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (num) {
					return A3($author$project$View$Pagination$renderItem, offset, num, onChange);
				},
				list));
	});
var $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node('span');
var $author$project$View$Pagination$view = function (_v0) {
	var offset = _v0.fo;
	var total = _v0.iR;
	var onChange = _v0.bZ;
	var limit = _v0.eV;
	var totalPages = $elm$core$Basics$ceiling(total / limit);
	var start = ((!offset) && (!total)) ? 0 : (((!offset) && (total > 0)) ? 1 : (offset * limit));
	var end = (offset * limit) + limit;
	var endResults = (_Utils_cmp(total, end) < 0) ? total : end;
	var disableRight = _Utils_cmp(offset + 1, totalPages) > -1;
	var disableLeft = (offset - 1) < 0;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.dI)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.dZ)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.fy),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(disableLeft)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Previous')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.fk),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(disableRight)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Next')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.gr)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.f5)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Showing'),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.bV)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$elm$core$String$fromInt(start))
											])),
										$rtfeldman$elm_css$Html$Styled$text('to'),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.bV)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$elm$core$String$fromInt(endResults))
											])),
										$rtfeldman$elm_css$Html$Styled$text('of'),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.bV)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$elm$core$String$fromInt(total))
											])),
										$rtfeldman$elm_css$Html$Styled$text('results')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$nav,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.ft)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.a0),
												$rtfeldman$elm_css$Html$Styled$Attributes$disabled((offset - 1) < 0),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												onChange(0)),
												$rtfeldman$elm_css$Html$Styled$Attributes$disabled(disableLeft)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Svg$Styled$svg,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$View$Pagination$styles.bk),
														$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 20 20'),
														$rtfeldman$elm_css$Svg$Styled$Attributes$fill('currentColor')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Svg$Styled$path,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Svg$Styled$Attributes$fillRule('evenodd'),
																$rtfeldman$elm_css$Svg$Styled$Attributes$d($author$project$View$Pagination$moveStart),
																$rtfeldman$elm_css$Svg$Styled$Attributes$clipRule('evenodd')
															]),
														_List_Nil)
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.a0),
												$rtfeldman$elm_css$Html$Styled$Attributes$disabled((offset - 1) < 0),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												onChange(offset - 1)),
												$rtfeldman$elm_css$Html$Styled$Attributes$disabled(disableLeft)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.gb)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Previous')
													])),
												A2(
												$rtfeldman$elm_css$Svg$Styled$svg,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$View$Pagination$styles.bk),
														$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 20 20'),
														$rtfeldman$elm_css$Svg$Styled$Attributes$fill('currentColor')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Svg$Styled$path,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Svg$Styled$Attributes$fillRule('evenodd'),
																$rtfeldman$elm_css$Svg$Styled$Attributes$d($author$project$View$Pagination$prev),
																$rtfeldman$elm_css$Svg$Styled$Attributes$clipRule('evenodd')
															]),
														_List_Nil)
													]))
											])),
										A3($author$project$View$Pagination$renderList, offset, totalPages, onChange),
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.a0),
												$rtfeldman$elm_css$Html$Styled$Attributes$disabled(disableRight),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												onChange(offset + 1))
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[$author$project$Tailwind$Utilities$sr_only]))
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Next')
													])),
												A2(
												$rtfeldman$elm_css$Svg$Styled$svg,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$View$Pagination$styles.bk),
														$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 20 20'),
														$rtfeldman$elm_css$Svg$Styled$Attributes$fill('currentColor')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Svg$Styled$path,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Svg$Styled$Attributes$fillRule('evenodd'),
																$rtfeldman$elm_css$Svg$Styled$Attributes$d($author$project$View$Pagination$next),
																$rtfeldman$elm_css$Svg$Styled$Attributes$clipRule('evenodd')
															]),
														_List_Nil)
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$button,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.a0),
												$rtfeldman$elm_css$Html$Styled$Attributes$disabled(disableRight),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												onChange(totalPages - 1))
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Svg$Styled$svg,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$View$Pagination$styles.bk),
														$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 20 20'),
														$rtfeldman$elm_css$Svg$Styled$Attributes$fill('currentColor')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Svg$Styled$path,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Svg$Styled$Attributes$fillRule('evenodd'),
																$rtfeldman$elm_css$Svg$Styled$Attributes$d($author$project$View$Pagination$moveEnd),
																$rtfeldman$elm_css$Svg$Styled$Attributes$clipRule('evenodd')
															]),
														_List_Nil)
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Page$AdminList$tableData = function (model) {
	var _v0 = model;
	var status = _v0.cQ;
	var offset = _v0.fo;
	var limit = _v0.eV;
	var total = _v0.iR;
	switch (status.$) {
		case 4:
			var data = status.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dI)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.hJ)
							]),
						_List_fromArray(
							[
								A2($author$project$Page$AdminList$table, model, data)
							])),
						$author$project$View$Pagination$view(
						{
							eV: limit,
							fo: offset,
							bZ: A2($elm$core$Basics$composeL, $author$project$Page$AdminList$toAppMsg, $author$project$Type$AdminList$OnChangeOffset),
							iR: total
						})
					]));
		case 2:
			var error = status.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$AdminList$errorCodeString, error))
					]));
		default:
			return $author$project$View$Loading$view;
	}
};
var $author$project$Page$AdminList$view = F2(
	function (_v0, authState) {
		var _v1 = authState.h1;
		var adminList = _v1.gQ;
		var profile = _v1.fD;
		var role = $author$project$Data$Role$getRole(profile.fD);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.dI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.cV)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.hu)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Admins')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AdminList$styles.dg)
						]),
					_List_fromArray(
						[
							A2($author$project$Page$AdminList$searchArea, role, adminList),
							$author$project$Page$AdminList$tableData(adminList)
						]))
				]));
	});
var $author$project$Type$AuditLog$OnCancelExport = {$: 17};
var $author$project$Api$AuditLogExport$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Cannot export';
		default:
			return 'Missing error code';
	}
};
var $author$project$Tailwind$Utilities$inline = A2($rtfeldman$elm_css$Css$property, 'display', 'inline');
var $rtfeldman$elm_css$Css$marginLeft = $rtfeldman$elm_css$Css$prop1('margin-left');
var $rtfeldman$elm_css$Css$marginTop = $rtfeldman$elm_css$Css$prop1('margin-top');
var $author$project$Tailwind$Utilities$mb_1_dot_5 = A2($rtfeldman$elm_css$Css$property, 'margin-bottom', '0.375rem');
var $author$project$Tailwind$Utilities$mb_3 = A2($rtfeldman$elm_css$Css$property, 'margin-bottom', '0.75rem');
var $author$project$Tailwind$Utilities$ml_1_dot_5 = A2($rtfeldman$elm_css$Css$property, 'margin-left', '0.375rem');
var $author$project$Tailwind$Utilities$mr_3 = A2($rtfeldman$elm_css$Css$property, 'margin-right', '0.75rem');
var $rtfeldman$elm_css$Css$PercentageUnits = 0;
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var $author$project$Tailwind$Utilities$text_red_700 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-text-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(185, 28, 28, var(--tw-text-opacity))')
		]));
var $author$project$Page$AuditLog$styles = {
	dg: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$px_2,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$flex_col,
			$author$project$Tailwind$Utilities$flex_grow,
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6]))
		]),
	cm: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$px_3,
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(7),
			$rtfeldman$elm_css$Css$px(12))
		]),
	dq: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(28))
		]),
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_gray_100, $author$project$Tailwind$Utilities$h_screen, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col]),
	bH: _List_fromArray(
		[$author$project$Tailwind$Utilities$block, $author$project$Tailwind$Utilities$text_left, $author$project$Tailwind$Utilities$mb_2, $author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_red_700]),
	ec: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(28)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10))
		]),
	eh: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$flex_wrap
		]),
	hB: _List_fromArray(
		[$author$project$Tailwind$Utilities$mb_1_dot_5]),
	hH: _List_fromArray(
		[$author$project$Tailwind$Utilities$block, $author$project$Tailwind$Utilities$text_left, $author$project$Tailwind$Utilities$mb_2, $author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_700]),
	cI: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(400))
		]),
	h6: _List_fromArray(
		[$author$project$Tailwind$Utilities$inline, $author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900]),
	cJ: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$leading_6, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900]),
	cK: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$mt_3,
			$author$project$Tailwind$Utilities$text_center,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_5]))
		]),
	h7: _List_fromArray(
		[$author$project$Tailwind$Utilities$inline, $author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_700, $author$project$Tailwind$Utilities$ml_1_dot_5]),
	fV: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_60, $author$project$Tailwind$Utilities$mr_3]),
	fY: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(200)),
			$author$project$Tailwind$Utilities$mb_3,
			$author$project$Tailwind$Utilities$mr_3
		]),
	cV: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$max_w_7xl,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_4,
			$author$project$Tailwind$Breakpoints$md(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6])),
			$author$project$Tailwind$Utilities$text_left
		])
};
var $author$project$Page$AuditLog$exportLoading = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.cI)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.cK)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.cJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Exporting Audit Trail...')
						]))
				])),
			$author$project$View$Loading$view
		]));
var $author$project$Type$AuditLog$OnAutocompleteClose = {$: 20};
var $author$project$Type$AuditLog$OnAutocompleteSelect = {$: 19};
var $author$project$Type$AuditLog$OnChangeAdmin = function (a) {
	return {$: 5, a: a};
};
var $author$project$Type$AuditLog$OnChangeEndTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Type$AuditLog$OnChangeRole = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$AuditLog$OnChangeSearch = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$AuditLog$OnChangeStartTime = function (a) {
	return {$: 6, a: a};
};
var $author$project$Type$AuditLog$OnChangeSuperAdmin = function (a) {
	return {$: 4, a: a};
};
var $author$project$Type$AuditLog$OnExport = {$: 15};
var $author$project$Type$AuditLog$OnSubmit = {$: 13};
var $author$project$Data$AuditLog$roleStrings = _List_fromArray(
	['Anonymous', 'Admin', 'SuperAdmin']);
var $author$project$Page$AuditLog$toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAuditLog);
var $futureworkz$elm_autocomplete$Internal$OnMouseDown = function (a) {
	return {$: 4, a: a};
};
var $futureworkz$elm_autocomplete$Internal$OnMouseUp = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$onMouseDown = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'mousedown',
		$elm$json$Json$Decode$succeed(msg));
};
var $rtfeldman$elm_css$Html$Styled$Events$onMouseUp = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'mouseup',
		$elm$json$Json$Decode$succeed(msg));
};
var $futureworkz$elm_autocomplete$Autocomplete$Styled$choiceEvents = F2(
	function (mapper, index) {
		var _v0 = mapper;
		var onSelect = _v0.hZ;
		var mapHtml = _v0.hP;
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Events$onMouseDown(
				mapHtml(
					$futureworkz$elm_autocomplete$Internal$OnMouseDown(index))),
				$rtfeldman$elm_css$Html$Styled$Events$onMouseUp(
				mapHtml(
					$futureworkz$elm_autocomplete$Internal$OnMouseUp(index))),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(onSelect)
			]);
	});
var $futureworkz$elm_autocomplete$Internal$OnInput = function (a) {
	return {$: 0, a: a};
};
var $futureworkz$elm_autocomplete$Internal$ArrowDown = 1;
var $futureworkz$elm_autocomplete$Internal$ArrowUp = 0;
var $futureworkz$elm_autocomplete$Internal$OnKeyDown = function (a) {
	return {$: 3, a: a};
};
var $futureworkz$elm_autocomplete$Autocomplete$Styled$onKeyDownDecoder = function (mapper) {
	var _v0 = mapper;
	var onSelect = _v0.hZ;
	var mapHtml = _v0.hP;
	return A2(
		$elm$json$Json$Decode$andThen,
		function (s) {
			switch (s) {
				case 'ArrowUp':
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(
							mapHtml(
								$futureworkz$elm_autocomplete$Internal$OnKeyDown(0)),
							true));
				case 'ArrowDown':
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(
							mapHtml(
								$futureworkz$elm_autocomplete$Internal$OnKeyDown(1)),
							true));
				case 'Enter':
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(onSelect, true));
				default:
					return $elm$json$Json$Decode$fail('Ignore other keys');
			}
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
};
var $futureworkz$elm_autocomplete$Autocomplete$Styled$inputEvents = function (mapper) {
	var _v0 = mapper;
	var mapHtml = _v0.hP;
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Events$onInput(
			A2($elm$core$Basics$composeL, mapHtml, $futureworkz$elm_autocomplete$Internal$OnInput)),
			A2(
			$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
			'keydown',
			$futureworkz$elm_autocomplete$Autocomplete$Styled$onKeyDownDecoder(mapper))
		]);
};
var $futureworkz$elm_autocomplete$Autocomplete$Styled$events = function (mapper) {
	return {
		g6: $futureworkz$elm_autocomplete$Autocomplete$Styled$choiceEvents(mapper),
		hD: $futureworkz$elm_autocomplete$Autocomplete$Styled$inputEvents(mapper)
	};
};
var $rtfeldman$elm_css$Html$Styled$li = $rtfeldman$elm_css$Html$Styled$node('li');
var $futureworkz$elm_autocomplete$Autocomplete$isSelected = F2(
	function (selected, index) {
		if (selected.$ === 1) {
			return false;
		} else {
			var i = selected.a;
			return _Utils_eq(i, index);
		}
	});
var $author$project$Tailwind$Utilities$cursor_default = A2($rtfeldman$elm_css$Css$property, 'cursor', 'default');
var $author$project$Tailwind$Utilities$h_0 = A2($rtfeldman$elm_css$Css$property, 'height', '0px');
var $author$project$Tailwind$Utilities$list_none = A2($rtfeldman$elm_css$Css$property, 'list-style-type', 'none');
var $author$project$Tailwind$Utilities$max_h_60 = A2($rtfeldman$elm_css$Css$property, 'max-height', '15rem');
var $author$project$Tailwind$Utilities$mt_1 = A2($rtfeldman$elm_css$Css$property, 'margin-top', '0.25rem');
var $author$project$Tailwind$Utilities$p_2 = A2($rtfeldman$elm_css$Css$property, 'padding', '0.5rem');
var $author$project$Tailwind$Utilities$shadow_lg = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-shadow', '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', 'var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)')
		]));
var $author$project$Tailwind$Utilities$text_base = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-size', '1rem'),
			A2($rtfeldman$elm_css$Css$property, 'line-height', '1.5rem')
		]));
var $author$project$Tailwind$Utilities$text_black = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-text-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(0, 0, 0, var(--tw-text-opacity))')
		]));
var $author$project$Tailwind$Utilities$truncate = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'overflow', 'hidden'),
			A2($rtfeldman$elm_css$Css$property, 'text-overflow', 'ellipsis'),
			A2($rtfeldman$elm_css$Css$property, 'white-space', 'nowrap')
		]));
var $author$project$Tailwind$Utilities$w_0 = A2($rtfeldman$elm_css$Css$property, 'width', '0px');
var $author$project$Tailwind$Utilities$w_screen = A2($rtfeldman$elm_css$Css$property, 'width', '100vw');
var $author$project$Tailwind$Utilities$z_0 = A2($rtfeldman$elm_css$Css$property, 'z-index', '0');
var $author$project$View$Form$Autocomplete$styles = {
	dA: _List_fromArray(
		[$author$project$Tailwind$Utilities$relative, $author$project$Tailwind$Utilities$w_0, $author$project$Tailwind$Utilities$h_0, $author$project$Tailwind$Utilities$top_0, $author$project$Tailwind$Utilities$left_0, $author$project$Tailwind$Utilities$overflow_visible, $author$project$Tailwind$Utilities$z_0]),
	dE: _List_fromArray(
		[$author$project$Tailwind$Utilities$fixed, $author$project$Tailwind$Utilities$w_screen, $author$project$Tailwind$Utilities$h_screen, $author$project$Tailwind$Utilities$top_0, $author$project$Tailwind$Utilities$left_0]),
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$relative, $author$project$Tailwind$Utilities$z_10]),
	bH: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$text_black,
			$author$project$Tailwind$Utilities$cursor_default,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_white]))
		]),
	ct: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$text_gray_700,
			$author$project$Tailwind$Utilities$cursor_default,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_white]))
		]),
	hC: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$box_border,
			$author$project$Tailwind$Utilities$block,
			$author$project$Tailwind$Utilities$border_solid,
			$author$project$Tailwind$Utilities$w_full,
			$author$project$Tailwind$Utilities$h_9,
			$author$project$Tailwind$Utilities$px_3,
			$author$project$Tailwind$Utilities$py_2,
			$author$project$Tailwind$Utilities$border,
			$author$project$Tailwind$Utilities$border_gray_300,
			$author$project$Tailwind$Utilities$rounded_md,
			$author$project$Tailwind$Utilities$shadow_sm,
			$author$project$Tailwind$Utilities$placeholder_gray_400,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$outline_none, $author$project$Tailwind$Utilities$ring_blue_600, $author$project$Tailwind$Utilities$border_indigo_500])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$text_sm]))
		]),
	a6: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$relative,
			$author$project$Tailwind$Utilities$cursor_pointer,
			$author$project$Tailwind$Utilities$px_2,
			$author$project$Tailwind$Utilities$py_2,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$list_none,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_gray_100]))
		]),
	bj: _List_fromArray(
		[$author$project$Tailwind$Utilities$block, $author$project$Tailwind$Utilities$truncate]),
	br: _List_fromArray(
		[$author$project$Tailwind$Utilities$box_border, $author$project$Tailwind$Utilities$border_solid, $author$project$Tailwind$Utilities$border, $author$project$Tailwind$Utilities$border_gray_300, $author$project$Tailwind$Utilities$absolute, $author$project$Tailwind$Utilities$z_10, $author$project$Tailwind$Utilities$mt_1, $author$project$Tailwind$Utilities$max_h_60, $author$project$Tailwind$Utilities$w_full, $author$project$Tailwind$Utilities$overflow_auto, $author$project$Tailwind$Utilities$rounded_md, $author$project$Tailwind$Utilities$bg_white, $author$project$Tailwind$Utilities$p_2, $author$project$Tailwind$Utilities$text_base, $author$project$Tailwind$Utilities$shadow_lg, $author$project$Tailwind$Utilities$ring_1, $author$project$Tailwind$Utilities$ring_black, $author$project$Tailwind$Utilities$ring_opacity_5]),
	gJ: _List_fromArray(
		[$author$project$Tailwind$Utilities$relative, $author$project$Tailwind$Utilities$mt_1])
};
var $author$project$View$Form$Autocomplete$renderChoice = F5(
	function (events, toItemLabel, selectedIndex, index, item) {
		var active_css = A2($futureworkz$elm_autocomplete$Autocomplete$isSelected, selectedIndex, index) ? _List_fromArray(
			[$author$project$Tailwind$Utilities$bg_gray_100]) : _List_Nil;
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_Utils_ap(
				events(index),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap($author$project$View$Form$Autocomplete$styles.a6, active_css))
					])),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$View$Form$Autocomplete$styles.bj, active_css))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							toItemLabel(item))
						]))
				]));
	});
var $rtfeldman$elm_css$Html$Styled$ul = $rtfeldman$elm_css$Html$Styled$node('ul');
var $futureworkz$elm_autocomplete$Autocomplete$viewState = function (_v0) {
	var s = _v0;
	return {bC: s.bC, cw: s.cw, b6: s.b6, ij: s.ij, cQ: s.aT};
};
var $author$project$View$Form$Autocomplete$view = function (_v0) {
	var autocompleteState = _v0.P;
	var toItemLabel = _v0.iP;
	var placeholder = _v0.h4;
	var onSelect = _v0.hZ;
	var onClose = _v0.fp;
	var mapHtml = _v0.hP;
	var _v1 = $futureworkz$elm_autocomplete$Autocomplete$viewState(autocompleteState);
	var query = _v1.b6;
	var choices = _v1.bC;
	var selectedIndex = _v1.ij;
	var status = _v1.cQ;
	var closeView = _Utils_eq(status, $futureworkz$elm_autocomplete$Autocomplete$NotFetched) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Autocomplete$styles.dA),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(onClose)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Autocomplete$styles.dE)
					]),
				_List_Nil)
			]));
	var _v2 = $futureworkz$elm_autocomplete$Autocomplete$Styled$events(
		{hP: mapHtml, hZ: onSelect});
	var inputEvents = _v2.hD;
	var choiceEvents = _v2.g6;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Autocomplete$styles.gJ)
			]),
		_List_fromArray(
			[
				closeView,
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Autocomplete$styles.dI)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_Utils_ap(
							inputEvents,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
									$rtfeldman$elm_css$Html$Styled$Attributes$value(query),
									$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(placeholder),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Autocomplete$styles.hC)
								])),
						_List_Nil),
						function () {
						switch (status.$) {
							case 0:
								return $rtfeldman$elm_css$Html$Styled$text('');
							case 1:
								return A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Autocomplete$styles.br)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$View$Form$Autocomplete$styles.a6, $author$project$View$Form$Autocomplete$styles.ct))
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Autocomplete$styles.bj)
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('Fetching...')
														]))
												]))
										]));
							case 2:
								var s = status.a;
								return A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Autocomplete$styles.br)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$View$Form$Autocomplete$styles.a6, $author$project$View$Form$Autocomplete$styles.bH))
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Autocomplete$styles.bj)
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(s)
														]))
												]))
										]));
							default:
								return $elm$core$List$isEmpty(choices) ? A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Autocomplete$styles.br)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$li,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$View$Form$Autocomplete$styles.a6, $author$project$View$Form$Autocomplete$styles.ct))
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Autocomplete$styles.bj)
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('Not matched')
														]))
												]))
										])) : A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Form$Autocomplete$styles.br)
										]),
									A2(
										$elm$core$List$indexedMap,
										A3($author$project$View$Form$Autocomplete$renderChoice, choiceEvents, toItemLabel, selectedIndex),
										choices));
						}
					}()
					]))
			]));
};
var $author$project$Page$AuditLog$filterArea = F2(
	function (profileRole, _v0) {
		var superAdmins = _v0.iz;
		var autocompleteState = _v0.P;
		var search = _v0.fU;
		var admins = _v0.gR;
		var role = _v0.ic;
		var superAdminID = _v0.V;
		var adminID = _v0.N;
		var startTime = _v0.gc;
		var endTime = _v0.d8;
		var superAdminOptions = A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					{d_: false, hH: 'Select Super Admin', i3: ''}
				]),
			A2(
				$elm$core$List$map,
				function (_v9) {
					var value = _v9.i3;
					var label = _v9.hH;
					return {
						d_: false,
						hH: label,
						i3: $elm$core$String$fromInt(value)
					};
				},
				superAdmins));
		var roleOptions = A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					{d_: false, hH: 'Select Role', i3: ''}
				]),
			A2(
				$elm$core$List$map,
				function (roleString) {
					return {d_: false, hH: roleString, i3: roleString};
				},
				$author$project$Data$AuditLog$roleStrings));
		var roleView = function () {
			if (profileRole === 1) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.fY)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Role')
								])),
							$author$project$View$Form$Select$view(
							{
								hY: A2($elm$core$Basics$composeL, $author$project$Page$AuditLog$toAppMsg, $author$project$Type$AuditLog$OnChangeRole),
								h0: roleOptions,
								i4: role
							})
						]));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}();
		var auditLogRole = $author$project$Data$AuditLog$toRole(role.i3);
		var superAdminView = function () {
			var _v5 = _Utils_Tuple2(profileRole, auditLogRole);
			if (((_v5.a === 1) && (!_v5.b.$)) && (_v5.b.a === 2)) {
				var _v6 = _v5.a;
				var _v7 = _v5.b.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.fY)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('SuperAdmin')
								])),
							$author$project$View$Form$Select$view(
							{
								hY: A2($elm$core$Basics$composeL, $author$project$Page$AuditLog$toAppMsg, $author$project$Type$AuditLog$OnChangeSuperAdmin),
								h0: superAdminOptions,
								i4: superAdminID
							})
						]));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}();
		var apiUrlView = $author$project$View$Form$Autocomplete$view(
			{
				P: autocompleteState,
				hP: A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnAuditLog),
					$author$project$Type$AuditLog$OnAutocomplete),
				fp: $author$project$Page$AuditLog$toAppMsg($author$project$Type$AuditLog$OnAutocompleteClose),
				hZ: $author$project$Page$AuditLog$toAppMsg($author$project$Type$AuditLog$OnAutocompleteSelect),
				h4: 'Search for action',
				iP: function (s) {
					return s;
				}
			});
		var adminOptions = A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					{d_: false, hH: 'Select Admin', i3: ''}
				]),
			A2(
				$elm$core$List$map,
				function (_v4) {
					var value = _v4.i3;
					var label = _v4.hH;
					return {
						d_: false,
						hH: label,
						i3: $elm$core$String$fromInt(value)
					};
				},
				admins));
		var adminView_ = A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.fY)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.hH)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Admin')
						])),
					$author$project$View$Form$Select$view(
					{
						hY: A2($elm$core$Basics$composeL, $author$project$Page$AuditLog$toAppMsg, $author$project$Type$AuditLog$OnChangeAdmin),
						h0: adminOptions,
						i4: adminID
					})
				]));
		var adminView = function () {
			if (profileRole === 1) {
				if ((!auditLogRole.$) && (auditLogRole.a === 1)) {
					var _v3 = auditLogRole.a;
					return adminView_;
				} else {
					return $rtfeldman$elm_css$Html$Styled$text('');
				}
			} else {
				return adminView_;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.eh)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.fV)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Data')
								])),
							$author$project$View$Form$Input$view(
							{
								bJ: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: search},
								bL: 'name',
								bP: false,
								bS: '',
								bX: 'search',
								bZ: A2($elm$core$Basics$composeL, $author$project$Page$AuditLog$toAppMsg, $author$project$Type$AuditLog$OnChangeSearch),
								b5: 'Search within Data'
							})
						])),
					roleView,
					superAdminView,
					adminView,
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.fY)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Action')
								])),
							apiUrlView
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.fY)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Start Time')
								])),
							$author$project$View$Form$Input$view(
							{
								bJ: startTime,
								bL: 'date',
								bP: false,
								bS: '',
								bX: 'startTime',
								bZ: A2($elm$core$Basics$composeL, $author$project$Page$AuditLog$toAppMsg, $author$project$Type$AuditLog$OnChangeStartTime),
								b5: ''
							})
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.fY)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('End Time')
								])),
							$author$project$View$Form$Input$view(
							{
								bJ: endTime,
								bL: 'date',
								bP: false,
								bS: '',
								bX: 'endTime',
								bZ: A2($elm$core$Basics$composeL, $author$project$Page$AuditLog$toAppMsg, $author$project$Type$AuditLog$OnChangeEndTime),
								b5: ''
							})
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.dq)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.fz, $author$project$Page$AuditLog$styles.cm)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$AuditLog$toAppMsg($author$project$Type$AuditLog$OnSubmit))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Submit')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.ec)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.fz, $author$project$Page$AuditLog$styles.cm)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$AuditLog$toAppMsg($author$project$Type$AuditLog$OnExport))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Export')
								]))
						]))
				]));
	});
var $author$project$Type$AuditLog$OnChangeOffset = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$AuditLogList$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 2:
			return 'Invalid limit';
		case 3:
			return 'Invalid offset';
		default:
			return 'Missing error code';
	}
};
var $author$project$Data$AuditLog$ApiUrl = function (a) {
	return {$: 4, a: a};
};
var $author$project$Data$AuditLog$CreatedAt = function (a) {
	return {$: 5, a: a};
};
var $author$project$Type$AuditLog$OnChangeOrderBy = function (a) {
	return {$: 9, a: a};
};
var $author$project$Data$AuditLog$Role = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$AuditLog$UserID = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$AuditLog$UserName = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$AuditLog$getOrdering = function (kind) {
	switch (kind.$) {
		case 0:
			var asc = kind.a;
			return asc;
		case 1:
			var asc = kind.a;
			return asc;
		case 2:
			var asc = kind.a;
			return asc;
		case 3:
			var asc = kind.a;
			return asc;
		case 4:
			var asc = kind.a;
			return asc;
		default:
			var asc = kind.a;
			return asc;
	}
};
var $author$project$Data$AuditLog$isSameOrdering = F2(
	function (a, b) {
		var _v0 = _Utils_Tuple2(a, b);
		_v0$6:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						return true;
					} else {
						break _v0$6;
					}
				case 1:
					if (_v0.b.$ === 1) {
						return true;
					} else {
						break _v0$6;
					}
				case 2:
					if (_v0.b.$ === 2) {
						return true;
					} else {
						break _v0$6;
					}
				case 3:
					if (_v0.b.$ === 3) {
						return true;
					} else {
						break _v0$6;
					}
				case 4:
					if (_v0.b.$ === 4) {
						return true;
					} else {
						break _v0$6;
					}
				default:
					if (_v0.b.$ === 5) {
						return true;
					} else {
						break _v0$6;
					}
			}
		}
		return false;
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$title = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('title');
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.cP, posixMinutes) < 0) {
					return posixMinutes + era.fo;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		he: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		ff: month,
		gM: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).he;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).ff;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			'0',
			$elm$core$String$fromInt(time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).gM;
	});
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Ext$Iso8601$toDMYHIS = function (posix) {
	var list = A2(
		$elm$core$String$split,
		' ',
		A3(
			$elm$core$String$replace,
			'Z',
			'',
			A3(
				$elm$core$String$replace,
				'T',
				' ',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(posix))));
	var second = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2(
				$elm$core$String$split,
				'.',
				A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(
						$elm$core$List$reverse(list))))));
	var first = A3(
		$elm$core$List$foldl,
		$elm$core$Basics$append,
		'',
		A2(
			$elm$core$List$intersperse,
			'/',
			A2(
				$elm$core$String$split,
				'-',
				A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(list)))));
	return first + (' ' + second);
};
var $author$project$Page$AuditLog$renderItem = function (_v0) {
	var id = _v0.eu;
	var role = _v0.ic;
	var apiUrl = _v0.c6;
	var apiPayload = _v0.gV;
	var createdAt = _v0.hc;
	var _v1 = function () {
		if (!role.$) {
			var info = role.a;
			return _Utils_Tuple3(info.eR, '', '');
		} else {
			var info = role.a;
			return _Utils_Tuple3(
				info.eR,
				$elm$core$String$fromInt(info.eu),
				info.fg);
		}
	}();
	var roleString = _v1.a;
	var userID = _v1.b;
	var userName = _v1.c;
	return A2(
		$rtfeldman$elm_css$Html$Styled$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$String$fromInt(id))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(roleString)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(userID)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(userName)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(apiUrl)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap($author$project$View$Table$tableStyles.aL, $author$project$View$Table$tableStyles.iG)),
						$rtfeldman$elm_css$Html$Styled$Attributes$title(apiPayload)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(apiPayload)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap($author$project$View$Table$tableStyles.aL, $author$project$View$Table$tableStyles.iH))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Ext$Iso8601$toDMYHIS(createdAt))
					]))
			]));
};
var $author$project$View$Table$renderOrdering = F4(
	function (label, isAsc, isActive, onClick_) {
		var svgImage = isAsc ? 'M19.5 8.25l-7.5 7.5-7.5-7.5' : 'M4.5 15.75l7.5-7.5 7.5 7.5';
		var orderingIcon = isActive ? A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.fr),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(onClick_)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$svg,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$View$Table$tableStyles.fs),
							$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 20 20'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$stroke('currentColor')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Svg$Styled$path,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('round'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$d(svgImage)
								]),
							_List_Nil)
						]))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
		return A2(
			$rtfeldman$elm_css$Html$Styled$th,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap($author$project$View$Table$tableStyles.bn, $author$project$View$Table$tableStyles.go)),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(onClick_)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(label),
					orderingIcon
				]));
	});
var $author$project$Page$AuditLog$table = F2(
	function (orderBy, data) {
		var orderByAsc = $author$project$Data$AuditLog$getOrdering(orderBy);
		return A2(
			$rtfeldman$elm_css$Html$Styled$table,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iA)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$thead,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iO)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							_List_fromArray(
								[
									A4(
									$author$project$View$Table$renderOrdering,
									'ID',
									orderByAsc,
									A2(
										$author$project$Data$AuditLog$isSameOrdering,
										orderBy,
										$author$project$Data$AuditLog$ID(orderByAsc)),
									$author$project$Page$AuditLog$toAppMsg(
										$author$project$Type$AuditLog$OnChangeOrderBy(
											$author$project$Data$AuditLog$ID(!orderByAsc)))),
									A4(
									$author$project$View$Table$renderOrdering,
									'Role',
									orderByAsc,
									A2(
										$author$project$Data$AuditLog$isSameOrdering,
										orderBy,
										$author$project$Data$AuditLog$Role(orderByAsc)),
									$author$project$Page$AuditLog$toAppMsg(
										$author$project$Type$AuditLog$OnChangeOrderBy(
											$author$project$Data$AuditLog$Role(!orderByAsc)))),
									A4(
									$author$project$View$Table$renderOrdering,
									'User ID',
									orderByAsc,
									A2(
										$author$project$Data$AuditLog$isSameOrdering,
										orderBy,
										$author$project$Data$AuditLog$UserID(orderByAsc)),
									$author$project$Page$AuditLog$toAppMsg(
										$author$project$Type$AuditLog$OnChangeOrderBy(
											$author$project$Data$AuditLog$UserID(!orderByAsc)))),
									A4(
									$author$project$View$Table$renderOrdering,
									'User Name',
									orderByAsc,
									A2(
										$author$project$Data$AuditLog$isSameOrdering,
										orderBy,
										$author$project$Data$AuditLog$UserName(orderByAsc)),
									$author$project$Page$AuditLog$toAppMsg(
										$author$project$Type$AuditLog$OnChangeOrderBy(
											$author$project$Data$AuditLog$UserName(!orderByAsc)))),
									A4(
									$author$project$View$Table$renderOrdering,
									'Action',
									orderByAsc,
									A2(
										$author$project$Data$AuditLog$isSameOrdering,
										orderBy,
										$author$project$Data$AuditLog$ApiUrl(orderByAsc)),
									$author$project$Page$AuditLog$toAppMsg(
										$author$project$Type$AuditLog$OnChangeOrderBy(
											$author$project$Data$AuditLog$ApiUrl(!orderByAsc)))),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Data')
										])),
									A4(
									$author$project$View$Table$renderOrdering,
									'Created At',
									orderByAsc,
									A2(
										$author$project$Data$AuditLog$isSameOrdering,
										orderBy,
										$author$project$Data$AuditLog$CreatedAt(orderByAsc)),
									$author$project$Page$AuditLog$toAppMsg(
										$author$project$Type$AuditLog$OnChangeOrderBy(
											$author$project$Data$AuditLog$CreatedAt(!orderByAsc))))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$tbody,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iE)
						]),
					A2($elm$core$List$map, $author$project$Page$AuditLog$renderItem, data))
				]));
	});
var $author$project$Page$AuditLog$tableData = function (_v0) {
	var status = _v0.cQ;
	var offset = _v0.fo;
	var limit = _v0.eV;
	var total = _v0.iR;
	var orderBy = _v0.fr;
	switch (status.$) {
		case 4:
			var data = status.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dI)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.hJ)
							]),
						_List_fromArray(
							[
								A2($author$project$Page$AuditLog$table, orderBy, data)
							])),
						$author$project$View$Pagination$view(
						{
							eV: limit,
							fo: offset,
							bZ: A2($elm$core$Basics$composeL, $author$project$Page$AuditLog$toAppMsg, $author$project$Type$AuditLog$OnChangeOffset),
							iR: total
						})
					]));
		case 2:
			var error = status.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$AuditLogList$errorCodeString, error))
					]));
		default:
			return $author$project$View$Loading$view;
	}
};
var $author$project$Page$AuditLog$view = F2(
	function (_v0, authState) {
		var _v1 = authState.h1;
		var profile = _v1.fD;
		var auditLog = _v1.c7;
		var _v2 = auditLog;
		var _export = _v2.a1;
		var _v3 = function () {
			switch (_export.$) {
				case 2:
					var error = _export.a;
					return _Utils_Tuple2(
						false,
						A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.bH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$AuditLogExport$errorCodeString, error))
								])));
				case 1:
					return _Utils_Tuple2(
						true,
						A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil));
				default:
					return _Utils_Tuple2(
						false,
						A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil));
			}
		}();
		var isExporting = _v3.a;
		var exportError = _v3.b;
		var role = $author$project$Data$Role$getRole(profile.fD);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.dI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.cV)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.hu)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Audit Trail')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AuditLog$styles.dg)
						]),
					_List_fromArray(
						[
							A2($author$project$Page$AuditLog$filterArea, role, auditLog),
							exportError,
							$author$project$Page$AuditLog$tableData(auditLog)
						])),
					$author$project$View$Popup$view(
					{
						dJ: $author$project$Page$AuditLog$exportLoading,
						eK: isExporting,
						fp: $author$project$Page$AuditLog$toAppMsg($author$project$Type$AuditLog$OnCancelExport)
					})
				]));
	});
var $author$project$Api$BotDetail$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid tanent';
		case 2:
			return 'Bot not found';
		default:
			return 'Missing error code';
	}
};
var $author$project$Api$TenantList$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid limit';
		case 2:
			return 'Invalid offset';
		default:
			return 'Missing error code';
	}
};
var $author$project$Type$BotDetail$OnBotTreePopupChange = function (a) {
	return {$: 10, a: a};
};
var $author$project$Type$BotDetail$OnChangeHost = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$BotDetail$OnChangeIsPublished = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$BotDetail$OnChangeLanguageCode = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$BotDetail$OnChangeName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$BotDetail$OnChangeTenant = function (a) {
	return {$: 4, a: a};
};
var $author$project$Type$BotDetail$OnUpdate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Data$Bot$languageCodes = _List_fromArray(
	[
		{d_: false, hH: 'English', i3: 'en'},
		{d_: false, hH: 'Chinese', i3: 'zh'}
	]);
var $author$project$Data$Bot$getLanguageCodeLabel = function (code) {
	var result = A2(
		$elm$core$List$map,
		function (_v1) {
			var label = _v1.hH;
			return label;
		},
		A2(
			$elm$core$List$filter,
			function (_v0) {
				var value = _v0.i3;
				return _Utils_eq(value, code);
			},
			$author$project$Data$Bot$languageCodes));
	var resultString = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(result));
	return resultString + (' (' + (code + ')'));
};
var $author$project$Data$BotTree$getInvalidBranches_ = F2(
	function (branch, result) {
		if (branch.$ === 1) {
			var textBranch = branch.a;
			var updatedResult = $elm$core$List$isEmpty(textBranch.a) ? A2(
				$elm$core$List$append,
				result,
				_List_fromArray(
					[branch])) : result;
			return A3($elm$core$List$foldl, $author$project$Data$BotTree$getInvalidBranches_, updatedResult, textBranch.a);
		} else {
			return result;
		}
	});
var $author$project$Data$BotTree$isValid = function (_v0) {
	var root = _v0;
	return $elm$core$List$isEmpty(
		A3($elm$core$List$foldl, $author$project$Data$BotTree$getInvalidBranches_, _List_Nil, root.a));
};
var $author$project$Page$BotDetail$styles = {
	cj: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col]),
	$7: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_row, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$border_t, $author$project$Tailwind$Utilities$border_solid, $author$project$Tailwind$Utilities$border_b_0, $author$project$Tailwind$Utilities$border_l_0, $author$project$Tailwind$Utilities$border_r_0, $author$project$Tailwind$Utilities$border_gray_200, $author$project$Tailwind$Utilities$pt_8]),
	dI: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$vh(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(10))),
			$author$project$Tailwind$Utilities$overflow_auto
		]),
	ek: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$py_8,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6]))
		]),
	aC: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_row, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$border_t, $author$project$Tailwind$Utilities$border_solid, $author$project$Tailwind$Utilities$border_b_0, $author$project$Tailwind$Utilities$border_l_0, $author$project$Tailwind$Utilities$border_r_0, $author$project$Tailwind$Utilities$border_gray_200, $author$project$Tailwind$Utilities$py_8, $author$project$Tailwind$Utilities$mb_2]),
	hC: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$block,
			$author$project$Tailwind$Utilities$w_full,
			$author$project$Tailwind$Utilities$border_solid,
			$author$project$Tailwind$Utilities$shadow_sm,
			$author$project$Tailwind$Utilities$border_gray_200,
			$author$project$Tailwind$Utilities$rounded_md,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$ring_indigo_500, $author$project$Tailwind$Utilities$border_indigo_500])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$text_sm]))
		]),
	aD: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_4over12, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col, $author$project$Tailwind$Utilities$rounded_md, $author$project$Tailwind$Utilities$shadow_sm, $author$project$Tailwind$Utilities$h_9]),
	hH: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$block,
			$author$project$Tailwind$Utilities$text_left,
			$author$project$Tailwind$Utilities$w_4over12,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$text_gray_700,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_px, $author$project$Tailwind$Utilities$pt_2]))
		]),
	fv: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$py_12,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6])),
			$author$project$Tailwind$Utilities$border_t,
			$author$project$Tailwind$Utilities$border_solid,
			$author$project$Tailwind$Utilities$border_b_0,
			$author$project$Tailwind$Utilities$border_l_0,
			$author$project$Tailwind$Utilities$border_r_0,
			$author$project$Tailwind$Utilities$border_gray_200,
			$author$project$Tailwind$Utilities$pt_8,
			$author$project$Tailwind$Utilities$space_y_6
		]),
	aP: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$leading_6, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900, $author$project$Tailwind$Utilities$m_0, $author$project$Tailwind$Utilities$pb_4]),
	cV: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col, $author$project$Tailwind$Utilities$items_start]),
	iS: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$mt_2]),
	gx: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col]),
	cX: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$text_red_600, $author$project$Tailwind$Utilities$mt_2]),
	cZ: _List_fromArray(
		[$author$project$Tailwind$Utilities$px_4]),
	gF: _List_fromArray(
		[$author$project$Tailwind$Utilities$px_4, $author$project$Tailwind$Utilities$mr_4])
};
var $author$project$Page$BotDetail$toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotDetail);
var $author$project$Type$BotDetail$OnBotTreeExport = function (a) {
	return {$: 11, a: a};
};
var $author$project$Type$BotDetail$OnBotTreeImport = function (a) {
	return {$: 12, a: a};
};
var $author$project$Type$BotDetail$OnBranchFormClose = {$: 27};
var $author$project$Type$BotDetail$OnChangeSearch = function (a) {
	return {$: 16, a: a};
};
var $author$project$Type$BotDetail$OnDeleteBranchClose = {$: 37};
var $author$project$Type$BotDetail$OnRootFormOpen = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Type$BotDetail$OnBranchFormKindChange = function (a) {
	return {$: 29, a: a};
};
var $author$project$Type$BotDetail$OnBranchFormSubmit = function (a) {
	return {$: 30, a: a};
};
var $author$project$Data$BotTree$branchOpions = _List_fromArray(
	[
		{
		d_: false,
		hH: 'Branch',
		i3: $author$project$Data$BotTree$toBranchKindString(1)
	},
		{
		d_: false,
		hH: 'Text',
		i3: $author$project$Data$BotTree$toBranchKindString(0)
	}
	]);
var $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var $rtfeldman$elm_css$Css$alignItems = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignItems',
		'align-items',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$Tailwind$Utilities$bg_transparent = A2($rtfeldman$elm_css$Css$property, 'background-color', 'transparent');
var $author$project$Tailwind$Utilities$col_start_2 = A2($rtfeldman$elm_css$Css$property, 'grid-column-start', '2');
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$flexStart = $rtfeldman$elm_css$Css$prop1('flex-start');
var $author$project$Tailwind$Utilities$h_full = A2($rtfeldman$elm_css$Css$property, 'height', '100%');
var $author$project$Tailwind$Utilities$justify_end = A2($rtfeldman$elm_css$Css$property, 'justify-content', 'flex-end');
var $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1('left');
var $author$project$Tailwind$Utilities$mb_5 = A2($rtfeldman$elm_css$Css$property, 'margin-bottom', '1.25rem');
var $rtfeldman$elm_css$Css$minHeight = $rtfeldman$elm_css$Css$prop1('min-height');
var $author$project$Tailwind$Utilities$ml_12 = A2($rtfeldman$elm_css$Css$property, 'margin-left', '3rem');
var $author$project$Tailwind$Utilities$mt_0 = A2($rtfeldman$elm_css$Css$property, 'margin-top', '0px');
var $author$project$Tailwind$Utilities$mt_10 = A2($rtfeldman$elm_css$Css$property, 'margin-top', '2.5rem');
var $rtfeldman$elm_css$Css$none = {as: 0, de: 0, y: 0, c: 0, l: 0, hw: 0, eA: 0, cz: 0, aG: 0, aj: 0, S: 0, e: 0, d: 0, cC: 0, b3: 0, h5: 0, M: 0, b7: 0, ig: 0, aM: 0, ao: 0, D: 0, iV: 0, iZ: 0, i3: 'none'};
var $author$project$Tailwind$Utilities$origin_top_right = A2($rtfeldman$elm_css$Css$property, 'transform-origin', 'top right');
var $author$project$Tailwind$Utilities$overflow_x_hidden = A2($rtfeldman$elm_css$Css$property, 'overflow-x', 'hidden');
var $rtfeldman$elm_css$Css$Addition = 0;
var $rtfeldman$elm_css$Css$plus = 0;
var $author$project$Tailwind$Utilities$pt_5 = A2($rtfeldman$elm_css$Css$property, 'padding-top', '1.25rem');
var $rtfeldman$elm_css$Css$RemUnits = 0;
var $rtfeldman$elm_css$Css$rem = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'rem');
var $rtfeldman$elm_css$Css$VwUnits = 0;
var $rtfeldman$elm_css$Css$vw = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'vw');
var $author$project$Tailwind$Utilities$w_32 = A2($rtfeldman$elm_css$Css$property, 'width', '8rem');
var $author$project$Page$BotDetail$BotTree$styles = {
	c9: _List_fromArray(
		[$author$project$Tailwind$Utilities$fixed, $author$project$Tailwind$Utilities$z_10, $author$project$Tailwind$Utilities$inset_0, $author$project$Tailwind$Utilities$overflow_y_auto, $author$project$Tailwind$Utilities$overflow_x_hidden]),
	df: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$relative,
			$rtfeldman$elm_css$Css$minWidth(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$vw(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(800))),
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$vw(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(100))),
			$rtfeldman$elm_css$Css$height(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$vh(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(100))),
			$author$project$Tailwind$Utilities$bg_white,
			$author$project$Tailwind$Utilities$rounded_lg,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$pt_5,
			$author$project$Tailwind$Utilities$pb_4,
			$author$project$Tailwind$Utilities$text_left,
			$author$project$Tailwind$Utilities$overflow_hidden,
			$author$project$Tailwind$Utilities$shadow_xl,
			$author$project$Tailwind$Utilities$transform,
			$author$project$Tailwind$Utilities$transition_all
		]),
	dg: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$items_end,
			$author$project$Tailwind$Utilities$justify_center,
			$author$project$Tailwind$Utilities$w_full,
			$author$project$Tailwind$Utilities$h_full,
			$author$project$Tailwind$Utilities$p_4,
			$author$project$Tailwind$Utilities$text_center,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$p_0]))
		]),
	dn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-5))
		]),
	bz: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(800)),
			$author$project$Tailwind$Utilities$truncate
		]),
	ci: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$items_center,
			$author$project$Tailwind$Utilities$cursor_pointer,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart)
		]),
	bA: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$w_full,
			$author$project$Tailwind$Utilities$mt_0,
			$author$project$Tailwind$Utilities$rounded_md,
			$author$project$Tailwind$Utilities$border,
			$author$project$Tailwind$Utilities$border_gray_300,
			$author$project$Tailwind$Utilities$shadow_sm,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_2,
			$author$project$Tailwind$Utilities$bg_white,
			$author$project$Tailwind$Utilities$text_base,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$text_gray_700,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$cursor_pointer,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$outline_none, $author$project$Tailwind$Utilities$ring_2, $author$project$Tailwind$Utilities$ring_offset_2, $author$project$Tailwind$Utilities$ring_indigo_500])),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_gray_50]))
		]),
	du: $author$project$View$Theme$defaultStyles.fz,
	dB: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
			$author$project$Tailwind$Utilities$bg_white,
			$author$project$Tailwind$Utilities$rounded_md,
			$author$project$Tailwind$Utilities$text_gray_400,
			$author$project$Tailwind$Utilities$border_0,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$outline_none, $author$project$Tailwind$Utilities$ring_2, $author$project$Tailwind$Utilities$ring_offset_2, $author$project$Tailwind$Utilities$ring_indigo_500])),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$text_gray_500]))
		]),
	dD: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
			$author$project$Tailwind$Utilities$hidden,
			$author$project$Tailwind$Utilities$absolute,
			$author$project$Tailwind$Utilities$top_0,
			$author$project$Tailwind$Utilities$right_0,
			$author$project$Tailwind$Utilities$pt_4,
			$author$project$Tailwind$Utilities$pr_4,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$block]))
		]),
	dF: _List_fromArray(
		[$author$project$Tailwind$Utilities$h_6, $author$project$Tailwind$Utilities$w_6]),
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$fixed, $author$project$Tailwind$Utilities$inset_0, $author$project$Tailwind$Utilities$bg_gray_500, $author$project$Tailwind$Utilities$bg_opacity_75, $author$project$Tailwind$Utilities$transition_opacity]),
	cn: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$w_full,
			$author$project$Tailwind$Utilities$inline_flex,
			$author$project$Tailwind$Utilities$justify_center,
			$author$project$Tailwind$Utilities$rounded_md,
			$author$project$Tailwind$Utilities$border,
			$author$project$Tailwind$Utilities$border_transparent,
			$author$project$Tailwind$Utilities$shadow_sm,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_2,
			$author$project$Tailwind$Utilities$bg_indigo_600,
			$author$project$Tailwind$Utilities$text_base,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$text_white,
			$author$project$Tailwind$Utilities$cursor_pointer,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$outline_none, $author$project$Tailwind$Utilities$ring_2, $author$project$Tailwind$Utilities$ring_offset_2, $author$project$Tailwind$Utilities$ring_indigo_500])),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_indigo_700])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$col_start_2, $author$project$Tailwind$Utilities$text_sm])),
			$rtfeldman$elm_css$Css$disabled(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$cursor_not_allowed, $author$project$Tailwind$Utilities$opacity_30]))
		]),
	dT: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$w_full,
			$author$project$Tailwind$Utilities$inline_flex,
			$author$project$Tailwind$Utilities$justify_center,
			$author$project$Tailwind$Utilities$rounded_md,
			$author$project$Tailwind$Utilities$border,
			$author$project$Tailwind$Utilities$border_transparent,
			$author$project$Tailwind$Utilities$shadow_sm,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_2,
			$author$project$Tailwind$Utilities$bg_red_600,
			$author$project$Tailwind$Utilities$text_base,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$text_white,
			$author$project$Tailwind$Utilities$cursor_pointer,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$outline_none, $author$project$Tailwind$Utilities$ring_2, $author$project$Tailwind$Utilities$ring_offset_2, $author$project$Tailwind$Utilities$ring_red_500])),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_red_700])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$col_start_2, $author$project$Tailwind$Utilities$text_sm]))
		]),
	dV: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$leading_6, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900]),
	dW: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$mt_3,
			$author$project$Tailwind$Utilities$text_center,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_5]))
		]),
	dY: _List_fromArray(
		[$author$project$Tailwind$Utilities$relative, $author$project$Tailwind$Utilities$z_10]),
	bG: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$inline_flex,
			$author$project$Tailwind$Utilities$justify_center,
			$author$project$Tailwind$Utilities$absolute,
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-11))
		]),
	cp: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$mt_2,
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(600)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(400))
		]),
	d6: _List_fromArray(
		[$author$project$Tailwind$Utilities$ml_12, $author$project$Tailwind$Utilities$text_red_600]),
	ed: _List_fromArray(
		[$author$project$Tailwind$Utilities$mr_4]),
	ew: _List_fromArray(
		[$author$project$Tailwind$Utilities$mr_4]),
	aD: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_full, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col, $author$project$Tailwind$Utilities$rounded_md, $author$project$Tailwind$Utilities$shadow_sm, $author$project$Tailwind$Utilities$h_9, $author$project$Tailwind$Utilities$mt_2]),
	bN: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$items_center,
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-1))
		]),
	hH: _List_fromArray(
		[$author$project$Tailwind$Utilities$block, $author$project$Tailwind$Utilities$text_left, $author$project$Tailwind$Utilities$w_4over12, $author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_700, $author$project$Tailwind$Utilities$mt_px, $author$project$Tailwind$Utilities$pt_8]),
	bR: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$items_center,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart)
		]),
	eU: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-4))
		]),
	hR: _List_fromArray(
		[$author$project$Tailwind$Utilities$ml_2, $author$project$Tailwind$Utilities$text_red_600]),
	bW: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$items_center,
			$rtfeldman$elm_css$Css$minHeight(
			$rtfeldman$elm_css$Css$rem(1.5)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$rem(1.5)),
			$author$project$Tailwind$Utilities$h_6,
			$author$project$Tailwind$Utilities$w_6,
			$author$project$Tailwind$Utilities$ml_2,
			$author$project$Tailwind$Utilities$cursor_pointer
		]),
	I: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$w_32,
			$author$project$Tailwind$Utilities$text_gray_700,
			$author$project$Tailwind$Utilities$block,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_2,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$bg_transparent,
			$author$project$Tailwind$Utilities$border_none,
			$author$project$Tailwind$Utilities$text_left,
			$author$project$Tailwind$Utilities$cursor_pointer,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_gray_200]))
		]),
	b$: _List_fromArray(
		[$author$project$Tailwind$Utilities$py_1]),
	b0: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$origin_top_right,
			$author$project$Tailwind$Utilities$absolute,
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(5)),
			$author$project$Tailwind$Utilities$mt_2,
			$author$project$Tailwind$Utilities$bg_white,
			$author$project$Tailwind$Utilities$ring_1,
			$author$project$Tailwind$Utilities$ring_black,
			$author$project$Tailwind$Utilities$ring_opacity_5,
			$author$project$Tailwind$Utilities$shadow_lg,
			$author$project$Tailwind$Utilities$z_10,
			$author$project$Tailwind$Utilities$rounded_lg,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$outline_none]))
		]),
	b1: _List_fromArray(
		[$author$project$Tailwind$Utilities$relative, $author$project$Tailwind$Utilities$inline_block]),
	cH: _List_fromArray(
		[$author$project$Tailwind$Utilities$mt_10, $author$project$Tailwind$Utilities$grid, $author$project$Tailwind$Utilities$grid_cols_2, $author$project$Tailwind$Utilities$gap_3, $author$project$Tailwind$Utilities$grid_flow_row_dense]),
	fP: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-2))
		]),
	fS: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$justify_end]),
	fV: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$w_60,
			$author$project$Tailwind$Utilities$mb_5,
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
		]),
	gw: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$items_end]),
	bp: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$minHeight(
			$rtfeldman$elm_css$Css$rem(2)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$rem(2)),
			$author$project$Tailwind$Utilities$h_8,
			$author$project$Tailwind$Utilities$w_8,
			$author$project$Tailwind$Utilities$mr_2
		]),
	gy: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(60))),
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$plus,
				$rtfeldman$elm_css$Css$px(12))),
			$author$project$Tailwind$Utilities$overflow_auto,
			$author$project$Tailwind$Utilities$mt_5
		]),
	cY: _List_fromArray(
		[$author$project$Tailwind$Utilities$list_none, $author$project$Tailwind$Utilities$my_2]),
	gA: _List_fromArray(
		[$author$project$Tailwind$Utilities$list_none, $author$project$Tailwind$Utilities$p_0, $author$project$Tailwind$Utilities$m_0])
};
var $author$project$Page$BotDetail$BotTree$toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotDetail);
var $author$project$Page$BotDetail$BotTree$botPopup = F2(
	function (model, bot) {
		var _v0 = model;
		var branchForm = _v0.k;
		var _v1 = branchForm;
		var kind = _v1.eR;
		var branch = _v1.a_;
		var path = _v1.h3;
		var _v2 = function () {
			if (branch.$ === 1) {
				return _Utils_Tuple2(false, path);
			} else {
				return _Utils_Tuple2(
					true,
					$elm$core$List$reverse(
						A2(
							$elm$core$List$drop,
							1,
							$elm$core$List$reverse(path))));
			}
		}();
		var isEdit = _v2.a;
		var parentPath = _v2.b;
		var children = A2($author$project$Data$BotTree$getChildren, parentPath, bot.cW);
		var branchOpions = (($elm$core$List$length(path) > 0) && ((($elm$core$List$length(children) === 1) && isEdit) || (!$elm$core$List$length(children)))) ? $author$project$Data$BotTree$branchOpions : A2(
			$elm$core$List$map,
			function (option) {
				return _Utils_eq(kind.i3, option.i3) ? option : _Utils_update(
					option,
					{d_: true});
			},
			$author$project$Data$BotTree$branchOpions);
		var submitable = $author$project$Data$Form$isEmptyFields(
			_List_fromArray(
				[branchForm.hH, kind])) && $author$project$Data$Form$isValidFields(
			_List_fromArray(
				[branchForm.hH, kind]));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.hH)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Kind')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.aD)
										]),
									_List_fromArray(
										[
											$author$project$View$Form$Select$view(
											{
												hY: A2($elm$core$Basics$composeL, $author$project$Page$BotDetail$BotTree$toAppMsg, $author$project$Type$BotDetail$OnBranchFormKindChange),
												h0: branchOpions,
												i4: kind
											})
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Label')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.cp)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id('editorMarkdownBot')
										]),
									_List_Nil),
									$author$project$View$Form$Input$displayValidationError(branchForm.hH.bH)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.cH)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bA),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$BotDetail$BotTree$toAppMsg($author$project$Type$BotDetail$OnBranchFormClose))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Cancel')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.cn),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!submitable),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$BotDetail$BotTree$toAppMsg(
										$author$project$Type$BotDetail$OnBranchFormSubmit(bot)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Save')
								]))
						]))
				]));
	});
var $author$project$Type$BotDetail$OnBranchDelete = function (a) {
	return {$: 31, a: a};
};
var $author$project$Page$BotDetail$BotTree$deletePopup = function (bot) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.dW)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.dV)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Do you want to delete?')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.cH)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bA),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Page$BotDetail$BotTree$toAppMsg($author$project$Type$BotDetail$OnDeleteBranchClose))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Cancel')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.dT),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Page$BotDetail$BotTree$toAppMsg(
									$author$project$Type$BotDetail$OnBranchDelete(bot)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Delete')
							]))
					]))
			]));
};
var $author$project$Tailwind$Utilities$font_bold = A2($rtfeldman$elm_css$Css$property, 'font-weight', '700');
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode = $rtfeldman$elm_css$VirtualDom$Styled$Unstyled;
var $rtfeldman$elm_css$Css$Global$global = function (snippets) {
	return $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode(
		A3(
			$elm$virtual_dom$VirtualDom$node,
			'span',
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'display: none;'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'class', 'elm-css-style-wrapper')
				]),
			$elm$core$List$singleton(
				A3(
					$elm$virtual_dom$VirtualDom$node,
					'style',
					_List_Nil,
					$elm$core$List$singleton(
						$elm$virtual_dom$VirtualDom$text(
							$rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
								$rtfeldman$elm_css$Css$Preprocess$stylesheet(snippets))))))));
};
var $author$project$Tailwind$Utilities$list_decimal = A2($rtfeldman$elm_css$Css$property, 'list-style-type', 'decimal');
var $author$project$Tailwind$Utilities$list_disc = A2($rtfeldman$elm_css$Css$property, 'list-style-type', 'disc');
var $author$project$Tailwind$Utilities$m_2 = A2($rtfeldman$elm_css$Css$property, 'margin', '0.5rem');
var $author$project$Tailwind$Utilities$m_4 = A2($rtfeldman$elm_css$Css$property, 'margin', '1rem');
var $author$project$Tailwind$Utilities$mb_0 = A2($rtfeldman$elm_css$Css$property, 'margin-bottom', '0px');
var $author$project$Tailwind$Utilities$ml_0 = A2($rtfeldman$elm_css$Css$property, 'margin-left', '0px');
var $author$project$Tailwind$Utilities$ml_8 = A2($rtfeldman$elm_css$Css$property, 'margin-left', '2rem');
var $author$project$Tailwind$Utilities$text_xl = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-size', '1.25rem'),
			A2($rtfeldman$elm_css$Css$property, 'line-height', '1.75rem')
		]));
var $author$project$Ext$Markdown$markdownStyles = $rtfeldman$elm_css$Css$Global$global(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Global$selector,
			'.markdownContainer p',
			_List_fromArray(
				[$author$project$Tailwind$Utilities$m_0, $author$project$Tailwind$Utilities$mb_2])),
			A2(
			$rtfeldman$elm_css$Css$Global$selector,
			'.markdownContainer p:only-child',
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mb_0])),
			A2($rtfeldman$elm_css$Css$Global$selector, '.markdownContainer a', _List_Nil),
			A2(
			$rtfeldman$elm_css$Css$Global$selector,
			'.markdownContainer h1',
			_List_fromArray(
				[$author$project$Tailwind$Utilities$font_bold, $author$project$Tailwind$Utilities$m_2, $author$project$Tailwind$Utilities$ml_0, $author$project$Tailwind$Utilities$text_xl])),
			A2(
			$rtfeldman$elm_css$Css$Global$selector,
			'.markdownContainer h2',
			_List_fromArray(
				[$author$project$Tailwind$Utilities$font_bold, $author$project$Tailwind$Utilities$m_2, $author$project$Tailwind$Utilities$ml_0, $author$project$Tailwind$Utilities$text_xl])),
			A2(
			$rtfeldman$elm_css$Css$Global$selector,
			'.markdownContainer h3',
			_List_fromArray(
				[$author$project$Tailwind$Utilities$font_bold, $author$project$Tailwind$Utilities$m_2, $author$project$Tailwind$Utilities$ml_0, $author$project$Tailwind$Utilities$text_xl])),
			A2(
			$rtfeldman$elm_css$Css$Global$selector,
			'.markdownContainer h4',
			_List_fromArray(
				[$author$project$Tailwind$Utilities$font_bold, $author$project$Tailwind$Utilities$m_2, $author$project$Tailwind$Utilities$ml_0, $author$project$Tailwind$Utilities$text_xl])),
			A2(
			$rtfeldman$elm_css$Css$Global$selector,
			'.markdownContainer h5',
			_List_fromArray(
				[$author$project$Tailwind$Utilities$font_bold, $author$project$Tailwind$Utilities$m_2, $author$project$Tailwind$Utilities$ml_0, $author$project$Tailwind$Utilities$text_xl])),
			A2(
			$rtfeldman$elm_css$Css$Global$selector,
			'.markdownContainer h6',
			_List_fromArray(
				[$author$project$Tailwind$Utilities$font_bold, $author$project$Tailwind$Utilities$m_2, $author$project$Tailwind$Utilities$ml_0, $author$project$Tailwind$Utilities$text_xl])),
			A2($rtfeldman$elm_css$Css$Global$selector, '.markdownContainer strong', _List_Nil),
			A2($rtfeldman$elm_css$Css$Global$selector, '.markdownContainer em', _List_Nil),
			A2($rtfeldman$elm_css$Css$Global$selector, '.markdownContainer del', _List_Nil),
			A2(
			$rtfeldman$elm_css$Css$Global$selector,
			'.markdownContainer ul',
			_List_fromArray(
				[$author$project$Tailwind$Utilities$list_disc, $author$project$Tailwind$Utilities$m_4, $author$project$Tailwind$Utilities$ml_8, $author$project$Tailwind$Utilities$p_0])),
			A2($rtfeldman$elm_css$Css$Global$selector, '.markdownContainer ul > li', _List_Nil),
			A2(
			$rtfeldman$elm_css$Css$Global$selector,
			'.markdownContainer ol',
			_List_fromArray(
				[$author$project$Tailwind$Utilities$list_decimal, $author$project$Tailwind$Utilities$m_4, $author$project$Tailwind$Utilities$ml_8, $author$project$Tailwind$Utilities$p_0])),
			A2($rtfeldman$elm_css$Css$Global$selector, '.markdownContainer ol > li', _List_Nil)
		]));
var $author$project$Type$BotDetail$OnRootFormSubmit = function (a) {
	return {$: 23, a: a};
};
var $author$project$Page$BotDetail$BotTree$rootPopup = F2(
	function (model, bot) {
		var _v0 = model;
		var rootForm = _v0.ae;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Label')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.cp)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id('editorMarkdownBot')
										]),
									_List_Nil),
									$author$project$View$Form$Input$displayValidationError(rootForm.hH.bH)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.cH)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bA),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$BotDetail$BotTree$toAppMsg(
										A2($author$project$Type$BotDetail$OnRootFormOpen, false, '')))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Cancel')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.cn),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$BotDetail$BotTree$toAppMsg(
										$author$project$Type$BotDetail$OnRootFormSubmit(bot)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Save')
								]))
						]))
				]));
	});
var $author$project$Type$BotDetail$OnChangeBranchOpen = F3(
	function (a, b, c) {
		return {$: 24, a: a, b: b, c: c};
	});
var $author$project$Page$BotDetail$BotTree$collapseIcon = 'M13 5l7 7-7 7M5 5l7 7-7 7';
var $author$project$Page$BotDetail$BotTree$svgColor = '#6b7280';
var $author$project$Page$BotDetail$BotTree$collapseSvg = function (normalColor) {
	var strokeColor = normalColor ? $author$project$Page$BotDetail$BotTree$svgColor : 'red';
	return A2(
		$rtfeldman$elm_css$Svg$Styled$svg,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bp),
				$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 -1 20 30'),
				$rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('2'),
				$rtfeldman$elm_css$Svg$Styled$Attributes$stroke(strokeColor),
				$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('round'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$d($author$project$Page$BotDetail$BotTree$collapseIcon)
					]),
				_List_Nil)
			]));
};
var $author$project$Page$BotDetail$BotTree$expandIcon = 'M19 13l-7 7-7-7m14-8l-7 7-7-7';
var $author$project$Page$BotDetail$BotTree$expandSvg = function (normalColor) {
	var strokeColor = normalColor ? $author$project$Page$BotDetail$BotTree$svgColor : 'red';
	return A2(
		$rtfeldman$elm_css$Svg$Styled$svg,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bp),
				$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 20 30'),
				$rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('2'),
				$rtfeldman$elm_css$Svg$Styled$Attributes$stroke(strokeColor),
				$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('round'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$d($author$project$Page$BotDetail$BotTree$expandIcon)
					]),
				_List_Nil)
			]));
};
var $author$project$Page$BotDetail$BotTree$lastBranchIcon = 'M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z';
var $author$project$Page$BotDetail$BotTree$lastBranchSvg = A2(
	$rtfeldman$elm_css$Svg$Styled$svg,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bp),
			$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 20 28'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('2'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$stroke($author$project$Page$BotDetail$BotTree$svgColor)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('round'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d($author$project$Page$BotDetail$BotTree$lastBranchIcon)
				]),
			_List_Nil)
		]));
var $author$project$Type$BotDetail$OnBranchCollapseAll = F3(
	function (a, b, c) {
		return {$: 35, a: a, b: b, c: c};
	});
var $author$project$Type$BotDetail$OnBranchExpandAll = F3(
	function (a, b, c) {
		return {$: 34, a: a, b: b, c: c};
	});
var $author$project$Type$BotDetail$OnBranchFormOpen = F3(
	function (a, b, c) {
		return {$: 26, a: a, b: b, c: c};
	});
var $author$project$Type$BotDetail$OnBranchMoveDown = F3(
	function (a, b, c) {
		return {$: 33, a: a, b: b, c: c};
	});
var $author$project$Type$BotDetail$OnBranchMoveUp = F3(
	function (a, b, c) {
		return {$: 32, a: a, b: b, c: c};
	});
var $author$project$Type$BotDetail$OnChangeBranchShowMenu = F3(
	function (a, b, c) {
		return {$: 25, a: a, b: b, c: c};
	});
var $author$project$Type$BotDetail$OnDeleteBranchOpen = F3(
	function (a, b, c) {
		return {$: 36, a: a, b: b, c: c};
	});
var $author$project$Page$BotDetail$BotTree$addIcon = 'M12 4v16m8-8H4';
var $author$project$Page$BotDetail$BotTree$addSvg = A2(
	$rtfeldman$elm_css$Svg$Styled$svg,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bW),
			$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 20 29'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('2'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$stroke($author$project$Page$BotDetail$BotTree$svgColor),
			$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('round'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d($author$project$Page$BotDetail$BotTree$addIcon)
				]),
			_List_Nil)
		]));
var $author$project$Page$BotDetail$BotTree$editIcon = 'M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z';
var $author$project$Page$BotDetail$BotTree$editSvg = A2(
	$rtfeldman$elm_css$Svg$Styled$svg,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bW),
			$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 -1 20 30'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('2'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$stroke($author$project$Page$BotDetail$BotTree$svgColor),
			$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('round'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d($author$project$Page$BotDetail$BotTree$editIcon)
				]),
			_List_Nil)
		]));
var $author$project$Page$BotDetail$BotTree$menuIcon = 'M8 12h.01M12 12h.01M16 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z';
var $author$project$Page$BotDetail$BotTree$menuSvg = A2(
	$rtfeldman$elm_css$Svg$Styled$svg,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bW),
			$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 20 28'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('2'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$stroke($author$project$Page$BotDetail$BotTree$svgColor),
			$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('round'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d($author$project$Page$BotDetail$BotTree$menuIcon)
				]),
			_List_Nil)
		]));
var $author$project$Page$BotDetail$BotTree$options = F4(
	function (reachedMaxNode, path, branch, bot) {
		if (!branch.$) {
			var showMenu = branch.a.h;
			var menu = showMenu ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.b0)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.b$)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.I),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Page$BotDetail$BotTree$toAppMsg(
											A3($author$project$Type$BotDetail$OnBranchMoveUp, path, branch, bot)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Move up')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.I),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Page$BotDetail$BotTree$toAppMsg(
											A3($author$project$Type$BotDetail$OnBranchMoveDown, path, branch, bot)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Move down')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.I),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Page$BotDetail$BotTree$toAppMsg(
											A3($author$project$Type$BotDetail$OnDeleteBranchOpen, path, branch, bot)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Delete')
									]))
							]))
					])) : $rtfeldman$elm_css$Html$Styled$text('');
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bN)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Page$BotDetail$BotTree$toAppMsg(
									A3(
										$author$project$Type$BotDetail$OnBranchFormOpen,
										path,
										$elm$core$Maybe$Just(branch),
										bot)))
							]),
						_List_fromArray(
							[$author$project$Page$BotDetail$BotTree$editSvg])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.b1)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bG),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Page$BotDetail$BotTree$toAppMsg(
											A3($author$project$Type$BotDetail$OnChangeBranchShowMenu, path, branch, bot)))
									]),
								_List_fromArray(
									[$author$project$Page$BotDetail$BotTree$menuSvg])),
								menu
							]))
					]));
		} else {
			var showMenu = branch.a.h;
			var branches = branch.a.a;
			var menu = showMenu ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.b0)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.b$)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.I),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Page$BotDetail$BotTree$toAppMsg(
											A3($author$project$Type$BotDetail$OnBranchMoveUp, path, branch, bot)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Move up')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.I),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Page$BotDetail$BotTree$toAppMsg(
											A3($author$project$Type$BotDetail$OnBranchMoveDown, path, branch, bot)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Move down')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.I),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Page$BotDetail$BotTree$toAppMsg(
											A3($author$project$Type$BotDetail$OnBranchExpandAll, path, branch, bot)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Expand All')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.I),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Page$BotDetail$BotTree$toAppMsg(
											A3($author$project$Type$BotDetail$OnBranchCollapseAll, path, branch, bot)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Collapse All')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.I),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Page$BotDetail$BotTree$toAppMsg(
											A3($author$project$Type$BotDetail$OnDeleteBranchOpen, path, branch, bot)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Delete')
									]))
							]))
					])) : $rtfeldman$elm_css$Html$Styled$text('');
			var emptyChildError = $elm$core$List$isEmpty(branches) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.d6)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text($author$project$Data$Message$messages.h9)
					])) : $rtfeldman$elm_css$Html$Styled$text('');
			var addIconView = reachedMaxNode ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Page$BotDetail$BotTree$toAppMsg(
							A3($author$project$Type$BotDetail$OnBranchFormOpen, path, $elm$core$Maybe$Nothing, bot)))
					]),
				_List_fromArray(
					[$author$project$Page$BotDetail$BotTree$addSvg]));
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bN)
					]),
				_List_fromArray(
					[
						addIconView,
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Page$BotDetail$BotTree$toAppMsg(
									A3(
										$author$project$Type$BotDetail$OnBranchFormOpen,
										path,
										$elm$core$Maybe$Just(branch),
										bot)))
							]),
						_List_fromArray(
							[$author$project$Page$BotDetail$BotTree$editSvg])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.b1)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bG),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Page$BotDetail$BotTree$toAppMsg(
											A3($author$project$Type$BotDetail$OnChangeBranchShowMenu, path, branch, bot)))
									]),
								_List_fromArray(
									[$author$project$Page$BotDetail$BotTree$menuSvg])),
								menu
							])),
						emptyChildError
					]));
		}
	});
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $author$project$Ext$Markdown$defaultOptions = {
	hh: $elm$core$Maybe$Nothing,
	ht: $elm$core$Maybe$Just(
		{g3: false, iD: false}),
	$8: false,
	$9: false
};
var $rtfeldman$elm_css$Html$Styled$fromUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode;
var $elm_explorations$markdown$Markdown$toHtmlWith = _Markdown_toHtml;
var $author$project$Ext$Markdown$toHtml = function (markdown) {
	return $rtfeldman$elm_css$Html$Styled$fromUnstyled(
		A3(
			$elm_explorations$markdown$Markdown$toHtmlWith,
			$author$project$Ext$Markdown$defaultOptions,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('markdownContainer')
				]),
			markdown));
};
var $author$project$Page$BotDetail$BotTree$leafView = F5(
	function (reachedMaxNode, leaf, path, branch, bot) {
		var leaf_ = leaf;
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bR)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bR)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.eU)
										]),
									_List_fromArray(
										[$author$project$Page$BotDetail$BotTree$lastBranchSvg])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bz)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bz)
												]),
											_List_fromArray(
												[
													$author$project$Ext$Markdown$toHtml(leaf_.cT)
												]))
										]))
								])),
							A4($author$project$Page$BotDetail$BotTree$options, reachedMaxNode, path, branch, bot)
						]))
				]));
	});
var $author$project$Page$BotDetail$BotTree$branchView = F6(
	function (reachedMaxNode, model, bot, path, index, branch) {
		var path_ = A2(
			$elm$core$List$append,
			path,
			_List_fromArray(
				[index]));
		if (!branch.$) {
			var lastBranch = branch.a;
			return A5($author$project$Page$BotDetail$BotTree$leafView, reachedMaxNode, lastBranch.bT, path_, branch, bot);
		} else {
			var textBranch = branch.a;
			var showBranchs = textBranch.al ? A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.cY)
					]),
				A2(
					$elm$core$List$indexedMap,
					A4($author$project$Page$BotDetail$BotTree$branchView, reachedMaxNode, model, bot, path_),
					textBranch.a)) : $rtfeldman$elm_css$Html$Styled$text('');
			var branchSvg = textBranch.al ? $author$project$Page$BotDetail$BotTree$expandSvg(textBranch.aR) : $author$project$Page$BotDetail$BotTree$collapseSvg(textBranch.aR);
			return A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.ci)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.ci),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Page$BotDetail$BotTree$toAppMsg(
											A3($author$project$Type$BotDetail$OnChangeBranchOpen, path_, branch, bot)))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.dn)
											]),
										_List_fromArray(
											[branchSvg])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bz)
											]),
										_List_fromArray(
											[
												$author$project$Ext$Markdown$toHtml(textBranch.hH)
											]))
									])),
								A4($author$project$Page$BotDetail$BotTree$options, reachedMaxNode, path_, branch, bot)
							])),
						showBranchs
					]));
		}
	});
var $author$project$Type$BotDetail$OnRootAddChildren = function (a) {
	return {$: 20, a: a};
};
var $author$project$Type$BotDetail$OnRootCollapseAll = function (a) {
	return {$: 19, a: a};
};
var $author$project$Type$BotDetail$OnRootExpandAll = function (a) {
	return {$: 18, a: a};
};
var $author$project$Type$BotDetail$OnRootShowMenu = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$BotDetail$BotTree$rootOptions = F3(
	function (reachedMaxNode, label, bot) {
		var menu = function () {
			var _v0 = bot.cW;
			var root = _v0;
			return root.h ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.b0)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.b$)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.I),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Page$BotDetail$BotTree$toAppMsg(
											$author$project$Type$BotDetail$OnRootExpandAll(bot)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Expand All')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.I),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Page$BotDetail$BotTree$toAppMsg(
											$author$project$Type$BotDetail$OnRootCollapseAll(bot)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Collapse All')
									]))
							]))
					])) : $rtfeldman$elm_css$Html$Styled$text('');
		}();
		var menuIconView = A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.b1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bG),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Page$BotDetail$BotTree$toAppMsg(
								$author$project$Type$BotDetail$OnRootShowMenu(bot)))
						]),
					_List_fromArray(
						[$author$project$Page$BotDetail$BotTree$menuSvg])),
					menu
				]));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bN)
				]),
			reachedMaxNode ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Page$BotDetail$BotTree$toAppMsg(
								A2($author$project$Type$BotDetail$OnRootFormOpen, true, label)))
						]),
					_List_fromArray(
						[$author$project$Page$BotDetail$BotTree$editSvg])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.hR)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text($author$project$Data$Message$messages.hR)
						])),
					menuIconView
				]) : _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Page$BotDetail$BotTree$toAppMsg(
								$author$project$Type$BotDetail$OnRootAddChildren(bot)))
						]),
					_List_fromArray(
						[$author$project$Page$BotDetail$BotTree$addSvg])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Page$BotDetail$BotTree$toAppMsg(
								A2($author$project$Type$BotDetail$OnRootFormOpen, true, label)))
						]),
					_List_fromArray(
						[$author$project$Page$BotDetail$BotTree$editSvg])),
					menuIconView
				]));
	});
var $author$project$Page$BotDetail$BotTree$rootIcon = 'M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z';
var $author$project$Page$BotDetail$BotTree$rootSvg = A2(
	$rtfeldman$elm_css$Svg$Styled$svg,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bp),
			$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 20 28'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('2'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$stroke($author$project$Page$BotDetail$BotTree$svgColor)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('round'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d($author$project$Page$BotDetail$BotTree$rootIcon)
				]),
			_List_Nil)
		]));
var $author$project$Page$BotDetail$BotTree$treeView = F3(
	function (reachedMaxNode, model, bot) {
		var tree = bot.cW;
		var root = tree;
		return A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.gA)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.bR)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.fP)
										]),
									_List_fromArray(
										[$author$project$Page$BotDetail$BotTree$rootSvg])),
									$author$project$Ext$Markdown$toHtml(root.hH),
									A3($author$project$Page$BotDetail$BotTree$rootOptions, reachedMaxNode, root.hH, bot)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.cY)
								]),
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (index, branch) {
										return A6($author$project$Page$BotDetail$BotTree$branchView, reachedMaxNode, model, bot, _List_Nil, index, branch);
									}),
								root.a))
						]))
				]));
	});
var $author$project$Page$BotDetail$BotTree$view = F4(
	function (reachedMaxNode, validTree, bot, model) {
		var _v0 = model;
		var search = _v0.fU;
		var branchForm = _v0.k;
		var rootForm = _v0.ae;
		var _v1 = model;
		var openBotTreePopup = _v1.cE;
		var _v2 = branchForm;
		var open = _v2.al;
		return openBotTreePopup ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.dY)
				]),
			_List_fromArray(
				[
					$author$project$Ext$Markdown$markdownStyles,
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.dI)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.c9)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.dg)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.df)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.fS)
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.gw)
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$button,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css(
																	_Utils_ap($author$project$View$Theme$defaultStyles.dt, $author$project$Page$BotDetail$BotTree$styles.ed)),
																	$rtfeldman$elm_css$Html$Styled$Events$onClick(
																	$author$project$Page$BotDetail$BotTree$toAppMsg(
																		$author$project$Type$BotDetail$OnBotTreeExport(bot))),
																	$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!validTree)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Export')
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$button,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css(
																	_Utils_ap($author$project$View$Theme$defaultStyles.co, $author$project$Page$BotDetail$BotTree$styles.ew)),
																	$rtfeldman$elm_css$Html$Styled$Events$onClick(
																	$author$project$Page$BotDetail$BotTree$toAppMsg(
																		$author$project$Type$BotDetail$OnBotTreeImport(bot)))
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Import')
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$button,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.du),
																	$rtfeldman$elm_css$Html$Styled$Events$onClick(
																	$author$project$Page$BotDetail$BotTree$toAppMsg(
																		$author$project$Type$BotDetail$OnBotTreePopupChange(false)))
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Close')
																]))
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.dD)
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$button,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.dB),
															$rtfeldman$elm_css$Html$Styled$Events$onClick(
															$author$project$Page$BotDetail$BotTree$toAppMsg(
																$author$project$Type$BotDetail$OnBotTreePopupChange(false)))
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Svg$Styled$svg,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.dF),
																	$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none'),
																	$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24'),
																	$rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('2'),
																	$rtfeldman$elm_css$Svg$Styled$Attributes$stroke('currentColor')
																]),
															_List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Svg$Styled$path,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
																			$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('round'),
																			$rtfeldman$elm_css$Svg$Styled$Attributes$d('M6 18L18 6M6 6l12 12')
																		]),
																	_List_Nil)
																]))
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.fV)
												]),
											_List_fromArray(
												[
													$author$project$View$Form$Input$view(
													{
														bJ: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: search},
														bL: 'text',
														bP: false,
														bS: '',
														bX: 'search',
														bZ: A2($elm$core$Basics$composeL, $author$project$Page$BotDetail$BotTree$toAppMsg, $author$project$Type$BotDetail$OnChangeSearch),
														b5: 'Search'
													})
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$BotTree$styles.gy)
												]),
											_List_fromArray(
												[
													A3($author$project$Page$BotDetail$BotTree$treeView, reachedMaxNode, model, bot)
												]))
										]))
								]))
						])),
					$author$project$View$Popup$view(
					{
						dJ: A2($author$project$Page$BotDetail$BotTree$botPopup, model, bot),
						eK: open,
						fp: $author$project$Page$BotDetail$BotTree$toAppMsg($author$project$Type$BotDetail$OnBranchFormClose)
					}),
					$author$project$View$Popup$view(
					{
						dJ: A2($author$project$Page$BotDetail$BotTree$rootPopup, model, bot),
						eK: rootForm.al,
						fp: $author$project$Page$BotDetail$BotTree$toAppMsg(
							A2($author$project$Type$BotDetail$OnRootFormOpen, false, ''))
					}),
					$author$project$View$Popup$view(
					{
						dJ: $author$project$Page$BotDetail$BotTree$deletePopup(bot),
						eK: branchForm.b_,
						fp: $author$project$Page$BotDetail$BotTree$toAppMsg($author$project$Type$BotDetail$OnDeleteBranchClose)
					})
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Page$BotDetail$fieldsView = F4(
	function (tenants, bot, model, authState) {
		var validTree = $author$project$Data$BotTree$isValid(bot.cW);
		var unSaveMessage = bot.eI ? A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.cX)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Bot Responses is changed. Please save it.')
				])) : $rtfeldman$elm_css$Html$Styled$text('');
		var treeError = validTree ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.cX)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Invalid bot responses.')
				]));
		var totalBranches = A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.iS)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					'Total Responses: ' + $elm$core$String$fromInt(
						$author$project$Data$BotTree$getBranchCount(bot.cW)))
				]));
		var tenantOptions = A2(
			$elm$core$List$map,
			function (tenant) {
				return {
					d_: false,
					hH: tenant.fg,
					i3: $elm$core$String$fromInt(tenant.eu)
				};
			},
			tenants);
		var maxNodes = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.e1;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v3) {
							var id = _v3.eu;
							return _Utils_eq(
								$elm$core$String$fromInt(id),
								model.gm.i3);
						},
						tenants))));
		var isPublishedOptions = _List_fromArray(
			[
				{
				d_: false,
				hH: 'Yes',
				i3: $author$project$Data$Form$boolToString(true)
			},
				{
				d_: false,
				hH: 'No',
				i3: $author$project$Data$Form$boolToString(false)
			}
			]);
		var allNodes = $author$project$Data$BotTree$getBranchCount(bot.cW);
		var _v0 = authState.h1;
		var profile = _v0.fD;
		var role = $author$project$Data$Role$getRole(profile.fD);
		var _v1 = model;
		var languageCode = _v1.eT;
		var isPublished = _v1.eJ;
		var tenantID = _v1.gm;
		var formStatus = _v1.J;
		var host = _v1.et;
		var name = _v1.fg;
		var submitable = $author$project$Data$Form$isValidFields(
			_List_fromArray(
				[languageCode, name, isPublished, tenantID])) && ((1 !== formStatus) && (validTree && (_Utils_cmp(maxNodes, allNodes) > -1)));
		var tenantView = function () {
			if (role === 1) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.aC)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Tenant')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.aD)
								]),
							_List_fromArray(
								[
									$author$project$View$Form$Select$view(
									{
										hY: A2($elm$core$Basics$composeL, $author$project$Page$BotDetail$toAppMsg, $author$project$Type$BotDetail$OnChangeTenant),
										h0: tenantOptions,
										i4: tenantID
									})
								]))
						]));
			} else {
				return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.ek)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.cV)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.aP)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									'Edit Bot: ' + $author$project$Data$Bot$getLanguageCodeLabel(bot.eT))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.aC)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Name')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.aD)
								]),
							_List_fromArray(
								[
									$author$project$View$Form$Input$view(
									{
										bJ: name,
										bL: 'text',
										bP: true,
										bS: '',
										bX: 'name',
										bZ: A2($elm$core$Basics$composeL, $author$project$Page$BotDetail$toAppMsg, $author$project$Type$BotDetail$OnChangeName),
										b5: 'Name'
									})
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.aC)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Host')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.aD)
								]),
							_List_fromArray(
								[
									$author$project$View$Form$Input$view(
									{
										bJ: host,
										bL: 'text',
										bP: true,
										bS: '',
										bX: 'host',
										bZ: A2($elm$core$Basics$composeL, $author$project$Page$BotDetail$toAppMsg, $author$project$Type$BotDetail$OnChangeHost),
										b5: 'Host'
									})
								]))
						])),
					tenantView,
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.aC)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Language Code')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.aD)
								]),
							_List_fromArray(
								[
									$author$project$View$Form$Select$view(
									{
										hY: A2($elm$core$Basics$composeL, $author$project$Page$BotDetail$toAppMsg, $author$project$Type$BotDetail$OnChangeLanguageCode),
										h0: $author$project$Data$Bot$languageCodes,
										i4: languageCode
									})
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.aC)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Publish')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.aD)
								]),
							_List_fromArray(
								[
									$author$project$View$Form$Select$view(
									{
										hY: A2($elm$core$Basics$composeL, $author$project$Page$BotDetail$toAppMsg, $author$project$Type$BotDetail$OnChangeIsPublished),
										h0: isPublishedOptions,
										i4: isPublished
									})
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.aC)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Bot Responses')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.gx)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap($author$project$View$Theme$defaultStyles.fz, $author$project$Page$BotDetail$styles.gF)),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Page$BotDetail$toAppMsg(
												$author$project$Type$BotDetail$OnBotTreePopupChange(true)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('View')
										])),
									totalBranches,
									treeError
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.$7)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.hH)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.cj)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('submit'),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap($author$project$View$Theme$defaultStyles.fz, $author$project$Page$BotDetail$styles.cZ)),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Page$BotDetail$toAppMsg(
												$author$project$Type$BotDetail$OnUpdate(bot))),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!submitable)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Update')
										])),
									unSaveMessage
								]))
						])),
					A4(
					$author$project$Page$BotDetail$BotTree$view,
					_Utils_cmp(allNodes, maxNodes) > -1,
					validTree,
					bot,
					model)
				]));
	});
var $author$project$Page$BotDetail$formView = F4(
	function (tenants, bot, model, authState) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotDetail$styles.dI)
				]),
			_List_fromArray(
				[
					A4($author$project$Page$BotDetail$fieldsView, tenants, bot, model, authState)
				]));
	});
var $author$project$Page$BotDetail$view = F2(
	function (_v0, authState) {
		var _v1 = authState.h1;
		var botDetail = _v1.g0;
		var _v2 = botDetail;
		var bot = _v2.j;
		var tenants = _v2.iM;
		var _v3 = _Utils_Tuple2(tenants, bot);
		_v3$1:
		while (true) {
			_v3$2:
			while (true) {
				_v3$3:
				while (true) {
					_v3$5:
					while (true) {
						switch (_v3.a.$) {
							case 2:
								var error = _v3.a.a;
								return $author$project$View$Error$view(
									A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$TenantList$errorCodeString, error));
							case 1:
								switch (_v3.b.$) {
									case 2:
										break _v3$1;
									case 1:
										break _v3$2;
									default:
										break _v3$2;
								}
							case 4:
								switch (_v3.b.$) {
									case 2:
										break _v3$1;
									case 1:
										break _v3$3;
									case 4:
										var tenants_ = _v3.a.a;
										var bot_ = _v3.b.a;
										return A4($author$project$Page$BotDetail$formView, tenants_, bot_, botDetail, authState);
									default:
										break _v3$5;
								}
							default:
								switch (_v3.b.$) {
									case 2:
										break _v3$1;
									case 1:
										break _v3$3;
									default:
										break _v3$5;
								}
						}
					}
					return $author$project$View$Loading$view;
				}
				var _v5 = _v3.b;
				return $author$project$View$Loading$view;
			}
			var _v4 = _v3.a;
			return $author$project$View$Loading$view;
		}
		var error = _v3.b.a;
		return $author$project$View$Error$view(
			A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$BotDetail$errorCodeString, error));
	});
var $author$project$Type$BotList$OnChangeCreatePopup = function (a) {
	return {$: 17, a: a};
};
var $author$project$Type$BotList$OnFormChangeHost = function (a) {
	return {$: 20, a: a};
};
var $author$project$Type$BotList$OnFormChangeLanguageCode = function (a) {
	return {$: 18, a: a};
};
var $author$project$Type$BotList$OnFormChangeName = function (a) {
	return {$: 19, a: a};
};
var $author$project$Type$BotList$OnFormChangeTenant = function (a) {
	return {$: 21, a: a};
};
var $author$project$Type$BotList$OnSubmitForm = {$: 22};
var $author$project$Api$BotCreate$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid tenant';
		case 2:
			return 'Invalid node data';
		case 3:
			return 'Invalid language code';
		case 4:
			return 'Bot already exists';
		case 5:
			return 'Invalid host';
		case 6:
			return 'Cannot get current bots';
		case 7:
			return 'Reached the maximum number of bots';
		case 8:
			return 'Tenant not found';
		default:
			return 'Missing error code';
	}
};
var $author$project$Page$BotList$getLanguageCodeOptions = A2(
	$elm$core$List$append,
	_List_fromArray(
		[
			{d_: false, hH: 'Select Language Code', i3: ''}
		]),
	$author$project$Data$Bot$languageCodes);
var $author$project$Page$BotList$getTenantOptions = function (tenants) {
	return A2(
		$elm$core$List$append,
		_List_fromArray(
			[
				{d_: false, hH: 'Select Tenant', i3: ''}
			]),
		A2(
			$elm$core$List$map,
			function (_v0) {
				var value = _v0.i3;
				var label = _v0.hH;
				return {
					d_: false,
					hH: label,
					i3: $elm$core$String$fromInt(value)
				};
			},
			tenants));
};
var $author$project$Tailwind$Utilities$mb_1 = A2($rtfeldman$elm_css$Css$property, 'margin-bottom', '0.25rem');
var $author$project$Page$BotList$styles = {
	c1: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$justify_between, $author$project$Tailwind$Utilities$flex_wrap, $author$project$Tailwind$Utilities$mb_2]),
	ce: _List_fromArray(
		[$author$project$Tailwind$Utilities$no_underline, $author$project$Tailwind$Utilities$text_white, $author$project$Tailwind$Utilities$px_4, $author$project$Tailwind$Utilities$py_2]),
	dg: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$px_2,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$flex_col,
			$author$project$Tailwind$Utilities$flex_grow,
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6]))
		]),
	ch: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_gray_200, $author$project$Tailwind$Utilities$p_4, $author$project$Tailwind$Utilities$rounded_md]),
	bA: _List_fromArray(
		[$author$project$Tailwind$Utilities$mt_3]),
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_gray_100, $author$project$Tailwind$Utilities$h_screen, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col]),
	dR: _List_fromArray(
		[$author$project$Tailwind$Utilities$ml_3]),
	dS: _List_fromArray(
		[$author$project$Tailwind$Utilities$mr_4]),
	dU: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$text_gray_500]),
	bH: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_red_600]),
	eh: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$flex_wrap]),
	a3: _List_fromArray(
		[$author$project$Tailwind$Utilities$mb_1, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col]),
	cv: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_full]),
	eo: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_gray_50]),
	eD: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_full]),
	eE: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$leading_6, $author$project$Tailwind$Utilities$font_bold, $author$project$Tailwind$Utilities$text_gray_900]),
	eF: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$mt_3,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_5]))
		]),
	hH: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_left, $author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_700, $author$project$Tailwind$Utilities$my_2]),
	cH: _List_fromArray(
		[$author$project$Tailwind$Utilities$mt_4, $author$project$Tailwind$Utilities$grid, $author$project$Tailwind$Utilities$grid_cols_2, $author$project$Tailwind$Utilities$gap_3, $author$project$Tailwind$Utilities$grid_flow_row_dense]),
	cI: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(400))
		]),
	cJ: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$leading_6, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900]),
	cK: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$mt_3,
			$author$project$Tailwind$Utilities$text_center,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_5]))
		]),
	fV: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_60, $author$project$Tailwind$Utilities$mr_3]),
	fY: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_60, $author$project$Tailwind$Utilities$py_2, $author$project$Tailwind$Utilities$mr_3]),
	ii: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$absolute,
			$author$project$Tailwind$Utilities$top_0,
			$author$project$Tailwind$Utilities$left_12,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$h_12,
			$author$project$Tailwind$Utilities$z_10,
			$author$project$Tailwind$Utilities$items_center,
			$author$project$Tailwind$Utilities$space_x_3,
			$author$project$Tailwind$Utilities$bg_gray_50,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$left_16]))
		]),
	cV: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$max_w_7xl,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_4,
			$author$project$Tailwind$Breakpoints$md(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6])),
			$author$project$Tailwind$Utilities$text_left
		])
};
var $author$project$Page$BotList$toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotList);
var $author$project$Page$BotList$renderCreateBotPopUp = F2(
	function (model, authState) {
		var _v0 = authState.h1;
		var profile = _v0.fD;
		var role = $author$project$Data$Role$getRole(profile.fD);
		var _v1 = model;
		var tenants = _v1.iM;
		var form = _v1.t;
		var tenantOptions = $author$project$Page$BotList$getTenantOptions(tenants);
		var _v2 = form;
		var languageCode = _v2.eT;
		var name = _v2.fg;
		var host = _v2.et;
		var tenantID = _v2.gm;
		var status = _v2.cQ;
		var errorCode = _v2.cq;
		var showError = function () {
			if (!errorCode.$) {
				var error = errorCode.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.bH)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$BotCreate$errorCodeString, error))
						]));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}();
		var _v3 = function () {
			if (role === 1) {
				return _Utils_Tuple2(
					A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.a3)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.hH)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Tenant')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.cv)
									]),
								_List_fromArray(
									[
										$author$project$View$Form$Select$view(
										{
											hY: A2($elm$core$Basics$composeL, $author$project$Page$BotList$toAppMsg, $author$project$Type$BotList$OnFormChangeTenant),
											h0: tenantOptions,
											i4: tenantID
										})
									]))
							])),
					$author$project$Data$Form$isEmptyFields(
						_List_fromArray(
							[languageCode, tenantID, host, name])) && ($author$project$Data$Form$isValidFields(
						_List_fromArray(
							[languageCode, tenantID, host, name])) && (1 !== status)));
			} else {
				return _Utils_Tuple2(
					A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					$author$project$Data$Form$isEmptyFields(
						_List_fromArray(
							[languageCode, host, name])) && ($author$project$Data$Form$isValidFields(
						_List_fromArray(
							[languageCode, host, name])) && (1 !== status)));
			}
		}();
		var tenantView = _v3.a;
		var submitable = _v3.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.cI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.cK)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.cJ)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Create Bot')
								]))
						])),
					showError,
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.a3)
						]),
					_List_fromArray(
						[
							$author$project$View$Form$Input$view(
							{
								bJ: name,
								bL: 'text',
								bP: true,
								bS: 'Name',
								bX: 'name',
								bZ: A2($elm$core$Basics$composeL, $author$project$Page$BotList$toAppMsg, $author$project$Type$BotList$OnFormChangeName),
								b5: 'Name'
							})
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.a3)
						]),
					_List_fromArray(
						[
							$author$project$View$Form$Input$view(
							{
								bJ: host,
								bL: 'text',
								bP: true,
								bS: 'Host',
								bX: 'host',
								bZ: A2($elm$core$Basics$composeL, $author$project$Page$BotList$toAppMsg, $author$project$Type$BotList$OnFormChangeHost),
								b5: 'Host'
							})
						])),
					tenantView,
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.a3)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Language Code')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.cv)
								]),
							_List_fromArray(
								[
									$author$project$View$Form$Select$view(
									{
										hY: A2($elm$core$Basics$composeL, $author$project$Page$BotList$toAppMsg, $author$project$Type$BotList$OnFormChangeLanguageCode),
										h0: $author$project$Page$BotList$getLanguageCodeOptions,
										i4: languageCode
									})
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.cH)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.dt),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$BotList$toAppMsg(
										$author$project$Type$BotList$OnChangeCreatePopup(false)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Cancel')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.fz),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$BotList$toAppMsg($author$project$Type$BotList$OnSubmitForm)),
									$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!submitable)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Create')
								]))
						]))
				]));
	});
var $author$project$Type$BotList$OnChangeLanguageCode = function (a) {
	return {$: 4, a: a};
};
var $author$project$Type$BotList$OnChangeSearch = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$BotList$OnChangeTenant = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$BotList$OnOpenModal = {$: 7};
var $author$project$Page$BotList$searchArea = F2(
	function (role, _v0) {
		var tenants = _v0.iM;
		var search = _v0.fU;
		var tenantID = _v0.gm;
		var languageCode = _v0.eT;
		var checkedList = _v0.F;
		var tenantOptions = $author$project$Page$BotList$getTenantOptions(tenants);
		var showDelete = ($elm$core$List$length(checkedList) > 0) ? A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.co, $author$project$Page$BotList$styles.dS)),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Page$BotList$toAppMsg($author$project$Type$BotList$OnOpenModal))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.ce),
							$rtfeldman$elm_css$Html$Styled$Attributes$href('#')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Delete All')
						]))
				])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
		var selectView = function () {
			if (role === 1) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.fY)
						]),
					_List_fromArray(
						[
							$author$project$View$Form$Select$view(
							{
								hY: A2($elm$core$Basics$composeL, $author$project$Page$BotList$toAppMsg, $author$project$Type$BotList$OnChangeTenant),
								h0: tenantOptions,
								i4: tenantID
							})
						]));
			} else {
				return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
			}
		}();
		var languageCodeOptions = $author$project$Page$BotList$getLanguageCodeOptions;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.c1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.eh)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.fV)
								]),
							_List_fromArray(
								[
									$author$project$View$Form$Input$view(
									{
										bJ: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: search},
										bL: 'name',
										bP: false,
										bS: '',
										bX: 'search',
										bZ: A2($elm$core$Basics$composeL, $author$project$Page$BotList$toAppMsg, $author$project$Type$BotList$OnChangeSearch),
										b5: 'Search'
									})
								])),
							selectView,
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.fY)
								]),
							_List_fromArray(
								[
									$author$project$View$Form$Select$view(
									{
										hY: A2($elm$core$Basics$composeL, $author$project$Page$BotList$toAppMsg, $author$project$Type$BotList$OnChangeLanguageCode),
										h0: languageCodeOptions,
										i4: languageCode
									})
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							showDelete,
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.fz),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$BotList$toAppMsg(
										$author$project$Type$BotList$OnChangeCreatePopup(true)))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.ce),
											$rtfeldman$elm_css$Html$Styled$Attributes$href('#')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Create Bot')
										]))
								]))
						]))
				]));
	});
var $author$project$Type$BotList$OnChangeOffset = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$BotList$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid limit';
		case 2:
			return 'Invalid offset';
		case 3:
			return 'Cannot get bot';
		default:
			return 'Missing error code';
	}
};
var $author$project$Type$BotList$OnCheckAll = {$: 5};
var $author$project$Type$BotList$OnCloseModal = {$: 8};
var $author$project$Type$BotList$OnSelectDeleteBot = function (a) {
	return {$: 24, a: a};
};
var $author$project$Type$BotList$OnSelectIntegrationBot = function (a) {
	return {$: 25, a: a};
};
var $author$project$Type$BotList$OnDelete = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$BotList$renderDeleteBots = F2(
	function (tenants, bot) {
		var tenantName = A2(
			$elm$core$Maybe$withDefault,
			'...',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.hH;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.i3;
							},
							$elm$core$Basics$eq(bot.gm)),
						tenants))));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.cI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.dU)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('- Tenant: ' + (tenantName + (', Language Code: ' + bot.eT)))
						]))
				]));
	});
var $author$project$Page$BotList$renderDeletePopup = F3(
	function (data, tenants, checkedList) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.cK)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.cJ)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Do you want to delete these Bots?')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Page$BotList$renderDeleteBots(tenants),
						checkedList)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.cH)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.dt),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$BotList$toAppMsg($author$project$Type$BotList$OnCloseModal))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Cancel')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.co),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$BotList$toAppMsg(
										$author$project$Type$BotList$OnDelete(data)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Type$BotList$OnDeleteSingle = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Page$BotList$renderDeleteSinglePopup = F2(
	function (id, data) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.cI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.cK)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.cJ)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Do you want to delete this bot?')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.cH)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.dt),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$BotList$toAppMsg(
										$author$project$Type$BotList$OnSelectDeleteBot(0)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Cancel')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.co),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$BotList$toAppMsg(
										A2($author$project$Type$BotList$OnDeleteSingle, id, data)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Delete')
								]))
						]))
				]));
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Ext$Html$space = '\u00A0';
var $author$project$Ext$Html$tab = $elm$core$String$concat(
	A2($elm$core$List$repeat, 4, $author$project$Ext$Html$space));
var $author$project$Page$BotList$renderIntegrationPopup = function (_v0) {
	var languageCode = _v0.eT;
	var botScriptTag = '<script src=\"' + ($author$project$Env$env.dj + '\" /></script>');
	var botDivTag = '<div id=\"faq-chat-bot\"></div>';
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.eD)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.eF)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.eE)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Bot Integration Instructions')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('To integrate the chatbot into your website, insert the following code at the end of your HTML body tag:')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.ch)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(botDivTag)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(botScriptTag)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('<script>')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text($author$project$Ext$Html$tab + 'faqChatBot.init({')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + 'divElementID: \"faq-chat-bot\", // must match the ID of the div'))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + ('defaultLanguageCode: \"' + (languageCode + '\", // default language for the bot to start in'))))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + 'availableLanguageCodes: [\"en\", \"zh\"], // all available languages for user to select'))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text($author$project$Ext$Html$tab + '});')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('</script>')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('For example,')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.ch)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('<html>')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text($author$project$Ext$Html$tab + '<body>')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + '<!-- ... other html elements ... -->'))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								_Utils_ap(
									$author$project$Ext$Html$tab,
									_Utils_ap($author$project$Ext$Html$tab, botDivTag)))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								_Utils_ap(
									$author$project$Ext$Html$tab,
									_Utils_ap($author$project$Ext$Html$tab, botScriptTag)))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + '<script>'))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + 'faqChatBot.init({')))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + 'divElementID: \"faq-chat-bot\",'))))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + ('defaultLanguageCode: \"' + (languageCode + '\",'))))))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + 'availableLanguageCodes: [\"en\", \"zh\"],'))))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + '});')))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text($author$project$Ext$Html$tab + ($author$project$Ext$Html$tab + '</script>'))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text($author$project$Ext$Html$tab + '</body>')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('</html>')
							]))
					]))
			]));
};
var $author$project$Type$BotList$OnCheck = function (a) {
	return {$: 6, a: a};
};
var $author$project$Data$Bot$getNodeCount_ = F2(
	function (_v0, result) {
		var children = _v0.bB;
		var nodes = children;
		return A3($elm$core$List$foldl, $author$project$Data$Bot$getNodeCount_, result + 1, nodes);
	});
var $author$project$Data$Bot$getNodeCount = function (_v0) {
	var children = _v0.bB;
	var nodes = children;
	return A3($elm$core$List$foldl, $author$project$Data$Bot$getNodeCount_, 0, nodes);
};
var $author$project$Page$BotList$renderItem = F3(
	function (tenants, checkedList, bot) {
		var _v0 = bot;
		var id = _v0.eu;
		var tenantID = _v0.gm;
		var languageCode = _v0.eT;
		var name = _v0.fg;
		var host = _v0.et;
		var isPublished = _v0.eJ;
		var nodeJson = _v0.fl;
		var existedBot = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.eu;
				},
				$elm$core$Basics$eq(id)),
			checkedList);
		var checked = $elm$core$List$length(existedBot) > 0;
		var checkedRowCss = checked ? $rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.eo) : $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil);
		var rowMarker = checked ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.id)
				]),
			_List_Nil) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
		var selectedCss = checked ? $rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap($author$project$View$Table$tableStyles.aL, $author$project$View$Table$tableStyles.il)) : $rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL);
		var tenantName = A2(
			$elm$core$Maybe$withDefault,
			'...',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.hH;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.i3;
							},
							$elm$core$Basics$eq(tenantID)),
						tenants))));
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[checkedRowCss]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dy)
						]),
					_List_fromArray(
						[
							rowMarker,
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dx),
									$rtfeldman$elm_css$Html$Styled$Attributes$checked(checked),
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									function (_v1) {
										return $author$project$Page$BotList$toAppMsg(
											$author$project$Type$BotList$OnCheck(bot));
									})
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[selectedCss]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(id))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(name)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(host)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(
								$author$project$Data$Bot$getNodeCount(nodeJson)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(tenantName)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Data$Bot$getLanguageCodeLabel(languageCode))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Data$Form$boolToString(isPublished))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$View$Table$tableStyles.aL, $author$project$View$Table$tableStyles.iF))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									$author$project$Data$Route$routeUrl.d1(id)),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.hn)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Edit')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.ip)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(' | ')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dR),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$BotList$toAppMsg(
										$author$project$Type$BotList$OnSelectDeleteBot(id)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Delete')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.ip)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(' | ')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.hn),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$BotList$toAppMsg(
										$author$project$Type$BotList$OnSelectIntegrationBot(
											$elm$core$Maybe$Just(bot))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Integration')
								]))
						]))
				]));
	});
var $author$project$Page$BotList$table = F2(
	function (model, data) {
		var _v0 = model;
		var checkedList = _v0.F;
		var isShowModal = _v0.bQ;
		var tenants = _v0.iM;
		var selectedDeleteBot = _v0.bg;
		var selectedIntegrationBot = _v0.fZ;
		var checked = ($elm$core$List$length(checkedList) > 0) && _Utils_eq(
			$elm$core$List$length(checkedList),
			$elm$core$List$length(data));
		var showIntegrationView = function () {
			if (!selectedIntegrationBot.$) {
				var bot = selectedIntegrationBot.a;
				return $author$project$View$Popup$view(
					{
						dJ: $author$project$Page$BotList$renderIntegrationPopup(bot),
						eK: true,
						fp: $author$project$Page$BotList$toAppMsg(
							$author$project$Type$BotList$OnSelectIntegrationBot($elm$core$Maybe$Nothing))
					});
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$table,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iA)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$thead,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iO)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dy)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$input,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dx),
													$rtfeldman$elm_css$Html$Styled$Attributes$checked(checked),
													$rtfeldman$elm_css$Html$Styled$Events$onInput(
													function (_v1) {
														return $author$project$Page$BotList$toAppMsg($author$project$Type$BotList$OnCheckAll);
													})
												]),
											_List_Nil)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('ID')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Name')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Host')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Total Responses')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Tenant')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Language Code')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Published')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Action')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$tbody,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iE)
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Page$BotList$renderItem, tenants, checkedList),
						data)),
					$author$project$View$Popup$view(
					{
						dJ: A3($author$project$Page$BotList$renderDeletePopup, data, tenants, checkedList),
						eK: isShowModal,
						fp: $author$project$Page$BotList$toAppMsg($author$project$Type$BotList$OnCloseModal)
					}),
					$author$project$View$Popup$view(
					{
						dJ: A2($author$project$Page$BotList$renderDeleteSinglePopup, selectedDeleteBot, data),
						eK: !(!selectedDeleteBot),
						fp: $author$project$Page$BotList$toAppMsg(
							$author$project$Type$BotList$OnSelectDeleteBot(0))
					}),
					showIntegrationView
				]));
	});
var $author$project$Page$BotList$tableData = function (model) {
	var _v0 = model;
	var status = _v0.cQ;
	var offset = _v0.fo;
	var limit = _v0.eV;
	var total = _v0.iR;
	switch (status.$) {
		case 4:
			var data = status.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dI)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.hJ)
							]),
						_List_fromArray(
							[
								A2($author$project$Page$BotList$table, model, data)
							])),
						$author$project$View$Pagination$view(
						{
							eV: limit,
							fo: offset,
							bZ: A2($elm$core$Basics$composeL, $author$project$Page$BotList$toAppMsg, $author$project$Type$BotList$OnChangeOffset),
							iR: total
						})
					]));
		case 2:
			var error = status.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$BotList$errorCodeString, error))
					]));
		default:
			return $author$project$View$Loading$view;
	}
};
var $author$project$Page$BotList$view = F2(
	function (_v0, authState) {
		var _v1 = authState.h1;
		var botList = _v1.g1;
		var profile = _v1.fD;
		var role = $author$project$Data$Role$getRole(profile.fD);
		var _v2 = botList;
		var isShowCreate = _v2.cy;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.dI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.cV)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.hu)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Bots')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotList$styles.dg)
						]),
					_List_fromArray(
						[
							A2($author$project$Page$BotList$searchArea, role, botList),
							$author$project$Page$BotList$tableData(botList),
							$author$project$View$Popup$view(
							{
								dJ: A2($author$project$Page$BotList$renderCreateBotPopUp, botList, authState),
								eK: isShowCreate,
								fp: $author$project$Page$BotList$toAppMsg(
									$author$project$Type$BotList$OnChangeCreatePopup(false))
							})
						]))
				]));
	});
var $author$project$Type$BotLog$OnCancelExport = {$: 17};
var $author$project$Api$BotLogExport$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Export fail';
		case 2:
			return 'Cannot get bot';
		default:
			return 'Missing error code';
	}
};
var $author$project$Page$BotLog$styles = {
	dg: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$px_2,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$flex_col,
			$author$project$Tailwind$Utilities$flex_grow,
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6]))
		]),
	cm: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$px_3,
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(7),
			$rtfeldman$elm_css$Css$px(12))
		]),
	dq: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(28))
		]),
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_gray_100, $author$project$Tailwind$Utilities$h_screen, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col]),
	bH: _List_fromArray(
		[$author$project$Tailwind$Utilities$block, $author$project$Tailwind$Utilities$text_left, $author$project$Tailwind$Utilities$mb_2, $author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_red_700]),
	ec: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(28)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10))
		]),
	eh: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$flex_wrap
		]),
	hH: _List_fromArray(
		[$author$project$Tailwind$Utilities$block, $author$project$Tailwind$Utilities$text_left, $author$project$Tailwind$Utilities$mb_2, $author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_700]),
	cI: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(400))
		]),
	cJ: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$leading_6, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900]),
	cK: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$mt_3,
			$author$project$Tailwind$Utilities$text_center,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_5]))
		]),
	fY: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(200)),
			$author$project$Tailwind$Utilities$mb_3,
			$author$project$Tailwind$Utilities$mr_3
		]),
	cV: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$max_w_7xl,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_4,
			$author$project$Tailwind$Breakpoints$md(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6])),
			$author$project$Tailwind$Utilities$text_left
		])
};
var $author$project$Page$BotLog$exportLoading = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.cI)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.cK)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.cJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Exporting Bot Log...')
						]))
				])),
			$author$project$View$Loading$view
		]));
var $author$project$Type$BotLog$Email = 1;
var $author$project$Type$BotLog$OnAutocompleteClose = function (a) {
	return {$: 20, a: a};
};
var $author$project$Type$BotLog$OnAutocompleteSelect = function (a) {
	return {$: 19, a: a};
};
var $author$project$Type$BotLog$OnChangeBotID = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$BotLog$OnChangeEndTime = function (a) {
	return {$: 4, a: a};
};
var $author$project$Type$BotLog$OnChangeLanguageCode = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$BotLog$OnChangeStartTime = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$BotLog$OnChangeTenant = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$BotLog$OnExport = {$: 15};
var $author$project$Type$BotLog$OnSubmit = {$: 14};
var $author$project$Type$BotLog$SessionID = 0;
var $author$project$Page$BotLog$toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotLog);
var $author$project$Page$BotLog$filterArea = F2(
	function (role, _v0) {
		var tenants = _v0.iM;
		var languageCode = _v0.eT;
		var tenantID = _v0.gm;
		var startTime = _v0.gc;
		var endTime = _v0.d8;
		var botID = _v0.di;
		var bots = _v0.g2;
		var sessionIDAutocomplete = _v0.U;
		var emailAutocomplete = _v0.R;
		var tenantOptions = A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					{d_: false, hH: 'Select Tenant', i3: ''}
				]),
			A2(
				$elm$core$List$map,
				function (_v3) {
					var value = _v3.i3;
					var label = _v3.hH;
					return {
						d_: false,
						hH: label,
						i3: $elm$core$String$fromInt(value)
					};
				},
				tenants));
		var tenantView = function () {
			if (role === 1) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.fY)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Tenant')
								])),
							$author$project$View$Form$Select$view(
							{
								hY: A2($elm$core$Basics$composeL, $author$project$Page$BotLog$toAppMsg, $author$project$Type$BotLog$OnChangeTenant),
								h0: tenantOptions,
								i4: tenantID
							})
						]));
			} else {
				return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
			}
		}();
		var sessionIDListView = $author$project$View$Form$Autocomplete$view(
			{
				P: sessionIDAutocomplete,
				hP: A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotLog),
					$author$project$Type$BotLog$OnAutocomplete(0)),
				fp: $author$project$Page$BotLog$toAppMsg(
					$author$project$Type$BotLog$OnAutocompleteClose(0)),
				hZ: $author$project$Page$BotLog$toAppMsg(
					$author$project$Type$BotLog$OnAutocompleteSelect(0)),
				h4: 'Search for session',
				iP: function (s) {
					return s;
				}
			});
		var languageCodeOptions = A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					{d_: false, hH: 'Select Language Code', i3: ''}
				]),
			$author$project$Data$Bot$languageCodes);
		var emailListView = $author$project$View$Form$Autocomplete$view(
			{
				P: emailAutocomplete,
				hP: A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotLog),
					$author$project$Type$BotLog$OnAutocomplete(1)),
				fp: $author$project$Page$BotLog$toAppMsg(
					$author$project$Type$BotLog$OnAutocompleteClose(1)),
				hZ: $author$project$Page$BotLog$toAppMsg(
					$author$project$Type$BotLog$OnAutocompleteSelect(1)),
				h4: 'Search for email',
				iP: function (s) {
					return s;
				}
			});
		var botOptions = A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					{d_: false, hH: 'Select Bot', i3: ''}
				]),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var value = _v1.i3;
					var label = _v1.hH;
					return {
						d_: false,
						hH: label,
						i3: $elm$core$String$fromInt(value)
					};
				},
				bots));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.eh)
				]),
			_List_fromArray(
				[
					tenantView,
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.fY)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Language Code')
								])),
							$author$project$View$Form$Select$view(
							{
								hY: A2($elm$core$Basics$composeL, $author$project$Page$BotLog$toAppMsg, $author$project$Type$BotLog$OnChangeLanguageCode),
								h0: languageCodeOptions,
								i4: languageCode
							})
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.fY)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Bot')
								])),
							$author$project$View$Form$Select$view(
							{
								hY: A2($elm$core$Basics$composeL, $author$project$Page$BotLog$toAppMsg, $author$project$Type$BotLog$OnChangeBotID),
								h0: botOptions,
								i4: botID
							})
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.fY)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Session ID')
								])),
							sessionIDListView
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.fY)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Email')
								])),
							emailListView
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.fY)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Start Time')
								])),
							$author$project$View$Form$Input$view(
							{
								bJ: startTime,
								bL: 'date',
								bP: false,
								bS: '',
								bX: 'startTime',
								bZ: A2($elm$core$Basics$composeL, $author$project$Page$BotLog$toAppMsg, $author$project$Type$BotLog$OnChangeStartTime),
								b5: ''
							})
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.fY)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('End Time')
								])),
							$author$project$View$Form$Input$view(
							{
								bJ: endTime,
								bL: 'date',
								bP: false,
								bS: '',
								bX: 'endTime',
								bZ: A2($elm$core$Basics$composeL, $author$project$Page$BotLog$toAppMsg, $author$project$Type$BotLog$OnChangeEndTime),
								b5: ''
							})
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.dq)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.fz, $author$project$Page$BotLog$styles.cm)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$BotLog$toAppMsg($author$project$Type$BotLog$OnSubmit))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Submit')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.ec)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.fz, $author$project$Page$BotLog$styles.cm)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$BotLog$toAppMsg($author$project$Type$BotLog$OnExport))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Export')
								]))
						]))
				]));
	});
var $author$project$Type$BotLog$OnChangeOffset = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$BotLog$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 2:
			return 'Invalid limit';
		case 3:
			return 'Invalid offset';
		case 4:
			return 'Cannot count bot list';
		default:
			return 'Missing error code';
	}
};
var $author$project$Data$BotLog$BotID = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$BotLog$CreatedAt = function (a) {
	return {$: 4, a: a};
};
var $author$project$Data$BotLog$Kind = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$BotLog$OnChangeOrderBy = function (a) {
	return {$: 6, a: a};
};
var $author$project$Data$BotLog$SessionID = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$BotLog$getOrdering = function (kind) {
	switch (kind.$) {
		case 0:
			var asc = kind.a;
			return asc;
		case 1:
			var asc = kind.a;
			return asc;
		case 2:
			var asc = kind.a;
			return asc;
		case 3:
			var asc = kind.a;
			return asc;
		default:
			var asc = kind.a;
			return asc;
	}
};
var $author$project$Data$BotLog$isSameOrdering = F2(
	function (a, b) {
		var _v0 = _Utils_Tuple2(a, b);
		_v0$5:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						return true;
					} else {
						break _v0$5;
					}
				case 1:
					if (_v0.b.$ === 1) {
						return true;
					} else {
						break _v0$5;
					}
				case 2:
					if (_v0.b.$ === 2) {
						return true;
					} else {
						break _v0$5;
					}
				case 3:
					if (_v0.b.$ === 3) {
						return true;
					} else {
						break _v0$5;
					}
				default:
					if (_v0.b.$ === 4) {
						return true;
					} else {
						break _v0$5;
					}
			}
		}
		return false;
	});
var $author$project$Type$BotLog$OnShowBotSessions = function (a) {
	return {$: 11, a: a};
};
var $author$project$Data$BotLog$getKindStringInfo = function (kind) {
	switch (kind.$) {
		case 0:
			return _Utils_Tuple2('Text', '');
		case 1:
			var data = kind.a;
			return _Utils_Tuple2('Branch', data);
		default:
			var id = kind.a.eu;
			var fields = kind.a.eg;
			return _Utils_Tuple2(
				'Form',
				'ID: ' + (id + (' - ' + ('Fields: ' + A2($elm$json$Json$Encode$encode, 0, fields)))));
	}
};
var $author$project$Page$BotLog$renderItem = F2(
	function (botNames, log) {
		var _v0 = log;
		var id = _v0.eu;
		var botID = _v0.di;
		var sessionID = _v0.f1;
		var kind = _v0.eR;
		var createdAt = _v0.hc;
		var botName = A2(
			$elm$core$Maybe$withDefault,
			'...',
			A2($elm$core$Dict$get, botID, botNames));
		var _v1 = $author$project$Data$BotLog$getKindStringInfo(kind);
		var kind_ = _v1.a;
		var data = _v1.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(id))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(botName)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$View$Table$tableStyles.aL, $author$project$View$Table$tableStyles.iI)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							A3($elm$core$Basics$composeL, $author$project$Page$BotLog$toAppMsg, $author$project$Type$BotLog$OnShowBotSessions, sessionID))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(sessionID)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(kind_)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$View$Table$tableStyles.aL, $author$project$View$Table$tableStyles.iG)),
							$rtfeldman$elm_css$Html$Styled$Attributes$title(data)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(data)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$View$Table$tableStyles.aL, $author$project$View$Table$tableStyles.iH))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Ext$Iso8601$toDMYHIS(createdAt))
						]))
				]));
	});
var $author$project$Page$BotLog$table = F3(
	function (orderBy, botNames, data) {
		var orderByAsc = $author$project$Data$BotLog$getOrdering(orderBy);
		return A2(
			$rtfeldman$elm_css$Html$Styled$table,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iA)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$thead,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iO)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							_List_fromArray(
								[
									A4(
									$author$project$View$Table$renderOrdering,
									'ID',
									orderByAsc,
									A2(
										$author$project$Data$BotLog$isSameOrdering,
										orderBy,
										$author$project$Data$BotLog$ID(orderByAsc)),
									$author$project$Page$BotLog$toAppMsg(
										$author$project$Type$BotLog$OnChangeOrderBy(
											$author$project$Data$BotLog$ID(!orderByAsc)))),
									A4(
									$author$project$View$Table$renderOrdering,
									'Bot ID',
									orderByAsc,
									A2(
										$author$project$Data$BotLog$isSameOrdering,
										orderBy,
										$author$project$Data$BotLog$BotID(orderByAsc)),
									$author$project$Page$BotLog$toAppMsg(
										$author$project$Type$BotLog$OnChangeOrderBy(
											$author$project$Data$BotLog$BotID(!orderByAsc)))),
									A4(
									$author$project$View$Table$renderOrdering,
									'Session ID',
									orderByAsc,
									A2(
										$author$project$Data$BotLog$isSameOrdering,
										orderBy,
										$author$project$Data$BotLog$SessionID(orderByAsc)),
									$author$project$Page$BotLog$toAppMsg(
										$author$project$Type$BotLog$OnChangeOrderBy(
											$author$project$Data$BotLog$SessionID(!orderByAsc)))),
									A4(
									$author$project$View$Table$renderOrdering,
									'Kind',
									orderByAsc,
									A2(
										$author$project$Data$BotLog$isSameOrdering,
										orderBy,
										$author$project$Data$BotLog$Kind(orderByAsc)),
									$author$project$Page$BotLog$toAppMsg(
										$author$project$Type$BotLog$OnChangeOrderBy(
											$author$project$Data$BotLog$Kind(!orderByAsc)))),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Data')
										])),
									A4(
									$author$project$View$Table$renderOrdering,
									'Created At',
									orderByAsc,
									A2(
										$author$project$Data$BotLog$isSameOrdering,
										orderBy,
										$author$project$Data$BotLog$CreatedAt(orderByAsc)),
									$author$project$Page$BotLog$toAppMsg(
										$author$project$Type$BotLog$OnChangeOrderBy(
											$author$project$Data$BotLog$CreatedAt(!orderByAsc))))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$tbody,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iE)
						]),
					A2(
						$elm$core$List$map,
						$author$project$Page$BotLog$renderItem(botNames),
						data))
				]));
	});
var $author$project$Page$BotLog$tableData = function (model) {
	var _v0 = model;
	var status = _v0.cQ;
	var botNames = _v0.cg;
	var offset = _v0.fo;
	var limit = _v0.eV;
	var total = _v0.iR;
	var orderBy = _v0.fr;
	switch (status.$) {
		case 4:
			var data = status.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dI)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.hJ)
							]),
						_List_fromArray(
							[
								A3($author$project$Page$BotLog$table, orderBy, botNames, data)
							])),
						$author$project$View$Pagination$view(
						{
							eV: limit,
							fo: offset,
							bZ: A2($elm$core$Basics$composeL, $author$project$Page$BotLog$toAppMsg, $author$project$Type$BotLog$OnChangeOffset),
							iR: total
						})
					]));
		case 2:
			var error = status.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$BotLog$errorCodeString, error))
					]));
		default:
			return $author$project$View$Loading$view;
	}
};
var $author$project$Type$BotLog$OnCloseBotSessions = {$: 12};
var $author$project$Page$BotLog$BotSessionList$styles = {
	c9: _List_fromArray(
		[$author$project$Tailwind$Utilities$fixed, $author$project$Tailwind$Utilities$z_10, $author$project$Tailwind$Utilities$inset_0, $author$project$Tailwind$Utilities$overflow_y_auto, $author$project$Tailwind$Utilities$overflow_x_hidden]),
	df: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$minWidth(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$vw(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(800))),
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$vw(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(100))),
			$rtfeldman$elm_css$Css$height(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$vh(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(100))),
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$flex_col,
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$author$project$Tailwind$Utilities$bg_white,
			$author$project$Tailwind$Utilities$rounded_lg,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$pt_5,
			$author$project$Tailwind$Utilities$pb_4,
			$author$project$Tailwind$Utilities$text_left,
			$author$project$Tailwind$Utilities$overflow_hidden,
			$author$project$Tailwind$Utilities$shadow_xl,
			$author$project$Tailwind$Utilities$transform,
			$author$project$Tailwind$Utilities$transition_all
		]),
	dg: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$items_end,
			$author$project$Tailwind$Utilities$flex_col,
			$author$project$Tailwind$Utilities$justify_center,
			$author$project$Tailwind$Utilities$h_full,
			$author$project$Tailwind$Utilities$p_4,
			$author$project$Tailwind$Utilities$text_center,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$p_0]))
		]),
	dp: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$items_end]),
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$fixed, $author$project$Tailwind$Utilities$inset_0, $author$project$Tailwind$Utilities$bg_gray_500, $author$project$Tailwind$Utilities$bg_opacity_75, $author$project$Tailwind$Utilities$transition_opacity]),
	dY: _List_fromArray(
		[$author$project$Tailwind$Utilities$relative, $author$project$Tailwind$Utilities$z_10]),
	fS: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$justify_between, $author$project$Tailwind$Utilities$items_center])
};
var $author$project$Api$BotLogSessionList$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Cannot get logs';
		default:
			return 'Missing error code';
	}
};
var $author$project$Page$BotLog$BotSessionList$renderItem = F2(
	function (botNames, log) {
		var _v0 = log;
		var id = _v0.eu;
		var botID = _v0.di;
		var kind = _v0.eR;
		var createdAt = _v0.hc;
		var botName = A2(
			$elm$core$Maybe$withDefault,
			'...',
			A2($elm$core$Dict$get, botID, botNames));
		var _v1 = $author$project$Data$BotLog$getKindStringInfo(kind);
		var kind_ = _v1.a;
		var data = _v1.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(id))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(botName)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(kind_)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(data)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Ext$Iso8601$toDMYHIS(createdAt))
						]))
				]));
	});
var $author$project$Page$BotLog$BotSessionList$table = F2(
	function (botNames, data) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$table,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iA)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$thead,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iO)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('ID')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Bot')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Kind')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Data')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Created At')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$tbody,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iE)
						]),
					A2(
						$elm$core$List$map,
						$author$project$Page$BotLog$BotSessionList$renderItem(botNames),
						data))
				]));
	});
var $author$project$Page$BotLog$BotSessionList$tableData = function (_v0) {
	var botSessions = _v0.aZ;
	var botNames = _v0.cg;
	switch (botSessions.$) {
		case 4:
			var data = botSessions.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dI)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.hJ)
							]),
						_List_fromArray(
							[
								A2($author$project$Page$BotLog$BotSessionList$table, botNames, data)
							]))
					]));
		case 2:
			var error = botSessions.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$BotLogSessionList$errorCodeString, error))
					]));
		default:
			return $author$project$View$Loading$view;
	}
};
var $author$project$Page$BotLog$BotSessionList$toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotLog);
var $author$project$Page$BotLog$BotSessionList$view = function (model) {
	var _v0 = model;
	var showBotSessions = _v0.cO;
	var currentSessionID = _v0.dN;
	return showBotSessions ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$BotSessionList$styles.dY)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$BotSessionList$styles.dI)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$BotSessionList$styles.c9)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$BotSessionList$styles.dg)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$BotSessionList$styles.df)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$BotSessionList$styles.fS)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.hu)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($elm$core$Maybe$withDefault, 'Missing session ID', currentSessionID))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$BotSessionList$styles.dp)
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$button,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
																$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.fz),
																$rtfeldman$elm_css$Html$Styled$Events$onClick(
																$author$project$Page$BotLog$BotSessionList$toAppMsg($author$project$Type$BotLog$OnCloseBotSessions))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('Close')
															]))
													]))
											])),
										$author$project$Page$BotLog$BotSessionList$tableData(model)
									]))
							]))
					]))
			])) : $rtfeldman$elm_css$Html$Styled$text('');
};
var $author$project$Page$BotLog$view = F2(
	function (_v0, authState) {
		var _v1 = authState.h1;
		var profile = _v1.fD;
		var botLog = _v1.dk;
		var _v2 = botLog;
		var _export = _v2.a1;
		var _v3 = function () {
			switch (_export.$) {
				case 2:
					var error = _export.a;
					return _Utils_Tuple2(
						false,
						A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.bH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$BotLogExport$errorCodeString, error))
								])));
				case 1:
					return _Utils_Tuple2(
						true,
						A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil));
				default:
					return _Utils_Tuple2(
						false,
						A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil));
			}
		}();
		var isExporting = _v3.a;
		var exportError = _v3.b;
		var role = $author$project$Data$Role$getRole(profile.fD);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.dI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.cV)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.hu)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Bot Logs')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotLog$styles.dg)
						]),
					_List_fromArray(
						[
							A2($author$project$Page$BotLog$filterArea, role, botLog),
							exportError,
							$author$project$Page$BotLog$tableData(botLog)
						])),
					$author$project$Page$BotLog$BotSessionList$view(botLog),
					$author$project$View$Popup$view(
					{
						dJ: $author$project$Page$BotLog$exportLoading,
						eK: isExporting,
						fp: $author$project$Page$BotLog$toAppMsg($author$project$Type$BotLog$OnCancelExport)
					})
				]));
	});
var $author$project$Type$BotReport$OnCancelExport = {$: 13};
var $author$project$Api$BotReportExport$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Export fail';
		case 2:
			return 'Cannot admin';
		default:
			return 'Missing error code';
	}
};
var $author$project$Tailwind$Utilities$my_10 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'margin-top', '2.5rem'),
			A2($rtfeldman$elm_css$Css$property, 'margin-bottom', '2.5rem')
		]));
var $author$project$Page$BotReport$styles = {
	c1: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$justify_between, $author$project$Tailwind$Utilities$flex_wrap, $author$project$Tailwind$Utilities$mb_2]),
	dg: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$px_2,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$flex_col,
			$author$project$Tailwind$Utilities$flex_grow,
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6]))
		]),
	cm: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$px_3,
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(7),
			$rtfeldman$elm_css$Css$px(12))
		]),
	dq: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(28))
		]),
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_gray_100, $author$project$Tailwind$Utilities$h_screen, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col]),
	bH: _List_fromArray(
		[$author$project$Tailwind$Utilities$block, $author$project$Tailwind$Utilities$text_left, $author$project$Tailwind$Utilities$mb_2, $author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_red_700]),
	ec: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(28)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10))
		]),
	eh: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$flex_wrap
		]),
	ez: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_full, $author$project$Tailwind$Utilities$text_center, $author$project$Tailwind$Utilities$my_10, $author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$text_gray_700]),
	hH: _List_fromArray(
		[$author$project$Tailwind$Utilities$block, $author$project$Tailwind$Utilities$text_left, $author$project$Tailwind$Utilities$mb_2, $author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_700]),
	cI: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(400))
		]),
	cJ: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$leading_6, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900]),
	cK: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$mt_3,
			$author$project$Tailwind$Utilities$text_center,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_5]))
		]),
	fY: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(200)),
			$author$project$Tailwind$Utilities$mb_3,
			$author$project$Tailwind$Utilities$mr_3
		]),
	cV: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$max_w_7xl,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_4,
			$author$project$Tailwind$Breakpoints$md(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6])),
			$author$project$Tailwind$Utilities$text_left
		])
};
var $author$project$Page$BotReport$exportLoading = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.cI)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.cK)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.cJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Exporting Bot Report...')
						]))
				])),
			$author$project$View$Loading$view
		]));
var $author$project$Type$BotReport$OnChangeEndTime = function (a) {
	return {$: 4, a: a};
};
var $author$project$Type$BotReport$OnChangeLanguageCode = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$BotReport$OnChangeStartTime = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$BotReport$OnExport = {$: 11};
var $author$project$Type$BotReport$OnSubmit = {$: 10};
var $author$project$Type$BotReport$OnChangeBotID = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$BotReport$toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnBotReport);
var $author$project$Page$BotReport$botSelect = function (_v0) {
	var bots = _v0.g2;
	var botID = _v0.di;
	switch (bots.$) {
		case 4:
			var data = bots.a;
			var botOptions = A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						{d_: false, hH: 'Select Bots', i3: ''}
					]),
				A2(
					$elm$core$List$map,
					function (_v2) {
						var value = _v2.i3;
						var label = _v2.hH;
						return {
							d_: false,
							hH: label,
							i3: $elm$core$String$fromInt(value)
						};
					},
					data));
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.fY)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.hH)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Bot')
							])),
						$author$project$View$Form$Select$view(
						{
							hY: A2($elm$core$Basics$composeL, $author$project$Page$BotReport$toAppMsg, $author$project$Type$BotReport$OnChangeBotID),
							h0: botOptions,
							i4: botID
						})
					]));
		case 2:
			var error = bots.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$Options$errorCodeString, error))
					]));
		default:
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Loading...')
					]));
	}
};
var $author$project$Type$BotReport$OnChangeTenant = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$BotReport$tenantSelect = F2(
	function (role, _v0) {
		var tenants = _v0.iM;
		var tenantID = _v0.gm;
		switch (tenants.$) {
			case 4:
				var data = tenants.a;
				var tenantOptions = A2(
					$elm$core$List$append,
					_List_fromArray(
						[
							{d_: false, hH: 'Select Tenant', i3: ''}
						]),
					A2(
						$elm$core$List$map,
						function (_v3) {
							var value = _v3.i3;
							var label = _v3.hH;
							return {
								d_: false,
								hH: label,
								i3: $elm$core$String$fromInt(value)
							};
						},
						data));
				var tenantView = function () {
					if (role === 1) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.fY)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.hH)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Tenant')
										])),
									$author$project$View$Form$Select$view(
									{
										hY: A2($elm$core$Basics$composeL, $author$project$Page$BotReport$toAppMsg, $author$project$Type$BotReport$OnChangeTenant),
										h0: tenantOptions,
										i4: tenantID
									})
								]));
					} else {
						return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
					}
				}();
				return tenantView;
			case 2:
				var error = tenants.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$Options$errorCodeString, error))
						]));
			default:
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Loading...')
						]));
		}
	});
var $author$project$Page$BotReport$filterArea = F2(
	function (role, model) {
		var languageCodeOptions = A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					{d_: false, hH: 'Select Language Code', i3: ''}
				]),
			$author$project$Data$Bot$languageCodes);
		var _v0 = model;
		var languageCode = _v0.eT;
		var startTime = _v0.gc;
		var endTime = _v0.d8;
		var botID = _v0.di;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.c1)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.eh)
						]),
					_List_fromArray(
						[
							A2($author$project$Page$BotReport$tenantSelect, role, model),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.fY)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.hH)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Language Code')
										])),
									$author$project$View$Form$Select$view(
									{
										hY: A2($elm$core$Basics$composeL, $author$project$Page$BotReport$toAppMsg, $author$project$Type$BotReport$OnChangeLanguageCode),
										h0: languageCodeOptions,
										i4: languageCode
									})
								])),
							$author$project$Page$BotReport$botSelect(model),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.fY)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.hH)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Start Time')
										])),
									$author$project$View$Form$Input$view(
									{
										bJ: startTime,
										bL: 'date',
										bP: false,
										bS: '',
										bX: 'startTime',
										bZ: A2($elm$core$Basics$composeL, $author$project$Page$BotReport$toAppMsg, $author$project$Type$BotReport$OnChangeStartTime),
										b5: ''
									})
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.fY)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.hH)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('End Time')
										])),
									$author$project$View$Form$Input$view(
									{
										bJ: endTime,
										bL: 'date',
										bP: false,
										bS: '',
										bX: 'endTime',
										bZ: A2($elm$core$Basics$composeL, $author$project$Page$BotReport$toAppMsg, $author$project$Type$BotReport$OnChangeEndTime),
										b5: ''
									})
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.dq)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.fz, $author$project$Page$BotReport$styles.cm)),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Page$BotReport$toAppMsg($author$project$Type$BotReport$OnSubmit)),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
											!$author$project$Data$Form$isEmptyFields(
												_List_fromArray(
													[botID])))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Submit')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.ec)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.fz, $author$project$Page$BotReport$styles.cm)),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Page$BotReport$toAppMsg($author$project$Type$BotReport$OnExport)),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(
											!$author$project$Data$Form$isEmptyFields(
												_List_fromArray(
													[botID])))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Export')
										]))
								]))
						]))
				]));
	});
var $author$project$Type$BotReport$OnChangeOffset = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$BotReportDay$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid limit';
		case 2:
			return 'Cannot admin';
		default:
			return 'Missing error code';
	}
};
var $author$project$Ext$Iso8601$toDMY = function (posix) {
	return A3(
		$elm$core$List$foldl,
		$elm$core$Basics$append,
		'',
		A2(
			$elm$core$List$intersperse,
			'/',
			A2(
				$elm$core$String$split,
				'-',
				A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(
						A2(
							$elm$core$String$split,
							' ',
							A3(
								$elm$core$String$replace,
								'Z',
								'',
								A3(
									$elm$core$String$replace,
									'T',
									' ',
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(posix)))))))));
};
var $author$project$Page$BotReport$renderItem = function (log) {
	var _v0 = log;
	var day = _v0.he;
	var totalUsers = _v0.iU;
	var totalBranches = _v0.iS;
	var totalText = _v0.iT;
	return A2(
		$rtfeldman$elm_css$Html$Styled$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Ext$Iso8601$toDMY(day))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$String$fromInt(totalUsers))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$String$fromInt(totalBranches))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$String$fromInt(totalText))
					]))
			]));
};
var $author$project$Page$BotReport$table = function (data) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iA)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$thead,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iO)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$th,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Day')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$th,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Total Users')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$th,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Total Branches')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$th,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Total Text')
									]))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$tbody,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iE)
					]),
				A2($elm$core$List$map, $author$project$Page$BotReport$renderItem, data))
			]));
};
var $author$project$Page$BotReport$tableData = function (_v0) {
	var reports = _v0.aI;
	var offset = _v0.fo;
	var limit = _v0.eV;
	var total = _v0.iR;
	switch (reports.$) {
		case 4:
			var data = reports.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dI)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.hJ)
							]),
						_List_fromArray(
							[
								$author$project$Page$BotReport$table(data)
							])),
						$author$project$View$Pagination$view(
						{
							eV: limit,
							fo: offset,
							bZ: A2($elm$core$Basics$composeL, $author$project$Page$BotReport$toAppMsg, $author$project$Type$BotReport$OnChangeOffset),
							iR: total
						})
					]));
		case 2:
			var error = reports.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$BotReportDay$errorCodeString, error))
					]));
		case 0:
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.ez)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Please select bot to view report!')
					]));
		default:
			return $author$project$View$Loading$view;
	}
};
var $author$project$Page$BotReport$view = F2(
	function (_v0, authState) {
		var _v1 = authState.h1;
		var profile = _v1.fD;
		var botReport = _v1.dm;
		var _v2 = botReport;
		var _export = _v2.a1;
		var _v3 = function () {
			switch (_export.$) {
				case 2:
					var error = _export.a;
					return _Utils_Tuple2(
						false,
						A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.bH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$BotReportExport$errorCodeString, error))
								])));
				case 1:
					return _Utils_Tuple2(
						true,
						A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil));
				default:
					return _Utils_Tuple2(
						false,
						A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil));
			}
		}();
		var isExporting = _v3.a;
		var exportError = _v3.b;
		var role = $author$project$Data$Role$getRole(profile.fD);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.dI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.cV)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.hu)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Bot Reports')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BotReport$styles.dg)
						]),
					_List_fromArray(
						[
							A2($author$project$Page$BotReport$filterArea, role, botReport),
							exportError,
							$author$project$Page$BotReport$tableData(botReport)
						])),
					$author$project$View$Popup$view(
					{
						dJ: $author$project$Page$BotReport$exportLoading,
						eK: isExporting,
						fp: $author$project$Page$BotReport$toAppMsg($author$project$Type$BotReport$OnCancelExport)
					})
				]));
	});
var $author$project$Tailwind$Utilities$gap_5 = A2($rtfeldman$elm_css$Css$property, 'gap', '1.25rem');
var $author$project$Tailwind$Utilities$grid_cols_1 = A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', 'repeat(1, minmax(0, 1fr))');
var $author$project$Tailwind$Utilities$grid_cols_3 = A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', 'repeat(3, minmax(0, 1fr))');
var $author$project$Tailwind$Utilities$py_5 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-top', '1.25rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-bottom', '1.25rem')
		]));
var $author$project$Page$Dashboard$styles = {
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_gray_100, $author$project$Tailwind$Utilities$h_screen]),
	fW: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$leading_6, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900]),
	gd: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_5,
			$author$project$Tailwind$Utilities$bg_white,
			$author$project$Tailwind$Utilities$shadow,
			$author$project$Tailwind$Utilities$rounded_lg,
			$author$project$Tailwind$Utilities$overflow_hidden,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$p_6]))
		]),
	ge: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_500, $author$project$Tailwind$Utilities$truncate]),
	gf: _List_fromArray(
		[$author$project$Tailwind$Utilities$mt_1, $author$project$Tailwind$Utilities$text_3xl, $author$project$Tailwind$Utilities$font_semibold, $author$project$Tailwind$Utilities$text_gray_900]),
	gg: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$mt_5,
			$author$project$Tailwind$Utilities$grid,
			$author$project$Tailwind$Utilities$grid_cols_1,
			$author$project$Tailwind$Utilities$gap_5,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$grid_cols_3]))
		]),
	gh: _List_fromArray(
		[
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$grid_cols_2]))
		]),
	cV: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$max_w_7xl,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_4,
			$author$project$Tailwind$Breakpoints$md(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6])),
			$author$project$Tailwind$Utilities$text_left
		])
};
var $author$project$Page$Dashboard$sectionTitle = function (title) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h2,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.fW)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(title)
			]));
};
var $author$project$Page$Dashboard$statsBox = F2(
	function (title, value) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.gd)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.ge)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(title)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.gf)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(value)
						]))
				]));
	});
var $author$project$Page$Dashboard$view = F2(
	function (_v0, _v1) {
		var pages = _v1.h1;
		var _v2 = pages.hd.dP;
		if (_v2.$ === 4) {
			var data = _v2.a;
			var role = $author$project$Data$Role$getRole(pages.fD.fD);
			var superAdminsView = function () {
				if (role === 1) {
					return A2(
						$author$project$Page$Dashboard$statsBox,
						'Total Super Admins',
						$elm$core$String$fromInt(data.iz));
				} else {
					return $rtfeldman$elm_css$Html$Styled$text('');
				}
			}();
			var tenantsView = function () {
				if (role === 1) {
					return A2(
						$author$project$Page$Dashboard$statsBox,
						'Total Tenants',
						$elm$core$String$fromInt(data.iM));
				} else {
					return $rtfeldman$elm_css$Html$Styled$text('');
				}
			}();
			var adminStyles = function () {
				if (role === 1) {
					return _List_Nil;
				} else {
					return $author$project$Page$Dashboard$styles.gh;
				}
			}();
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.dI)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.cV)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.hu)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Dashboard')
									])),
								$author$project$Page$Dashboard$sectionTitle('All Time Stats'),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_Utils_ap(adminStyles, $author$project$Page$Dashboard$styles.gg))
									]),
								_List_fromArray(
									[
										superAdminsView,
										A2(
										$author$project$Page$Dashboard$statsBox,
										'Total Admins',
										$elm$core$String$fromInt(data.gR)),
										tenantsView,
										A2(
										$author$project$Page$Dashboard$statsBox,
										'Total Bots',
										$elm$core$String$fromInt(data.g2)),
										A2(
										$author$project$Page$Dashboard$statsBox,
										'Total Interactions',
										$elm$core$String$fromInt(data.dl)),
										A2(
										$author$project$Page$Dashboard$statsBox,
										'Total Users',
										$elm$core$String$fromInt(data.i2))
									]))
							]))
					]));
		} else {
			return $author$project$View$Loading$view;
		}
	});
var $author$project$Page$NotFound$styles = {
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$justify_center]),
	cx: _List_fromArray(
		[$author$project$Tailwind$Utilities$mx_auto, $author$project$Tailwind$Utilities$h_12, $author$project$Tailwind$Utilities$w_auto]),
	eW: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_indigo_600, $author$project$Tailwind$Utilities$no_underline, $author$project$Tailwind$Utilities$cursor_pointer]),
	aP: _List_fromArray(
		[$author$project$Tailwind$Utilities$mt_2, $author$project$Tailwind$Utilities$text_3xl, $author$project$Tailwind$Utilities$text_gray_900]),
	gJ: _List_fromArray(
		[$author$project$Tailwind$Utilities$max_w_md])
};
var $author$project$Page$NotFound$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NotFound$styles.dI)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NotFound$styles.gJ)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NotFound$styles.cx),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$image.eZ)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NotFound$styles.aP)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Page not found')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NotFound$styles.eW),
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.es)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Go back to Dashboard!')
								]))
						]))
				]))
		]));
var $author$project$Type$Profile$OnChangeConfirmPassword = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$Profile$OnChangeEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$Profile$OnChangeName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$Profile$OnChangePassword = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$Profile$OnUpdate = {$: 4};
var $author$project$Type$Profile$OnUpdatePassword = {$: 8};
var $author$project$Tailwind$Utilities$max_w_2xl = A2($rtfeldman$elm_css$Css$property, 'max-width', '42rem');
var $author$project$Tailwind$Utilities$pt_10 = A2($rtfeldman$elm_css$Css$property, 'padding-top', '2.5rem');
var $author$project$Tailwind$Utilities$space_y_5 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Global$children(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$Global$selector,
					':not([hidden]) ~ :not([hidden])',
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, '--tw-space-y-reverse', '0'),
							A2($rtfeldman$elm_css$Css$property, 'margin-top', 'calc(1.25rem * calc(1 - var(--tw-space-y-reverse)))'),
							A2($rtfeldman$elm_css$Css$property, 'margin-bottom', 'calc(1.25rem * var(--tw-space-y-reverse))')
						]))
				]))
		]));
var $author$project$Page$Profile$styles = {
	cj: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_4over12, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$rounded_md, $author$project$Tailwind$Utilities$h_9]),
	$7: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_row, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$border_t, $author$project$Tailwind$Utilities$border_solid, $author$project$Tailwind$Utilities$border_b_0, $author$project$Tailwind$Utilities$border_l_0, $author$project$Tailwind$Utilities$border_r_0, $author$project$Tailwind$Utilities$border_gray_200, $author$project$Tailwind$Utilities$pt_8]),
	dI: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$vh(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(60))),
			$author$project$Tailwind$Utilities$overflow_auto,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6]))
		]),
	dX: _List_fromArray(
		[$author$project$Tailwind$Utilities$mt_1, $author$project$Tailwind$Utilities$max_w_2xl, $author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$text_gray_500]),
	ek: _List_fromArray(
		[$author$project$Tailwind$Utilities$py_8]),
	aC: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_row, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$border_t, $author$project$Tailwind$Utilities$border_solid, $author$project$Tailwind$Utilities$border_b_0, $author$project$Tailwind$Utilities$border_l_0, $author$project$Tailwind$Utilities$border_r_0, $author$project$Tailwind$Utilities$border_gray_200, $author$project$Tailwind$Utilities$py_8, $author$project$Tailwind$Utilities$mb_2]),
	aD: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_4over12, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$rounded_md, $author$project$Tailwind$Utilities$shadow_sm, $author$project$Tailwind$Utilities$h_9]),
	hH: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$block,
			$author$project$Tailwind$Utilities$text_left,
			$author$project$Tailwind$Utilities$w_4over12,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$text_gray_700,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_px, $author$project$Tailwind$Utilities$pt_2]))
		]),
	fv: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$border_t,
			$author$project$Tailwind$Utilities$border_solid,
			$author$project$Tailwind$Utilities$border_b_0,
			$author$project$Tailwind$Utilities$border_l_0,
			$author$project$Tailwind$Utilities$border_r_0,
			$author$project$Tailwind$Utilities$border_gray_200,
			$author$project$Tailwind$Utilities$pt_8,
			$author$project$Tailwind$Utilities$space_y_6,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$pt_10, $author$project$Tailwind$Utilities$space_y_5]))
		]),
	aP: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$leading_6, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900, $author$project$Tailwind$Utilities$m_0]),
	cV: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col, $author$project$Tailwind$Utilities$items_start]),
	cZ: _List_fromArray(
		[$author$project$Tailwind$Utilities$px_4])
};
var $author$project$Page$Profile$view = F2(
	function (_v0, authState) {
		var toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnProfile);
		var _v1 = authState.h1;
		var profile = _v1.fD;
		var _v2 = profile;
		var name = _v2.fg;
		var email = _v2.d4;
		var password = _v2.fu;
		var confirmPassword = _v2.G;
		var formStatus = _v2.J;
		var submitableInfo = $author$project$Data$Form$isValidFields(
			_List_fromArray(
				[name, email])) && (1 !== formStatus);
		var submitablePassword = $author$project$Data$Form$isEmptyFields(
			_List_fromArray(
				[password, confirmPassword])) && ($author$project$Data$Form$isValidFields(
			_List_fromArray(
				[password, confirmPassword])) && (_Utils_eq(password.i3, confirmPassword.i3) && (1 !== formStatus)));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.dI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.ek)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.cV)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h3,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.aP)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Update Profile')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.dX)
										]),
									_List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.aC)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.hH)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Name')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.aD)
										]),
									_List_fromArray(
										[
											$author$project$View$Form$Input$view(
											{
												bJ: name,
												bL: 'text',
												bP: true,
												bS: '',
												bX: 'username',
												bZ: A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$OnChangeName),
												b5: 'Name'
											})
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.aC)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.hH)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Email')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.aD)
										]),
									_List_fromArray(
										[
											$author$project$View$Form$Input$view(
											{
												bJ: email,
												bL: 'email',
												bP: true,
												bS: '',
												bX: 'email',
												bZ: A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$OnChangeEmail),
												b5: 'Email'
											})
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.$7)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.hH)
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.cj)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$button,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('submit'),
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.fz, $author$project$Page$Profile$styles.cZ)),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													toAppMsg($author$project$Type$Profile$OnUpdate)),
													$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!submitableInfo)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Update')
												]))
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.fv)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.cV)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h3,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.aP)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Update Password')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.aC)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.hH)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Password')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.aD)
										]),
									_List_fromArray(
										[
											$author$project$View$Form$Input$view(
											{
												bJ: password,
												bL: 'password',
												bP: true,
												bS: '',
												bX: 'password',
												bZ: A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$OnChangePassword),
												b5: 'Password'
											})
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.aC)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.hH)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Confirm Password')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.aD)
										]),
									_List_fromArray(
										[
											$author$project$View$Form$Input$view(
											{
												bJ: confirmPassword,
												bL: 'password',
												bP: true,
												bS: '',
												bX: 'confirmPassword',
												bZ: A2($elm$core$Basics$composeL, toAppMsg, $author$project$Type$Profile$OnChangeConfirmPassword),
												b5: 'Confirm Password'
											})
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.$7)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.hH)
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Profile$styles.cj)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$button,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('submit'),
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.fz, $author$project$Page$Profile$styles.cZ)),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													toAppMsg($author$project$Type$Profile$OnUpdatePassword)),
													$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!submitablePassword)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Update Password')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Api$SuperAdminDetail$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Cannot get super admin';
		default:
			return 'Missing error code';
	}
};
var $author$project$Type$SuperAdminDetail$OnChangeEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$SuperAdminDetail$OnChangeName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$SuperAdminDetail$OnCreate = {$: 4};
var $author$project$Type$SuperAdminDetail$OnUpdate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Type$SuperAdminDetail$OnChangeConfirmPassword = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$SuperAdminDetail$OnChangePassword = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$SuperAdminDetail$styles = {
	cj: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_4over12, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$rounded_md, $author$project$Tailwind$Utilities$h_9]),
	$7: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_row, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$border_t, $author$project$Tailwind$Utilities$border_solid, $author$project$Tailwind$Utilities$border_b_0, $author$project$Tailwind$Utilities$border_l_0, $author$project$Tailwind$Utilities$border_r_0, $author$project$Tailwind$Utilities$border_gray_200, $author$project$Tailwind$Utilities$py_8, $author$project$Tailwind$Utilities$mb_2]),
	dI: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$vh(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(10))),
			$author$project$Tailwind$Utilities$overflow_auto
		]),
	ek: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$py_8,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6]))
		]),
	aC: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_row, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$border_t, $author$project$Tailwind$Utilities$border_solid, $author$project$Tailwind$Utilities$border_b_0, $author$project$Tailwind$Utilities$border_l_0, $author$project$Tailwind$Utilities$border_r_0, $author$project$Tailwind$Utilities$border_gray_200, $author$project$Tailwind$Utilities$py_8, $author$project$Tailwind$Utilities$mb_2]),
	hC: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$block,
			$author$project$Tailwind$Utilities$w_full,
			$author$project$Tailwind$Utilities$border_solid,
			$author$project$Tailwind$Utilities$shadow_sm,
			$author$project$Tailwind$Utilities$border_gray_200,
			$author$project$Tailwind$Utilities$rounded_md,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$ring_indigo_500, $author$project$Tailwind$Utilities$border_indigo_500])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$text_sm]))
		]),
	aD: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_4over12, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$rounded_md, $author$project$Tailwind$Utilities$shadow_sm, $author$project$Tailwind$Utilities$h_9]),
	hH: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$block,
			$author$project$Tailwind$Utilities$text_left,
			$author$project$Tailwind$Utilities$w_4over12,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$text_gray_700,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_px, $author$project$Tailwind$Utilities$pt_2]))
		]),
	fv: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$py_12,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6])),
			$author$project$Tailwind$Utilities$border_t,
			$author$project$Tailwind$Utilities$border_solid,
			$author$project$Tailwind$Utilities$border_b_0,
			$author$project$Tailwind$Utilities$border_l_0,
			$author$project$Tailwind$Utilities$border_r_0,
			$author$project$Tailwind$Utilities$border_gray_200,
			$author$project$Tailwind$Utilities$pt_8,
			$author$project$Tailwind$Utilities$space_y_6
		]),
	aP: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$leading_6, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900, $author$project$Tailwind$Utilities$m_0, $author$project$Tailwind$Utilities$pb_4]),
	cV: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col, $author$project$Tailwind$Utilities$items_start]),
	cZ: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$py_2,
			$author$project$Tailwind$Utilities$px_4,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$ring_indigo_500])),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_indigo_700]))
		]),
	gB: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_row, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$border_t, $author$project$Tailwind$Utilities$border_solid, $author$project$Tailwind$Utilities$border_b_0, $author$project$Tailwind$Utilities$border_l_0, $author$project$Tailwind$Utilities$border_r_0, $author$project$Tailwind$Utilities$border_gray_200, $author$project$Tailwind$Utilities$pt_8])
};
var $author$project$Page$SuperAdminDetail$toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnSuperAdminDetail);
var $author$project$Page$SuperAdminDetail$passwordFields = function (superAdminDetail) {
	var _v0 = superAdminDetail;
	var password = _v0.fu;
	var confirmPassword = _v0.G;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.aC)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.hH)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Password')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.aD)
							]),
						_List_fromArray(
							[
								$author$project$View$Form$Input$view(
								{
									bJ: password,
									bL: 'password',
									bP: true,
									bS: '',
									bX: 'password',
									bZ: A2($elm$core$Basics$composeL, $author$project$Page$SuperAdminDetail$toAppMsg, $author$project$Type$SuperAdminDetail$OnChangePassword),
									b5: 'Password'
								})
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.aC)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.hH)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Confirm password')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.aD)
							]),
						_List_fromArray(
							[
								$author$project$View$Form$Input$view(
								{
									bJ: confirmPassword,
									bL: 'password',
									bP: true,
									bS: '',
									bX: 'confirmPassword',
									bZ: A2($elm$core$Basics$composeL, $author$project$Page$SuperAdminDetail$toAppMsg, $author$project$Type$SuperAdminDetail$OnChangeConfirmPassword),
									b5: 'Confirm password'
								})
							]))
					]))
			]));
};
var $author$project$Page$SuperAdminDetail$fieldsView = F2(
	function (superAdmin, superAdminDetail) {
		var _v0 = superAdminDetail;
		var name = _v0.fg;
		var email = _v0.d4;
		var password = _v0.fu;
		var confirmPassword = _v0.G;
		var formStatus = _v0.J;
		var _v1 = function () {
			if (!superAdmin.$) {
				var superAdmin_ = superAdmin.a;
				return {
					ck: $author$project$Page$SuperAdminDetail$toAppMsg(
						$author$project$Type$SuperAdminDetail$OnUpdate(superAdmin_.eu)),
					cl: 'Update',
					cG: A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					cS: $author$project$Data$Form$isEmptyFields(
						_List_fromArray(
							[name, email])) && ($author$project$Data$Form$isValidFields(
						_List_fromArray(
							[name, email])) && (1 !== formStatus)),
					aP: 'Edit Super Admin: ' + superAdmin_.fg
				};
			} else {
				return {
					ck: $author$project$Page$SuperAdminDetail$toAppMsg($author$project$Type$SuperAdminDetail$OnCreate),
					cl: 'Create',
					cG: $author$project$Page$SuperAdminDetail$passwordFields(superAdminDetail),
					cS: $author$project$Data$Form$isEmptyFields(
						_List_fromArray(
							[name, email, password, confirmPassword])) && (($author$project$Data$Form$isValidFields(
						_List_fromArray(
							[name, email, password, confirmPassword])) && _Utils_eq(password.i3, confirmPassword.i3)) && (1 !== formStatus)),
					aP: 'Create New Super Admin'
				};
			}
		}();
		var title = _v1.aP;
		var passwordView = _v1.cG;
		var btnTitle = _v1.cl;
		var btnMsg = _v1.ck;
		var submitable = _v1.cS;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.ek)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.cV)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.aP)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(title)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.aC)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Name')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.aD)
								]),
							_List_fromArray(
								[
									$author$project$View$Form$Input$view(
									{
										bJ: name,
										bL: 'text',
										bP: true,
										bS: '',
										bX: 'name',
										bZ: A2($elm$core$Basics$composeL, $author$project$Page$SuperAdminDetail$toAppMsg, $author$project$Type$SuperAdminDetail$OnChangeName),
										b5: 'Name'
									})
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.aC)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.hH)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Email')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.aD)
								]),
							_List_fromArray(
								[
									$author$project$View$Form$Input$view(
									{
										bJ: email,
										bL: 'email',
										bP: true,
										bS: '',
										bX: 'email',
										bZ: A2($elm$core$Basics$composeL, $author$project$Page$SuperAdminDetail$toAppMsg, $author$project$Type$SuperAdminDetail$OnChangeEmail),
										b5: 'Email'
									})
								]))
						])),
					passwordView,
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.$7)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.hH)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.cj)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('submit'),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.fz, $author$project$Page$SuperAdminDetail$styles.cZ)),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(btnMsg),
											$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!submitable)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(btnTitle)
										]))
								]))
						]))
				]));
	});
var $author$project$Type$SuperAdminDetail$OnUpdatePassword = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$SuperAdminDetail$updatePasswordFieldsView = F2(
	function (id, model) {
		var _v0 = model;
		var password = _v0.fu;
		var confirmPassword = _v0.G;
		var formStatus = _v0.J;
		var submitable = $author$project$Data$Form$isValidFields(
			_List_fromArray(
				[password, confirmPassword])) && (_Utils_eq(password.i3, confirmPassword.i3) && (1 !== formStatus));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.fv)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.cV)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h3,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.aP)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Update Password')
										]))
								])),
							$author$project$Page$SuperAdminDetail$passwordFields(model),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.gB)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.hH)
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.cj)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$button,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('submit'),
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.fz, $author$project$Page$SuperAdminDetail$styles.cZ)),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Page$SuperAdminDetail$toAppMsg(
														$author$project$Type$SuperAdminDetail$OnUpdatePassword(id))),
													$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!submitable)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Update Password')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$SuperAdminDetail$formView = F2(
	function (superAdmin, superAdminDetail) {
		var updatePasswordView = function () {
			if (!superAdmin.$) {
				var superAdmin_ = superAdmin.a;
				return A2($author$project$Page$SuperAdminDetail$updatePasswordFieldsView, superAdmin_.eu, superAdminDetail);
			} else {
				return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminDetail$styles.dI)
				]),
			_List_fromArray(
				[
					A2($author$project$Page$SuperAdminDetail$fieldsView, superAdmin, superAdminDetail),
					updatePasswordView
				]));
	});
var $author$project$Page$SuperAdminDetail$view = F2(
	function (_v0, authState) {
		var _v1 = authState.h1;
		var superAdminDetail = _v1.ix;
		var _v2 = superAdminDetail;
		var superAdmin = _v2.iw;
		switch (superAdmin.$) {
			case 0:
				return A2($author$project$Page$SuperAdminDetail$formView, $elm$core$Maybe$Nothing, superAdminDetail);
			case 2:
				var error = superAdmin.a;
				return $author$project$View$Error$view(
					A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$SuperAdminDetail$errorCodeString, error));
			case 1:
				return $author$project$View$Loading$view;
			case 4:
				var superAdmin_ = superAdmin.a;
				return A2(
					$author$project$Page$SuperAdminDetail$formView,
					$elm$core$Maybe$Just(superAdmin_),
					superAdminDetail);
			default:
				return $author$project$View$Loading$view;
		}
	});
var $author$project$Type$SuperAdminList$OnChangeSearch = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$SuperAdminList$OnOpenModal = {$: 5};
var $author$project$Page$SuperAdminList$styles = {
	c1: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$justify_between, $author$project$Tailwind$Utilities$mb_2, $author$project$Tailwind$Utilities$flex_wrap]),
	ce: _List_fromArray(
		[$author$project$Tailwind$Utilities$no_underline, $author$project$Tailwind$Utilities$text_white, $author$project$Tailwind$Utilities$px_4, $author$project$Tailwind$Utilities$py_2]),
	dg: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$px_2,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$flex_col,
			$author$project$Tailwind$Utilities$flex_grow,
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6]))
		]),
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_gray_100, $author$project$Tailwind$Utilities$h_screen, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col]),
	dR: _List_fromArray(
		[$author$project$Tailwind$Utilities$ml_3]),
	dS: _List_fromArray(
		[$author$project$Tailwind$Utilities$mr_4]),
	dU: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$text_gray_500]),
	eh: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex]),
	eo: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_gray_50]),
	cH: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$mt_5,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_6, $author$project$Tailwind$Utilities$grid, $author$project$Tailwind$Utilities$grid_cols_2, $author$project$Tailwind$Utilities$gap_3, $author$project$Tailwind$Utilities$grid_flow_row_dense]))
		]),
	cI: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(400))
		]),
	cJ: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$leading_6, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900]),
	cK: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$mt_3,
			$author$project$Tailwind$Utilities$text_center,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_5]))
		]),
	fV: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_60, $author$project$Tailwind$Utilities$mb_2]),
	fY: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_60, $author$project$Tailwind$Utilities$px_3, $author$project$Tailwind$Utilities$py_2]),
	ii: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$absolute,
			$author$project$Tailwind$Utilities$top_0,
			$author$project$Tailwind$Utilities$left_12,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$h_12,
			$author$project$Tailwind$Utilities$z_10,
			$author$project$Tailwind$Utilities$items_center,
			$author$project$Tailwind$Utilities$space_x_3,
			$author$project$Tailwind$Utilities$bg_gray_50,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$left_16]))
		]),
	cV: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$max_w_7xl,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_4,
			$author$project$Tailwind$Breakpoints$md(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6])),
			$author$project$Tailwind$Utilities$text_left
		])
};
var $author$project$Page$SuperAdminList$toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnSuperAdminList);
var $author$project$Page$SuperAdminList$searchArea = function (_v0) {
	var search = _v0.fU;
	var checkedList = _v0.F;
	var showDelete = ($elm$core$List$length(checkedList) > 0) ? A2(
		$rtfeldman$elm_css$Html$Styled$button,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.co, $author$project$Page$SuperAdminList$styles.dS)),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				$author$project$Page$SuperAdminList$toAppMsg($author$project$Type$SuperAdminList$OnOpenModal))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.ce),
						$rtfeldman$elm_css$Html$Styled$Attributes$href('#')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Delete All')
					]))
			])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.c1)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.fV)
					]),
				_List_fromArray(
					[
						$author$project$View$Form$Input$view(
						{
							bJ: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: search},
							bL: 'name',
							bP: false,
							bS: '',
							bX: 'search',
							bZ: A2($elm$core$Basics$composeL, $author$project$Page$SuperAdminList$toAppMsg, $author$project$Type$SuperAdminList$OnChangeSearch),
							b5: 'Search'
						})
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						showDelete,
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.fz)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.ce),
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.dL)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Create Super Admin')
									]))
							]))
					]))
			]));
};
var $author$project$Type$SuperAdminList$OnChangeOffset = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$SuperAdminList$errorCodeString = function (code) {
	switch (code) {
		case 0:
			return 'Invalid params';
		case 1:
			return 'Invalid limit';
		case 2:
			return 'Invalid offset';
		default:
			return 'Missing error code';
	}
};
var $author$project$Type$SuperAdminList$OnCheckAll = {$: 3};
var $author$project$Type$SuperAdminList$OnCloseModal = {$: 6};
var $author$project$Type$SuperAdminList$OnSelectSuperAdmin = function (a) {
	return {$: 13, a: a};
};
var $author$project$Type$SuperAdminList$OnDelete = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$SuperAdminList$renderDeleteSuperAdmins = function (superAdmin) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.dU)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('- ' + superAdmin.fg)
			]));
};
var $author$project$Page$SuperAdminList$renderDeletePopup = F2(
	function (data, checkedList) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.cI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.cK)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.cJ)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Do you want to delete these super admins?')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					A2($elm$core$List$map, $author$project$Page$SuperAdminList$renderDeleteSuperAdmins, checkedList)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.cH)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.dt),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$SuperAdminList$toAppMsg($author$project$Type$SuperAdminList$OnCloseModal))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Cancel')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.co),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$SuperAdminList$toAppMsg(
										$author$project$Type$SuperAdminList$OnDelete(data)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Type$SuperAdminList$OnDeleteSingle = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Page$SuperAdminList$renderDeleteSinglePopup = F2(
	function (id, data) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.cI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.cK)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.cJ)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Do you want to delete this super admin?')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.cH)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.fz, $author$project$View$Theme$defaultStyles.dt)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$SuperAdminList$toAppMsg(
										$author$project$Type$SuperAdminList$OnSelectSuperAdmin(0)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Cancel')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.fz, $author$project$View$Theme$defaultStyles.co)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$SuperAdminList$toAppMsg(
										A2($author$project$Type$SuperAdminList$OnDeleteSingle, id, data)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Type$SuperAdminList$OnCheck = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$SuperAdminList$renderItem = F2(
	function (checkedList, superAdmin) {
		var _v0 = superAdmin;
		var id = _v0.eu;
		var name = _v0.fg;
		var email = _v0.d4;
		var existedSuperAdmin = A2(
			$elm$core$List$filter,
			function (item) {
				return _Utils_eq(item.eu, id);
			},
			checkedList);
		var checked = $elm$core$List$length(existedSuperAdmin) > 0;
		var checkedRowCss = checked ? $rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.eo) : $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil);
		var rowMarker = checked ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.id)
				]),
			_List_Nil) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
		var selectedCss = checked ? $rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap($author$project$View$Table$tableStyles.aL, $author$project$View$Table$tableStyles.il)) : $rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[checkedRowCss]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dy)
						]),
					_List_fromArray(
						[
							rowMarker,
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dx),
									$rtfeldman$elm_css$Html$Styled$Attributes$checked(checked),
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									function (_v1) {
										return $author$project$Page$SuperAdminList$toAppMsg(
											$author$project$Type$SuperAdminList$OnCheck(superAdmin));
									})
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[selectedCss]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(id))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(name)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(email)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$View$Table$tableStyles.aL, $author$project$View$Table$tableStyles.iF))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									$author$project$Data$Route$routeUrl.d2(id)),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.hn)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Edit')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.ip)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(' | ')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dR),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$SuperAdminList$toAppMsg(
										$author$project$Type$SuperAdminList$OnSelectSuperAdmin(id)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Page$SuperAdminList$table = F2(
	function (_v0, data) {
		var checkedList = _v0.F;
		var isShowModal = _v0.bQ;
		var selectedSuperAdmin = _v0.bh;
		var checked = ($elm$core$List$length(checkedList) > 0) && _Utils_eq(
			$elm$core$List$length(checkedList),
			$elm$core$List$length(data));
		return A2(
			$rtfeldman$elm_css$Html$Styled$table,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iA)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$thead,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iO)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dy)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$input,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dx),
													$rtfeldman$elm_css$Html$Styled$Attributes$checked(checked),
													$rtfeldman$elm_css$Html$Styled$Events$onInput(
													function (_v1) {
														return $author$project$Page$SuperAdminList$toAppMsg($author$project$Type$SuperAdminList$OnCheckAll);
													})
												]),
											_List_Nil)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('ID')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Name')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Email')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Action')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$tbody,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iE)
						]),
					A2(
						$elm$core$List$map,
						$author$project$Page$SuperAdminList$renderItem(checkedList),
						data)),
					$author$project$View$Popup$view(
					{
						dJ: A2($author$project$Page$SuperAdminList$renderDeletePopup, data, checkedList),
						eK: isShowModal,
						fp: $author$project$Page$SuperAdminList$toAppMsg($author$project$Type$SuperAdminList$OnCloseModal)
					}),
					$author$project$View$Popup$view(
					{
						dJ: A2($author$project$Page$SuperAdminList$renderDeleteSinglePopup, selectedSuperAdmin, data),
						eK: !(!selectedSuperAdmin),
						fp: $author$project$Page$SuperAdminList$toAppMsg(
							$author$project$Type$SuperAdminList$OnSelectSuperAdmin(0))
					})
				]));
	});
var $author$project$Page$SuperAdminList$tableData = function (model) {
	var _v0 = model;
	var status = _v0.cQ;
	var offset = _v0.fo;
	var limit = _v0.eV;
	var total = _v0.iR;
	switch (status.$) {
		case 4:
			var data = status.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dI)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.hJ)
							]),
						_List_fromArray(
							[
								A2($author$project$Page$SuperAdminList$table, model, data)
							])),
						$author$project$View$Pagination$view(
						{
							eV: limit,
							fo: offset,
							bZ: A2($elm$core$Basics$composeL, $author$project$Page$SuperAdminList$toAppMsg, $author$project$Type$SuperAdminList$OnChangeOffset),
							iR: total
						})
					]));
		case 2:
			var error = status.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$SuperAdminList$errorCodeString, error))
					]));
		default:
			return $author$project$View$Loading$view;
	}
};
var $author$project$Page$SuperAdminList$view = F2(
	function (_v0, authState) {
		var _v1 = authState.h1;
		var superAdminList = _v1.iy;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.dI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.cV)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.hu)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Super Admins')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SuperAdminList$styles.dg)
						]),
					_List_fromArray(
						[
							$author$project$Page$SuperAdminList$searchArea(superAdminList),
							$author$project$Page$SuperAdminList$tableData(superAdminList)
						]))
				]));
	});
var $author$project$Type$TenantDetail$OnChangeMaxBots = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$TenantDetail$OnChangeMaxNodes = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$TenantDetail$OnChangeName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$TenantDetail$OnCreate = {$: 3};
var $author$project$Type$TenantDetail$OnUpdate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$TenantDetail$styles = {
	cj: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_4over12, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$rounded_md, $author$project$Tailwind$Utilities$h_9]),
	$7: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_row, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$border_t, $author$project$Tailwind$Utilities$border_solid, $author$project$Tailwind$Utilities$border_b_0, $author$project$Tailwind$Utilities$border_l_0, $author$project$Tailwind$Utilities$border_r_0, $author$project$Tailwind$Utilities$border_gray_200, $author$project$Tailwind$Utilities$pt_8]),
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$h_screen, $author$project$Tailwind$Utilities$overflow_auto]),
	ek: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$py_8,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6]))
		]),
	aC: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_row, $author$project$Tailwind$Utilities$border_t, $author$project$Tailwind$Utilities$border_solid, $author$project$Tailwind$Utilities$border_b_0, $author$project$Tailwind$Utilities$border_l_0, $author$project$Tailwind$Utilities$border_r_0, $author$project$Tailwind$Utilities$border_gray_200, $author$project$Tailwind$Utilities$py_8, $author$project$Tailwind$Utilities$mb_2]),
	hC: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$block,
			$author$project$Tailwind$Utilities$w_full,
			$author$project$Tailwind$Utilities$border_solid,
			$author$project$Tailwind$Utilities$shadow_sm,
			$author$project$Tailwind$Utilities$border_gray_200,
			$author$project$Tailwind$Utilities$rounded_md,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$ring_indigo_500, $author$project$Tailwind$Utilities$border_indigo_500])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$text_sm]))
		]),
	aD: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_4over12, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$rounded_md, $author$project$Tailwind$Utilities$shadow_sm, $author$project$Tailwind$Utilities$h_9]),
	hH: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$block,
			$author$project$Tailwind$Utilities$text_left,
			$author$project$Tailwind$Utilities$w_4over12,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$text_gray_700,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_px, $author$project$Tailwind$Utilities$pt_2]))
		]),
	aP: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$leading_6, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900, $author$project$Tailwind$Utilities$m_0, $author$project$Tailwind$Utilities$pb_4]),
	cV: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col, $author$project$Tailwind$Utilities$items_start]),
	cZ: _List_fromArray(
		[$author$project$Tailwind$Utilities$px_4])
};
var $author$project$Page$TenantDetail$toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnTenantDetail);
var $author$project$Page$TenantDetail$formView = F2(
	function (tenant, tenantDetail) {
		var _v0 = tenantDetail;
		var name = _v0.fg;
		var maxNodes = _v0.e1;
		var formStatus = _v0.J;
		var maxBots = _v0.e0;
		var _v1 = function () {
			if (!tenant.$) {
				var tenant_ = tenant.a;
				return {
					ck: $author$project$Page$TenantDetail$toAppMsg(
						$author$project$Type$TenantDetail$OnUpdate(tenant_.eu)),
					cl: 'Update',
					cS: $author$project$Data$Form$isEmptyFields(
						_List_fromArray(
							[name, maxNodes, maxBots])) && ($author$project$Data$Form$isValidFields(
						_List_fromArray(
							[name, maxNodes, maxBots])) && (1 !== formStatus)),
					aP: 'Edit Tenant: ' + tenant_.fg
				};
			} else {
				return {
					ck: $author$project$Page$TenantDetail$toAppMsg($author$project$Type$TenantDetail$OnCreate),
					cl: 'Create',
					cS: $author$project$Data$Form$isEmptyFields(
						_List_fromArray(
							[name, maxNodes, maxBots])) && ($author$project$Data$Form$isValidFields(
						_List_fromArray(
							[name, maxNodes, maxBots])) && (1 !== formStatus)),
					aP: 'Create New Tenant'
				};
			}
		}();
		var title = _v1.aP;
		var btnTitle = _v1.cl;
		var btnMsg = _v1.ck;
		var submitable = _v1.cS;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantDetail$styles.dI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantDetail$styles.ek)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantDetail$styles.cV)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h3,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantDetail$styles.aP)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(title)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantDetail$styles.aC)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantDetail$styles.hH)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Name')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantDetail$styles.aD)
										]),
									_List_fromArray(
										[
											$author$project$View$Form$Input$view(
											{
												bJ: name,
												bL: 'text',
												bP: true,
												bS: '',
												bX: 'name',
												bZ: A2($elm$core$Basics$composeL, $author$project$Page$TenantDetail$toAppMsg, $author$project$Type$TenantDetail$OnChangeName),
												b5: 'Name'
											})
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantDetail$styles.aC)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantDetail$styles.hH)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Max Bots')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantDetail$styles.aD)
										]),
									_List_fromArray(
										[
											$author$project$View$Form$Input$view(
											{
												bJ: maxBots,
												bL: 'text',
												bP: true,
												bS: '',
												bX: 'maxBots',
												bZ: A2($elm$core$Basics$composeL, $author$project$Page$TenantDetail$toAppMsg, $author$project$Type$TenantDetail$OnChangeMaxBots),
												b5: 'Max Bots'
											})
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantDetail$styles.aC)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantDetail$styles.hH)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Max Bot Responses')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantDetail$styles.aD)
										]),
									_List_fromArray(
										[
											$author$project$View$Form$Input$view(
											{
												bJ: maxNodes,
												bL: 'number',
												bP: true,
												bS: '',
												bX: 'maxNodes',
												bZ: A2($elm$core$Basics$composeL, $author$project$Page$TenantDetail$toAppMsg, $author$project$Type$TenantDetail$OnChangeMaxNodes),
												b5: 'Max Bot Responses'
											})
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantDetail$styles.$7)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantDetail$styles.hH)
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantDetail$styles.cj)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$button,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('submit'),
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.fz, $author$project$Page$TenantDetail$styles.cZ)),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(btnMsg),
													$rtfeldman$elm_css$Html$Styled$Attributes$disabled(!submitable)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(btnTitle)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$TenantDetail$view = F2(
	function (_v0, authState) {
		var _v1 = authState.h1;
		var tenantDetail = _v1.iK;
		var _v2 = tenantDetail;
		var tenant = _v2.bm;
		switch (tenant.$) {
			case 0:
				return A2($author$project$Page$TenantDetail$formView, $elm$core$Maybe$Nothing, tenantDetail);
			case 2:
				var error = tenant.a;
				return $author$project$View$Error$view(
					A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$TenantDetail$errorCodeString, error));
			case 1:
				return $author$project$View$Loading$view;
			case 4:
				var superAdmin_ = tenant.a;
				return A2(
					$author$project$Page$TenantDetail$formView,
					$elm$core$Maybe$Just(superAdmin_),
					tenantDetail);
			default:
				return $author$project$View$Loading$view;
		}
	});
var $author$project$Type$TenantList$OnChangeSearch = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$TenantList$OnOpenModal = {$: 5};
var $author$project$Tailwind$Utilities$mb_4 = A2($rtfeldman$elm_css$Css$property, 'margin-bottom', '1rem');
var $author$project$Page$TenantList$styles = {
	c1: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$justify_between, $author$project$Tailwind$Utilities$flex_wrap, $author$project$Tailwind$Utilities$mb_4]),
	ce: _List_fromArray(
		[$author$project$Tailwind$Utilities$no_underline, $author$project$Tailwind$Utilities$text_white, $author$project$Tailwind$Utilities$px_4, $author$project$Tailwind$Utilities$py_2]),
	dg: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$px_2,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$flex_col,
			$author$project$Tailwind$Utilities$flex_grow,
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$author$project$Tailwind$Breakpoints$lg(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6]))
		]),
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_gray_100, $author$project$Tailwind$Utilities$h_screen, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col]),
	dR: _List_fromArray(
		[$author$project$Tailwind$Utilities$ml_3]),
	dS: _List_fromArray(
		[$author$project$Tailwind$Utilities$mr_4]),
	dU: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$text_gray_500]),
	eo: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_gray_50]),
	cH: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$mt_5,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_6, $author$project$Tailwind$Utilities$grid, $author$project$Tailwind$Utilities$grid_cols_2, $author$project$Tailwind$Utilities$gap_3, $author$project$Tailwind$Utilities$grid_flow_row_dense]))
		]),
	cI: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(400))
		]),
	cJ: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$leading_6, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900]),
	cK: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$mt_3,
			$author$project$Tailwind$Utilities$text_center,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_5]))
		]),
	fV: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_60]),
	fY: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_60, $author$project$Tailwind$Utilities$px_3, $author$project$Tailwind$Utilities$py_2]),
	ii: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$absolute,
			$author$project$Tailwind$Utilities$top_0,
			$author$project$Tailwind$Utilities$left_12,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$h_12,
			$author$project$Tailwind$Utilities$z_10,
			$author$project$Tailwind$Utilities$items_center,
			$author$project$Tailwind$Utilities$space_x_3,
			$author$project$Tailwind$Utilities$bg_gray_50,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$left_16]))
		]),
	cV: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$max_w_7xl,
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$py_4,
			$author$project$Tailwind$Breakpoints$md(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_8])),
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$px_6])),
			$author$project$Tailwind$Utilities$text_left
		])
};
var $author$project$Page$TenantList$toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnTenantList);
var $author$project$Page$TenantList$searchArea = function (_v0) {
	var search = _v0.fU;
	var checkedList = _v0.F;
	var showDelete = ($elm$core$List$length(checkedList) > 0) ? A2(
		$rtfeldman$elm_css$Html$Styled$button,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				A2($elm$core$List$append, $author$project$View$Theme$defaultStyles.co, $author$project$Page$TenantList$styles.dS)),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				$author$project$Page$TenantList$toAppMsg($author$project$Type$TenantList$OnOpenModal))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.ce),
						$rtfeldman$elm_css$Html$Styled$Attributes$href('#')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Delete All')
					]))
			])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.c1)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.fV)
					]),
				_List_fromArray(
					[
						$author$project$View$Form$Input$view(
						{
							bJ: {bH: $elm$core$Maybe$Nothing, gD: _List_Nil, i3: search},
							bL: 'name',
							bP: false,
							bS: '',
							bX: 'search',
							bZ: A2($elm$core$Basics$composeL, $author$project$Page$TenantList$toAppMsg, $author$project$Type$TenantList$OnChangeSearch),
							b5: 'Search'
						})
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						showDelete,
						A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.fz)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.ce),
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.dM)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Create Tenant')
									]))
							]))
					]))
			]));
};
var $author$project$Type$TenantList$OnChangeOffset = function (a) {
	return {$: 7, a: a};
};
var $author$project$Type$TenantList$OnCheckAll = {$: 3};
var $author$project$Type$TenantList$OnCloseModal = {$: 6};
var $author$project$Type$TenantList$OnSelectTenant = function (a) {
	return {$: 13, a: a};
};
var $author$project$Type$TenantList$OnDelete = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$TenantList$renderDeleteTenants = function (tenant) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.dU)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('- ' + tenant.fg)
			]));
};
var $author$project$Page$TenantList$renderDeletePopup = F2(
	function (data, checkedList) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.cI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.cK)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.cJ)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Do you want to delete these tenants?')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					A2($elm$core$List$map, $author$project$Page$TenantList$renderDeleteTenants, checkedList)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.cH)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.dt),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$TenantList$toAppMsg($author$project$Type$TenantList$OnCloseModal))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Cancel')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.co),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$TenantList$toAppMsg(
										$author$project$Type$TenantList$OnDelete(data)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Type$TenantList$OnDeleteSingle = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Page$TenantList$renderDeleteSinglePopup = F2(
	function (id, data) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.cI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.cK)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.cJ)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Do you want to delete this tenant?')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.cH)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.dt),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$TenantList$toAppMsg(
										$author$project$Type$TenantList$OnSelectTenant(0)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Cancel')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.co),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$TenantList$toAppMsg(
										A2($author$project$Type$TenantList$OnDeleteSingle, id, data)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Type$TenantList$OnCheck = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$TenantList$renderItem = F2(
	function (tenant, checkedList) {
		var _v0 = tenant;
		var id = _v0.eu;
		var name = _v0.fg;
		var maxBots = _v0.e0;
		var maxNodes = _v0.e1;
		var existedTenant = A2(
			$elm$core$List$filter,
			function (item) {
				return _Utils_eq(item.eu, id);
			},
			checkedList);
		var checked = $elm$core$List$length(existedTenant) > 0;
		var checkedRowCss = checked ? $rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.eo) : $rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil);
		var rowMarker = checked ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.id)
				]),
			_List_Nil) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
		var selectedCss = checked ? $rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap($author$project$View$Table$tableStyles.aL, $author$project$View$Table$tableStyles.il)) : $rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[checkedRowCss]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dy)
						]),
					_List_fromArray(
						[
							rowMarker,
							A2(
							$rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dx),
									$rtfeldman$elm_css$Html$Styled$Attributes$checked(checked),
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									function (_v1) {
										return $author$project$Page$TenantList$toAppMsg(
											$author$project$Type$TenantList$OnCheck(tenant));
									})
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[selectedCss]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(id))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(name)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(maxBots))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.aL)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(maxNodes))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$View$Table$tableStyles.aL, $author$project$View$Table$tableStyles.iF))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									$author$project$Data$Route$routeUrl.d3(id)),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.hn)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Edit')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.ip)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(' | ')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dR),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$TenantList$toAppMsg(
										$author$project$Type$TenantList$OnSelectTenant(id)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Page$TenantList$table = F2(
	function (_v0, data) {
		var checkedList = _v0.F;
		var isShowModal = _v0.bQ;
		var selectedTenant = _v0.bi;
		var checked = ($elm$core$List$length(checkedList) > 0) && _Utils_eq(
			$elm$core$List$length(checkedList),
			$elm$core$List$length(data));
		return A2(
			$rtfeldman$elm_css$Html$Styled$table,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iA)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$thead,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iO)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dy)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$input,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dx),
													$rtfeldman$elm_css$Html$Styled$Attributes$checked(checked),
													$rtfeldman$elm_css$Html$Styled$Events$onInput(
													function (_v1) {
														return $author$project$Page$TenantList$toAppMsg($author$project$Type$TenantList$OnCheckAll);
													})
												]),
											_List_Nil)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('ID')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Name')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Max Bots')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Max Bot Responses')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.bn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Action')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$tbody,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.iE)
						]),
					A2(
						$elm$core$List$map,
						function (item) {
							return A2($author$project$Page$TenantList$renderItem, item, checkedList);
						},
						data)),
					$author$project$View$Popup$view(
					{
						dJ: A2($author$project$Page$TenantList$renderDeletePopup, data, checkedList),
						eK: isShowModal,
						fp: $author$project$Page$TenantList$toAppMsg($author$project$Type$TenantList$OnCloseModal)
					}),
					$author$project$View$Popup$view(
					{
						dJ: A2($author$project$Page$TenantList$renderDeleteSinglePopup, selectedTenant, data),
						eK: !(!selectedTenant),
						fp: $author$project$Page$TenantList$toAppMsg(
							$author$project$Type$TenantList$OnSelectTenant(0))
					})
				]));
	});
var $author$project$Page$TenantList$tableData = function (model) {
	var _v0 = model;
	var status = _v0.cQ;
	var offset = _v0.fo;
	var limit = _v0.eV;
	var total = _v0.iR;
	switch (status.$) {
		case 4:
			var data = status.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.dI)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Table$tableStyles.hJ)
							]),
						_List_fromArray(
							[
								A2($author$project$Page$TenantList$table, model, data)
							])),
						$author$project$View$Pagination$view(
						{
							eV: limit,
							fo: offset,
							bZ: A2($elm$core$Basics$composeL, $author$project$Page$TenantList$toAppMsg, $author$project$Type$TenantList$OnChangeOffset),
							iR: total
						})
					]));
		case 2:
			var error = status.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Data$Message$apiErrorCodeString, $author$project$Api$TenantList$errorCodeString, error))
					]));
		default:
			return $author$project$View$Loading$view;
	}
};
var $author$project$Page$TenantList$view = F2(
	function (_v0, authState) {
		var _v1 = authState.h1;
		var tenantList = _v1.iL;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.dI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.cV)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.hu)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Tenants')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TenantList$styles.dg)
						]),
					_List_fromArray(
						[
							$author$project$Page$TenantList$searchArea(tenantList),
							$author$project$Page$TenantList$tableData(tenantList)
						]))
				]));
	});
var $author$project$View$page = function (model) {
	var _v0 = model.cM;
	switch (_v0.$) {
		case 1:
			return _Utils_Tuple2(
				$author$project$View$Layout$NoAuthLayout,
				$author$project$Page$Login$view(model));
		case 2:
			return _Utils_Tuple2(
				$author$project$View$Layout$NoAuthLayout,
				$author$project$Page$Login$view(model));
		case 0:
			return A2($author$project$View$authPage, model, $author$project$Page$Dashboard$view);
		case 3:
			return A2($author$project$View$authPage, model, $author$project$Page$Profile$view);
		case 4:
			return A2($author$project$View$authPage, model, $author$project$Page$AdminList$view);
		case 5:
			return A2($author$project$View$authPage, model, $author$project$Page$AdminDetail$view);
		case 6:
			return A2($author$project$View$authPage, model, $author$project$Page$AdminDetail$view);
		case 7:
			return A2($author$project$View$authPage, model, $author$project$Page$SuperAdminList$view);
		case 8:
			return A2($author$project$View$authPage, model, $author$project$Page$SuperAdminDetail$view);
		case 9:
			return A2($author$project$View$authPage, model, $author$project$Page$SuperAdminDetail$view);
		case 10:
			return A2($author$project$View$authPage, model, $author$project$Page$TenantList$view);
		case 11:
			return A2($author$project$View$authPage, model, $author$project$Page$TenantDetail$view);
		case 12:
			return A2($author$project$View$authPage, model, $author$project$Page$TenantDetail$view);
		case 15:
			return A2($author$project$View$authPage, model, $author$project$Page$BotLog$view);
		case 16:
			return A2($author$project$View$authPage, model, $author$project$Page$BotReport$view);
		case 13:
			return A2($author$project$View$authPage, model, $author$project$Page$BotList$view);
		case 14:
			return A2($author$project$View$authPage, model, $author$project$Page$BotDetail$view);
		case 17:
			return A2($author$project$View$authPage, model, $author$project$Page$AuditLog$view);
		default:
			return _Utils_Tuple2($author$project$View$Layout$NoAuthLayout, $author$project$Page$NotFound$view);
	}
};
var $author$project$Type$Menu$OnChangeLogoutModal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$OnMenu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$OnLogout = {$: 4};
var $author$project$Tailwind$Utilities$max_w_lg = A2($rtfeldman$elm_css$Css$property, 'max-width', '32rem');
var $author$project$Tailwind$Utilities$mt_8 = A2($rtfeldman$elm_css$Css$property, 'margin-top', '2rem');
var $author$project$Tailwind$Utilities$pb_16 = A2($rtfeldman$elm_css$Css$property, 'padding-bottom', '4rem');
var $author$project$Tailwind$Utilities$pl_56 = A2($rtfeldman$elm_css$Css$property, 'padding-left', '14rem');
var $author$project$Tailwind$Utilities$px_12 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'padding-left', '3rem'),
			A2($rtfeldman$elm_css$Css$property, 'padding-right', '3rem')
		]));
var $author$project$Tailwind$Utilities$rounded_3xl = A2($rtfeldman$elm_css$Css$property, 'border-radius', '1.5rem');
var $author$project$View$Layout$styles = {
	gZ: _List_fromArray(
		[$author$project$Tailwind$Utilities$h_screen, $author$project$Tailwind$Utilities$overflow_hidden]),
	dz: _List_fromArray(
		[$author$project$Tailwind$Utilities$w_full, $author$project$Tailwind$Utilities$max_w_lg, $author$project$Tailwind$Utilities$mt_8, $author$project$Tailwind$Utilities$py_8, $author$project$Tailwind$Utilities$px_12, $author$project$Tailwind$Utilities$rounded_3xl]),
	dI: _List_fromArray(
		[$author$project$Tailwind$Utilities$h_screen, $author$project$Tailwind$Utilities$box_border, $author$project$Tailwind$Utilities$overflow_x_hidden, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$justify_center, $author$project$Tailwind$Utilities$py_4, $author$project$Tailwind$Utilities$pt_8, $author$project$Tailwind$Utilities$pb_16, $author$project$Tailwind$Utilities$bg_gray_50]),
	e$: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex_1]),
	cH: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$mt_8,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_8, $author$project$Tailwind$Utilities$grid, $author$project$Tailwind$Utilities$grid_cols_2, $author$project$Tailwind$Utilities$gap_3, $author$project$Tailwind$Utilities$grid_flow_row_dense]))
		]),
	cI: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(400))
		]),
	cJ: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_lg, $author$project$Tailwind$Utilities$leading_6, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_900]),
	cK: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$mt_3,
			$author$project$Tailwind$Utilities$text_center,
			$author$project$Tailwind$Breakpoints$sm(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$mt_5]))
		]),
	fN: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$h_screen,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$flex_col,
			$author$project$Tailwind$Utilities$flex_1,
			$author$project$Tailwind$Breakpoints$md(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$pl_56]))
		])
};
var $author$project$View$Layout$logoutConfirmationModal = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Layout$styles.cI)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Layout$styles.cK)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Layout$styles.cJ)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Do you want to logout?')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Layout$styles.cH)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.dt),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Type$OnAuth(
								$author$project$Type$OnMenu(
									$author$project$Type$Menu$OnChangeLogoutModal(false))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Cancel')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Theme$defaultStyles.co),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Type$OnLogout)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Logout')
						]))
				]))
		]));
var $rtfeldman$elm_css$Html$Styled$main_ = $rtfeldman$elm_css$Html$Styled$node('main');
var $author$project$Data$Animate$SlideInDown = 68;
var $author$project$Data$Animate$animationToString = function (animation) {
	switch (animation) {
		case 0:
			return 'bounce';
		case 1:
			return 'flash';
		case 2:
			return 'pulse';
		case 3:
			return 'rubberBand';
		case 4:
			return 'shake';
		case 5:
			return 'headShake';
		case 6:
			return 'swing';
		case 7:
			return 'tada';
		case 8:
			return 'wobble';
		case 9:
			return 'jello';
		case 10:
			return 'bounceIn';
		case 11:
			return 'bounceInDown';
		case 12:
			return 'bounceInLeft';
		case 13:
			return 'bounceInRight';
		case 14:
			return 'bounceInUp';
		case 15:
			return 'bounceOut';
		case 16:
			return 'bounceOutDown';
		case 17:
			return 'bounceOutLeft';
		case 18:
			return 'bounceOutRight';
		case 19:
			return 'bounceOutUp';
		case 20:
			return 'fadeIn';
		case 21:
			return 'fadeInDown';
		case 22:
			return 'fadeInDownBig';
		case 23:
			return 'fadeInLeft';
		case 24:
			return 'fadeInLeftBig';
		case 25:
			return 'fadeInRight';
		case 26:
			return 'fadeInRightBig';
		case 27:
			return 'fadeInUp';
		case 28:
			return 'fadeInUpBig';
		case 29:
			return 'fadeOut';
		case 30:
			return 'fadeOutDown';
		case 31:
			return 'fadeOutDownBig';
		case 32:
			return 'fadeOutLeft';
		case 33:
			return 'fadeOutLeftBig';
		case 34:
			return 'fadeOutRight';
		case 35:
			return 'fadeOutRightBig';
		case 36:
			return 'fadeOutUp';
		case 37:
			return 'fadeOutUpBig';
		case 38:
			return 'flipInX';
		case 39:
			return 'flipInY';
		case 40:
			return 'flipOutX';
		case 41:
			return 'flipOutY';
		case 42:
			return 'lightSpeedIn';
		case 43:
			return 'lightSpeedOut';
		case 44:
			return 'rotateIn';
		case 45:
			return 'rotateInDownLeft';
		case 46:
			return 'rotateInDownRight';
		case 47:
			return 'rotateInUpLeft';
		case 48:
			return 'rotateInUpRight';
		case 49:
			return 'rotateOut';
		case 50:
			return 'rotateOutDownLeft';
		case 51:
			return 'rotateOutDownRight';
		case 52:
			return 'rotateOutUpLeft';
		case 53:
			return 'rotateOutUpRight';
		case 54:
			return 'hinge';
		case 55:
			return 'jackInTheBox';
		case 56:
			return 'rollIn';
		case 57:
			return 'rollOut';
		case 58:
			return 'zoomIn';
		case 59:
			return 'zoomInDown';
		case 60:
			return 'zoomInLeft';
		case 61:
			return 'zoomInRight';
		case 62:
			return 'zoomInUp';
		case 63:
			return 'zoomOut';
		case 64:
			return 'zoomOutDown';
		case 65:
			return 'zoomOutLeft';
		case 66:
			return 'zoomOutRight';
		case 67:
			return 'zoomOutUp';
		case 68:
			return 'slideInDown';
		case 69:
			return 'slideInLeft';
		case 70:
			return 'slideInRight';
		case 71:
			return 'slideInUp';
		case 72:
			return 'slideOutDown';
		case 73:
			return 'slideOutLeft';
		case 74:
			return 'slideOutRight';
		default:
			return 'slideOutUp';
	}
};
var $author$project$Data$Animate$animateClass = function (animation) {
	return ' animate ' + ($author$project$Data$Animate$animationToString(animation) + ' ');
};
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $author$project$Data$Animate$animate = function (animation) {
	return $rtfeldman$elm_css$Html$Styled$Attributes$class(
		$author$project$Data$Animate$animateClass(animation));
};
var $author$project$Type$CloseAlert = function (a) {
	return {$: 10, a: a};
};
var $rtfeldman$elm_css$Css$animationDuration = function (arg) {
	return A2($rtfeldman$elm_css$Css$prop1, 'animation-duration', arg);
};
var $author$project$Tailwind$Utilities$bg_blue_50 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-bg-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(239, 246, 255, var(--tw-bg-opacity))')
		]));
var $author$project$Tailwind$Utilities$bg_green_50 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-bg-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(236, 253, 245, var(--tw-bg-opacity))')
		]));
var $author$project$Tailwind$Utilities$bg_red_50 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-bg-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(254, 242, 242, var(--tw-bg-opacity))')
		]));
var $author$project$Tailwind$Utilities$bg_yellow_50 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-bg-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(255, 251, 235, var(--tw-bg-opacity))')
		]));
var $rtfeldman$elm_css$Css$breakWord = {cF: 0, i3: 'break-word'};
var $author$project$Tailwind$Utilities$m_0_dot_5 = A2($rtfeldman$elm_css$Css$property, 'margin', '0.125rem');
var $rtfeldman$elm_css$Css$ms = function (amount) {
	return {
		d$: 0,
		i3: $elm$core$String$fromFloat(amount) + 'ms'
	};
};
var $rtfeldman$elm_css$Css$overflowWrap = $rtfeldman$elm_css$Css$prop1('overflow-wrap');
var $author$project$Tailwind$Utilities$p_2_dot_5 = A2($rtfeldman$elm_css$Css$property, 'padding', '0.625rem');
var $author$project$Tailwind$Utilities$text_blue_400 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-text-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(96, 165, 250, var(--tw-text-opacity))')
		]));
var $author$project$Tailwind$Utilities$text_green_800 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-text-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(6, 95, 70, var(--tw-text-opacity))')
		]));
var $author$project$Tailwind$Utilities$text_red_400 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-text-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(248, 113, 113, var(--tw-text-opacity))')
		]));
var $author$project$Tailwind$Utilities$text_yellow_400 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-text-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(251, 191, 36, var(--tw-text-opacity))')
		]));
var $author$project$Tailwind$Utilities$top_2_dot_5 = A2($rtfeldman$elm_css$Css$property, 'top', '0.625rem');
var $author$project$Tailwind$Utilities$w_96 = A2($rtfeldman$elm_css$Css$property, 'width', '24rem');
var $author$project$Tailwind$Utilities$z_50 = A2($rtfeldman$elm_css$Css$property, 'z-index', '50');
var $author$project$View$Alert$style = {
	aq: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$justify_between, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$m_0_dot_5, $author$project$Tailwind$Utilities$p_2_dot_5, $author$project$Tailwind$Utilities$rounded_md]),
	dC: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$w_6,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$cursor_pointer]))
		]),
	dI: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$fixed,
			$author$project$Tailwind$Utilities$top_2_dot_5,
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$pct(40)),
			$author$project$Tailwind$Utilities$w_96,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$flex_col,
			$author$project$Tailwind$Utilities$justify_center,
			$author$project$Tailwind$Utilities$box_border,
			$author$project$Tailwind$Utilities$z_50,
			$rtfeldman$elm_css$Css$animationDuration(
			$rtfeldman$elm_css$Css$ms(400))
		]),
	dO: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_red_400, $author$project$Tailwind$Utilities$bg_red_50]),
	ee: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_red_400, $author$project$Tailwind$Utilities$bg_red_50]),
	ey: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_blue_400, $author$project$Tailwind$Utilities$bg_blue_50]),
	e3: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflowWrap($rtfeldman$elm_css$Css$breakWord),
			A2($rtfeldman$elm_css$Css$property, 'word-wrap', 'break-word'),
			A2($rtfeldman$elm_css$Css$property, 'word-break', 'break-word')
		]),
	iv: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_green_50, $author$project$Tailwind$Utilities$text_sm, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_green_800]),
	gH: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_yellow_400, $author$project$Tailwind$Utilities$bg_yellow_50])
};
var $author$project$View$Alert$alertStyle = function (alert) {
	switch (alert.$) {
		case 0:
			return _Utils_ap($author$project$View$Alert$style.aq, $author$project$View$Alert$style.iv);
		case 1:
			return _Utils_ap($author$project$View$Alert$style.aq, $author$project$View$Alert$style.ey);
		case 2:
			return _Utils_ap($author$project$View$Alert$style.aq, $author$project$View$Alert$style.ee);
		case 3:
			return _Utils_ap($author$project$View$Alert$style.aq, $author$project$View$Alert$style.gH);
		default:
			return _Utils_ap($author$project$View$Alert$style.aq, $author$project$View$Alert$style.dO);
	}
};
var $rtfeldman$elm_css$Svg$Styled$Attributes$height = $rtfeldman$elm_css$VirtualDom$Styled$attribute('height');
var $rtfeldman$elm_css$Svg$Styled$line = $rtfeldman$elm_css$Svg$Styled$node('line');
var $author$project$Data$Alert$message = function (alert) {
	switch (alert.$) {
		case 0:
			var text = alert.a;
			return text;
		case 1:
			var text = alert.a;
			return text;
		case 2:
			var text = alert.a;
			return text;
		case 3:
			var text = alert.a;
			return text;
		default:
			var text = alert.a;
			return text;
	}
};
var $rtfeldman$elm_css$Svg$Styled$Attributes$width = $rtfeldman$elm_css$VirtualDom$Styled$attribute('width');
var $rtfeldman$elm_css$Svg$Styled$Attributes$x1 = $rtfeldman$elm_css$VirtualDom$Styled$attribute('x1');
var $rtfeldman$elm_css$Svg$Styled$Attributes$x2 = $rtfeldman$elm_css$VirtualDom$Styled$attribute('x2');
var $rtfeldman$elm_css$Svg$Styled$Attributes$y1 = $rtfeldman$elm_css$VirtualDom$Styled$attribute('y1');
var $rtfeldman$elm_css$Svg$Styled$Attributes$y2 = $rtfeldman$elm_css$VirtualDom$Styled$attribute('y2');
var $author$project$View$Alert$renderAlert = function (_v0) {
	var alert = _v0.b;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				$author$project$View$Alert$alertStyle(alert))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Alert$style.e3)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Data$Alert$message(alert))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Alert$style.dC),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Type$CloseAlert(alert))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$svg,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$height('24'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$stroke('currentColor'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('round'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('2'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$width('24')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Svg$Styled$line,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Svg$Styled$Attributes$x1('18'),
										$rtfeldman$elm_css$Svg$Styled$Attributes$y1('6'),
										$rtfeldman$elm_css$Svg$Styled$Attributes$x2('6'),
										$rtfeldman$elm_css$Svg$Styled$Attributes$y2('18')
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Svg$Styled$line,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Svg$Styled$Attributes$x1('6'),
										$rtfeldman$elm_css$Svg$Styled$Attributes$y1('6'),
										$rtfeldman$elm_css$Svg$Styled$Attributes$x2('18'),
										$rtfeldman$elm_css$Svg$Styled$Attributes$y2('18')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Data$Alert$toList = function (_v0) {
	var state = _v0;
	return $elm$core$Dict$toList(state);
};
var $author$project$View$Alert$view = function (alertState) {
	var alerts = $author$project$Data$Alert$toList(alertState);
	return $elm$core$List$isEmpty(alerts) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Alert$style.dI),
				$author$project$Data$Animate$animate(68)
			]),
		A2($elm$core$List$map, $author$project$View$Alert$renderAlert, alerts));
};
var $author$project$Type$Menu$OnChangeMenu = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Menu$Item$menu = function (role) {
	return _List_fromArray(
		[
			{
			E: _List_fromArray(
				[$author$project$Data$Route$HomeRoute]),
			v: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
			eK: true,
			fg: 'Dashboard',
			cM: $author$project$Data$Route$HomeRoute
		},
			{
			E: _List_fromArray(
				[
					$author$project$Data$Route$SuperAdminsRoute,
					$author$project$Data$Route$CreateSuperAdminRoute,
					$author$project$Data$Route$EditSuperAdminRoute(0)
				]),
			v: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
			eK: role === 1,
			fg: 'Super Admins',
			cM: $author$project$Data$Route$SuperAdminsRoute
		},
			{
			E: _List_fromArray(
				[
					$author$project$Data$Route$TenantsRoute,
					$author$project$Data$Route$CreateTenantRoute,
					$author$project$Data$Route$EditTenantRoute(0)
				]),
			v: 'M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z',
			eK: role === 1,
			fg: 'Tenants',
			cM: $author$project$Data$Route$TenantsRoute
		},
			{
			E: _List_fromArray(
				[
					$author$project$Data$Route$AdminsRoute,
					$author$project$Data$Route$CreateAdminRoute,
					$author$project$Data$Route$EditAdminRoute(0)
				]),
			v: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z',
			eK: true,
			fg: 'Admins',
			cM: $author$project$Data$Route$AdminsRoute
		},
			{
			E: _List_fromArray(
				[$author$project$Data$Route$BotsRoute]),
			v: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01',
			eK: true,
			fg: 'Bots',
			cM: $author$project$Data$Route$BotsRoute
		},
			{
			E: _List_fromArray(
				[$author$project$Data$Route$BotLogRoute]),
			v: 'M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z',
			eK: true,
			fg: 'Bot Logs',
			cM: $author$project$Data$Route$BotLogRoute
		},
			{
			E: _List_fromArray(
				[$author$project$Data$Route$BotReportRoute]),
			v: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
			eK: true,
			fg: 'Bot Reports',
			cM: $author$project$Data$Route$BotReportRoute
		},
			{
			E: _List_fromArray(
				[$author$project$Data$Route$AuditLogRoute]),
			v: 'M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
			eK: true,
			fg: 'Audit Trail',
			cM: $author$project$Data$Route$AuditLogRoute
		},
			{E: _List_Nil, v: 'M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1', eK: true, fg: 'Logout', cM: $author$project$Data$Route$LoginRoute}
		]);
};
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.i3);
};
var $author$project$Tailwind$Utilities$bg_gray_600 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-bg-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(75, 85, 99, var(--tw-bg-opacity))')
		]));
var $author$project$Tailwind$Utilities$flex_shrink_0 = A2($rtfeldman$elm_css$Css$property, 'flex-shrink', '0');
var $rtfeldman$elm_css$Css$initial = {c3: 0, q: 0, aX: 0, da: 0, as: 0, db: 0, at: 0, X: 0, y: 0, by: 0, Q: 0, c: 0, l: 0, ay: 0, cu: 0, a2: 0, bK: 0, ah: 0, u: 0, az: 0, i: 0, _: 0, bM: 0, eO: 0, cz: 0, a5: 0, aE: 0, aa: 0, aF: 0, aG: 0, aj: 0, ak: 0, S: 0, bU: 0, e: 0, d: 0, cC: 0, hX: 0, ac: 0, b3: 0, aH: 0, M: 0, cc: 0, aM: 0, an: 0, aN: 0, aO: 0, ao: 0, D: 0, aQ: '', bt: 0, i3: 'initial', bu: 0, ag: 0};
var $rtfeldman$elm_css$Css$inherit = _Utils_update(
	$rtfeldman$elm_css$Css$initial,
	{i3: 'inherit'});
var $author$project$Tailwind$Utilities$max_w_xs = A2($rtfeldman$elm_css$Css$property, 'max-width', '20rem');
var $author$project$Tailwind$Utilities$ml_1 = A2($rtfeldman$elm_css$Css$property, 'margin-left', '0.25rem');
var $author$project$Tailwind$Utilities$neg_mr_12 = A2($rtfeldman$elm_css$Css$property, 'margin-right', '-3rem');
var $author$project$Tailwind$Utilities$ring_inset = A2($rtfeldman$elm_css$Css$property, '--tw-ring-inset', 'inset');
var $author$project$Tailwind$Utilities$ring_white = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--tw-ring-opacity', '1'),
			A2($rtfeldman$elm_css$Css$property, '--tw-ring-color', 'rgba(255, 255, 255, var(--tw-ring-opacity))')
		]));
var $author$project$Tailwind$Utilities$rounded_full = A2($rtfeldman$elm_css$Css$property, 'border-radius', '9999px');
var $author$project$Tailwind$Utilities$space_y_1 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Global$children(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$Global$selector,
					':not([hidden]) ~ :not([hidden])',
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, '--tw-space-y-reverse', '0'),
							A2($rtfeldman$elm_css$Css$property, 'margin-top', 'calc(0.25rem * calc(1 - var(--tw-space-y-reverse)))'),
							A2($rtfeldman$elm_css$Css$property, 'margin-bottom', 'calc(0.25rem * var(--tw-space-y-reverse))')
						]))
				]))
		]));
var $author$project$Tailwind$Utilities$w_14 = A2($rtfeldman$elm_css$Css$property, 'width', '3.5rem');
var $author$project$Tailwind$Utilities$z_40 = A2($rtfeldman$elm_css$Css$property, 'z-index', '40');
var $author$project$View$Menu$Mobile$styles = {
	ei: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex_shrink_0, $author$project$Tailwind$Utilities$w_14]),
	e5: _List_fromArray(
		[$author$project$Tailwind$Utilities$fixed, $author$project$Tailwind$Utilities$inset_0, $author$project$Tailwind$Utilities$bg_gray_600, $author$project$Tailwind$Utilities$bg_opacity_75]),
	e6: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$ml_1,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$items_center,
			$author$project$Tailwind$Utilities$justify_center,
			$author$project$Tailwind$Utilities$h_10,
			$author$project$Tailwind$Utilities$w_10,
			$author$project$Tailwind$Utilities$rounded_full,
			$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$inherit),
			$author$project$Tailwind$Utilities$border_0,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$outline_none, $author$project$Tailwind$Utilities$ring_2, $author$project$Tailwind$Utilities$ring_inset, $author$project$Tailwind$Utilities$ring_white]))
		]),
	e7: _List_fromArray(
		[$author$project$Tailwind$Utilities$absolute, $author$project$Tailwind$Utilities$top_0, $author$project$Tailwind$Utilities$right_0, $author$project$Tailwind$Utilities$neg_mr_12, $author$project$Tailwind$Utilities$pt_2]),
	cB: _List_fromArray(
		[$author$project$Tailwind$Utilities$relative, $author$project$Tailwind$Utilities$z_40, $author$project$Tailwind$Utilities$hidden]),
	e8: _List_fromArray(
		[$author$project$Tailwind$Utilities$h_8, $author$project$Tailwind$Utilities$w_auto]),
	e9: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex_shrink_0, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$px_4]),
	fa: _List_fromArray(
		[$author$project$Tailwind$Utilities$mt_5, $author$project$Tailwind$Utilities$flex_1, $author$project$Tailwind$Utilities$h_0, $author$project$Tailwind$Utilities$overflow_y_auto]),
	fb: _List_fromArray(
		[$author$project$Tailwind$Utilities$px_2, $author$project$Tailwind$Utilities$space_y_1]),
	fc: _List_fromArray(
		[$author$project$Tailwind$Utilities$relative, $author$project$Tailwind$Utilities$flex_1, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col, $author$project$Tailwind$Utilities$max_w_xs, $author$project$Tailwind$Utilities$w_full, $author$project$Tailwind$Utilities$pt_5, $author$project$Tailwind$Utilities$pb_4, $author$project$Tailwind$Utilities$bg_white]),
	fd: _List_fromArray(
		[$author$project$Tailwind$Utilities$fixed, $author$project$Tailwind$Utilities$inset_0, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$z_40]),
	fe: _List_fromArray(
		[$author$project$Tailwind$Utilities$h_6, $author$project$Tailwind$Utilities$w_6, $author$project$Tailwind$Utilities$text_white]),
	f4: _List_fromArray(
		[$author$project$Tailwind$Utilities$block])
};
var $author$project$View$Menu$Info$styles = {
	c8: _List_fromArray(
		[$author$project$Tailwind$Utilities$inline_block, $author$project$Tailwind$Utilities$text_gray_500, $author$project$Tailwind$Utilities$h_10, $author$project$Tailwind$Utilities$w_10, $author$project$Tailwind$Utilities$rounded_full]),
	aC: _List_fromArray(
		[$author$project$Tailwind$Utilities$ml_3]),
	fg: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_base, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_700, $author$project$Tailwind$Utilities$m_0]),
	fE: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex_shrink_0, $author$project$Tailwind$Utilities$block, $author$project$Tailwind$Utilities$no_underline]),
	fF: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex_shrink_0, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$border_t, $author$project$View$Theme$defaultStyles.g$, $author$project$View$Theme$defaultStyles.g_, $author$project$Tailwind$Utilities$p_4]),
	fG: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$items_center]),
	gE: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_base, $author$project$Tailwind$Utilities$font_medium, $author$project$Tailwind$Utilities$text_gray_500, $author$project$Tailwind$Utilities$m_0])
};
var $author$project$View$Menu$Info$view = function (authState) {
	var _v0 = authState.h1.fD;
	var profile = _v0.fD;
	var name = function () {
		if (profile.$ === 1) {
			var value = profile.a;
			return value.fg;
		} else {
			var value = profile.a;
			return value.fg;
		}
	}();
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Info$styles.fF)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.fD),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Info$styles.fE)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Info$styles.fG)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Svg$Styled$svg,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$View$Menu$Info$styles.c8),
												$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none'),
												$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24'),
												$rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('2'),
												$rtfeldman$elm_css$Svg$Styled$Attributes$stroke('currentColor')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Svg$Styled$path,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
														$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('round'),
														$rtfeldman$elm_css$Svg$Styled$Attributes$d('M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z')
													]),
												_List_Nil)
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Info$styles.aC)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Info$styles.fg)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(name)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Info$styles.gE)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('View profile')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$View$Menu$Item$styles = {
	c0: _List_fromArray(
		[$author$project$Tailwind$Utilities$bg_gray_100]),
	v: _List_fromArray(
		[$author$project$Tailwind$Utilities$text_gray_500, $author$project$Tailwind$Utilities$mr_3, $author$project$Tailwind$Utilities$flex_shrink_0, $author$project$Tailwind$Utilities$h_6, $author$project$Tailwind$Utilities$w_6]),
	eM: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$text_gray_900,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$items_center,
			$author$project$Tailwind$Utilities$px_2,
			$author$project$Tailwind$Utilities$py_2,
			$author$project$Tailwind$Utilities$text_sm,
			$author$project$Tailwind$Utilities$font_medium,
			$author$project$Tailwind$Utilities$rounded_md,
			$author$project$Tailwind$Utilities$no_underline,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$bg_gray_50, $author$project$Tailwind$Utilities$text_gray_900]))
		])
};
var $author$project$View$Menu$Item$view = F2(
	function (_v0, appModel) {
		var name = _v0.fg;
		var icon = _v0.v;
		var route = _v0.cM;
		var activeRoute = _v0.E;
		var toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnMenu);
		var activeMenuStyle = function (route_) {
			return A2($elm$core$List$member, route_, activeRoute) ? $author$project$View$Menu$Item$styles.c0 : _List_Nil;
		};
		var _v1 = (name === 'Logout') ? _Utils_Tuple2(
			'#',
			toAppMsg(
				$author$project$Type$Menu$OnChangeLogoutModal(true))) : _Utils_Tuple2(
			$author$project$Data$Route$routeToUrl(route),
			toAppMsg(
				$author$project$Type$Menu$OnChangeMenu(false)));
		var href_ = _v1.a;
		var onClick_ = _v1.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href(href_),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						$author$project$View$Menu$Item$styles.eM,
						activeMenuStyle(appModel.cM))),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(onClick_)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$svg,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$View$Menu$Item$styles.v),
							$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('2'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$stroke('currentColor')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Svg$Styled$path,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('round'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$d(icon)
								]),
							_List_Nil)
						])),
					$rtfeldman$elm_css$Html$Styled$text(name)
				]));
	});
var $author$project$View$Menu$Mobile$view = F2(
	function (authState, appModel) {
		var toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnMenu);
		var _v0 = authState.h1;
		var profile = _v0.fD;
		var role = $author$project$Data$Role$getRole(profile.fD);
		var filterMenu = A2(
			$elm$core$List$filter,
			function (item) {
				return item.eK;
			},
			$author$project$View$Menu$Item$menu(role));
		var _v1 = authState.hS;
		var isShowMenu = _v1.eL;
		var menuStyles = isShowMenu ? _Utils_ap($author$project$View$Menu$Mobile$styles.cB, $author$project$View$Menu$Mobile$styles.f4) : $author$project$View$Menu$Mobile$styles.cB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(menuStyles)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Mobile$styles.e5)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Mobile$styles.fd)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Mobile$styles.fc)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Mobile$styles.e7)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$button,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Mobile$styles.e6),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													toAppMsg(
														$author$project$Type$Menu$OnChangeMenu(false)))
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Svg$Styled$svg,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$View$Menu$Mobile$styles.fe),
															$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none'),
															$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24'),
															$rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('2'),
															$rtfeldman$elm_css$Svg$Styled$Attributes$stroke('currentColor')
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Svg$Styled$path,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
																	$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('round'),
																	$rtfeldman$elm_css$Svg$Styled$Attributes$d('M6 18L18 6M6 6l12 12')
																]),
															_List_Nil)
														]))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Mobile$styles.e9)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$img,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Mobile$styles.e8),
													$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$image.eZ)
												]),
											_List_Nil)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Mobile$styles.fa)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$nav,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Mobile$styles.fb)
												]),
											A2(
												$elm$core$List$map,
												function (n) {
													return A2($author$project$View$Menu$Item$view, n, appModel);
												},
												filterMenu))
										])),
									$author$project$View$Menu$Info$view(authState)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$Mobile$styles.ei)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Tailwind$Utilities$w_56 = A2($rtfeldman$elm_css$Css$property, 'width', '14rem');
var $author$project$View$Menu$SideBar$styles = {
	eZ: _List_fromArray(
		[$author$project$Tailwind$Utilities$h_8, $author$project$Tailwind$Utilities$w_auto]),
	e_: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$items_center, $author$project$Tailwind$Utilities$justify_center, $author$project$Tailwind$Utilities$p_4]),
	e2: _List_fromArray(
		[$author$project$Tailwind$Utilities$mt_5, $author$project$Tailwind$Utilities$flex_grow, $author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col]),
	fi: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex_1, $author$project$Tailwind$Utilities$px_2, $author$project$Tailwind$Utilities$pb_4, $author$project$Tailwind$Utilities$space_y_1]),
	f6: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$hidden,
			$author$project$Tailwind$Breakpoints$md(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$w_56, $author$project$Tailwind$Utilities$flex_col, $author$project$Tailwind$Utilities$fixed, $author$project$Tailwind$Utilities$inset_y_0]))
		]),
	f7: _List_fromArray(
		[$author$project$Tailwind$Utilities$flex, $author$project$Tailwind$Utilities$flex_col, $author$project$Tailwind$Utilities$flex_grow, $author$project$Tailwind$Utilities$bg_white, $author$project$Tailwind$Utilities$overflow_y_auto, $author$project$Tailwind$Utilities$border, $author$project$Tailwind$Utilities$border_gray_200, $author$project$Tailwind$Utilities$border_solid])
};
var $author$project$View$Menu$SideBar$view = F2(
	function (authState, appModel) {
		var _v0 = authState.h1;
		var profile = _v0.fD;
		var role = $author$project$Data$Role$getRole(profile.fD);
		var filterMenu = A2(
			$elm$core$List$filter,
			function (item) {
				return item.eK;
			},
			$author$project$View$Menu$Item$menu(role));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$SideBar$styles.f6)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$SideBar$styles.f7)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$SideBar$styles.e_)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$SideBar$styles.eZ),
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$image.eZ)
										]),
									_List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$SideBar$styles.e2)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$nav,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$SideBar$styles.fi)
										]),
									A2(
										$elm$core$List$map,
										function (item) {
											return A2($author$project$View$Menu$Item$view, item, appModel);
										},
										filterMenu))
								])),
							$author$project$View$Menu$Info$view(authState)
						]))
				]));
	});
var $author$project$Tailwind$Utilities$border_r = A2($rtfeldman$elm_css$Css$property, 'border-right-width', '1px');
var $author$project$Tailwind$Utilities$h_16 = A2($rtfeldman$elm_css$Css$property, 'height', '4rem');
var $author$project$Tailwind$Utilities$sticky = A2($rtfeldman$elm_css$Css$property, 'position', 'sticky');
var $author$project$View$Menu$TopBar$styles = {
	fq: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$px_4,
			$author$project$Tailwind$Utilities$border_r,
			$author$project$Tailwind$Utilities$border_gray_200,
			$author$project$Tailwind$Utilities$border_0,
			$author$project$Tailwind$Utilities$text_gray_500,
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$outline_none, $author$project$Tailwind$Utilities$ring_2, $author$project$Tailwind$Utilities$ring_inset, $author$project$Tailwind$Utilities$ring_indigo_500])),
			$author$project$Tailwind$Breakpoints$md(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$hidden]))
		]),
	f4: _List_fromArray(
		[$author$project$Tailwind$Utilities$block]),
	gk: _List_fromArray(
		[$author$project$Tailwind$Utilities$h_6, $author$project$Tailwind$Utilities$w_6]),
	gq: _List_fromArray(
		[
			$author$project$Tailwind$Utilities$sticky,
			$author$project$Tailwind$Utilities$top_0,
			$author$project$Tailwind$Utilities$z_10,
			$author$project$Tailwind$Utilities$flex_shrink_0,
			$author$project$Tailwind$Utilities$flex,
			$author$project$Tailwind$Utilities$h_16,
			$author$project$Tailwind$Utilities$bg_white,
			$author$project$Tailwind$Utilities$shadow,
			$author$project$Tailwind$Breakpoints$md(
			_List_fromArray(
				[$author$project$Tailwind$Utilities$hidden]))
		])
};
var $author$project$View$Menu$TopBar$view = function () {
	var toAppMsg = A2($elm$core$Basics$composeL, $author$project$Type$OnAuth, $author$project$Type$OnMenu);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$TopBar$styles.gq)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$TopBar$styles.fq),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						toAppMsg(
							$author$project$Type$Menu$OnChangeMenu(true)))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$svg,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$View$Menu$TopBar$styles.gk),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('2'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$stroke('currentColor')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Svg$Styled$path,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinecap('round'),
										$rtfeldman$elm_css$Svg$Styled$Attributes$strokeLinejoin('round'),
										$rtfeldman$elm_css$Svg$Styled$Attributes$d('M4 6h16M4 12h16M4 18h7')
									]),
								_List_Nil)
							]))
					]))
			]));
}();
var $author$project$View$Layout$authLayout = F3(
	function (authState, appModel, subview) {
		var _v0 = authState;
		var menu = _v0.hS;
		var _v1 = menu;
		var showLogoutModal = _v1.f3;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$View$Menu$Mobile$view, authState, appModel),
							A2($author$project$View$Menu$SideBar$view, authState, appModel),
							A2(
							$rtfeldman$elm_css$Html$Styled$main_,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Layout$styles.e$)
								]),
							_List_fromArray(
								[
									$author$project$View$Alert$view(appModel.ar),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Layout$styles.fN)
										]),
									_List_fromArray(
										[$author$project$View$Menu$TopBar$view, subview])),
									$author$project$View$Popup$view(
									{
										dJ: $author$project$View$Layout$logoutConfirmationModal,
										eK: showLogoutModal,
										fp: $author$project$Type$OnAuth(
											$author$project$Type$OnMenu(
												$author$project$Type$Menu$OnChangeLogoutModal(false)))
									})
								]))
						]))
				]));
	});
var $author$project$View$Layout$noAuthLayout = F2(
	function (appModel, subview) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Layout$styles.dI)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Layout$styles.dz)
						]),
					_List_fromArray(
						[
							$author$project$View$Alert$view(appModel.ar),
							subview
						]))
				]));
	});
var $author$project$View$Layout$view = F2(
	function (model, _v0) {
		var layout = _v0.a;
		var subview = _v0.b;
		if (!layout.$) {
			return A2($author$project$View$Layout$noAuthLayout, model, subview);
		} else {
			var authState = layout.a;
			return A3($author$project$View$Layout$authLayout, authState, model, subview);
		}
	});
var $author$project$View$body = function (model) {
	return A2(
		$author$project$View$Layout$view,
		model,
		model.bO ? $author$project$View$page(model) : _Utils_Tuple2($author$project$View$Layout$NoAuthLayout, $author$project$View$Loading$view));
};
var $elm$virtual_dom$VirtualDom$lazy2 = _VirtualDom_lazy2;
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				return styles;
			} else {
				return A3(
					$elm$core$Dict$insert,
					cssTemplate,
					$rtfeldman$elm_css$Hash$fromString(cssTemplate),
					styles);
			}
		} else {
			return styles;
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string(classname));
			} else {
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string('_unstyled'));
			}
		} else {
			return val;
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', classname);
			} else {
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', '_unstyled');
			}
		} else {
			return val;
		}
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$nodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_nodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration = F3(
	function (template, classname, declaration) {
		return declaration + ('\n' + A3($elm$core$String$replace, $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, classname, template));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return A3($elm$core$Dict$foldl, $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration, '', dict);
};
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = F2(
	function (maybeNonce, styles) {
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			'span',
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'display: none;'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'class', 'elm-css-style-wrapper')
				]),
			_List_fromArray(
				[
					A3(
					$elm$virtual_dom$VirtualDom$node,
					'style',
					function () {
						if (!maybeNonce.$) {
							var nonce = maybeNonce.a;
							return _List_fromArray(
								[
									A2($elm$virtual_dom$VirtualDom$attribute, 'nonce', nonce)
								]);
						} else {
							return _List_Nil;
						}
					}(),
					$elm$core$List$singleton(
						$elm$virtual_dom$VirtualDom$text(
							$rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))))
				]));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F4(
	function (maybeNonce, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode, maybeNonce, styles);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F3(
	function (maybeNonce, allStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode, maybeNonce, allStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F4(
	function (maybeNonce, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, maybeNonce, styles, keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F5(
	function (maybeNonce, ns, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, maybeNonce, styles, keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F5(
	function (maybeNonce, ns, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode, maybeNonce, styles);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyle, $elm$core$Maybe$Nothing, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, $elm$core$Maybe$Nothing, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp = F2(
	function (fn, arg) {
		return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			fn(arg));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$lazy = F2(
	function (fn, arg) {
		return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A3($elm$virtual_dom$VirtualDom$lazy2, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp, fn, arg));
	});
var $rtfeldman$elm_css$Html$Styled$Lazy$lazy = $rtfeldman$elm_css$VirtualDom$Styled$lazy;
var $author$project$View$title = function (model) {
	var _v0 = model.cM;
	switch (_v0.$) {
		case 0:
			return 'Dashboard';
		case 1:
			return 'Login';
		case 2:
			return 'Super Admin Login';
		case 3:
			return 'Profile';
		case 4:
			return 'Admins';
		case 5:
			return 'Create Admin';
		case 6:
			return 'Edit Admin';
		case 7:
			return 'Super Admins';
		case 8:
			return 'Create Super Admin';
		case 9:
			return 'Edit Super Admin';
		case 10:
			return 'Tenants';
		case 11:
			return 'Create Tenant';
		case 12:
			return 'Edit Tenant';
		case 13:
			return 'Bots';
		case 14:
			return 'Edit Bot';
		case 15:
			return 'Bot Logs';
		case 16:
			return 'Bot Reports';
		case 17:
			return 'Audit Trail';
		default:
			return 'Not Found';
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $author$project$View$view = function (model) {
	return {
		df: _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$toUnstyled(
				A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$View$body, model))
			]),
		aP: $author$project$View$title(model)
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{hA: $author$project$Model$initialModel, h_: $author$project$Type$OnUrlChange, h$: $author$project$Type$OnUrlRequest, iu: $author$project$Subscription$subscriptions, iW: $author$project$Model$update, i5: $author$project$View$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (authInfo) {
			return $elm$json$Json$Decode$succeed(
				{gY: authInfo});
		},
		A2(
			$elm$json$Json$Decode$field,
			'authInfo',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
						A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$Just,
						A2(
							$elm$json$Json$Decode$andThen,
							function (token) {
								return A2(
									$elm$json$Json$Decode$andThen,
									function (role) {
										return $elm$json$Json$Decode$succeed(
											{ic: role, iQ: token});
									},
									A2($elm$json$Json$Decode$field, 'role', $elm$json$Json$Decode$string));
							},
							A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string)))
					])))))(0)}});}(this));